webpackJsonp([1],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(423)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(199),
  /* template */
  __webpack_require__(1460),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(307),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(357)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(300),
  /* template */
  __webpack_require__(1386),
  /* scopeId */
  "data-v-0c872338",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(425)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(215),
  /* template */
  __webpack_require__(1463),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(433)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(290),
  /* template */
  __webpack_require__(1473),
  /* scopeId */
  "data-v-c00bc10a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(432)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(296),
  /* template */
  __webpack_require__(1472),
  /* scopeId */
  "data-v-bfcee144",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(393)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(250),
  /* template */
  __webpack_require__(1428),
  /* scopeId */
  "data-v-50484af0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(437)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(264),
  /* template */
  __webpack_require__(1477),
  /* scopeId */
  "data-v-d4d588a2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(371)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(287),
  /* template */
  __webpack_require__(1405),
  /* scopeId */
  "data-v-25bf06ca",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(372)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(247),
  /* template */
  __webpack_require__(1406),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(384)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(254),
  /* template */
  __webpack_require__(1419),
  /* scopeId */
  "data-v-3a79c056",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(419)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(298),
  /* template */
  __webpack_require__(1456),
  /* scopeId */
  "data-v-7f0ef6f8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(439)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(216),
  /* template */
  __webpack_require__(1480),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(360)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(252),
  /* template */
  __webpack_require__(1389),
  /* scopeId */
  "data-v-0ea6133f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(421)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(255),
  /* template */
  __webpack_require__(1458),
  /* scopeId */
  "data-v-83f32c16",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(426)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(288),
  /* template */
  __webpack_require__(1465),
  /* scopeId */
  "data-v-9f3492fc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(398)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(297),
  /* template */
  __webpack_require__(1432),
  /* scopeId */
  "data-v-52402c50",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 27 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/article-list_mock.6ee989c.png";

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/article_mock.831ae76.png";

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/issue_mock.433656c.png";

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/mock.eff9512.png";

/***/ }),
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/header-img.6fe0291.png";

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/header-logo.c54b939.png";

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(380)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(208),
  /* template */
  __webpack_require__(1415),
  /* scopeId */
  "data-v-30e6b256",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(220),
  /* template */
  __webpack_require__(1381),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(396)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(232),
  /* template */
  __webpack_require__(1430),
  /* scopeId */
  "data-v-50ba058a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(399)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(233),
  /* template */
  __webpack_require__(1433),
  /* scopeId */
  "data-v-5969fa3b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(375)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(253),
  /* template */
  __webpack_require__(1409),
  /* scopeId */
  "data-v-290ce35a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(386)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(289),
  /* template */
  __webpack_require__(1421),
  /* scopeId */
  "data-v-3ea54fe6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(414)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(291),
  /* template */
  __webpack_require__(1451),
  /* scopeId */
  "data-v-72272b19",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(363)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(293),
  /* template */
  __webpack_require__(1392),
  /* scopeId */
  "data-v-131e4173",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(383)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(294),
  /* template */
  __webpack_require__(1418),
  /* scopeId */
  "data-v-356965de",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(435)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(295),
  /* template */
  __webpack_require__(1475),
  /* scopeId */
  "data-v-c8943e1a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(303),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(304),
  /* template */
  __webpack_require__(1478),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(306),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./img/aging/favicon.ico": 445,
	"./img/aging/footer-logo.png": 446,
	"./img/aging/header-img.png": 447,
	"./img/aging/header-logo.png": 448,
	"./img/genes/favicon.ico": 449,
	"./img/genes/footer-logo.png": 450,
	"./img/genes/header-img.png": 451,
	"./img/genes/header-logo.png": 452,
	"./img/icons/aging/arrow-down.png": 453,
	"./img/icons/aging/arrow-right-dark.png": 454,
	"./img/icons/aging/arrow-right.png": 455,
	"./img/icons/aging/home.png": 456,
	"./img/icons/aging/ic_peer_review.png": 457,
	"./img/icons/aging/ic_plagerism.png": 458,
	"./img/icons/aging/ic_style_guidelines.png": 459,
	"./img/icons/aging/ic_submit.png": 460,
	"./img/icons/arrow-down-large.png": 461,
	"./img/icons/arrow-right.png": 462,
	"./img/icons/arrow-up-large.png": 463,
	"./img/icons/genes/arrow-down.png": 464,
	"./img/icons/genes/arrow-right-dark.png": 465,
	"./img/icons/genes/arrow-right.png": 466,
	"./img/icons/genes/home.png": 467,
	"./img/icons/genes/ic_peer_review.png": 468,
	"./img/icons/genes/ic_plagerism.png": 469,
	"./img/icons/genes/ic_style_guidelines.png": 470,
	"./img/icons/genes/ic_submit.png": 471,
	"./img/icons/oncoscience/arrow-down.png": 472,
	"./img/icons/oncoscience/arrow-right-dark.png": 473,
	"./img/icons/oncoscience/arrow-right.png": 474,
	"./img/icons/oncoscience/home.png": 475,
	"./img/icons/oncoscience/ic_peer_review.png": 476,
	"./img/icons/oncoscience/ic_plagerism.png": 477,
	"./img/icons/oncoscience/ic_style_guidelines.png": 478,
	"./img/icons/oncoscience/ic_submit.png": 479,
	"./img/icons/oncotarget/arrow-down.png": 480,
	"./img/icons/oncotarget/arrow-right-dark.png": 481,
	"./img/icons/oncotarget/arrow-right.png": 482,
	"./img/icons/oncotarget/home.png": 483,
	"./img/icons/oncotarget/ic_peer_review.png": 484,
	"./img/icons/oncotarget/ic_plagerism.png": 485,
	"./img/icons/oncotarget/ic_style_guidelines.png": 486,
	"./img/icons/oncotarget/ic_submit.png": 487,
	"./img/icons/search.png": 488,
	"./img/icons/social-fb.png": 489,
	"./img/icons/social-gp.png": 490,
	"./img/icons/social-li.png": 491,
	"./img/icons/social-tw.png": 492,
	"./img/icons/social-yt.png": 493,
	"./img/oncoscience/favicon.ico": 494,
	"./img/oncoscience/footer-logo.png": 166,
	"./img/oncoscience/header-img.png": 167,
	"./img/oncoscience/header-logo.png": 168,
	"./img/oncotarget/favicon.ico": 495,
	"./img/oncotarget/footer-logo.png": 496,
	"./img/oncotarget/header-img.png": 497,
	"./img/oncotarget/header-logo.png": 498,
	"./img/pause-circle.png": 499,
	"./img/play-circle.png": 500,
	"./img/rapamycin-logo.png": 501,
	"./img/share-circle.png": 502,
	"./img/temp/CurrentIssueCover.png": 503,
	"./img/temp/IssueCover.png": 504,
	"./img/temp/MobileSiteCover.png": 505,
	"./img/temp/SponsorshipCover.png": 506,
	"./img/temp/no-image-available.png": 507,
	"./img/temp/slide-1.jpg": 508,
	"./img/temp/slide-2.jpg": 509,
	"./img/temp/slide-3.jpg": 510,
	"./img/temp/slide-4.jpg": 511,
	"./img/temp/test_video.png": 512,
	"./mocks/article": 184,
	"./mocks/article-list": 183,
	"./mocks/article-list.json": 183,
	"./mocks/article-list_mock.png": 28,
	"./mocks/article.json": 184,
	"./mocks/article_mock.png": 29,
	"./mocks/issue": 185,
	"./mocks/issue.json": 185,
	"./mocks/issue_mock.png": 30,
	"./mocks/mock": 186,
	"./mocks/mock.json": 186,
	"./mocks/mock.png": 31,
	"./mocks/video-list": 187,
	"./mocks/video-list.json": 187,
	"./scss/_base.scss": 338,
	"./scss/_buttons.scss": 339,
	"./scss/_common.scss": 340,
	"./scss/_global-variables.scss": 341,
	"./scss/_helpers.scss": 342,
	"./scss/_icons.scss": 343,
	"./scss/_mixins.scss": 344,
	"./scss/site-themes/aging.scss": 345,
	"./scss/site-themes/genes.scss": 346,
	"./scss/site-themes/oncoscience.scss": 347,
	"./scss/site-themes/oncotarget.scss": 348,
	"./scss/site.scss": 27
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 182;

/***/ }),
/* 183 */
/***/ (function(module, exports) {

module.exports = {"articles":[{"ids":{"pmid":"20157571","pmc":"2815741","pii":"100101","doi":"10.18632/aging.100101"},"title":"p53, sex, and aging: lessons from the fruit fly","advance":false,"volume":1,"issue":{"volume":1,"issue":"11","issue_linkable":"11","display":true,"cover":"hmEg7MQKMLbWjfo3Q.png","pub_date":"2009-11-01T07:00:00.000+0000","date_settings":{"day":false,"month":true,"year":true},"current":false,"caption":"","pages":{"start":881,"end":960},"optimized":true,"optimized_file":"hmEg7MQKMLbWjfo3Q.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true,"xsmall":true},"prev_next":{"prev":{"_id":"e83C7xrecYb7rgDv4","volume":1,"issue":"10","issue_linkable":"10","param":"v1i10"},"next":{"_id":"Lim5Ndx6TGPx9xkBJ","volume":1,"issue":"12","issue_linkable":"12","param":"v1i12"}},"coverPath":"https://s3-us-west-1.amazonaws.com/paperchase-aging/covers/hmEg7MQKMLbWjfo3Q.png","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/covers_optimized/original/hmEg7MQKMLbWjfo3Q.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/covers_optimized/hero/hmEg7MQKMLbWjfo3Q.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/covers_optimized/large/hmEg7MQKMLbWjfo3Q.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/covers_optimized/medium/hmEg7MQKMLbWjfo3Q.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/covers_optimized/small/hmEg7MQKMLbWjfo3Q.png","xsmall":"https://s3-us-west-1.amazonaws.com/paperchase-aging/covers_optimized/xsmall/hmEg7MQKMLbWjfo3Q.png"}},"page_start":881,"page_end":883,"keywords":["Drosophila melanogaster","sexual antagonistic pleoitropy","longevity"],"article_type":{"short_name":"news","nlm_type":"news","plural":"News","name":"News"},"authors":[{"name_first":"Jae H.","name_middle":"","name_last":"Hur","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"David W.","name_middle":"","name_last":"Walker","name_suffix":"","equal_contrib":false,"ids":{},"affiliations_numbers":[0,1],"author_notes_ids":[]}],"affiliations":["Department of Physiological Science, University of California, Los Angeles, CA 90095, USA","Molecular Biology Institute, University of California, Los Angeles, CA 90095, USA"],"dates":{"epub":"2009-11-13T06:00:00.000Z"},"history":{"received":"2009-11-09T06:00:00.000Z","accepted":"2009-11-12T06:00:00.000Z"},"publisher":"Impact Journals LLC","files":{"pdf":{"file":"9EdnXEakSw9F8pp8J.pdf","display":true,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/pdf/9EdnXEakSw9F8pp8J.pdf"},"xml":{"file":"9EdnXEakSw9F8pp8J.xml","display":true,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/xml/9EdnXEakSw9F8pp8J.xml"},"journal":"aging"},"correspondence":[{"text":"David W. Walker, PhD, Department of Physiological Science, University of California, Los Angeles, 621 Charles E. Young Dr. South, Los Angeles, CA 90095-1527, USA","email":"davidwalker@ucla.edu"}],"display":true,"feature":false,"abstract":"","pdfPageCount":17,"issue_pub_date_year":2009,"vi":"v1i11"},{"files":{"pdf":{"file":"ikCkZYNqL7MJ7tTko.pdf","display":true,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/pdf/ikCkZYNqL7MJ7tTko.pdf"},"xml":{"file":"ikCkZYNqL7MJ7tTko.xml","display":true,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/xml/ikCkZYNqL7MJ7tTko.xml"},"figures":[{"id":"f1","label":"Figure 1","caption":"<b>A microarray assay of miRNA expression profiles and a KEGG pathway enrichment analysis of target mRNAs predicted from differentially-expressed (DE) miRNAs in mouse oocytes aging for different times.</b> (<b>A</b>) Heat map and cluster analysis of miRNA expression in oocytes aging for different times. Red indicates high relative expression and green indicates low relative expression. Fold changes greater than 2 (FC>2) were used as threshold for miRNA differential expression. (<b>B</b>) A table shows number of DE miRNAs, number of target mRNAs predicted from DE miRNAs and number of enriched KEGG pathways in oocytes aging for different times.","file":"ikCkZYNqL7MJ7tTko_f1.tif","version":1,"optimized":true,"optimized_file":"ikCkZYNqL7MJ7tTko_f1.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/ikCkZYNqL7MJ7tTko_f1.tif","optimized_urls":{"original":"/img?size=original&img=ikCkZYNqL7MJ7tTko_f1.png&v=1","hero":"/img?size=hero&img=ikCkZYNqL7MJ7tTko_f1.png&v=1","large":"/img?size=large&img=ikCkZYNqL7MJ7tTko_f1.png&v=1","medium":"/img?size=medium&img=ikCkZYNqL7MJ7tTko_f1.png&v=1","small":"/img?size=small&img=ikCkZYNqL7MJ7tTko_f1.png&v=1"}},{"id":"f2","label":"Figure 2","caption":"<b>RT-qPCR verification of microarray assay results for apoptosis-related miRNAs.</b> Each treatment was repeated 3-4 times and each replicate contained ~600 oocytes. a-c: Values with a different letter above bars differ significantly (P < 0.05).","file":"ikCkZYNqL7MJ7tTko_f2.tif","version":1,"optimized":true,"optimized_file":"ikCkZYNqL7MJ7tTko_f2.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/ikCkZYNqL7MJ7tTko_f2.tif","optimized_urls":{"original":"/img?size=original&img=ikCkZYNqL7MJ7tTko_f2.png&v=1","hero":"/img?size=hero&img=ikCkZYNqL7MJ7tTko_f2.png&v=1","large":"/img?size=large&img=ikCkZYNqL7MJ7tTko_f2.png&v=1","medium":"/img?size=medium&img=ikCkZYNqL7MJ7tTko_f2.png&v=1","small":"/img?size=small&img=ikCkZYNqL7MJ7tTko_f2.png&v=1"}},{"id":"f3","label":"Figure 3","caption":"<b>Levels of p-MAPK, TrkB, and ceramide expression in oocytes aging for different times.</b> Graphs <b>A</b>, <b>B</b> and <b>C</b> show quantification of p-MAPK, TrkB, and ceramide expression, respectively. For ceramide quantification, the fluorescence intensity value in oocytes recovered at 13 h post hCG injection was set as one and the other values were expressed relative to this value. Each treatment was repeated 3-4 times and each replicate contained 35-40 oocytes. a-c: Values with a different letter above bars differ significantly (P < 0.05). <b>D</b>, <b>E</b>, <b>F</b> and <b>G</b> are micrographs from laser confocal images showing expression of ceramide in oocytes recovered at different times after hCG injection. Ceramide was colored green in the laser confocal images. The bar is 18 µm and applies to all images.","file":"ikCkZYNqL7MJ7tTko_f3.tif","version":1,"optimized":true,"optimized_file":"ikCkZYNqL7MJ7tTko_f3.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/ikCkZYNqL7MJ7tTko_f3.tif","optimized_urls":{"original":"/img?size=original&img=ikCkZYNqL7MJ7tTko_f3.png&v=1","hero":"/img?size=hero&img=ikCkZYNqL7MJ7tTko_f3.png&v=1","large":"/img?size=large&img=ikCkZYNqL7MJ7tTko_f3.png&v=1","medium":"/img?size=medium&img=ikCkZYNqL7MJ7tTko_f3.png&v=1","small":"/img?size=small&img=ikCkZYNqL7MJ7tTko_f3.png&v=1"}},{"id":"f4","label":"Figure 4","caption":"<b>Effects of supplementation with U0126, ceramide or BDNF during in vitro aging on STAS of mouse oocytes.</b> Cumulus-denuded oocytes (DOs) recovered 13 h post hCG injection were used. For U0126 and BDNF treatment, the DOs were aged for 36 h in CZB medium supplemented with different concentrations of U0126 or BDNF before ethanol and 6-DMAP treatment for activation. For ceramide treatment, DOs were microinjected with 6 pl DMSO alone (control) or DMSO containing 1 mM ceramide and then aged for 36 h in CZB medium before ethanol and 6-DMAP treatment for activation. Each treatment was repeated 4-5 times with each replicate containing about 30 oocytes. a,b: Values with a different letter above bars differ significantly (P < 0.05).","file":"ikCkZYNqL7MJ7tTko_f4.tif","version":1,"optimized":true,"optimized_file":"ikCkZYNqL7MJ7tTko_f4.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/ikCkZYNqL7MJ7tTko_f4.tif","optimized_urls":{"original":"/img?size=original&img=ikCkZYNqL7MJ7tTko_f4.png&v=1","hero":"/img?size=hero&img=ikCkZYNqL7MJ7tTko_f4.png&v=1","large":"/img?size=large&img=ikCkZYNqL7MJ7tTko_f4.png&v=1","medium":"/img?size=medium&img=ikCkZYNqL7MJ7tTko_f4.png&v=1","small":"/img?size=small&img=ikCkZYNqL7MJ7tTko_f4.png&v=1"}},{"id":"f5","label":"Figure 5","caption":"<b>Activation rates and calcium stores in oocytes microinjected with miR-98 mimic (upper row) or inhibitor (lower row).</b> Freshly ovulated oocytes recovered at 13 h post hCG were injected with miR-98 mimic (MM) or miRNA mimic negative control (MC), or with miR-98 inhibitor (IN) or inhibitor negative control (IC), before aging culture in CZB medium. To observe activation, oocytes were treated with ethanol and 6-DMAP at 36 h (mimic) or 30 h (inhibitor) of aging culture, and activation was checked 6 h later. Each treatment was repeated 3 to 4 times and each replicate contained 35-40 oocytes. For calcium measurement, at 3 h and 36 h (mimic) or 30 h (inhibitor) of aging culture, oocytes were loaded with Fura-2 AM and the loaded oocytes were measured for calcium stores (ΔF340/380) using a Ca<sup>2+</sup> imaging system. Oocytes were monitored for 5 min to record baseline F340/380 ratio before ionomycin stimulation to release Ca<sup>2+</sup> into cytoplasm. Following ionomycin addition, oocytes were monitored for 20 min to record peak F340/380 ratio. The difference between peak and baseline F340/380 ratios represents the calcium stores (ΔF340/380) of an oocyte. Each treatment was repeated 3 to 4 times and each replicate contained 35-40 oocytes. a-c: Values with a different letter above bars differ significantly (P < 0.05).","file":"ikCkZYNqL7MJ7tTko_f5.tif","version":1,"optimized":true,"optimized_file":"ikCkZYNqL7MJ7tTko_f5.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/ikCkZYNqL7MJ7tTko_f5.tif","optimized_urls":{"original":"/img?size=original&img=ikCkZYNqL7MJ7tTko_f5.png&v=1","hero":"/img?size=hero&img=ikCkZYNqL7MJ7tTko_f5.png&v=1","large":"/img?size=large&img=ikCkZYNqL7MJ7tTko_f5.png&v=1","medium":"/img?size=medium&img=ikCkZYNqL7MJ7tTko_f5.png&v=1","small":"/img?size=small&img=ikCkZYNqL7MJ7tTko_f5.png&v=1"}},{"id":"f6","label":"Figure 6","caption":"<b>Caspase-3 expression in oocytes microinjected with miR-98 mimic or inhibitor.</b> Freshly ovulated oocytes recovered at 13 h post hCG were injected with miR-98 mimic (MM) or miRNA mimic negative control (MC), or with miR-98 inhibitor (IN) or inhibitor negative control (IC), before aging culture in CZB medium. At 36 h (mimic) or 30 h (inhibitor) of aging culture, oocytes were processed for immunofluorescence microscopy. Caspase-3 was colored red in the laser confocal images. The bar is 12 µm and applies to all images. For quantification, the fluorescence intensity values in control oocytes injected with MC or IC were set as one and the values in oocytes injected with MM or IN were expressed relative to the values in control oocytes. Each treatment was repeated 3-4 times and each replicate contained 35-40 oocytes. a,b: Values with a different letter above bars differ significantly (P < 0.05).","file":"ikCkZYNqL7MJ7tTko_f6.tif","version":1,"optimized":true,"optimized_file":"ikCkZYNqL7MJ7tTko_f6.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/ikCkZYNqL7MJ7tTko_f6.tif","optimized_urls":{"original":"/img?size=original&img=ikCkZYNqL7MJ7tTko_f6.png&v=1","hero":"/img?size=hero&img=ikCkZYNqL7MJ7tTko_f6.png&v=1","large":"/img?size=large&img=ikCkZYNqL7MJ7tTko_f6.png&v=1","medium":"/img?size=medium&img=ikCkZYNqL7MJ7tTko_f6.png&v=1","small":"/img?size=small&img=ikCkZYNqL7MJ7tTko_f6.png&v=1"}}],"journal":"aging"},"feature":false,"advance":false,"display":true,"title":"Expression profiles and function analysis of microRNAs in postovulatory aging mouse oocytes","page_start":1186,"page_end":1201,"ids":{"pii":"101219","publisher-id":"101219","doi":"10.18632/aging.101219","pmid":"28394765"},"abstract":"<p>In this study, microRNA (miRNA) profiles in postovulatory aging mouse oocytes were analyzed by microarray screening and RT-qPCR. Hierarchical cluster analysis on the microarray data and KEGG pathway enrichment analysis on the mRNAs targeted by differentially expressed (DE) miRNAs between two adjacent egg-ages suggest that while only a mild alteration in miRNA expression occurred from 13 to 18 h, a great change took place from 18 to 24 h post hCG injection. Theoretical exploration on functions of the predicted target genes suggest that KEGG pathways enriched by 13-18 h DE miRNAs are correlated with early events of oocyte aging while pathways most enriched by 18-24 h or 24-30 h DE miRNAs are correlated with the late symptoms of aged oocytes. Experimental verification on functions of the key proteins predicted by the KEGG analysis and injection of miR-98 mimics or inhibitors further confirmed that miRNAs played stimulatory/inhibitory roles in postovulatory oocyte aging. In conclusion, marked changes in miRNA expression are associated with significant alterations in function and morphology of postovulatory aging oocytes.</p>","article_type":{"short_name":"research_paper","nlm_type":"research-article","plural":"Research Papers","name":"Research Paper"},"affiliations":["College of Animal Science and Veterinary Medicine, Shandong Agricultural University, Tai-an City 271018, P. R. China"],"dates":{"epub":"2017-04-08T04:00:00.000Z"},"history":{"received":"2017-03-03T05:00:00.000Z","accepted":"2017-03-28T04:00:00.000Z"},"keywords":["microRNA","oocyte","aging","signaling pathway","molecular function"],"coi":"","previous":{"files":{"pdf":{"file":"ikCkZYNqL7MJ7tTko.pdf","display":true},"xml":{"file":"ikCkZYNqL7MJ7tTko.xml","display":true},"figures":[{"id":"f1","label":"Figure 1","caption":"<b>A microarray assay of miRNA expression profiles and a KEGG pathway enrichment analysis of target mRNAs predicted from differentially-expressed (DE) miRNAs in mouse oocytes aging for different times.</b> (<b>A</b>) Heat map and cluster analysis of miRNA expression in oocytes aging for different times. Red indicates high relative expression and green indicates low relative expression. Fold changes greater than 2 (FC>2) were used as threshold for miRNA differential expression. (<b>B</b>) A table shows number of DE miRNAs, number of target mRNAs predicted from DE miRNAs and number of enriched KEGG pathways in oocytes aging for different times.","file":"ikCkZYNqL7MJ7tTko_f1.tif","version":1,"optimized":true,"optimized_file":"ikCkZYNqL7MJ7tTko_f1.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true}},{"id":"f2","label":"Figure 2","caption":"<b>RT-qPCR verification of microarray assay results for apoptosis-related miRNAs.</b> Each treatment was repeated 3-4 times and each replicate contained ~600 oocytes. a-c: Values with a different letter above bars differ significantly (P < 0.05).","file":"ikCkZYNqL7MJ7tTko_f2.tif","version":1,"optimized":true,"optimized_file":"ikCkZYNqL7MJ7tTko_f2.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true}},{"id":"f3","label":"Figure 3","caption":"<b>Levels of p-MAPK, TrkB, and ceramide expression in oocytes aging for different times.</b> Graphs <b>A</b>, <b>B</b> and <b>C</b> show quantification of p-MAPK, TrkB, and ceramide expression, respectively. For ceramide quantification, the fluorescence intensity value in oocytes recovered at 13 h post hCG injection was set as one and the other values were expressed relative to this value. Each treatment was repeated 3-4 times and each replicate contained 35-40 oocytes. a-c: Values with a different letter above bars differ significantly (P < 0.05). <b>D</b>, <b>E</b>, <b>F</b> and <b>G</b> are micrographs from laser confocal images showing expression of ceramide in oocytes recovered at different times after hCG injection. Ceramide was colored green in the laser confocal images. The bar is 18 µm and applies to all images.","file":"ikCkZYNqL7MJ7tTko_f3.tif","version":1,"optimized":true,"optimized_file":"ikCkZYNqL7MJ7tTko_f3.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true}},{"id":"f4","label":"Figure 4","caption":"<b>Effects of supplementation with U0126, ceramide or BDNF during in vitro aging on STAS of mouse oocytes.</b> Cumulus-denuded oocytes (DOs) recovered 13 h post hCG injection were used. For U0126 and BDNF treatment, the DOs were aged for 36 h in CZB medium supplemented with different concentrations of U0126 or BDNF before ethanol and 6-DMAP treatment for activation. For ceramide treatment, DOs were microinjected with 6 pl DMSO alone (control) or DMSO containing 1 mM ceramide and then aged for 36 h in CZB medium before ethanol and 6-DMAP treatment for activation. Each treatment was repeated 4-5 times with each replicate containing about 30 oocytes. a,b: Values with a different letter above bars differ significantly (P < 0.05).","file":"ikCkZYNqL7MJ7tTko_f4.tif","version":1,"optimized":true,"optimized_file":"ikCkZYNqL7MJ7tTko_f4.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true}},{"id":"f5","label":"Figure 5","caption":"<b>Activation rates and calcium stores in oocytes microinjected with miR-98 mimic (upper row) or inhibitor (lower row).</b> Freshly ovulated oocytes recovered at 13 h post hCG were injected with miR-98 mimic (MM) or miRNA mimic negative control (MC), or with miR-98 inhibitor (IN) or inhibitor negative control (IC), before aging culture in CZB medium. To observe activation, oocytes were treated with ethanol and 6-DMAP at 36 h (mimic) or 30 h (inhibitor) of aging culture, and activation was checked 6 h later. Each treatment was repeated 3 to 4 times and each replicate contained 35-40 oocytes. For calcium measurement, at 3 h and 36 h (mimic) or 30 h (inhibitor) of aging culture, oocytes were loaded with Fura-2 AM and the loaded oocytes were measured for calcium stores (ΔF340/380) using a Ca<sup>2+</sup> imaging system. Oocytes were monitored for 5 min to record baseline F340/380 ratio before ionomycin stimulation to release Ca<sup>2+</sup> into cytoplasm. Following ionomycin addition, oocytes were monitored for 20 min to record peak F340/380 ratio. The difference between peak and baseline F340/380 ratios represents the calcium stores (ΔF340/380) of an oocyte. Each treatment was repeated 3 to 4 times and each replicate contained 35-40 oocytes. a-c: Values with a different letter above bars differ significantly (P < 0.05).","file":"ikCkZYNqL7MJ7tTko_f5.tif","version":1,"optimized":true,"optimized_file":"ikCkZYNqL7MJ7tTko_f5.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true}},{"id":"f6","label":"Figure 6","caption":"<b>Caspase-3 expression in oocytes microinjected with miR-98 mimic or inhibitor.</b> Freshly ovulated oocytes recovered at 13 h post hCG were injected with miR-98 mimic (MM) or miRNA mimic negative control (MC), or with miR-98 inhibitor (IN) or inhibitor negative control (IC), before aging culture in CZB medium. At 36 h (mimic) or 30 h (inhibitor) of aging culture, oocytes were processed for immunofluorescence microscopy. Caspase-3 was colored red in the laser confocal images. The bar is 12 µm and applies to all images. For quantification, the fluorescence intensity values in control oocytes injected with MC or IC were set as one and the values in oocytes injected with MM or IN were expressed relative to the values in control oocytes. Each treatment was repeated 3-4 times and each replicate contained 35-40 oocytes. a,b: Values with a different letter above bars differ significantly (P < 0.05).","file":"ikCkZYNqL7MJ7tTko_f6.tif","version":1,"optimized":true,"optimized_file":"ikCkZYNqL7MJ7tTko_f6.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true}}]},"feature":false,"advance":false,"display":true,"title":"Expression profiles and function analysis of microRNAs in postovulatory aging mouse oocytes","page_start":1186,"page_end":1201,"ids":{"pii":"101219","publisher-id":"101219","doi":"10.18632/aging.101219","pmid":"28394765"},"abstract":"<p>In this study, microRNA (miRNA) profiles in postovulatory aging mouse oocytes were analyzed by microarray screening and RT-qPCR. Hierarchical cluster analysis on the microarray data and KEGG pathway enrichment analysis on the mRNAs targeted by differentially expressed (DE) miRNAs between two adjacent egg-ages suggest that while only a mild alteration in miRNA expression occurred from 13 to 18 h, a great change took place from 18 to 24 h post hCG injection. Theoretical exploration on functions of the predicted target genes suggest that KEGG pathways enriched by 13-18 h DE miRNAs are correlated with early events of oocyte aging while pathways most enriched by 18-24 h or 24-30 h DE miRNAs are correlated with the late symptoms of aged oocytes. Experimental verification on functions of the key proteins predicted by the KEGG analysis and injection of miR-98 mimics or inhibitors further confirmed that miRNAs played stimulatory/inhibitory roles in postovulatory oocyte aging. In conclusion, marked changes in miRNA expression are associated with significant alterations in function and morphology of postovulatory aging oocytes.</p>","article_type":{"short_name":"research_paper","nlm_type":"research-article","plural":"Research Papers","name":"Research Paper"},"affiliations":["College of Animal Science and Veterinary Medicine, Shandong Agricultural University, Tai-an City 271018, P. R. China"],"dates":{"epub":"2017-04-08T04:00:00.000Z"},"history":{"received":"2017-03-03T05:00:00.000Z","accepted":"2017-03-28T04:00:00.000Z"},"keywords":["microRNA","oocyte","aging","signaling pathway","molecular function"],"coi":"","authors":[{"name_first":"Tian-Yang","name_middle":"","name_last":"Wang","name_suffix":"","equal_contrib":true,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Jie","name_middle":"","name_last":"Zhang","name_suffix":"","equal_contrib":true,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Jiang","name_middle":"","name_last":"Zhu","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Hua-Yu","name_middle":"","name_last":"Lian","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Hong-Jie","name_middle":"","name_last":"Yuan","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Min","name_middle":"","name_last":"Gao","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Ming-Jiu","name_middle":"","name_last":"Luo","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Jing-He","name_middle":"","name_last":"Tan","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]}],"correspondence":[{"text":"Jing-He Tan","email":"tanjh@sdau.edu.cn"}],"section":"ThGWnHeyhxdRzxfbA","pub_status":null,"submissions":[{"submission_id":"HT4JPm5MYsNe7zNab","created_date":"2017-04-10T16:28:05.330Z","pub_status":"aheadofprint"}],"issue_id":"5CfAJ7st288NsGrFC","author_notes":null,"volume":9,"issue":"4","aop":false},"authors":[{"name_first":"Tian-Yang","name_middle":"","name_last":"Wang","name_suffix":"","equal_contrib":"*","affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Jie","name_middle":"","name_last":"Zhang","name_suffix":"","equal_contrib":"*","affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Jiang","name_middle":"","name_last":"Zhu","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Hua-Yu","name_middle":"","name_last":"Lian","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Hong-Jie","name_middle":"","name_last":"Yuan","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Min","name_middle":"","name_last":"Gao","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Ming-Jiu","name_middle":"","name_last":"Luo","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Jing-He","name_middle":"","name_last":"Tan","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]}],"correspondence":[{"text":"Jing-He Tan","email":"tanjh@sdau.edu.cn"}],"pub_status":"ppublish","submissions":[{"submission_id":"HT4JPm5MYsNe7zNab","created_date":"2017-04-10T16:28:05.330Z","pub_status":"aheadofprint"},{"submission_id":"KPDTYnttsgrnZcjnZ","created_date":"2017-05-05T22:52:34.858Z","pub_status":"ppublish"}],"author_notes":null,"volume":9,"issue":{"volume":9,"issue":"4","pub_date":"2017-04-30T04:00:00.000+0000","date_settings":{"day":false,"month":true,"year":true},"display":true,"current":false,"caption":"<p>The cover for issue 4 of Aging features Figure 1, ''Scatter plots and density plots of LTL as a function of age for males and females residing in different countries\" from <a href=\"http://www.aging-us.com/article/101216/text\" target=\"_blank\">Steenstrup et al.</a></p>","issue_linkable":"4","cover":"5CfAJ7st288NsGrFC.png","prev_next":{"prev":{"volume":9,"issue":"3","issue_linkable":"3","param":"v9i3"},"next":{"volume":9,"issue":"5","issue_linkable":"5","param":"v9i5"}},"optimized":true,"optimized_file":"5CfAJ7st288NsGrFC.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"pages":{"start":1084,"end":1350},"coverPath":"https://s3-us-west-1.amazonaws.com/paperchase-aging/covers/5CfAJ7st288NsGrFC.png","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/covers_optimized/original/5CfAJ7st288NsGrFC.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/covers_optimized/hero/5CfAJ7st288NsGrFC.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/covers_optimized/large/5CfAJ7st288NsGrFC.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/covers_optimized/medium/5CfAJ7st288NsGrFC.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/covers_optimized/small/5CfAJ7st288NsGrFC.png"}},"aop":false,"pdfPageCount":12,"issue_pub_date_year":2017,"vi":"v9i4","equal_contribs":"*"}]}

/***/ }),
/* 184 */
/***/ (function(module, exports) {

module.exports = {"_id":"vmFJfarchkyMAtwWn","files":{"pdf":{"file":"vmFJfarchkyMAtwWn.pdf","display":true,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/pdf/vmFJfarchkyMAtwWn.pdf"},"xml":{"file":"vmFJfarchkyMAtwWn.xml","display":true,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/xml/vmFJfarchkyMAtwWn.xml"},"figures":[{"id":"f1","label":"Figure 1","caption":"<b>Flow chart of study subject recruitment and enrollment.</b>","file":"vmFJfarchkyMAtwWn_f1.png","url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/vmFJfarchkyMAtwWn_f1.png","version":1,"optimized":true,"optimized_file":"vmFJfarchkyMAtwWn_f1.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true,"xsmall":true}},{"id":"f2","label":"Figure 2","caption":"<b>Treatment effects on bone mineral density (BMD) in placebo and MSDK groups.</b> Bone mineral density in the left femoral neck, total left hip and lumbar spine was measured via DXA (n=11 per group). Each bar represents the mean (Â± S.E.M.) change in bone mineral density (g/cm<sup>2</sup>) from baseline to month 12 in the (<b>A</b>) left femoral neck, (<b>B</b>) total left hip and (<b>C</b>) lumbar spine (L1-L4) area, respectively for placebo (open bar) and MSDK (closed bars). *<i>p</i> â¤ 0.05 and ***<i>p</i> â¤ 0.001 versus placebo, unpaired one tailed <i>t</i>-test with Welchâs correction.","file":"vmFJfarchkyMAtwWn_f2.png","url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/vmFJfarchkyMAtwWn_f2.png","version":1,"optimized":true,"optimized_file":"vmFJfarchkyMAtwWn_f2.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true,"xsmall":true}},{"id":"f3","label":"Figure 3","caption":"<b>Treatment effects on serum bone marker turnover in placebo and MSDK groups.</b> Bone formation markers (<b>A</b>) total procollagen type 1 amino-terminal propeptide (P1NP) and (<b>B</b>) osteocalcin (OC; both intact and N-terminal mid-fragments), serum bone resorption marker (<b>C</b>) Collagen Type I C-Telopeptide (CTx) were measured at months 0, 6 and 12. Serum samples were collected from participants (n=11 per group) and bone markers concentrations were measured by sandwich ELISA assay using commercially available specific bone marker kits at all three time points. Each point in the line graph represents the least square mean (Â± S.E.M.) in the bone markers concentration for placebo (open circle, red) and treatment (closed box, blue). Scatter plots represent the ratio of (<b>D</b>) CTx: P1NP and (<b>E</b>) CTx: OC for each study subject, respectively, where the solid lines indicate the mean (Â± S.E.M.) value for each group. *<i>p</i> â¤ 0.05 and **<i>p</i> â¤0.01 versus placebo at similar time points. Longitudinal analysis for repeated measures using a generalized linear mixed model (GLMM) approach, considering groups and times as fixed effects and subjects nested within the groups as random.","file":"vmFJfarchkyMAtwWn_f3.png","url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/vmFJfarchkyMAtwWn_f3.png","version":1,"optimized":true,"optimized_file":"vmFJfarchkyMAtwWn_f3.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true,"xsmall":true}},{"id":"f4","label":"Figure 4","caption":"<b>Treatment effects on urinary nocturnal melatonin, serum vitamin D<sub>3</sub> and serum C-reactive protein (CRP) level in placebo and MSDK groups.</b> (<b>A</b>) Nocturnal hourly melatonin secretion in the urine was measured at month 12 (n=10 per group), by collecting all urine samples between 10pm and 6am and measuring using urinary melatonin-sulfate ELISA kit. Each point in the scatter plots represents an individualâs urine melatonin-sulfate level, in placebo (open circle, red) or MSDK (closed circle, blue). *<i>p</i> â¤ 0.05 versus placebo at month 12; Unpaired one-tailed <i>t</i>-test with Welchâs correction. Serum levels of (<b>B</b>) Vitamin D<sub>3</sub> and (<b>C</b>) CRP were measured at months 0, 6 and 12, using specific ELISA kits. Each point in the scatter plots represents the concentration for a single subject at a specific time point, in the placebo (open circle, red) or MSDK (closed circle, blue). *<i>p</i> â¤ 0.05 versus placebo at similar time point; Longitudinal analysis for repeated measures using generalized linear mixed model (GLMM) approach, considering groups and times as fixed effects and subjects nested within the groups as random.","file":"vmFJfarchkyMAtwWn_f4.png","url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/vmFJfarchkyMAtwWn_f4.png","version":1,"optimized":true,"optimized_file":"vmFJfarchkyMAtwWn_f4.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true,"xsmall":true}},{"id":"f5","label":"Figure 5","caption":"<b>Treatment effects on participants' sleep quality, mood, GI upset and general aches/pains in placebo and MSDK groups.</b> (<b>A</b>) Total diary comments made by the participants in each group throughout the study were stratified into four categories: sleep, mood, GI upset and general aches/pains, as illustrated by the four segments in the pie diagram. Each category was sub-stratified as positive (pink), neutral (yellow) and negative (green) comments. Each portion represents the percent of total comments made under each category.","file":"vmFJfarchkyMAtwWn_f5.png","url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/vmFJfarchkyMAtwWn_f5.png","version":1,"optimized":true,"optimized_file":"vmFJfarchkyMAtwWn_f5.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true,"xsmall":true}},{"id":"f6A","label":"Figure 6A","file":"vmFJfarchkyMAtwWn_f6a.png","url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/vmFJfarchkyMAtwWn_f6.png","version":1,"optimized":true,"optimized_file":"vmFJfarchkyMAtwWn_f6a.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true,"xsmall":true}},{"id":"f6B","label":"Figure 6B","caption":"<b>Effect of MSDK on osteoblast-mediated calcium mineralization</b>. On day 21 of MSDK exposure, calcium deposition by differentiated, matured osteoblasts were evaluated via alizarin red staining on the (<b>A</b>) bottom chamber cells of transwell co-culture and (<b>B</b>) layered co-culture. Inset graph represents similar analysis in absence of Os+/MSDK. Each bar represents the mean concentration of alizarin red (Î¼M) for respective groups normalized against Os-/Veh (n=3; Transwell co-culture: ****=<i>p</i><.0001 vs. all groups, a=<i>p</i><.01 vs. Os-/Veh, b=<i>p</i><.05 vs. Os-/MSDK, c=<i>p</i><.05 vs. Os+/Veh; Layered co-culture: ****=<i>p</i><.0001 vs. all groups, a=<i>p</i><.01 vs. Os-/Veh, b=<i>p</i><.01 vs. Os-/MSDK, c=<i>p</i><.01 vs. Os-/Veh). Os- =basal media, Os+ =osteogenic media, Veh= vehicle, Mel= melatonin, SC= strontium citrate, D3= vitamin D<sub>3</sub> (Cholecalciferol), K2= vitamin K<sub>2</sub> (MK7).","file":"vmFJfarchkyMAtwWn_f6b.png","url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/vmFJfarchkyMAtwWn_f6b.png","version":1,"optimized":true,"optimized_file":"vmFJfarchkyMAtwWn_f6b.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true,"xsmall":true}},{"id":"f7","label":"Figure 7","caption":"<b>Effect of MSDK on osteoclast differentiation.</b> On day 21 of MSDK exposure, TRAP releasing activity by differentiated, mature osteoclasts was evaluated by quantitative Tartrate Resistant Acid Phosphatase (TRAP) assay on the (<b>A</b>) top chamber cells of transwell co-culture and (<b>B</b>) layered co-culture. Each bar represents the mean fluorescence reading of TRAP (at 405nm ex, 515nm em) for respective groups normalized against Os-/Veh (n=3; Transwell co-culture: **=<i>p</i><.01 vs. Os-/Veh; Layered co-culture: *=<i>p</i><.05 vs. Os-/Veh). Os- =basal media, Os+ =osteogenic media, Veh= vehicle, Mel= melatonin, SC= strontium citrate, D3= vitamin D<sub>3</sub> (Cholecalciferol), K2= vitamin K<sub>2</sub> (MK7).","file":"vmFJfarchkyMAtwWn_f7.png","url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/vmFJfarchkyMAtwWn_f7.png","version":1,"optimized":true,"optimized_file":"vmFJfarchkyMAtwWn_f7.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true,"xsmall":true}},{"id":"f8A_C","label":"Figure 8A-C","caption":"<b>Effect of MSDK on sOPG and sRANKL expression in osteoblasts grown in transwell co-cultures, layered co-cultures and hMSCs monocultures.</b> After 21 days of MSDK exposure, OPG and RANKL expression in osteoblasts was measured by western blot in (<b>A</b>) transwell co-cultures, (<b>B</b>) layered co-cultures and (<b>C</b>) hMSCs monocultures. Cell lysates were prepared on day 21 from the bottom (osteoblasts) and top (osteoclasts) chambers in the transwell co-culture and from the whole plate (both osteoblast and osteoclast) in the layered co-culture. Protein levels were normalized against Î²-actin and then to Os-/MSDK. Mean expression of (<b>i</b>) OPG: RANKL, (<b>ii</b>) OPG and (<b>iii</b>) RANKL in each culture were analyzed, normalized against Os-/MSDK and compared between groups (Os-/MSDK, Os+/Veh, Os+/MSDK). ","file":"vmFJfarchkyMAtwWn_f8a_c.png","url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/vmFJfarchkyMAtwWn_f8a_c.png","version":1,"optimized":true,"optimized_file":"vmFJfarchkyMAtwWn_f8a_c.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true,"xsmall":true}},{"id":"f8D_G","label":"Figure 8D-G","caption":"<b>Effect of MSDK on sOPG and sRANKL expression in osteoblasts grown in transwell co-cultures, layered co-cultures and hMSCs monocultures.</b> Treatments effects on secreted OPG (sOPG) and RANKL (sRANKL) were measured by ELISA in (<b>D</b>) transwells and (<b>E</b>) monocultures. Mean concentrations (pg/mL) of (<b>i</b>) sOPG: sRANKL, (<b>ii</b>) sOPG and (<b>iii</b>) sRANKL in culture media were analyzed, normalized against Os-/MSDK and compared between groups. Treatment effects on RANKL processing were detected via western blot by measuring the mean osteoblastâs expression of (<b>i</b>) 25 KDa and (<b>ii</b>) 24 KDa RANKL fragments in (<b>F</b>) transwells; and (<b>G</b>) 24 KDa RANKL fragment in layered co-cultures. *=<i>p</i><.05, **=<i>p</i><.01 and ***=<i>p</i><.001; One-way ANOVA followed by Bonferroniâs post-hoc multiple comparison <i>t</i>-test (n=6 per group).","file":"vmFJfarchkyMAtwWn_f8d_g.png","url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/vmFJfarchkyMAtwWn_f8d_g.png","version":1,"optimized":true,"optimized_file":"vmFJfarchkyMAtwWn_f8d_g.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true,"xsmall":true}},{"id":"f9A_C","label":"Figure 9A-C","caption":"<b>Effect of MSDK on MAPKs, ERK1/2 and ERK5.</b> After 21 days of MSDK exposure, western blot was performed to determine (<b>A</b>) ERK1/2 expression of osteoblasts grown as transwell co-cultures, (<b>B</b>) ERK1/2 expression of osteoblasts and osteoclasts grown as layered co-cultures, (<b>C</b>) ERK5 expression of osteoblasts grown as transwell co-cultures. ","file":"vmFJfarchkyMAtwWn_f9a_c.png","url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/vmFJfarchkyMAtwWn_f9a_c.png","version":1,"optimized":true,"optimized_file":"vmFJfarchkyMAtwWn_f9a_c.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true,"xsmall":true}},{"id":"f9D_F","label":"Figure 9D-F","caption":"<b>Effect of MSDK on MAPKs, ERK1/2 and ERK5.</b> (<b>D</b>) ERK5 expression of osteoblasts and osteoclasts grown in layered co-culture, (<b>E</b>) ERK5 expression of osteoblasts in hMSCs mono-culture and (<b>F</b>) phospho-ERK5 expression of osteoclasts grown in transwell co-culture. Cell lysates were prepared on day 21 from the bottom (osteoblasts) and top (osteoclasts) chambers in the transwell co-culture and from the whole plate (both osteoblast and osteoclast) in the layered co-culture. Protein levels were normalized against Î²-actin and then to Os-/MSDK. Mean expression of (<b>i</b>) phospho-ERK: total-ERK (<b>ii</b>) phospho-ERK (<b>iii</b>) total-ERK in each co-cultures were analyzed and compared between groups (Os-/MSDK, Os+/Veh, Os+/MSDK). *=<i>p</i><.05, **=<i>p</i><.01 and **=<i>p</i><.001; One-way ANOVA followed by Bonferroniâs post-hoc multiple comparison <i>t</i>-test (n=6 per group).","file":"vmFJfarchkyMAtwWn_f9d_f.png","url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/vmFJfarchkyMAtwWn_f9d_f.png","version":1,"optimized":true,"optimized_file":"vmFJfarchkyMAtwWn_f9d_f.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true,"xsmall":true}},{"id":"f10A_F","label":"Figure 10A-F","caption":"<b>Effect of MSDK on RUNX2, Î²1 integrin, NFÎºB and metabolic proteins.</b> After 21 days of MSDK treatment, western blot was performed to determine (<b>A</b>) RUNX2 expression of osteoblasts grown in transwell co-cultures, (<b>B</b>) RUNX2 expression of osteoblasts grown in layered co-culture, (<b>C</b>) Î²1 integrin expression of osteoblasts grown in transwell co-cultures, (<b>D</b>) Î²1 integrin expression of osteoblasts and osteoclasts grown in layered co-cultures (<b>E</b>) NFÎºB expression of osteoclasts grown in transwell co-cultures, and (<b>F</b>) NFÎºB expression of osteoblasts and osteoclasts grown in layered co-cultures. ","file":"vmFJfarchkyMAtwWn_f10a_f.png","url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/vmFJfarchkyMAtwWn_f10a_f.png","version":1,"optimized":true,"optimized_file":"vmFJfarchkyMAtwWn_f10a_f.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true,"xsmall":true}},{"id":"f10G_H","label":"Figure 10G-H","caption":"<b>Effect of MSDK on RUNX2, Î²1 integrin, NFÎºB and metabolic proteins.</b> Metabolic proteins such as PPARÎ³, GLUT4 and Insulin RÎ² expression were also measured in (<b>G</b>) osteoblasts grown in transwell co-cultures and (<b>H</b>) in osteoblasts and osteoclasts grown in layered co-cultures. Cell lysates were prepared on day 21 from the bottom (osteoblasts) and top (osteoclasts) chambers in the transwell co-culture and from the whole plate (both osteoblast and osteoclast) in the layered co-culture. Protein levels were normalized against Î²-actin and then to Os-/MSDK. Mean protein levels were analyzed and compared between groups (Os-/MSDK, Os+/Veh, Os+/MSDK). *=<i>p</i><.05, **=<i>p</i><.01 and **=<i>p</i><.001; One-way ANOVA followed by Bonferroniâs post-hoc multiple comparison <i>t</i>-test (n=6 per group).","file":"vmFJfarchkyMAtwWn_f10g_h.png","url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/vmFJfarchkyMAtwWn_f10g_h.png","version":1,"optimized":true,"optimized_file":"vmFJfarchkyMAtwWn_f10g_h.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true,"xsmall":true}},{"id":"f11","label":"Figure 11","caption":"<b>Effect of MSDK on adipose-derived mesenchymal stem cells.</b> Adipose-derived mesenchymal stem cells (AMSCs) were exposed to MSDK for 7 days (<b>A</b>), 8 days (<b>C</b>) or 14 days (<b>B</b>) to assess its effects on alkaline phosphatase (<b>A</b>) or alizarin red staining (<b>B, C</b>). Red color indicates calcium deposition by MSCs. Each bar represents the mean absorbance of alkaline phosphatase activity or alizarin red at 490nm for respective groups Os+/Veh; Os+/GSK126; Os+/MSDK; Os+/GSK126/MSDK repeated twice in triplicate (except for the alizarin red experiment at day 8). GSK 126 = S-adenosyl-methionine-competitive small molecule inhibitor of EZH2 methyltransferase is known to promote osteogenic differentiation of MSCs through effects on the osteoblast epigenome [<a href=\"#r49\"  class=\"anchor\">49</a>,<a href=\"#r50\"  class=\"anchor\">50</a>]. The observed co-stimulatory effects of MSDK and GSK126 suggest mechanistic synergy.","file":"vmFJfarchkyMAtwWn_f11.png","url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/vmFJfarchkyMAtwWn_f11.png","version":1,"optimized":true,"optimized_file":"vmFJfarchkyMAtwWn_f11.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true,"xsmall":true}},{"id":"f12","label":"Figure 12","caption":"<b>Potential mechanism underlying MSDK effects on bone formation.</b> The diagram illustrates regulatory and biological relationships between the indicated proteins and treatments.","file":"vmFJfarchkyMAtwWn_f12.png","url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/vmFJfarchkyMAtwWn_f12.png","version":2,"optimized":true,"optimized_file":"vmFJfarchkyMAtwWn_f12.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true,"xsmall":true}}]},"feature":false,"advance":false,"display":true,"title":"Melatonin-micronutrients Osteopenia Treatment Study (MOTS): a translational study assessing melatonin, strontium (citrate), vitamin D3 and vitamin K2 (MK7) on bone density, bone marker turnover and health related quality of life in postmenopausal osteopenic women following a one-year double-blind RCT and on osteoblast-osteoclast co-cultures","page_start":256,"page_end":285,"ids":{"pii":"101158","publisher":"101158","doi":"10.18632/aging.101158","pmid":"28130552"},"abstract":"<p>This one-year double blind randomized control trial assessed the effects of nightly melatonin, strontium (citrate), vitamin D3 and vitamin K2 (MK7; MSDK) on bone mineral density (BMD) and quality of life (QOL) in postmenopausal osteopenic women (ages 49-75). Compared to placebo, MSDK treatment increased BMD in lumbar spine (4.3%) and left femoral neck (2.2%), with an upward trend for total left hip (p=0.069). MSDK increased serum P1NP levels and reduced bone turnover (CTx:P1NP). Psychometric analyses indicated that mood and sleep quality improved for the MSDK group. MSDK-exposed human mesenchymal stem cells (hMSCs) and human peripheral blood monocytes (hPBMCs) plated in transwells or layered demonstrated increases in osteoblastogenesis, decreases in osteoclastogenesis, increases in OPG (TNFRSF11B) and decreases in RANKL (TNFSF11) levels. In transwell osteoblasts, MSDK increased pERK1/2 (MAPK1/MAPK3) and RUNX2 levels; decreased ERK5 (MAPK7); and did not affect the expression of NFÎºB (NFKB1) and Î²1integrin (ITGB1). In layered osteoblasts, MSDK also decreased expression of the metabolic proteins PPARÎ³ (PPARG) and GLUT4 (SLC2A4). In adipose-derived human MSCs, MSDK induced osteoblastogenesis. These findings provide both clinical and mechanistic support for the use of MSDK for the prevention or treatment of osteopenia, osteoporosis or other bone-related diseases.</p>","article_type":{"short_name":"research_paper","nlm_type":"research-article","plural":"Research Papers","_id":"wT5ZtRSAWar3BDa5e","name":"Research Paper"},"section":"ThGWnHeyhxdRzxfbA","affiliations":["Division of Pharmaceutical Sciences, Duquesne University School of Pharmacy, Pittsburgh, PA 15282, USA","Functional Medicine, Heart Preventics, LLC, Sequim, WA 98382, USA","Enderby Healthcare/Legal Consulting, LLC, Pittsburgh, PA 15102, USA","Department of Mathematics, Duquesne University School of Liberal Arts, Pittsburgh, PA 15282, USA","Mayo Clinic, Department of Orthopedic Surgery, Rochester, MN 55905, USA"],"dates":{"epub":"2017-01-26T05:00:00.000+0000"},"history":{"received":"2016-11-08T05:00:00.000+0000","accepted":"2017-01-15T05:00:00.000+0000"},"keywords":["osteopenia","melatonin","osteoblasts","osteoclasts","PPARÎ³","GLUT4","adipocytes"],"last_update":"2017-03-01T22:49:20.107+0000","authors":[{"name_first":"Sifat","name_middle":"","name_last":"Maria","name_suffix":"","equal_contrib":false,"ids":{},"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Mark H.","name_middle":"","name_last":"Swanson","name_suffix":"","equal_contrib":false,"ids":{"mongo_id":"S4Euu9DY9AscqHi5K"},"affiliations_numbers":[1],"author_notes_ids":[]},{"name_first":"Larry T.","name_middle":"","name_last":"Enderby","name_suffix":"","equal_contrib":false,"ids":{"mongo_id":"oMQZWZ5ierh3u6CTn"},"affiliations_numbers":[2],"author_notes_ids":[]},{"name_first":"Frank","name_middle":"","name_last":"DâAmico","name_suffix":"","equal_contrib":false,"ids":{"mongo_id":"DokoThgbDfTBSkABA"},"affiliations_numbers":[3],"author_notes_ids":[]},{"name_first":"Brianna","name_middle":"","name_last":"Enderby","name_suffix":"","equal_contrib":false,"ids":{"mongo_id":"oMQZWZ5ierh3u6CTn"},"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Rebekah M.","name_middle":"","name_last":"Samsonraj","name_suffix":"","equal_contrib":false,"ids":{"mongo_id":"kzwGhwQrKbnLAmdkg"},"affiliations_numbers":[4],"author_notes_ids":[]},{"name_first":"Amel","name_middle":"","name_last":"Dudakovic","name_suffix":"","equal_contrib":false,"ids":{"mongo_id":"2RibELWq7xugfyR2T"},"affiliations_numbers":[4],"author_notes_ids":[]},{"name_first":"Andre J.","name_middle":"","name_last":"van Wijnen","name_suffix":"","equal_contrib":false,"ids":{"mongo_id":"xFcJzMBvvLQGELq5Q"},"affiliations_numbers":[4],"author_notes_ids":[]},{"name_first":"Paula A.","name_middle":"","name_last":"Witt-Enderby","name_suffix":"","equal_contrib":false,"ids":{"mongo_id":"qbYcWGCFgjfMBdCw9"},"affiliations_numbers":[0],"author_notes_ids":[]}],"correspondence":[{"text":"Paula A. Witt-Enderby","email":"wittp@duq.edu"}],"pub_status":"ppublish","submissions":[{"submission_id":"BKfxipYxs3WQtqbQH","created_date":"2017-01-28T01:46:53.790+0000","pub_status":"aheadofprint"},{"submission_id":"PSvC952ShJ7WxJm6Y","created_date":"2017-02-02T03:14:19.782+0000","pub_status":"ppublish"}],"issue_id":"v7W2XFptR6AcdZCjZ","volume":9,"issue":"1","aop":false,"fullText":{"_id":"vmFJfarchkyMAtwWn","sections":[{"content":[{"content":"The menopausal transition, although a natural physiological phenomenon, is often accompanied by bone loss leading to osteoporosis and related fractures. Currently, about 9 million US adults suffer from osteoporosis and another 50 million from osteopenia. These numbers are predicted to increase up to 11.9 million for osteoporosis and 64.3 million for osteopenia by 2030 [<a href=\"#r1\"  class=\"anchor\">1</a>]. One in three women and one in five men over age 50 will experience an osteoporosis-related fracture worldwide [<a href=\"#r2\"  class=\"anchor\">2</a>]. Over half of all women in the U.S. above age 50 have osteopenia with a prevalence of approximately 3.4 times more than osteoporosis [<a href=\"#r3\"  class=\"anchor\">3</a>]. Consequently, twice the number of fractures arise from women with osteopenia as they represent almost 50% of the total population at risk [<a href=\"#r4\"  class=\"anchor\">4</a>]. Besides bone loss, women transitioning through menopause also experience disrupted sleep, depressed mood, higher levels of anxiety and stressful life events [<a href=\"#r5\"  class=\"anchor\">5</a>].","contentType":"p"},{"content":"Osteopenia is defined as below normal bone density and the precursor to osteoporosis, with a T-score -1 to -2.5 [<a href=\"#r1\"  class=\"anchor\">1</a>]. During the osteopenic period, bone loss usually progresses insidiously and unnoticed unless a fracture occurs. If a Dual Energy X-ray Absorptiometry (DXA) is performed, it can serve as the baseline bone mineral density (BMD) assessment for diagnosis and future monitoring. However, pharmacological treatment is typically delayed or given âwatchful waitingâ until the transition to osteoporosis is diagnosed (T-score -2.5 or less at the femoral neck/spine); or if there is a history of a previous hip or vertebral fracture; or if the T score is between -1.0 and -2.5 at the femoral neck/spine and the 10-year risk of hip fracture â¥ 3% or 10-year risk of major osteoporosis-related fracture â¥ 20% by Fracture Risk Assessment Tool (FRAX<sup>Â®</sup>) calculation. Based on these current guidelines, a majority of postmenopausal osteopenic women may not receive their first DXA screening until age 65 [<a href=\"#r6\"  class=\"anchor\">6</a>]. Thus, osteopenia often carries a significant treatment uncertainty during the time of the greatest fracture risk burden [<a href=\"#r3\"  class=\"anchor\">3</a>].","contentType":"p"},{"content":"The non-pharmacologic recommendation for osteopenia include calcium or vitamin D supplementation, which has proven to be largely ineffective for reducing the incidence of fractures or the prevention of osteoporosis. Also the combination of calcium plus vitamin D only slightly reduces the risk of hip and other fractures [<a href=\"#r7\"  class=\"anchor\">7</a>,<a href=\"#r8\"  class=\"anchor\">8</a>]. Most of the existing pharmaceutical bone loss therapies are treatment-focused rather than preventative and mainly target preventing further bone loss rather than enhancing new bone formation. A new non-invasive treatment focusing on bone anabolism during osteopenia would be a critical first step to begin as early as perimenopause for maintaining normal bone integrity and microarchitecture and to prevent future fractures [<a href=\"#r9\"  class=\"anchor\">9</a>]. In this study, we investigated whether our treatment- melatonin, strontium (citrate), vitamin D<sub>3</sub> and vitamin K<sub>2</sub> (MSDK) could provide a much-needed stopgap treatment and serve as a safe and effective modulator of anabolic bone formation and metabolism to improve the efficacy of pre-osteoporosis prevention.","contentType":"p"},{"content":"In the Melatonin-micronutrients Osteopenia Treatment Study (MOTS; NCT01870115), we examined whether melatonin added in combination with three other natural bone-protective micronutrients: strontium (citrate), vitamins D<sub>3</sub> and K<sub>2</sub> (MSDK) could improve bone health without affecting or even improving health related quality of life (hrQOL) in postmenopausal osteopenic women. The second goal was to identify potential mechanisms underlying MSDKâs action using human osteoblast and osteoclast co-culture models. Women with osteopenia were targeted because osteopenia accounts for the highest population burden of fractures [<a href=\"#r4\"  class=\"anchor\">4</a>,<a href=\"#r10\"  class=\"anchor\">10</a>]. A nutritional bone support supplement formulated with MSDK could address this population group and become readily available without prescription at a nominal cost.","contentType":"p"},{"content":"Melatonin is a chronotherapeutic hormone and nutritional supplement that has demonstrated efficacy to renormalize bone marker turnover in perimenopausal women [<a href=\"#r11\"  class=\"anchor\">11</a>] and increase bone density in postmenopausal women with osteopenia [<a href=\"#r12\"  class=\"anchor\">12</a>]. Strontium increased vertebral and femoral bone density and reduced fracture in both postmenopausal osteopenic and osteoporotic women [<a href=\"#r13\"  class=\"anchor\">13</a>,<a href=\"#r14\"  class=\"anchor\">14</a>]. Vitamin K<sub>2</sub> has been shown to prevent bone loss, reduce the incidence of vertebral fractures and modestly increase bone density in a postmenopausal cohort primarily by improving bone microarchitecture and the bone mineral/matrix ratio and also by preserving bone quality [<a href=\"#r15\"  class=\"anchor\">15</a>,<a href=\"#r16\"  class=\"anchor\">16</a>]. Combination of vitamin D<sub>3</sub> with K<sub>2</sub> has been shown to increase vertebral bone density in postmenopausal women [<a href=\"#r17\"  class=\"anchor\">17</a>,<a href=\"#r18\"  class=\"anchor\">18</a>]. Also, improved vitamin D<sub>3</sub> status in postmenopausal women has been shown to significantly enhance BMD response to strontium ranelate, particularly in the femoral neck [<a href=\"#r19\"  class=\"anchor\">19</a>]. The Combination of Micronutrients for Bone (COMB) study, using strontium (citrate) and vitamins D<sub>3</sub> and K<sub>2</sub> was at least as effective as bisphosphonates and strontium ranelate at increasing BMD in the hip, spine and femoral neck sites [<a href=\"#r20\"  class=\"anchor\">20</a>].","contentType":"p"},{"content":"The MOTS utilizes a safe, complementary, non-pharmacologic combination therapy based on the hypothesis of <i>chronosynergy -</i> novel treatment approach using several condition-targeted bone restorative agents with melatonin to reverse bone loss reducing the need for osteoporosis-related medications later. In addition to improving bone health outcomes, this novel therapy may reduce the cost of treating bone disease. In a recent study, the introduction of melatonin into an osteoporosis treatment formulary resulted in significant savings with respect to annual treatment costs [<a href=\"#r21\"  class=\"anchor\">21</a>] lowering the economic burden associated with bone loss therapies. With continued study and validation, MSDK could become an early treatment option in the time-course for managing postmenopausal and age-related bone loss.","contentType":"p"}],"title":"Introduction","type":null,"headerLevel":1},{"content":[{"content":[{"content":"<a href=\"#f1\"  class=\"anchor\">Figure 1</a> illustrates the summary of the participantsâ screening and enrollment processes. A total of 184 women responded of which 105 (57.1%) did not meet the inclusion and exclusion criteria. Individuals were excluded due to having either normal bone density T-score (7.6%), or being perimenopausal (2%), or by having osteoporosis with or without taking medications (32.4%), or being osteopenic but taking bisphosphonates or hormone therapy (7.6%). Other common reasons for exclusion included use of medications for blood pressure (25%), depression and anxiety (17%); having diseases such as ulcerative colitis, rheumatoid arthritis (7.6%); or smoking (1%). Among the 79 respondents invited to join the study, 29 (37%) came for the initial visit and the other 50 individuals (63%) chose not to participate for their own reasons such as the fear of being on placebo for one year (35%) or not being able to commit to the bimonthly visits (25%). At the initial appointment, another 6 women were excluded due to undiagnosed hypertension. Finally, 23 women were enrolled in the study and randomized into either placebo or treatment (MSDK). One subject withdrew the next day and was not included in the overall analysis because it had been determined that if a subject took <3 doses of the study supplements, then they would be replaced and not included in the analysis. Another two subjects (one from MSDK and one from placebo) withdrew at months 4 and 6, respectively. They were included in the analysis following intention-to-treat (ITT) principle. All women were self-identified as white.","contentType":"p"},{"content":{"caption":"<b>Flow chart of study subject recruitment and enrollment.</b><br>","id":"f1","label":"Figure 1","alt":"Flow chart of study subject recruitment and enrollment.","url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/vmFJfarchkyMAtwWn_f1.png","optimized_urls":{"original":"/img?size=original&img=vmFJfarchkyMAtwWn_f1.png&v=1","hero":"/img?size=hero&img=vmFJfarchkyMAtwWn_f1.png&v=1","large":"/img?size=large&img=vmFJfarchkyMAtwWn_f1.png&v=1","medium":"/img?size=medium&img=vmFJfarchkyMAtwWn_f1.png&v=1","small":"/img?size=small&img=vmFJfarchkyMAtwWn_f1.png&v=1","xsmall":"/img?size=xsmall&img=vmFJfarchkyMAtwWn_f1.png&v=1"}},"contentType":"figure"},{"content":"Our recruitment strategies resulted in a healthy postmenopausal population with an age range [58.6 yr. (49 -75)] and body composition relevant for their age and physical status. Their DXA and FRAX<sup>Â®</sup> scores represented an osteopenic population, with moderate risk of fracture. Except for baseline serum collagen type I cross- linked telopeptide (CTx) values and diastolic blood pressure in the MSDK cohort, all other parameters were similar between groups suggesting an overall and well-adjusted randomization. Psychological assessment suggested that all subjects had normal mental health with no significant anxiety, stress or depression. Nearly 87% subjects were taking either calcium/vitamin D<sub>3</sub>, multivitamins and/or other dietary supplements. Almost all subjects were healthy sleepers with active lifestyles (<a href=\"#t1\"  class=\"anchor\">Table 1</a>).","contentType":"p"},{"contentType":"table","id":"t1","table":"<tbody><tr><td rowspan=\"2\"></td><td rowspan=\"2\"><b>Un-stratified</b></td><td colspan=\"2\"><b>Stratified</b></td></tr><tr><td colspan=\"1\"><b>Placebo (n=11)</b></td><td><b>MSDK (n=11)</b></td></tr><tr><td>Age</td><td>58.6 Â± 1.12 (49-75)</td><td>57 Â± 1.41 (49-63)</td><td>60 Â± 1.73 (54-75)</td></tr><tr><td>Blood pressure (BP)</td><td></td><td></td><td></td></tr><tr><td>Systolic (mmHg)</td><td>118.1 Â± 2.47 (100-140)</td><td>118.8 Â± 3.29 (100-140)</td><td>117.4 Â± 3.83 (100-140)</td></tr><tr><td>Diastolic (mmHg)</td><td>73.4 Â± 1.24 (61-80)</td><td>70.91 Â± 1.76 (61-80)</td><td>75.91 Â± 1.44 (64-80)*</td></tr><tr><td>Height (cm)</td><td>166.6 Â± 1.64 (154.9-182.9)</td><td>170.2 Â± 2.13 (158.8-182.9)</td><td>163 Â± 2.06 (154.9-172.7)</td></tr><tr><td>Weight (lb)</td><td>144.6 Â± 4.83 (113.4-198)</td><td>147.9 Â± 6.68 (121.4-177.2)</td><td>141.2 Â± 7.16 (113.4-198)</td></tr><tr><td>BMI (kg/m<sup>2</sup>)</td><td>23.62 Â± 0.7 (19.5-31.7)</td><td>23.16 Â± 0.93 (19.6-28)</td><td>24.09 Â± 1.08 (19.5-31.5)</td></tr><tr><td>BMR (kcal/24h)</td><td>1319 Â± 23 (1162-1543)</td><td>1347 Â± 31.06 (1215-1509)</td><td>1291 Â± 33.16 (1162-1543)</td></tr><tr><td>Fat Mass (lb)</td><td>47.84 Â± 3.51 (24.2-91.6)</td><td>48.96 Â± 4.39 (33.2-75.6)</td><td>46.71 Â± 5.67 (24.2-91.6)</td></tr><tr><td>Fat (%)</td><td>32.3 Â± 1.32 (21.4-46.3)</td><td>32.52 Â± 1.59 (25.3-43.2)</td><td>32.08 Â± 2.18 (21.4-46.3)</td></tr><tr><td>Lean Body Mass (lb)</td><td>96.75 Â± 1.81 (83-112.4)</td><td>98.98 Â± 2.99 (83-112.4)</td><td>94.51 Â± 1.94 (85.8-106.4)</td></tr><tr><td>Total Body Water (lb)</td><td>70.8 Â± 1.32 (60.8-82.2)</td><td>72.45 Â± 2.18 (60.8-82.2)</td><td>69.14 Â± 1.42 (62.8-77.8)</td></tr><tr><td>BMD (DXA)</td><td></td><td></td><td></td></tr><tr><td>Femoral Neck (g/cm<sup>2</sup>)</td><td>0.641 Â± 0.01 (0.511-0.717)</td><td>0.641 Â± 0.02 (0.511-0.717)</td><td>0.636 Â± 0.01 (0.598-0.701)</td></tr><tr><td>Total Left Hip (g/cm<sup>2</sup>)</td><td>0.768 Â± 0.01 (0.641-0.859)</td><td>0.769 Â± 0.02 (0.641-0.859)</td><td>0.761 Â± 0.01 (0.704-0.845)</td></tr><tr><td>Lumbar Spine (g/cm<sup>2</sup>)</td><td>0.865 Â± 0.02 (0.771-1.108)</td><td>0.869 Â± 0.03 (0.782-1.108)</td><td>0.852 Â± 0.02 (0.771-0.938)</td></tr><tr><td>Achilles heel T-score</td><td>-1.2 Â± 0.21 [(-2.7)-(1.8)]</td><td>-1.14 Â± 0.36 [(-2.2)-(1.8)]</td><td>-1.27 Â± 0.24 [(-2.7)-(0.1)]</td></tr><tr><td>Previous fractures</td><td>8 (36%)</td><td>4 (36%)</td><td>4 (36%)</td></tr><tr><td>FRAX: major Osteoporotic</td><td>12.02 Â± 0.96 (6.1-24)</td><td>13.05 Â± 1.59 (6.1â24)</td><td>10.98 Â± 1.07 (6.7â16)</td></tr><tr><td>FRAX: Hip</td><td>1.71 Â± 0.33 (0.2-7.4)</td><td>1.92 Â± 0.61 (0.5â7.4)</td><td>1.51 Â± 0.28 (0.2â3.2)</td></tr><tr><td>Bone markers</td><td></td><td></td><td></td></tr><tr><td>P1NP (pg/mL)</td><td>45.71 Â± 5.24 (4.75-100.5)</td><td>46.41 Â± 6.31 (15.23-83.87)</td><td>44.95 Â± 8.91 (4.75â100.5)</td></tr><tr><td>Osteocalcin (ng/mL)</td><td>24.68 Â± 1.95 (9.78-52.89)</td><td>24.55 Â± 2.51 (9.77â36.03)</td><td>24.82 Â± 3.11 (16.17â52.9)</td></tr><tr><td>CTx (ng/mL)</td><td>8.78 Â± 0.85 (3.89-18.97)</td><td>7.08 Â± 0.84 (3.89-12.31)</td><td>10.48 Â± 1.33 (4.6â18.97)*</td></tr><tr><td>Vitamin D<sub>3</sub> (ng/mL)</td><td>16.72 Â± 4.71 (0.5-100.9)</td><td>20.77 Â± 8.77 (0.83â100.9)</td><td>12.68 Â± 3.59 (0.5â38.61)</td></tr><tr><td>CRP (ng/mL)</td><td>2334 Â± 962.7 (124.1-17974)</td><td>2018 Â± 1132 (124.1â11705)</td><td>2621 Â± 1573 (124.1â17974)</td></tr><tr><td>MENQOL</td><td></td><td></td><td></td></tr><tr><td>Vasomotor</td><td>2.71 Â± 0.36 (1-6)</td><td>2.61 Â± 0.56 (1â6)</td><td>2.82 Â± 0.47 (1â5)</td></tr><tr><td>Physical</td><td>2.72 Â± 0.27 (1.05-5.55)</td><td>2.75 Â± 0.36 (1.1â5.5)</td><td>2.69 Â± 0.42 (1.05â5.3)</td></tr><tr><td>Psychosocial</td><td>2.61 Â± 0.31 (1-6.67)</td><td>2.8 Â± 0.53 (1â6.67)</td><td>2.42 Â± 0.36 (1â4.5)</td></tr><tr><td>Sexual</td><td>2.94 Â± 0.39 (1-6.67)</td><td>2.97 Â± 0.49 (1-5)</td><td>2.91 Â± 0.63 (1â6.67)</td></tr><tr><td>STAI: State</td><td>30.82 Â± 2.28 (20-58)</td><td>28.45 Â± 3.34 (20â58)</td><td>33.18 Â± 3.11 (20â53)</td></tr><tr><td>STAI: Trait</td><td>34.41 Â± 2.25 (20-65)</td><td>33.82 Â± 3.71 (22â65)</td><td>35 Â± 2.75 (20â45)</td></tr><tr><td>PSS</td><td>11.73 Â± 1.71 (1-30)</td><td>11.45 Â± 2.39 (1â30)</td><td>12 Â± 2.56 (2â26)</td></tr><tr><td>CES-D</td><td>6.41 Â± 1.63 (0-37)</td><td>7.09 Â± 3.09 (0â37)</td><td>5.73 Â± 1.21 (1â13)</td></tr><tr><td>Calcium-vitamin D<sub>3</sub>/Multivitamins</td><td>19 (86.4%)</td><td>10 (90%)</td><td>9 (81.8%)</td></tr></tbody>","title":"<h4>Table 1. Baseline characteristics of study cohort un-stratified and stratified by treatment</h4>","footer":"<tfoot><tr><td colspan=\"100\">Mean Â± S.E.M. (Range). BMI= Body mass index; BMR= Basal metabolic rate; BMD= Bone mineral density; P1NP= Total procollagen type 1 amino-terminal propeptide; OC= Osteocalcin; CTx= Collagen Type I C-Telopeptide; MENQOL= Menopause specific Quality Of Life; STAI= State and Trait Anxiety Inventory; PSS= Perceived Stress Scale; CES-D= Center for Epidemiologic studies Depression. *<i>p</i> < 0.05 versus placebo.</td></tr></tfoot>"}],"title":"Recruitment","contentType":"subsection","headerLevel":2},{"content":[{"content":"Bone health was monitored over the course of the study by DXA; by assessing serum bone marker activity; and by measuring fracture risk probability using FRAX<sup>Â®</sup>. <a href=\"#f2\"  class=\"anchor\">Figure 2</a> indicates the mean change in BMD (g/cm<sup>2</sup>) from baseline to month 12 in the left femoral neck, total left hip and lumbar spine. In left femoral neck, participants in the MSDK group had an average BMD change of +0.015 (2.2%) over one year, whereas participants in the placebo group had an average BMD change of -0.023 (-3.6%). Data analyses showed significant differences between groups (<i>p=</i> 0.021) (<a href=\"#f2\"  class=\"anchor\">Fig. 2A</a>). In total left hip, MSDK and placebo group had average BMD changes of +0.039 (5.03%) and +0.017 (2.2%), respectively. Even though analysis showed no significant difference in BMD between groups in this area, a trend (<i>p</i>= 0.069) for improvement in the MSDK group existed (<a href=\"#f2\"  class=\"anchor\">Fig. 2B</a>). Women taking MSDK showed the most significant increase in BMD in the lumbar spine (L1-L4) area (<i>p</i>< 0.001 vs. placebo). Mean BMD changes in this area for MSDK and placebo groups were +0.035 (4.3%) and -0.029 (-3.2%), respectively (<a href=\"#f2\"  class=\"anchor\">Fig. 2C</a>). Corresponding T-score changes in the left femoral neck, total left hip and lumbar spine area are shown in <a href=\"#t2\"  class=\"anchor\">Table 2</a>. FRAX<sup>Â®</sup> assessments revealed that one year MSDK treatment significantly reduced major vertebral and non-vertebral osteoporotic fracture risk by 6.48% from baseline compared to the 10.82% increase observed in placebo (<i>p=</i> 0.008). No significant effects of MSDK on hip fracture risk were observed.","contentType":"p"},{"content":{"caption":"<b>Treatment effects on bone mineral density (BMD) in placebo and MSDK groups.</b> Bone mineral density in the left femoral neck, total left hip and lumbar spine was measured via DXA (n=11 per group). Each bar represents the mean (Â± S.E.M.) change in bone mineral density (g/cm<sup>2</sup>) from baseline to month 12 in the (<b>A</b>) left femoral neck, (<b>B</b>) total left hip and (<b>C</b>) lumbar spine (L1-L4) area, respectively for placebo (open bar) and MSDK (closed bars). *<i>p</i> â¤ 0.05 and ***<i>p</i> â¤ 0.001 versus placebo, unpaired one tailed <i>t</i>-test with Welchâs correction.<br>","id":"f2","label":"Figure 2","alt":"Treatment effects on bone mineral density (BMD) in placebo and MSDK groups. Bone mineral density in the left femoral neck, total left hip and lumbar spine was measured via DXA (n=11 per group). Each bar represents the mean (Â± S.E.M.) change in bone mineral density (g/cm2) from baseline to month 12 in the (A) left femoral neck, (B) total left hip and (C) lumbar spine (L1-L4) area, respectively for placebo (open bar) and MSDK (closed bars). *p â¤ 0.05 and ***p â¤ 0.001 versus placebo, unpaired one tailed t-test with Welchâs correction.","url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/vmFJfarchkyMAtwWn_f2.png","optimized_urls":{"original":"/img?size=original&img=vmFJfarchkyMAtwWn_f2.png&v=1","hero":"/img?size=hero&img=vmFJfarchkyMAtwWn_f2.png&v=1","large":"/img?size=large&img=vmFJfarchkyMAtwWn_f2.png&v=1","medium":"/img?size=medium&img=vmFJfarchkyMAtwWn_f2.png&v=1","small":"/img?size=small&img=vmFJfarchkyMAtwWn_f2.png&v=1","xsmall":"/img?size=xsmall&img=vmFJfarchkyMAtwWn_f2.png&v=1"}},"contentType":"figure"},{"contentType":"table","id":"t2","table":"<tbody><tr><td></td><td colspan=\"3\"><b>Placebo</b></td><td></td><td colspan=\"3\"><b>MSDK</b></td></tr><tr><td></td><td><b>Month 0</b></td><td><b>Month 12</b></td><td><b>Change</b></td><td></td><td><b>Month 0</b></td><td><b>Month 12</b></td><td><b>Change</b></td></tr><tr><td>T-Scores</td><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr><tr><td>Femoral Neck</td><td>-1.87</td><td>-2.13</td><td><b>-0.20 (0.09)</b></td><td></td><td>-1.88</td><td>-1.74</td><td><b>0.13 (0.12) *</b></td></tr><tr><td>Total Left Hip</td><td>-1.42</td><td>-1.33</td><td>0.16 (0.06)</td><td></td><td>-1.37</td><td>-1.02</td><td>0.35 (0.09)</td></tr><tr><td>Lumber Spine L1-L4</td><td>-1.61</td><td>-1.81</td><td><b>-0.25 (0.09)</b></td><td></td><td>-1.70</td><td>-1.39</td><td><b>0.31 (0.09)</b> ***</td></tr><tr><td>Achilles heel BMD (T-score)</td><td>-1.14</td><td>-1.29</td><td>-0.18 (0.13)</td><td></td><td>-1.27</td><td>-1.36</td><td>0.09 (0.11)</td></tr><tr><td>FRAX</td><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr><tr><td>Major Osteoporotic</td><td>13.05</td><td>14.79</td><td><b>1.73 (0.44)</b></td><td></td><td>10.98</td><td>10.6</td><td><b>-0.38 (0.56)</b> **</td></tr><tr><td>Hip</td><td>1.92</td><td>2.84</td><td>0.92 (0.33)</td><td></td><td>1.51</td><td>1.45</td><td>0.11 (0.31)</td></tr><tr><td>Height (cm)</td><td>170.18</td><td>169.82</td><td>-0.35 (0.18)</td><td></td><td>163.02</td><td>162.95</td><td>-0.08 (0.25)</td></tr><tr><td>Weight (lb)</td><td>147.95</td><td>148.71</td><td>0.76 (1.71)</td><td></td><td>141.22</td><td>143.31</td><td>1.20 (0.83)</td></tr><tr><td>BMI (kg/m<sup>2</sup>)</td><td>23.16</td><td>23.36</td><td>0.21 (0.32)</td><td></td><td>24.09</td><td>24.31</td><td>0.24 (0.16)</td></tr><tr><td>BMR (kcal/24h)</td><td>1347.36</td><td>1347.82</td><td>0.45 (7.37)</td><td></td><td>1291.27</td><td>1293.91</td><td>2.64 (3.32)</td></tr><tr><td>Fat Mass (lb)</td><td>48.96</td><td>49.8</td><td>0.84 (1.88)</td><td></td><td>46.71</td><td>47.78</td><td>1.07 (0.74)</td></tr><tr><td>Fat (%)</td><td>32.52</td><td>32.85</td><td>0.33 (0.89)</td><td></td><td>32.08</td><td>32.59</td><td>0.51 (0.54)</td></tr><tr><td>Lean Body Mass (lb)</td><td>98.98</td><td>98.9</td><td>-0.07 (0.63)</td><td></td><td>94.51</td><td>94.53</td><td>0.02 (0.97)</td></tr><tr><td>Total Body Water (lb)</td><td>72.45</td><td>72.38</td><td>-0.07 (0.46)</td><td></td><td>69.14</td><td>69.22</td><td>0.07 (0.73)</td></tr><tr><td>MENQOL</td><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr><tr><td>Â Â Â Â Â Vasomotor</td><td>2.61</td><td>2.30</td><td>-0.31 (0.48)</td><td></td><td>3.00</td><td>2.53</td><td>-0.47 (0.28)</td></tr><tr><td>Â Â Â Â Â Physical</td><td>2.75</td><td>2.43</td><td>-0.32 (0.24)</td><td></td><td>2.53</td><td>2.18</td><td>-0.34 (0.34)</td></tr><tr><td>Â Â Â Â Â Psychosocial</td><td>2.80</td><td>2.27</td><td>-0.53 (0.30)</td><td></td><td>2.22</td><td>2.10</td><td>-0.12 (0.39)</td></tr><tr><td>Â Â Â Â Â Sexual</td><td>2.97</td><td>2.70</td><td>-0.27 (0.31)</td><td></td><td>2.93</td><td>2.03</td><td>-0.90 (0.49)</td></tr><tr><td>STAI: Anxiety</td><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr><tr><td>Â Â Â Â Â State</td><td>28.45</td><td>28.4</td><td>-0.05 (1.09)</td><td></td><td>32.5</td><td>27.4</td><td>-5.10 (4.08)</td></tr><tr><td>Â Â Â Â Â Trait</td><td>33.82</td><td>30.1</td><td>-3.71 (1.80)</td><td></td><td>34.1</td><td>31.3</td><td>-2.80 (3.38)</td></tr><tr><td>PSS: Perceived stress</td><td>11.45</td><td>7.6</td><td>-3.85 (1.18)</td><td></td><td>11.5</td><td>10.7</td><td>-0.80 (2.03)</td></tr><tr><td>CES-D: Depression</td><td>7.09</td><td>5.2</td><td>-1.89 (0.86)</td><td></td><td>5.1</td><td>5</td><td>-0.10 (1.67)</td></tr><tr><td>Medication intake</td><td colspan=\"3\">90.03%</td><td></td><td colspan=\"3\">92.4%</td></tr><tr><td>Sleep duration (hr)</td><td colspan=\"3\">7.06 Â± 0.23 (range: 6.13-8.31)</td><td></td><td colspan=\"3\">6.85 Â± 0.27 (range: 4.85-7.97)</td></tr><tr><td>Exercise intensity</td><td colspan=\"3\">435 Â± 77.93 (range: 209-1036)</td><td></td><td colspan=\"3\">300.2 Â± 75.78 (range: 161-1044)</td></tr><tr><td>Multivitamins/<br/>OTC supplements</td><td colspan=\"3\">81.82%</td><td></td><td colspan=\"3\">81.82%</td></tr></tbody>","title":"<h4>Table 2. Treatment effects on bone density (T-scores), fracture risk probability (FRAX), body composition, psychometric parameters and general well-being</h4>","footer":"<tfoot><tr><td colspan=\"100\">Mean (Â± S.E.M.). BMD= Bone mineral density; BMI= Body mass index; BMR= Basal metabolic rate; MENQOL= Menopause specific Quality Of Life; STAI= State and Trait Anxiety Inventory; PSS= Perceived Stress Scale; CES-D= Center for Epidemiologic Studies Depression. *<i>p</i> < 0.05, **<i>p</i> < 0.01 and ***<i>p</i> < 0.001 versus placebo (n=11 per group).</td></tr></tfoot>"}],"title":"MSDK increases bone mineral density (BMD) in postmenopausal osteopenic women","contentType":"subsection","headerLevel":2},{"content":[{"content":"Participantsâ serum bone formation markers total procollagen type 1 amino-terminal propeptide (P1NP) and osteocalcin (OC; both intact and N-terminal mid-fragments) and the bone resorption marker collagen type I cross- linked telopeptide (CTx) were assessed every 6 months throughout the study to evaluate the change in bone marker status with treatment (<a href=\"#f3\"  class=\"anchor\">Fig. 3</a>). MSDK treatment significantly increased serum P1NP vs. placebo at month 6 (<i>p</i>= 0.023) and month 12 (<i>p</i>= 0.004). Serum P1NP levels varied widely within and between groups ranging from 25.04 to 151.9 pg/mL (average: 66.62 Â± 11.09) in MSDK and from 2.75 to 48.14 pg/mL (average: 31.76 Â± 4.75) in placebo at month 12 (<a href=\"#f3\"  class=\"anchor\">Fig. 3A</a>). Further analysis revealed that the mean increase in P1NP levels in the MSDK group primarily occurred during the first six months of the study (data not shown). Even though serum OC levels did not differ significantly between groups at any time, a gradual decrease in the level was observed in placebo but not in the MSDK group (<i>p</i>= 0.071 vs. MSDK at month 12). MSDK and placebo groups had average OC levels of 25.88 (Â± 2.5) ng/mL and 19.79 (Â± 1.21) ng/mL, respectively at month 12 (<a href=\"#f3\"  class=\"anchor\">Fig. 3B</a>). Even though serum CTx levels were significantly higher in the MSDK group at baseline, it remained steady throughout the study suggesting that either MSDK had no intrinsic effect on CTx or the dose of MSDK was not high enough to compensate for the higher baseline CTx level in this group. Average CTx levels at month 12 in MSDK and placebo groups were 8.99 (Â± 1.01) ng/mL and 5.65 (Â± 0.42) ng/mL, respectively (<a href=\"#f3\"  class=\"anchor\">Fig. 3C</a>).","contentType":"p"},{"content":{"caption":"<b>Treatment effects on serum bone marker turnover in placebo and MSDK groups.</b> Bone formation markers (<b>A</b>) total procollagen type 1 amino-terminal propeptide (P1NP) and (<b>B</b>) osteocalcin (OC; both intact and N-terminal mid-fragments), serum bone resorption marker (<b>C</b>) Collagen Type I C-Telopeptide (CTx) were measured at months 0, 6 and 12. Serum samples were collected from participants (n=11 per group) and bone markers concentrations were measured by sandwich ELISA assay using commercially available specific bone marker kits at all three time points. Each point in the line graph represents the least square mean (Â± S.E.M.) in the bone markers concentration for placebo (open circle, red) and treatment (closed box, blue). Scatter plots represent the ratio of (<b>D</b>) CTx: P1NP and (<b>E</b>) CTx: OC for each study subject, respectively, where the solid lines indicate the mean (Â± S.E.M.) value for each group. *<i>p</i> â¤ 0.05 and **<i>p</i> â¤0.01 versus placebo at similar time points. Longitudinal analysis for repeated measures using a generalized linear mixed model (GLMM) approach, considering groups and times as fixed effects and subjects nested within the groups as random.<br>","id":"f3","label":"Figure 3","alt":"Treatment effects on serum bone marker turnover in placebo and MSDK groups. Bone formation markers (A) total procollagen type 1 amino-terminal propeptide (P1NP) and (B) osteocalcin (OC; both intact and N-terminal mid-fragments), serum bone resorption marker (C) Collagen Type I C-Telopeptide (CTx) were measured at months 0, 6 and 12. Serum samples were collected from participants (n=11 per group) and bone markers concentrations were measured by sandwich ELISA assay using commercially available specific bone marker kits at all three time points. Each point in the line graph represents the least square mean (Â± S.E.M.) in the bone markers concentration for placebo (open circle, red) and treatment (closed box, blue). Scatter plots represent the ratio of (D) CTx: P1NP and (E) CTx: OC for each study subject, respectively, where the solid lines indicate the mean (Â± S.E.M.) value for each group. *p â¤ 0.05 and **p â¤0.01 versus placebo at similar time points. Longitudinal analysis for repeated measures using a generalized linear mixed model (GLMM) approach, considering groups and times as fixed effects and subjects nested within the groups as random.","url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/vmFJfarchkyMAtwWn_f3.png","optimized_urls":{"original":"/img?size=original&img=vmFJfarchkyMAtwWn_f3.png&v=1","hero":"/img?size=hero&img=vmFJfarchkyMAtwWn_f3.png&v=1","large":"/img?size=large&img=vmFJfarchkyMAtwWn_f3.png&v=1","medium":"/img?size=medium&img=vmFJfarchkyMAtwWn_f3.png&v=1","small":"/img?size=small&img=vmFJfarchkyMAtwWn_f3.png&v=1","xsmall":"/img?size=xsmall&img=vmFJfarchkyMAtwWn_f3.png&v=1"}},"contentType":"figure"},{"content":"Because osteoclast activity is tightly coupled to osteoblast activity [<a href=\"#r22\"  class=\"anchor\">22</a>], bone turnover was assessed by measuring the ratio of bone resorption (CTx) to bone formation (P1NP or OC). Despite having higher baseline CTx levels in the MSDK group compared to placebo, the ratio of CTx:P1NP in women taking MSDK demonstrated a time-dependent decrease whereas no time-dependent increases were observed in placebo (<a href=\"#f3\"  class=\"anchor\">Fig. 3D</a>). Though not significant, a similar trend was observed for CTx:OC (<a href=\"#f3\"  class=\"anchor\">Fig. 3E</a>). In summary, one year MSDK treatment significantly increased BMD in the left femoral neck and lumbar spine, with a trend towards improvement in the total left hip. Increased BMD was associated with increases in P1NP, decreases in bone marker turnover (âCTx:P1NP) and a reduction in the 10-year probability of major osteoporotic fracture risk.","contentType":"p"}],"title":"MSDK increases serum bone formation markers in postmenopausal osteopenic women","contentType":"subsection","headerLevel":2},{"content":[{"content":"<a href=\"#f4\"  class=\"anchor\">Figure 4</a> illustrates nocturnal urinary melatonin-sulfate levels assessed at month 12 as well as serum vitamin D<sub>3</sub> and C-reactive protein (CRP) levels assessed at months 0, 6 and 12. As shown in <a href=\"#f4\"  class=\"anchor\">figure 4A</a>, women taking MSDK had significantly higher levels of urinary melatonin-sulfate levels compared to placebo (<i>p</i>= 0.0463). In placebo, urinary melatonin-sulfate levels ranged from 0.43 to 17.69 ng/mL/hr (average: 4.19 Â± 1.83). Participants in the MSDK group showed wide variation in their nighttime melatonin-sulfate levels ranging from 73.13 to 2883 ng/mL/hr (average: 586.4 Â± 309.4) despite taking equal nightly doses. Melatonin levels were found to significantly correlate with lumbar spine BMD (<i>p</i>= 0.029; correlation co-efficient, r= 0.487; 95% CI= 0.0566 to 0.7648) supporting the requirement of daily melatonin for maintaining bone density.","contentType":"p"},{"content":{"caption":"<b>Treatment effects on urinary nocturnal melatonin, serum vitamin D<sub>3</sub> and serum C-reactive protein (CRP) level in placebo and MSDK groups.</b> (<b>A</b>) Nocturnal hourly melatonin secretion in the urine was measured at month 12 (n=10 per group), by collecting all urine samples between 10pm and 6am and measuring using urinary melatonin-sulfate ELISA kit. Each point in the scatter plots represents an individualâs urine melatonin-sulfate level, in placebo (open circle, red) or MSDK (closed circle, blue). *<i>p</i> â¤ 0.05 versus placebo at month 12; Unpaired one-tailed <i>t</i>-test with Welchâs correction. Serum levels of (<b>B</b>) Vitamin D<sub>3</sub> and (<b>C</b>) CRP were measured at months 0, 6 and 12, using specific ELISA kits. Each point in the scatter plots represents the concentration for a single subject at a specific time point, in the placebo (open circle, red) or MSDK (closed circle, blue). *<i>p</i> â¤ 0.05 versus placebo at similar time point; Longitudinal analysis for repeated measures using generalized linear mixed model (GLMM) approach, considering groups and times as fixed effects and subjects nested within the groups as random.<br>","id":"f4","label":"Figure 4","alt":"Treatment effects on urinary nocturnal melatonin, serum vitamin D3 and serum C-reactive protein (CRP) level in placebo and MSDK groups. (A) Nocturnal hourly melatonin secretion in the urine was measured at month 12 (n=10 per group), by collecting all urine samples between 10pm and 6am and measuring using urinary melatonin-sulfate ELISA kit. Each point in the scatter plots represents an individualâs urine melatonin-sulfate level, in placebo (open circle, red) or MSDK (closed circle, blue). *p â¤ 0.05 versus placebo at month 12; Unpaired one-tailed t-test with Welchâs correction. Serum levels of (B) Vitamin D3 and (C) CRP were measured at months 0, 6 and 12, using specific ELISA kits. Each point in the scatter plots represents the concentration for a single subject at a specific time point, in the placebo (open circle, red) or MSDK (closed circle, blue). *p â¤ 0.05 versus placebo at similar time point; Longitudinal analysis for repeated measures using generalized linear mixed model (GLMM) approach, considering groups and times as fixed effects and subjects nested within the groups as random.","url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/vmFJfarchkyMAtwWn_f4.png","optimized_urls":{"original":"/img?size=original&img=vmFJfarchkyMAtwWn_f4.png&v=1","hero":"/img?size=hero&img=vmFJfarchkyMAtwWn_f4.png&v=1","large":"/img?size=large&img=vmFJfarchkyMAtwWn_f4.png&v=1","medium":"/img?size=medium&img=vmFJfarchkyMAtwWn_f4.png&v=1","small":"/img?size=small&img=vmFJfarchkyMAtwWn_f4.png&v=1","xsmall":"/img?size=xsmall&img=vmFJfarchkyMAtwWn_f4.png&v=1"}},"contentType":"figure"},{"content":"Participantsâ serum vitamin D<sub>3</sub> levels were assessed at months 0, 6 and 12 (<a href=\"#f4\"  class=\"anchor\">Fig. 4B</a>). Even though participants were allowed to take up to 1000IU of a vitamin D3 supplement for ethical reasons regardless of treatment, no significant differences were observed between group at baseline and over each timepoint. However, both groups showed wide variability in their serum vitamin D<sub>3</sub> levels throughout the study ranging from 2.54 to 57.32 ng/mL (average: 20.19 Â± 5.84) in MSDK and from 0.5 to 38.59 ng/mL (average: 13.71 Â± 4.24) in placebo at month 12. Correlations between vitamin D<sub>3</sub> levels and bone resorption were performed since it was shown that low vitamin D<sub>3</sub> is associated with high CTx [<a href=\"#r23\"  class=\"anchor\">23</a>]. Similar to past-published studies, serum D<sub>3</sub> levels in our study negatively correlated with CTx levels (<i>p</i>= 0.024; r = -0.5011; 95% CI= -0.7724 to -0.0751). As shown in <a href=\"#f4\"  class=\"anchor\">figure 4C</a>, serum CRP levels varied widely within and between groups ranging from 124 to 1422 ng/mL (average: 573.1 Â± 154.7) in MSDK and from 124.1 to 6023 ng/mL (average: 1513 Â± 581.2) in placebo at month 12. Although serum CRP levels did not differ significantly within or between groups, those taking MSDK had low serum CRP at month 12, indicating a favorable effect of MSDK on inflammatory status.","contentType":"p"}],"title":"MSDK increases melatonin-sulfate levels in postmenopausal osteopenic women","contentType":"subsection","headerLevel":2},{"content":[{"content":"Morphometric analysis revealed that MSDK had no effect on overall body composition of subjects (<a href=\"#t2\"  class=\"anchor\">Table 2</a>); however, average height losses in MSDK and placebo groups were 0.08 cm and 0.35 cm, respectively (<i>p</i>= 0.38). Participants in the MSDK group showed less fluctuation in their weight change (F=4.248, DFn=10; <i>p</i>= 0.032), BMI change (F=4.112, DFn=10; <i>p</i>= 0.036), BMR change (F=4.936, DFn=10; <i>p</i>= 0.019) and fat mass change (F=6.409, DFn=10; <i>p</i>= 0.007) from baseline to month 12 compared to placebo. The lack of weight variation over time may produce favorable effects on bone mass as described [<a href=\"#r24\"  class=\"anchor\">24</a>].","contentType":"p"},{"content":"Psychometric analyses were conducted using validated questionnaires. No effect of MSDK on menopause quality of life, anxiety, stress or depression status were observed compared to placebo (<a href=\"#t2\"  class=\"anchor\">Table 2</a>). However, sexual domain scores began to move in opposite directions where a trend towards an improvement was observed in women taking MSDK and a trend towards worsening was observed in placebo (graph not shown). Sleep quality improved in women taking MSDK (<a href=\"#f5\"  class=\"anchor\">Fig. 5A</a>) indicated by 29% more positive/neutral comments made in the MSDK group vs. placebo (<i>p</i>< .0001). The relative risk ratio of a positive sleep statement for women taking MSDK was 2.5 (95% CI= 1.44 to 4.35), suggesting that the likelihood of a positive sleep statement is 150% higher in MSDK group compared to placebo. Although the women in MSDK group experienced an improvement in sleep quality, their sleep duration remained similar to placebo (<a href=\"#t2\"  class=\"anchor\">Table 2</a>). Average sleep time (in hours) for those taking MSDK or placebo was 6.85 hr and 7.06 hr, respectively. Regarding mood, more positive comments were made in the MSDK group (56%) compared to placebo (42%). Interestingly, all (100%) comments made about GI symptoms in the placebo group were negative whereas 87% were negative in the MSDK groupâa reduction of 13%. Regarding general aches and pains, the percentage of negative comments made in the MSDK group was 79% compared to 84% recorded for placebo. Statistical analyses revealed no significant impact of MSDK on GI symptoms and general aches/pains. Most of what was reported, positive or negative, had to do with their overall general well-being reported in their daily diaries (<a href=\"#f5\"  class=\"anchor\">Fig. 5A</a>).","contentType":"p"},{"content":{"caption":"<b>Treatment effects on participants' sleep quality, mood, GI upset and general aches/pains in placebo and MSDK groups.</b> (<b>A</b>) Total diary comments made by the participants in each group throughout the study were stratified into four categories: sleep, mood, GI upset and general aches/pains, as illustrated by the four segments in the pie diagram. Each category was sub-stratified as positive (pink), neutral (yellow) and negative (green) comments. Each portion represents the percent of total comments made under each category.<br>","id":"f5","label":"Figure 5","alt":"Treatment effects on participants' sleep quality, mood, GI upset and general aches/pains in placebo and MSDK groups. (A) Total diary comments made by the participants in each group throughout the study were stratified into four categories: sleep, mood, GI upset and general aches/pains, as illustrated by the four segments in the pie diagram. Each category was sub-stratified as positive (pink), neutral (yellow) and negative (green) comments. Each portion represents the percent of total comments made under each category.","url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/vmFJfarchkyMAtwWn_f5.png","optimized_urls":{"original":"/img?size=original&img=vmFJfarchkyMAtwWn_f5.png&v=1","hero":"/img?size=hero&img=vmFJfarchkyMAtwWn_f5.png&v=1","large":"/img?size=large&img=vmFJfarchkyMAtwWn_f5.png&v=1","medium":"/img?size=medium&img=vmFJfarchkyMAtwWn_f5.png&v=1","small":"/img?size=small&img=vmFJfarchkyMAtwWn_f5.png&v=1","xsmall":"/img?size=xsmall&img=vmFJfarchkyMAtwWn_f5.png&v=1"}},"contentType":"figure"},{"content":"Analysis of exercise time and intensity showed no significant differences between groups (<i>p</i>= 0.23). Most participants in the placebo group were involved in high intensity exercise whereas almost all MSDK participants were involved in light to moderate exercise. Both groups also had an equal intake of multivitamins/herbal supplements/OTC products (81.82%). Analysis of confounders revealed no significant differences between groups (<a href=\"#t2\"  class=\"anchor\">Table 2</a>).","contentType":"p"},{"content":"The fact that MSDK treatment did not worsen any of the subjective measures assessed could impact positively on compliance, which was high in our study (Placebo=90.03% and MSDK = 92.4%; <a href=\"#t2\"  class=\"anchor\">Table 2</a>). No incidence of adverse effects was reported from our participants in either group during their bimonthly check-ups or through their daily logs. Bimonthly assessment of blood pressure demonstrated that both systolic and diastolic levels remained in the normal range throughout the study even though baseline diastolic BP in the MSDK group was significantly higher than placebo (data not shown).","contentType":"p"}],"title":"MSDK improves morphometric and psychometric parameters in postmenopausal osteopenic women","contentType":"subsection","headerLevel":2},{"content":[{"content":"The increases in serum P1NP in the MSDK group could be the result of MSDK-mediated increases in osteoblastogenesis and decreases in osteoclastogenesis as demonstrated in the co-culture studies. Both alizarin red staining and tartrate resistant acid phosphatase (TRAP) assays indicated successful differentiation of human adult mesenchymal stem cells (hMSCs) into osteoblasts and human peripheral blood monocytes (hPBMCs) into osteoclasts when grown together as co-culture in presence of osteogenic (Os+) media. <a href=\"#f6A\"  class=\"anchor\">Figure 6A</a> represents calcium mineralization of osteoblasts grown in transwell co-culture. Human adult MSCs grown in growth media alone (Os-/Veh) or in presence of MSDK (Os-/MSDK) did not differentiate into osteoblasts as revealed by the absence of alizarin red staining. However, hMSCs exposed to osteogenic media containing MSDK (Os+/MSDK) differentiated into osteoblasts. We next investigated if the individual components of MSDK were capable of inducing osteoblast differentiation beyond that of osteogenic medium (Os+) alone. Melatonin, strontium citrate (SC), vitamin D<sub>3</sub> (D3) or vitamin K<sub>2</sub> (K2) were added to osteogenic (Os+) medium and alizarin red staining was measured. Melatonin was the only component that increased transwell osteoblast differentiation vs. osteogenic medium containing vehicle (Os+/Veh) (<a href=\"#f6A\"  class=\"anchor\">Fig. 6A</a> inset). Similar treatment effects on osteoblast differentiation were observed in the layered co-culture except that the extent of MSDK-mediated osteoblast differentiation was less compared to the transwell osteoblasts (<a href=\"#f6B\"  class=\"anchor\">Fig. 6B</a>) and both melatonin and strontium (citrate) induced osteoblast differentiation alone when compared to osteogenic medium containing vehicle (Os+/Veh) (<a href=\"#f6B\"  class=\"anchor\">Fig. 6B</a> inset).","contentType":"p"},{"content":{"caption":"","id":"f6A","label":"Figure 6A","alt":"Figure 6A","url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/vmFJfarchkyMAtwWn_f6a.png","optimized_urls":{"original":"/img?size=original&img=vmFJfarchkyMAtwWn_f6a.png&v=1","hero":"/img?size=hero&img=vmFJfarchkyMAtwWn_f6a.png&v=1","large":"/img?size=large&img=vmFJfarchkyMAtwWn_f6a.png&v=1","medium":"/img?size=medium&img=vmFJfarchkyMAtwWn_f6a.png&v=1","small":"/img?size=small&img=vmFJfarchkyMAtwWn_f6a.png&v=1","xsmall":"/img?size=xsmall&img=vmFJfarchkyMAtwWn_f6a.png&v=1"}},"contentType":"figure"},{"content":{"caption":"<b>Effect of MSDK on osteoblast-mediated calcium mineralization</b>. On day 21 of MSDK exposure, calcium deposition by differentiated, matured osteoblasts were evaluated via alizarin red staining on the (<b>A</b>) bottom chamber cells of transwell co-culture and (<b>B</b>) layered co-culture. Inset graph represents similar analysis in absence of Os+/MSDK. Each bar represents the mean concentration of alizarin red (Î¼M) for respective groups normalized against Os-/Veh (n=3; Transwell co-culture: ****=<i>p</i><.0001 vs. all groups, a=<i>p</i><.01 vs. Os-/Veh, b=<i>p</i><.05 vs. Os-/MSDK, c=<i>p</i><.05 vs. Os+/Veh; Layered co-culture: ****=<i>p</i><.0001 vs. all groups, a=<i>p</i><.01 vs. Os-/Veh, b=<i>p</i><.01 vs. Os-/MSDK, c=<i>p</i><.01 vs. Os-/Veh). Os- =basal media, Os+ =osteogenic media, Veh= vehicle, Mel= melatonin, SC= strontium citrate, D3= vitamin D<sub>3</sub> (Cholecalciferol), K2= vitamin K<sub>2</sub> (MK7).<br>","id":"f6B","label":"Figure 6B","alt":"Effect of MSDK on osteoblast-mediated calcium mineralization. On day 21 of MSDK exposure, calcium deposition by differentiated, matured osteoblasts were evaluated via alizarin red staining on the (A) bottom chamber cells of transwell co-culture and (B) layered co-culture. Inset graph represents similar analysis in absence of Os+/MSDK. Each bar represents the mean concentration of alizarin red (Î¼M) for respective groups normalized against Os-/Veh (n=3; Transwell co-culture: ****=pppppppp3 (Cholecalciferol), K2= vitamin K2 (MK7).","url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/vmFJfarchkyMAtwWn_f6b.png","optimized_urls":{"original":"/img?size=original&img=vmFJfarchkyMAtwWn_f6b.png&v=1","hero":"/img?size=hero&img=vmFJfarchkyMAtwWn_f6b.png&v=1","large":"/img?size=large&img=vmFJfarchkyMAtwWn_f6b.png&v=1","medium":"/img?size=medium&img=vmFJfarchkyMAtwWn_f6b.png&v=1","small":"/img?size=small&img=vmFJfarchkyMAtwWn_f6b.png&v=1","xsmall":"/img?size=xsmall&img=vmFJfarchkyMAtwWn_f6b.png&v=1"}},"contentType":"figure"},{"content":"The effect of MSDK on TRAP levels was measured since TRAP is an well-known marker for terminally differentiated osteoclasts and their bone resorption activity [<a href=\"#r25\"  class=\"anchor\">25</a>,<a href=\"#r26\"  class=\"anchor\">26</a>]. <a href=\"#f7\"  class=\"anchor\">Figure 7A</a> demonstrates an MSDK-mediated inhibitory effect on transwell osteoclastic TRAP releasing activity, which was not observed in layered co-culture or when the components were given alone (<a href=\"#f7\"  class=\"anchor\">Fig. 7B</a>). These findings indicate that the direct interaction between osteoblasts and osteoclasts modulate each othersâ activityâdirect contact between human mesenchymal stem cells and peripheral blood monocytes undergoing differentiation into osteoblasts or osteoclasts attenuated MSDK-mediated increases in osteoblastogenesis and attenuated osteoclastogenesis, respectively.","contentType":"p"},{"content":{"caption":"<b>Effect of MSDK on osteoclast differentiation.</b> On day 21 of MSDK exposure, TRAP releasing activity by differentiated, mature osteoclasts was evaluated by quantitative Tartrate Resistant Acid Phosphatase (TRAP) assay on the (<b>A</b>) top chamber cells of transwell co-culture and (<b>B</b>) layered co-culture. Each bar represents the mean fluorescence reading of TRAP (at 405nm ex, 515nm em) for respective groups normalized against Os-/Veh (n=3; Transwell co-culture: **=<i>p</i><.01 vs. Os-/Veh; Layered co-culture: *=<i>p</i><.05 vs. Os-/Veh). Os- =basal media, Os+ =osteogenic media, Veh= vehicle, Mel= melatonin, SC= strontium citrate, D3= vitamin D<sub>3</sub> (Cholecalciferol), K2= vitamin K<sub>2</sub> (MK7).<br>","id":"f7","label":"Figure 7","alt":"Effect of MSDK on osteoclast differentiation. On day 21 of MSDK exposure, TRAP releasing activity by differentiated, mature osteoclasts was evaluated by quantitative Tartrate Resistant Acid Phosphatase (TRAP) assay on the (A) top chamber cells of transwell co-culture and (B) layered co-culture. Each bar represents the mean fluorescence reading of TRAP (at 405nm ex, 515nm em) for respective groups normalized against Os-/Veh (n=3; Transwell co-culture: **=pp3 (Cholecalciferol), K2= vitamin K2 (MK7).","url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/vmFJfarchkyMAtwWn_f7.png","optimized_urls":{"original":"/img?size=original&img=vmFJfarchkyMAtwWn_f7.png&v=1","hero":"/img?size=hero&img=vmFJfarchkyMAtwWn_f7.png&v=1","large":"/img?size=large&img=vmFJfarchkyMAtwWn_f7.png&v=1","medium":"/img?size=medium&img=vmFJfarchkyMAtwWn_f7.png&v=1","small":"/img?size=small&img=vmFJfarchkyMAtwWn_f7.png&v=1","xsmall":"/img?size=xsmall&img=vmFJfarchkyMAtwWn_f7.png&v=1"}},"contentType":"figure"}],"title":"MSDK increases osteoblastogenesis and decrease osteoclastogenesis in co-cultures of hMSCs and hPBMCs","contentType":"subsection","headerLevel":2},{"content":[{"content":"Figure 8 illustrates the effect of MSDK on osteoprotegerin (OPG) and receptor activator of nuclear factor kappa-B ligand (RANKL)âsignaling proteins known to modulate osteoclast activity and differentiation. As shown in figure 8Ai, MSDK increased the ratio of OPG:RANKL in transwell osteoblasts compared to Os+/Veh; this was due to increases in OPG (Fig. 8Aii) and decreases in RANKL (Fig. 8Aiii). Similar effects were observed when hMSCs were grown as monolayers (Fig. 8Ci and ii); in the absence of hPBMCs except that RANKL protein remained unchanged (Fig. 8Ciii) at levels similar to control. Interestingly, when human mesenchymal stem cells (hMSCs) were cultured in direct contact with peripheral blood monocytes (hPBMCs), no MSDK-mediated increases in the ratio of OPG:RANKL occurred (Fig. 8Bi); no further enhancement of OPG (Fig. 8Bii) or decrease in RANKL (Fig. 8Biii) occurred vs. osteogenic medium containing vehicle (Os+/Veh).","contentType":"p"},{"content":"The attenuation of osteoclastogenesis in transwell co-cultures vs. layered may be due to the secretory pattern of osteoprotegerin (sOPG) from the osteoblast rather than sRANKL (<a href=\"#f8D_G\"  class=\"anchor\">Figs. 8D, 8E</a>). For example, Os+/Veh and Os+/MSDK in both the transwells (<a href=\"#f8D_G\"  class=\"anchor\">Fig. 8D</a>) and monocultures (<a href=\"#f8D_G\"  class=\"anchor\">Fig. 8E</a>) induced sRANKL compared to Os-/MSDK. High sRANKL (Figs. 8Diii, 8Eiii) under these conditions should increase osteoclastogenesis, but this did not occur as shown in <a href=\"#f7\"  class=\"anchor\">figure 7</a>. In fact, osteoclastogenesis was inhibited in both co-cultures in the presence of osteogenic medium and, even more so, in the transwell co-cultures containing MSDK. The fact that osteoprotegerin was the only protein modulated by MSDK and that its level correlated with osteoclastogenesis suggests that secreted osteoprotegerin and <u>not</u> secreted RANKL was modulating osteoclastogenesis. The presence of the osteoclast in the transwell co-culture is probably modulating OPG release from the osteoblast because secreted OPG levels in hMSC monocultures decreased in response to MSDK. Perhaps, the inhibition of osteoclastogenesis observed in the transwell co-cultures was due to OPG-mediated decreases in free RANKL; this would decrease RANK activation on osteoclasts attenuating osteoclastogenesis and activity. Another possibility is that differential processing of RANKL by proteinases located on the osteoblasts creates soluble RANKL products less capable of generating osteoclasts [<a href=\"#r27\"  class=\"anchor\">27</a>]. This is supported in <a href=\"#f8D_G\"  class=\"anchor\">figure 8F</a> demonstrating the formation of different RANKL peptide fragments, particularly the 25kDa (Fig. 8Fi and 8G) and 24kDa fragments (Fig. 8Fii), which indicates ectodomain shedding by a disintegrin and metalloproteinase domain-containing protein (ADAM) 10 or matrix metalloproteinase (MMP) 14 [<a href=\"#r28\"  class=\"anchor\">28</a>].","contentType":"p"},{"content":{"caption":"<b>Effect of MSDK on sOPG and sRANKL expression in osteoblasts grown in transwell co-cultures, layered co-cultures and hMSCs monocultures.</b> After 21 days of MSDK exposure, OPG and RANKL expression in osteoblasts was measured by western blot in (<b>A</b>) transwell co-cultures, (<b>B</b>) layered co-cultures and (<b>C</b>) hMSCs monocultures. Cell lysates were prepared on day 21 from the bottom (osteoblasts) and top (osteoclasts) chambers in the transwell co-culture and from the whole plate (both osteoblast and osteoclast) in the layered co-culture. Protein levels were normalized against Î²-actin and then to Os-/MSDK. Mean expression of (<b>i</b>) OPG: RANKL, (<b>ii</b>) OPG and (<b>iii</b>) RANKL in each culture were analyzed, normalized against Os-/MSDK and compared between groups (Os-/MSDK, Os+/Veh, Os+/MSDK). <br>","id":"f8A_C","label":"Figure 8A-C","alt":"Effect of MSDK on sOPG and sRANKL expression in osteoblasts grown in transwell co-cultures, layered co-cultures and hMSCs monocultures. After 21 days of MSDK exposure, OPG and RANKL expression in osteoblasts was measured by western blot in (A) transwell co-cultures, (B) layered co-cultures and (C) hMSCs monocultures. Cell lysates were prepared on day 21 from the bottom (osteoblasts) and top (osteoclasts) chambers in the transwell co-culture and from the whole plate (both osteoblast and osteoclast) in the layered co-culture. Protein levels were normalized against Î²-actin and then to Os-/MSDK. Mean expression of (i) OPG: RANKL, (ii) OPG and (iii) RANKL in each culture were analyzed, normalized against Os-/MSDK and compared between groups (Os-/MSDK, Os+/Veh, Os+/MSDK). ","url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/vmFJfarchkyMAtwWn_f8a_c.png","optimized_urls":{"original":"/img?size=original&img=vmFJfarchkyMAtwWn_f8a_c.png&v=1","hero":"/img?size=hero&img=vmFJfarchkyMAtwWn_f8a_c.png&v=1","large":"/img?size=large&img=vmFJfarchkyMAtwWn_f8a_c.png&v=1","medium":"/img?size=medium&img=vmFJfarchkyMAtwWn_f8a_c.png&v=1","small":"/img?size=small&img=vmFJfarchkyMAtwWn_f8a_c.png&v=1","xsmall":"/img?size=xsmall&img=vmFJfarchkyMAtwWn_f8a_c.png&v=1"}},"contentType":"figure"},{"content":{"caption":"<b>Effect of MSDK on sOPG and sRANKL expression in osteoblasts grown in transwell co-cultures, layered co-cultures and hMSCs monocultures.</b> Treatments effects on secreted OPG (sOPG) and RANKL (sRANKL) were measured by ELISA in (<b>D</b>) transwells and (<b>E</b>) monocultures. Mean concentrations (pg/mL) of (<b>i</b>) sOPG: sRANKL, (<b>ii</b>) sOPG and (<b>iii</b>) sRANKL in culture media were analyzed, normalized against Os-/MSDK and compared between groups. Treatment effects on RANKL processing were detected via western blot by measuring the mean osteoblastâs expression of (<b>i</b>) 25 KDa and (<b>ii</b>) 24 KDa RANKL fragments in (<b>F</b>) transwells; and (<b>G</b>) 24 KDa RANKL fragment in layered co-cultures. *=<i>p</i><.05, **=<i>p</i><.01 and ***=<i>p</i><.001; One-way ANOVA followed by Bonferroniâs post-hoc multiple comparison <i>t</i>-test (n=6 per group).<br>","id":"f8D_G","label":"Figure 8D-G","alt":"Effect of MSDK on sOPG and sRANKL expression in osteoblasts grown in transwell co-cultures, layered co-cultures and hMSCs monocultures. Treatments effects on secreted OPG (sOPG) and RANKL (sRANKL) were measured by ELISA in (D) transwells and (E) monocultures. Mean concentrations (pg/mL) of (i) sOPG: sRANKL, (ii) sOPG and (iii) sRANKL in culture media were analyzed, normalized against Os-/MSDK and compared between groups. Treatment effects on RANKL processing were detected via western blot by measuring the mean osteoblastâs expression of (i) 25 KDa and (ii) 24 KDa RANKL fragments in (F) transwells; and (G) 24 KDa RANKL fragment in layered co-cultures. *=pppt-test (n=6 per group).","url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/vmFJfarchkyMAtwWn_f8d_g.png","optimized_urls":{"original":"/img?size=original&img=vmFJfarchkyMAtwWn_f8d_g.png&v=1","hero":"/img?size=hero&img=vmFJfarchkyMAtwWn_f8d_g.png&v=1","large":"/img?size=large&img=vmFJfarchkyMAtwWn_f8d_g.png&v=1","medium":"/img?size=medium&img=vmFJfarchkyMAtwWn_f8d_g.png&v=1","small":"/img?size=small&img=vmFJfarchkyMAtwWn_f8d_g.png&v=1","xsmall":"/img?size=xsmall&img=vmFJfarchkyMAtwWn_f8d_g.png&v=1"}},"contentType":"figure"}],"title":"MSDK modulates OPG and RANKL levels in co-cultures of hMSCs and hPBMCs dependent upon the type of culturing conditionâlayered or transwell","contentType":"subsection","headerLevel":2},{"content":[{"content":"<a href=\"#f9A_C\"  class=\"anchor\">Figures 9A and B</a> illustrate the effect of MSDK on ERK1/2âsignaling proteins known to modulate osteoblast differentiation [<a href=\"#r29\"  class=\"anchor\">29</a>-<a href=\"#r33\"  class=\"anchor\">33</a>]. MSDK primarily enhanced ERK1/2 activity (pERK1/2) and down-regulated total ERK1/2 (tERK1/2) in osteoblasts. Similar effects occurred in the layered co-cultures containing both osteoblasts and osteoclasts (<a href=\"#f9A_C\"  class=\"anchor\">Fig. 9B</a>). Previous studies have also shown that ERK5 plays a role in both osteoblast and osteoclast function and differentiation [<a href=\"#r34\"  class=\"anchor\">34</a>-<a href=\"#r36\"  class=\"anchor\">36</a>]. Therefore, MSDK effects on ERK5 in all three-cell culture modelsâtranswell, layered and monolayersâwere assessed. <a href=\"#f9A_C\"  class=\"anchor\">Figure 9C</a> illustrates the effect of MSDK on transwell osteoblastic ERK5 expression. As shown, hMSCs exposed to osteogenic (Os+) medium alone had decreased pERK5 activity compared to growth medium containing MSDK (Os-/MSDK), which was not due to decreases in total ERK5 (tERK5) levels. The addition of MSDK to the Os+ media produced an increase in pERK5 relative to Os+/Veh; however, this may be due to decreases in tERK5 since levels decreased when compared to Os-/MSDK. Interestingly, when human mesenchymal stem cells (hMSCs) were cultured in direct contact with peripheral blood monocytes (hPBMCs) (layered), no changes in pERK5 or tERK5 occurred (<a href=\"#f9D_F\"  class=\"anchor\">Fig. 9D</a>). It appears that the presence of the osteoclast exerts an inhibitory influence over osteoblastic pERK5 because when hMSCs were grown in the absence of osteoclasts, MSDK increased pERK5 and tERK5 (<a href=\"#f9D_F\"  class=\"anchor\">Fig. 9E</a>). Another alternative could be that MSDK exerts an opposite effect on pERK5 in periopheral blood monocytes compared to mesenchymal stem cells and because layered co-cultures contain both osteoblasts and osteoclasts, the net effect of MSDK would be zero. This idea is supported in <a href=\"#f9D_F\"  class=\"anchor\">figure 9F</a> demonstrating a trend towards increase in transwell osteoclastic pERK5 in response to MSDK.","contentType":"p"},{"content":{"caption":"<b>Effect of MSDK on MAPKs, ERK1/2 and ERK5.</b> After 21 days of MSDK exposure, western blot was performed to determine (<b>A</b>) ERK1/2 expression of osteoblasts grown as transwell co-cultures, (<b>B</b>) ERK1/2 expression of osteoblasts and osteoclasts grown as layered co-cultures, (<b>C</b>) ERK5 expression of osteoblasts grown as transwell co-cultures. <br>","id":"f9A_C","label":"Figure 9A-C","alt":"Effect of MSDK on MAPKs, ERK1/2 and ERK5. After 21 days of MSDK exposure, western blot was performed to determine (A) ERK1/2 expression of osteoblasts grown as transwell co-cultures, (B) ERK1/2 expression of osteoblasts and osteoclasts grown as layered co-cultures, (C) ERK5 expression of osteoblasts grown as transwell co-cultures. ","url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/vmFJfarchkyMAtwWn_f9a_c.png","optimized_urls":{"original":"/img?size=original&img=vmFJfarchkyMAtwWn_f9a_c.png&v=1","hero":"/img?size=hero&img=vmFJfarchkyMAtwWn_f9a_c.png&v=1","large":"/img?size=large&img=vmFJfarchkyMAtwWn_f9a_c.png&v=1","medium":"/img?size=medium&img=vmFJfarchkyMAtwWn_f9a_c.png&v=1","small":"/img?size=small&img=vmFJfarchkyMAtwWn_f9a_c.png&v=1","xsmall":"/img?size=xsmall&img=vmFJfarchkyMAtwWn_f9a_c.png&v=1"}},"contentType":"figure"},{"content":{"caption":"<b>Effect of MSDK on MAPKs, ERK1/2 and ERK5.</b> (<b>D</b>) ERK5 expression of osteoblasts and osteoclasts grown in layered co-culture, (<b>E</b>) ERK5 expression of osteoblasts in hMSCs mono-culture and (<b>F</b>) phospho-ERK5 expression of osteoclasts grown in transwell co-culture. Cell lysates were prepared on day 21 from the bottom (osteoblasts) and top (osteoclasts) chambers in the transwell co-culture and from the whole plate (both osteoblast and osteoclast) in the layered co-culture. Protein levels were normalized against Î²-actin and then to Os-/MSDK. Mean expression of (<b>i</b>) phospho-ERK: total-ERK (<b>ii</b>) phospho-ERK (<b>iii</b>) total-ERK in each co-cultures were analyzed and compared between groups (Os-/MSDK, Os+/Veh, Os+/MSDK). *=<i>p</i><.05, **=<i>p</i><.01 and **=<i>p</i><.001; One-way ANOVA followed by Bonferroniâs post-hoc multiple comparison <i>t</i>-test (n=6 per group).<br>","id":"f9D_F","label":"Figure 9D-F","alt":"Effect of MSDK on MAPKs, ERK1/2 and ERK5. (D) ERK5 expression of osteoblasts and osteoclasts grown in layered co-culture, (E) ERK5 expression of osteoblasts in hMSCs mono-culture and (F) phospho-ERK5 expression of osteoclasts grown in transwell co-culture. Cell lysates were prepared on day 21 from the bottom (osteoblasts) and top (osteoclasts) chambers in the transwell co-culture and from the whole plate (both osteoblast and osteoclast) in the layered co-culture. Protein levels were normalized against Î²-actin and then to Os-/MSDK. Mean expression of (i) phospho-ERK: total-ERK (ii) phospho-ERK (iii) total-ERK in each co-cultures were analyzed and compared between groups (Os-/MSDK, Os+/Veh, Os+/MSDK). *=pppt-test (n=6 per group).","url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/vmFJfarchkyMAtwWn_f9d_f.png","optimized_urls":{"original":"/img?size=original&img=vmFJfarchkyMAtwWn_f9d_f.png&v=1","hero":"/img?size=hero&img=vmFJfarchkyMAtwWn_f9d_f.png&v=1","large":"/img?size=large&img=vmFJfarchkyMAtwWn_f9d_f.png&v=1","medium":"/img?size=medium&img=vmFJfarchkyMAtwWn_f9d_f.png&v=1","small":"/img?size=small&img=vmFJfarchkyMAtwWn_f9d_f.png&v=1","xsmall":"/img?size=xsmall&img=vmFJfarchkyMAtwWn_f9d_f.png&v=1"}},"contentType":"figure"}],"title":"MSDK modulates pERK1/2 and pERK5 levels in co-cultures of hMSCs and hPBMCs dependent upon the type of culturing conditionâlayered or transwell","contentType":"subsection","headerLevel":2},{"content":[{"content":"<a href=\"#f10A_F\"  class=\"anchor\">Figures 10A and B</a> illustrate the effect of MSDK on Runt-related transcription factor 2 (RUNX2)âthe master regulator of osteogenesis [<a href=\"#r31\"  class=\"anchor\">31</a>,<a href=\"#r32\"  class=\"anchor\">32</a>] regulated by MAPKs [<a href=\"#r31\"  class=\"anchor\">31</a>,<a href=\"#r32\"  class=\"anchor\">32</a>] and melatonin in osteoblasts differentiated from hMSCs [<a href=\"#r33\"  class=\"anchor\">33</a>] and in bone [<a href=\"#r37\"  class=\"anchor\">37</a>,<a href=\"#r38\"  class=\"anchor\">38</a>]. Like many of the other proteins studied, the type of co-culture dictated the responses to MSDK. For example, MSDK enhanced RUNX2 expression in transwell osteoblasts beyond that induced by Os+/Veh (<a href=\"#f10A_F\"  class=\"anchor\">Fig. 10A</a>). However, in layered osteoblasts, MSDK did not further enhance RUNX2 expression induced by Os+/Veh (<a href=\"#f10A_F\"  class=\"anchor\">Fig. 10B</a>). The latter may be due to the possibility that maximal levels of RUNX2 expression may already have been attained.","contentType":"p"},{"content":{"caption":"<b>Effect of MSDK on RUNX2, Î²1 integrin, NFÎºB and metabolic proteins.</b> After 21 days of MSDK treatment, western blot was performed to determine (<b>A</b>) RUNX2 expression of osteoblasts grown in transwell co-cultures, (<b>B</b>) RUNX2 expression of osteoblasts grown in layered co-culture, (<b>C</b>) Î²1 integrin expression of osteoblasts grown in transwell co-cultures, (<b>D</b>) Î²1 integrin expression of osteoblasts and osteoclasts grown in layered co-cultures (<b>E</b>) NFÎºB expression of osteoclasts grown in transwell co-cultures, and (<b>F</b>) NFÎºB expression of osteoblasts and osteoclasts grown in layered co-cultures. <br>","id":"f10A_F","label":"Figure 10A-F","alt":"Effect of MSDK on RUNX2, Î²1 integrin, NFÎºB and metabolic proteins. After 21 days of MSDK treatment, western blot was performed to determine (A) RUNX2 expression of osteoblasts grown in transwell co-cultures, (B) RUNX2 expression of osteoblasts grown in layered co-culture, (C) Î²1 integrin expression of osteoblasts grown in transwell co-cultures, (D) Î²1 integrin expression of osteoblasts and osteoclasts grown in layered co-cultures (E) NFÎºB expression of osteoclasts grown in transwell co-cultures, and (F) NFÎºB expression of osteoblasts and osteoclasts grown in layered co-cultures. ","url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/vmFJfarchkyMAtwWn_f10a_f.png","optimized_urls":{"original":"/img?size=original&img=vmFJfarchkyMAtwWn_f10a_f.png&v=1","hero":"/img?size=hero&img=vmFJfarchkyMAtwWn_f10a_f.png&v=1","large":"/img?size=large&img=vmFJfarchkyMAtwWn_f10a_f.png&v=1","medium":"/img?size=medium&img=vmFJfarchkyMAtwWn_f10a_f.png&v=1","small":"/img?size=small&img=vmFJfarchkyMAtwWn_f10a_f.png&v=1","xsmall":"/img?size=xsmall&img=vmFJfarchkyMAtwWn_f10a_f.png&v=1"}},"contentType":"figure"}],"title":"MSDK modulates RUNX2 levels in co-cultures of hMSCs and hPBMCs dependent upon the type of culturing conditionâlayered or transwell","contentType":"subsection","headerLevel":2},{"content":[{"content":"<a href=\"#f10A_F\"  class=\"anchor\">Figures 10C and D</a> illustrate the effect of MSDK on Î²1integrinâproteins demonstrated to regulate the interaction between bone cells and extracellular matrix and thus control different aspects of bone cell growth and activity [<a href=\"#r39\"  class=\"anchor\">39</a>]. The use of these two different co-culture models permitted exploration of the roles of MSDK on cell matrix proteins especially in layered co-cultures where osteoblasts and osteoclasts are in direct contact with each other during the differentiation process. As shown in <a href=\"#f10A_F\"  class=\"anchor\">figures 10C and 10D</a>, the effect of osteogenic (Os+) medium alone on Î²1 integrin expression was opposite in effect depending on the type of co-cultureâosteogenic medium alone (Os+/Veh) induced osteoblastic Î²1 integrin levels in the layered co-culture (<a href=\"#f10A_F\"  class=\"anchor\">Fig. 10D</a>) but decreased its levels in transwell osteoblasts (<a href=\"#f10A_F\"  class=\"anchor\">Fig. 10C</a>). The addition of MSDK to the osteogenic medium did not further increase or decrease Î²1 integrin levels in either co-culture.","contentType":"p"}],"title":"MSDK did not modulate Î²1 integrin level in co-cultures of hMSCs and hPBMCs","contentType":"subsection","headerLevel":2},{"content":[{"content":"<a href=\"#f10A_F\"  class=\"anchor\">Figure 10E</a> demonstrates the effect of MSDK on nuclear factor-ÎºB (NFÎºB)âa protein shown to play a vital role in RANK-mediated osteoclastogenesis [<a href=\"#r40\"  class=\"anchor\">40</a>-<a href=\"#r42\"  class=\"anchor\">42</a>] and osteoblastogenesis [<a href=\"#r43\"  class=\"anchor\">43</a>,<a href=\"#r44\"  class=\"anchor\">44</a>]. As shown in <a href=\"#f10A_F\"  class=\"anchor\">figure 10E</a>, peripheral blood monocytes (hPBMCs) grown as transwell co-cultures with mesenchymal stem cells (hMSCs) exposed to osteogenic (Os+) medium containing MSDK demonstrated significant increases in NFÎºB compared to growth medium containing MSDK (Os-/MSDK) or osteogenic medium containing vehicle (Os+/Veh). No increases in NFÎºB occurred in the presence of osteogenic medium (Os+/Veh) alone. In contrast, exposure to osteogenic medium alone (Os+/Veh) increased NFÎºB levels in layered co-cultures but no further enhancement occurred in presence of MSDK (<a href=\"#f10A_F\"  class=\"anchor\">Fig. 10F</a><b>)</b>. The effects of Os+/MSDK on NFÎºB levels in transwell osteoclasts are not easily explained considering that this same culture condition (transwell and Os+/MSDK) decreased osteoclastogenesis (<a href=\"#f7\"  class=\"anchor\">Fig. 7A</a>).","contentType":"p"}],"title":"MSDK modulates NFÎºB levels in co-cultures of hMSCs and hPBMCs dependent upon the type of culturing conditionâlayered or transwell","contentType":"subsection","headerLevel":2},{"content":[{"content":"<a href=\"#f10G_H\"  class=\"anchor\">Figure 10G and H</a> illustrate the effect of MSDK on peroxisome proliferator-activated receptor gamma (PPARÎ³), glucose transporter type 4 (GLUT4) and the beta subunit of insulin receptor (Insulin RÎ²)âmetabolic proteins shown to modulate bone cell differentiation and activity [<a href=\"#r45\"  class=\"anchor\">45</a>-<a href=\"#r48\"  class=\"anchor\">48</a>]. Again, the type of culturing condition played vital roles in their expression in osteoblasts exposed to MSDK. For example, MSDK inhibited PPARÎ³ and GLUT4 levels in layered osteoblasts compared to cells exposed to osteogenic medium alone (<a href=\"#f10G_H\"  class=\"anchor\">Fig. 10H</a>), but not in transwell osteoblasts (<a href=\"#f10G_H\"  class=\"anchor\">Fig. 10G</a>). Insulin RÎ² levels, though, were only modulated in transwell osteoblasts exposed to osteogenic medium alone (<a href=\"#f10G_H\"  class=\"anchor\">Fig. 10G</a>). No effect on Insulin RÎ² levels occurred in layered osteoblasts in response to any of the treatments <b>(</b><a href=\"#f10G_H\"  class=\"anchor\">Fig. 10H</a>).","contentType":"p"},{"content":{"caption":"<b>Effect of MSDK on RUNX2, Î²1 integrin, NFÎºB and metabolic proteins.</b> Metabolic proteins such as PPARÎ³, GLUT4 and Insulin RÎ² expression were also measured in (<b>G</b>) osteoblasts grown in transwell co-cultures and (<b>H</b>) in osteoblasts and osteoclasts grown in layered co-cultures. Cell lysates were prepared on day 21 from the bottom (osteoblasts) and top (osteoclasts) chambers in the transwell co-culture and from the whole plate (both osteoblast and osteoclast) in the layered co-culture. Protein levels were normalized against Î²-actin and then to Os-/MSDK. Mean protein levels were analyzed and compared between groups (Os-/MSDK, Os+/Veh, Os+/MSDK). *=<i>p</i><.05, **=<i>p</i><.01 and **=<i>p</i><.001; One-way ANOVA followed by Bonferroniâs post-hoc multiple comparison <i>t</i>-test (n=6 per group).<br>","id":"f10G_H","label":"Figure 10G-H","alt":"Effect of MSDK on RUNX2, Î²1 integrin, NFÎºB and metabolic proteins. Metabolic proteins such as PPARÎ³, GLUT4 and Insulin RÎ² expression were also measured in (G) osteoblasts grown in transwell co-cultures and (H) in osteoblasts and osteoclasts grown in layered co-cultures. Cell lysates were prepared on day 21 from the bottom (osteoblasts) and top (osteoclasts) chambers in the transwell co-culture and from the whole plate (both osteoblast and osteoclast) in the layered co-culture. Protein levels were normalized against Î²-actin and then to Os-/MSDK. Mean protein levels were analyzed and compared between groups (Os-/MSDK, Os+/Veh, Os+/MSDK). *=pppt-test (n=6 per group).","url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/vmFJfarchkyMAtwWn_f10g_h.png","optimized_urls":{"original":"/img?size=original&img=vmFJfarchkyMAtwWn_f10g_h.png&v=1","hero":"/img?size=hero&img=vmFJfarchkyMAtwWn_f10g_h.png&v=1","large":"/img?size=large&img=vmFJfarchkyMAtwWn_f10g_h.png&v=1","medium":"/img?size=medium&img=vmFJfarchkyMAtwWn_f10g_h.png&v=1","small":"/img?size=small&img=vmFJfarchkyMAtwWn_f10g_h.png&v=1","xsmall":"/img?size=xsmall&img=vmFJfarchkyMAtwWn_f10g_h.png&v=1"}},"contentType":"figure"}],"title":"<b>MSDK modulates PPAR</b>Î³ <b>and GLUT4 levels in co-cultures of hMSCs and hPBMCs dependent upon the type of culturing conditionâlayered or transwell</b>","contentType":"subsection","headerLevel":2},{"content":[{"content":"Because MSDK produced important changes in PPARÎ³ and GLUT4âproteins known to play important roles in the switch from adipogenesis to osteogenesisâMSDK effects on adipose-derived mesenchymal stem cells (MSCs) were assessed. As shown in <a href=\"#f11\"  class=\"anchor\">figure 11</a>, MSDK in combination with osteogenic medium (OS+/MSDK) strongly induced osteoblast differentiation of human adipose-derived mesenchymal stem cells reflected by increases in alkaline phosphatase levels at day 7 (<a href=\"#f11\"  class=\"anchor\">Fig. 11A</a>), and increases in alizarin red staining at day 8 (<a href=\"#f11\"  class=\"anchor\">Fig. 11C</a>), which peaked by day 14 (<a href=\"#f11\"  class=\"anchor\">Fig. 11B</a>). Interestingly, we observed that MSDK effects were strongly enhanced in the presence of GSK126, an inhibitor of EZH2, a lysine methyl transferase. Because EZH2 is known to suppress osteogenic differentiation of MSCs and inhibit maturation of osteoblasts limiting bone accrual <i>in vivo</i> [<a href=\"#r49\"  class=\"anchor\">49</a>,<a href=\"#r50\"  class=\"anchor\">50</a>], the MSDK regimen mechanistically synergizes with EZH2-mediated epigenetic control of bone cell differentiation.","contentType":"p"},{"content":{"caption":"<b>Effect of MSDK on adipose-derived mesenchymal stem cells.</b> Adipose-derived mesenchymal stem cells (AMSCs) were exposed to MSDK for 7 days (<b>A</b>), 8 days (<b>C</b>) or 14 days (<b>B</b>) to assess its effects on alkaline phosphatase (<b>A</b>) or alizarin red staining (<b>B, C</b>). Red color indicates calcium deposition by MSCs. Each bar represents the mean absorbance of alkaline phosphatase activity or alizarin red at 490nm for respective groups Os+/Veh; Os+/GSK126; Os+/MSDK; Os+/GSK126/MSDK repeated twice in triplicate (except for the alizarin red experiment at day 8). GSK 126 = S-adenosyl-methionine-competitive small molecule inhibitor of EZH2 methyltransferase is known to promote osteogenic differentiation of MSCs through effects on the osteoblast epigenome [<a href=\"#r49\"  class=\"anchor\">49</a>,<a href=\"#r50\"  class=\"anchor\">50</a>]. The observed co-stimulatory effects of MSDK and GSK126 suggest mechanistic synergy.<br>","id":"f11","label":"Figure 11","alt":"Effect of MSDK on adipose-derived mesenchymal stem cells. Adipose-derived mesenchymal stem cells (AMSCs) were exposed to MSDK for 7 days (A), 8 days (C) or 14 days (B) to assess its effects on alkaline phosphatase (A) or alizarin red staining (B, C). Red color indicates calcium deposition by MSCs. Each bar represents the mean absorbance of alkaline phosphatase activity or alizarin red at 490nm for respective groups Os+/Veh; Os+/GSK126; Os+/MSDK; Os+/GSK126/MSDK repeated twice in triplicate (except for the alizarin red experiment at day 8). GSK 126 = S-adenosyl-methionine-competitive small molecule inhibitor of EZH2 methyltransferase is known to promote osteogenic differentiation of MSCs through effects on the osteoblast epigenome [49,50]. The observed co-stimulatory effects of MSDK and GSK126 suggest mechanistic synergy.","url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/vmFJfarchkyMAtwWn_f11.png","optimized_urls":{"original":"/img?size=original&img=vmFJfarchkyMAtwWn_f11.png&v=1","hero":"/img?size=hero&img=vmFJfarchkyMAtwWn_f11.png&v=1","large":"/img?size=large&img=vmFJfarchkyMAtwWn_f11.png&v=1","medium":"/img?size=medium&img=vmFJfarchkyMAtwWn_f11.png&v=1","small":"/img?size=small&img=vmFJfarchkyMAtwWn_f11.png&v=1","xsmall":"/img?size=xsmall&img=vmFJfarchkyMAtwWn_f11.png&v=1"}},"contentType":"figure"}],"title":"MSDK induces osteoblastogenesis in hAMSCs","contentType":"subsection","headerLevel":2}],"title":"Results","type":null,"headerLevel":1},{"content":[{"content":"Women begin to experience bone loss during late perimenopause, which continues even after menopause. In fact, half of the bone loss observed in women during the course of their lifetime occurs during the first 10 years postmenopause [<a href=\"#r51\"  class=\"anchor\">51</a>]. Our study is one of the first addressing the need for starting bone intervention therapies earlier to reverse bone loss in an osteopenic population. This is important because although the recurrent fracture rates are high in osteoporosis, new fractures predominantly arise in the osteopenic population [<a href=\"#r4\"  class=\"anchor\">4</a>,<a href=\"#r10\"  class=\"anchor\">10</a>]. Therefore, this shift to earlier intervention starting with osteopenia rather than osteoporosis may lead to the prevention of most fractures observed worldwide. In our study, osteopenic women taking MSDK for one year had a significant improvement in their left femoral neck and lumbar spine BMD and demonstrated a lower risk for a major osteoporotic fracture risk compared to women taking placebo. This is consistent with previous studies that demonstrate an increased BMD using melatonin alone [<a href=\"#r12\"  class=\"anchor\">12</a>], strontium alone [<a href=\"#r13\"  class=\"anchor\">13</a>,<a href=\"#r14\"  class=\"anchor\">14</a>] or combination vitamin D<sub>3</sub> and vitamin K<sub>2</sub> [<a href=\"#r17\"  class=\"anchor\">17</a>,<a href=\"#r18\"  class=\"anchor\">18</a>] or combination strontium citrate, vitamins K<sub>2</sub> and D<sub>3</sub> [<a href=\"#r20\"  class=\"anchor\">20</a>]. MSDK was found to be less effective in improving hip BMD, perhaps due to the kinetics of bone remodeling in long vs. flat bones [<a href=\"#r52\"  class=\"anchor\">52</a>]. Concomitant with the increases in BMD were increases in serum P1NP levels resulting in decreases in bone marker turnover (âCTx:P1NP)âthis was not observed in clinical studies using melatonin. In the Treatment of Osteopenia with Melatonin (MelaOst) study, one year dosing with melatonin (1mg, 3mg) demonstrated positive effects on femoral neck bone density in postmenopausal women with osteopenia [<a href=\"#r12\"  class=\"anchor\">12</a>,<a href=\"#r53\"  class=\"anchor\">53</a>]; however, no changes in any of the serum bone markers tested occurred. These findings from the MelaOst study, though important, suggest that the mechanism for melatonin-induced increases in BMD may be through calcium-mediated bone mineralization, which may produce a ceiling effect of melatonin alone on improving bone health if taken for long periods of time. Also, the higher dose of melatonin in the MOTS may be producing other beneficial effects on bone through melatoninâs anti-oxidant properties. The changes in serum P1NP is most likely due to strontium (citrate) component of MSDK since strontium (ranelate) in The Spinal Osteoporosis Therapeutic Intervention (SOTI) study increased bone-specific alkaline phosphatase (BSAP) by 8.1% [<a href=\"#r14\"  class=\"anchor\">14</a>]. In the MOTS, decreases in the ratio of bone resorption to bone formation (i.e., âCTx:P1NP) suggest that MSDK may be renormalizing bone marker turnover towards equilibrium resulting in increases in BMD and, if taken for extended periods of time, may continue to reverse bone loss through the aging process. Because P1NP is a marker of bone formation, the MSDK-mediated increases in P1NP may reflect increases in osteoblast differentiation. Although seasonal variation of vitamin D3 occurs [<a href=\"#r71\"  class=\"anchor\">71</a>] which could impact on serum CTx levels [<a href=\"#r23\"  class=\"anchor\">23</a>], both vitamin D3 and CTx levels remained similar between groups at all timepoints despite the fact that we enrolled and assessed participantsâ serum vitamin D3 and CTx levels between August 2013 to April 2015.","contentType":"p"},{"content":"This concept is supported in the human osteoblast and osteoclast co-culture studiesâboth transwell and layeredâdemonstrating that combination MSDK induced osteoblastogenesis to a much greater extent than that induced by melatonin or strontium (citrate) alone and that only combination MSDK inhibited osteoclastogenesis. The differences in the robustness of MSDKâs effects on osteoblast and osteoclast differentiation (i.e., greater increase in transwell osteoblast differentiation vs. layered; greater decrease in layered osteoclast differentiation vs. transwell), could be explained by the types of signaling pathways activated (pERK1/2, pERK5 and RUNX2) in transwell osteoblasts. This interpretation is supported by the findings that MSDK exposure induced transwell osteoblast pERK1/2, pERK5, and RUNX2 expression. Based on previous studies [<a href=\"#r29\"  class=\"anchor\">29</a>,<a href=\"#r33\"  class=\"anchor\">33</a>] and the MOTS, we propose that MSDK, through ERK1/2/5-mediated increases in RUNX2 expression in transwell human mesenchymal stem cells, increases their differentiation into osteoblasts. Because other pathways, such as p38, JNK, BMPs, canonical WNT also regulate RUNX2 transcriptional activity [<a href=\"#r54\"  class=\"anchor\">54</a>-<a href=\"#r56\"  class=\"anchor\">56</a>], these pathways cannot be ruled out and require further investigation.","contentType":"p"},{"content":"MSDK treatment triggered osteoblasts to produce more osteoprotegerin and less RANKL in the transwell co-cultures. The relative expression of osteoprotegerin and RANKL in osteoblasts is a critical transition point for balancing bone mineralization [<a href=\"#r41\"  class=\"anchor\">41</a>]. MSDK is more than likely balancing osteoblast and osteoclast activities, initially, through its differentiating effects on osteoblasts and then begins to modulate RANKL-mediated osteoclastogenesis through osteoblast-mediated osteoprotegerin expression to maintain appropriate bone remodeling. This concept is corroborated in the MOTS demonstrating a steady level of CTx throughout MSDK treatment. Besides being reduced as osteoblasts mature, RANKL can go through various stages of processing to regulate osteoclast activation; this processing is generated from the ectodomain shedding of membrane-bound RANKL via the action of MMP 3, 7 and 14 and ADAM 10, 17 (or TACE) and 19 [<a href=\"#r27\"  class=\"anchor\">27</a>,<a href=\"#r42\"  class=\"anchor\">42</a>]. In our study, MSDK, in combination with osteogenic (Os+) medium, decreased the 25kDa RANKL peptide fragment in transwell co-cultures indicative of a facilitation of ADAM 10âs catalytic activity [<a href=\"#r28\"  class=\"anchor\">28</a>]. In addition to MSDKâs effect on osteoblasts, osteoclast-mediated modulation of osteoblast differentiation may be occurring through paracrine factors released by osteoclasts (e.g., IGF1 and IGF2, FGF2, TGFB1 and TGFB2, BMP2, -3, -4, -6 and -7, PDGF) to favor osteoblast formation in transwells or through the osteoblast-osteoclast contact-dependent ephrin-signaling pathway [<a href=\"#r57\"  class=\"anchor\">57</a>-<a href=\"#r59\"  class=\"anchor\">59</a>].","contentType":"p"},{"content":"Bone loss therapies often fail to produce their desired effect because of poor compliance and limited adherence to the treatments. One study showed that the compliance rate for taking osteoporosis medications was <80%, as measured by the medication possession ratio (MPR), and this was associated with a 17% increase in fracture rate [<a href=\"#r60\"  class=\"anchor\">60</a>]. In our study, MSDK resulted in high (92%) compliance. Two of the participants dropped out from the studyâone from the placebo group and another from the MSDK group due to general illness. This is in contrast to the Combination of Micronutrients for Bone (COMB) study, which had lower complianceâabout 37 out of 114 patients (32.45%) in the COMB did not comply with the therapy [<a href=\"#r20\"  class=\"anchor\">20</a>]. The cohort differences between COMB and MOTS were study size (n=114 vs. n=20 respectively) and the baseline bone density status (osteoporosis vs. osteopenia respectively). Higher doses of strontium (citrate; 680 mg) and vitamin K<sub>2</sub> (100 mcg) were used in COMB compared to our study, which used 450 mg of strontium (citrate) and 60 mcg of vitamin K<sub>2</sub>. Also unique to our study is the inclusion of melatonin, which has been shown to restore bone marker balance [<a href=\"#r11\"  class=\"anchor\">11</a>]. Melatonin is an efficacious agent for entraining sleep rhythms and this fact could improve compliance due to the positive reinforcing effects of melatonin on sleep quality and mood. This is supported in the MOTS, in which 29% more positive/neutral comments about sleep and 14% more positive comments about mood were made in the MSDK group vs. placebo. Besides melatonin, the strontium (citrate) component in MSDK may be contributing to improvements of quality of life. In the SOTI trial, quality of life slightly improved using QualiOst which persisted for up to 4 years as reviewed [<a href=\"#r61\"  class=\"anchor\">61</a>]. Besides affecting compliance, melatoninâs ability to regulate sleep rhythms may be improving bone health. In postmenopausal women, poor sleep quality, specifically going to bed at a later bedtime, sleeping late into the morning and frequent daytime napping was associated with low BMD [<a href=\"#r62\"  class=\"anchor\">62</a>]. The melatonin component in MSDK may be keeping bone rhythms synchronized with the light/dark cycle preventing osteopenia and osteoporosis.","contentType":"p"},{"content":"As of today, no data are available regarding an appropriate therapeutic range for melatonin to produce positive effects on bone. Women taking the MSDK supplements (which contained 5mg melatonin) had ~140 times more nocturnal melatonin than women taking placebo. In fact women taking placebo had very low endogenous nocturnal urinary melatonin-sulfate levels consistent with reports showing low melatonin levels in an aged and menopausal population [<a href=\"#r63\"  class=\"anchor\">63</a>,<a href=\"#r64\"  class=\"anchor\">64</a>]. Even though women in the MSDK group took supplements at night for a year, their urinary melatonin-sulfate levels varied, possibly due to the differences in bioavailability similar to what was seen in males (range: 10%-56% in men; mean 33%) [<a href=\"#r65\"  class=\"anchor\">65</a>]. This study observed a direct relationship between urinary melatonin-sulfate levels and lumbar spine BMD similar to the findings of Amstrup and colleagues showing a dose-dependent effect of melatonin on femoral neck BMD [<a href=\"#r12\"  class=\"anchor\">12</a>]. Therefore, exogenous melatonin supplementation could play an important role in maintaining bone density in postmenopausal osteopenic women.","contentType":"p"},{"content":"After one year of MSDK treatment, CRP levels of the participants dropped below 1.4mg/L with a mean group value of 0.57mg/L compared to the placebo mean value of 1.5mg/L. A reduction in CRP levels by MSDK could imply a possible anti-inflammatory role of MSDK, aiding in the bone health and other diseases such as cardiovascular and metabolic disorders as reported [<a href=\"#r66\"  class=\"anchor\">66</a>-<a href=\"#r70\"  class=\"anchor\">70</a>]. Moreover, MSDK treatment did not have any worsening effect on blood pressure, indicating its relative safety in postmenopausal population in terms of cardiovascular events.","contentType":"p"},{"content":"Morphometric analyses were conducted to determine if any changes in body morphometry occurred in response to MSDK. Although no significant changes occurred in response to MSDK treatment when compared to placebo, there was less weight variance throughout the year in the MSDK group compared to placebo group (<i>p</i>= 0.032). Perhaps MSDK, most likely through melatonin, works to stabilize weight fluctuation, which could provide some bone protection. Dramatic changes in weight can contribute to increases in bone turnover and decreases in bone mass [<a href=\"#r24\"  class=\"anchor\">24</a>]; and mature women with a BMI lower than 18kg/m<sup>2</sup> are estimated to have more than 30% bone loss than normal women of same age [<a href=\"#r72\"  class=\"anchor\">72</a>]. In the MelaOst trial, postmenopausal osteopenic women taking melatonin had a decrease in total fat mass and trended towards an increase in lean body mass [<a href=\"#r53\"  class=\"anchor\">53</a>]. This shifting away from adipogenesis towards osteogenesis may explain, in part, MSDKâs actions on bone, which is supported in the co-cultures studies using human mesenchymal stem cells and peripheral blood monocytes but also in the adipocyte derived mesenchymal stem cells.","contentType":"p"},{"content":"PPARÎ³, although a key regulator in adipogenesis, energy expenditure and lipid, glucose, and insulin metabolism, produces undesirable effects on bone. High levels of PPARÎ³ may cause bone loss by switching the fate of mesenchymal stem cells towards adipogenesis rather than osteoblastogenesis [<a href=\"#r45\"  class=\"anchor\">45</a>] resulting in increased fat content in the bone or increased RANKL production [<a href=\"#r45\"  class=\"anchor\">45</a>,<a href=\"#r73\"  class=\"anchor\">73</a>]; low levels of PPARÎ³ increase bone mass by enhancing osteoblastogenesis [<a href=\"#r45\"  class=\"anchor\">45</a>,<a href=\"#r47\"  class=\"anchor\">47</a>,<a href=\"#r74\"  class=\"anchor\">74</a>]. In layered osteoblasts, MSDK inhibited both PPARÎ³ and GLUT4 expression induced by osteogenic medium in layered osteoblasts. These findings for PPARÎ³ are consistent with other studies using melatonin and strontium (ranelate) on osteoblastogenesis [<a href=\"#r75\"  class=\"anchor\">75</a>,<a href=\"#r76\"  class=\"anchor\">76</a>]. Correlations between PPARÎ³ and GLUT4 expression have been observed in other studies [<a href=\"#r77\"  class=\"anchor\">77</a>,<a href=\"#r78\"  class=\"anchor\">78</a>]. The findings that melatonin improved femoral bone mineral density [<a href=\"#r12\"  class=\"anchor\">12</a>] and decreased total fat mass [<a href=\"#r53\"  class=\"anchor\">53</a>] in postmenopausal osteopenic women and that MSDK increased BMD and demonstrated a reduction in weight fluctuation in a similar cohort suggests that MSDK may be inducing new bone formation by modulating the metabolic parameters in human mesenchymal stem cells. Specifically, MSDK may be driving mesenchymal stem cells down to osteogenic rather than adipogenic lineage through the downregulation of PPARÎ³ and GLUT4 in adipose-derived mesenchymal stem cells where MSDK induced their differentiation into osteoblasts. This is also supported by our findings in adipocytes-derived mesenchymal stem cells where MSDK induced their differentiation into osteoblasts.","contentType":"p"},{"content":"In conclusion, combination melatonin, strontium (citrate), vitamin D<sub>3</sub> and vitamin K<sub>2</sub> significantly increased lumbar spine BMD by 4.3% and left femoral neck BMD by 2.2%, with a trend (p=0.069) towards an increase in hip BMD from baseline after one year in postmenopausal osteopenic women. The 10-year vertebral fracture risk probability decreased by 6.48% in response to MSDK therapy compared to 10.8% increase in placebo. MSDK reduced bone marker turnover primarily by increasing the bone formation marker P1NP and maintaining healthy bone turnover (âCTx:P1NP ratios). MSDK demonstrated positive effects on inflammatory status and improved quality of life especially related to sleep. MSDK did not produce adverse effects psychologically as well as physically and did not negatively affect compliance rate. MSDK may be modulating osteoblast and osteoclast function via the release of paracrine factors, osteoprotegerin and RANKL from osteoblasts. These studies also describe novel signaling cascades (<a href=\"#f12\"  class=\"anchor\">Fig. 12</a>) underlying MSDK effects on osteoblastogenesis and osteoclastogenesis that include pERK1/2, pERK5, RUNX2, ADAMs, PPARÎ³ and GLUT4. Importantly, the mechanism of action of MSDK cocktail synergizes with the osteogenic effects obtained from inhibiting the epigenetic regulator EZH2, which normally suppresses osteogenic differentiation <i>in vitro</i> and bone accrual <i>in vivo</i> [<a href=\"#r49\"  class=\"anchor\">49</a>,<a href=\"#r50\"  class=\"anchor\">50</a>]. Because EZH2 inhibition similar to MSDK treatment has favorable bone anabolic outcomes <i>in vivo</i>, the possibility arises that combination treatment of MSDK with EZH2 inhibitors (e.g., GSK126) could be beneficial at least for short-term therapies aimed at increasing bone mineral density.","contentType":"p"},{"content":{"caption":"<b>Potential mechanism underlying MSDK effects on bone formation.</b> The diagram illustrates regulatory and biological relationships between the indicated proteins and treatments.<br>","id":"f12","label":"Figure 12","alt":"Potential mechanism underlying MSDK effects on bone formation. The diagram illustrates regulatory and biological relationships between the indicated proteins and treatments.","url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/vmFJfarchkyMAtwWn_f12.png","optimized_urls":{"original":"/img?size=original&img=vmFJfarchkyMAtwWn_f12.png&v=2","hero":"/img?size=hero&img=vmFJfarchkyMAtwWn_f12.png&v=2","large":"/img?size=large&img=vmFJfarchkyMAtwWn_f12.png&v=2","medium":"/img?size=medium&img=vmFJfarchkyMAtwWn_f12.png&v=2","small":"/img?size=small&img=vmFJfarchkyMAtwWn_f12.png&v=2","xsmall":"/img?size=xsmall&img=vmFJfarchkyMAtwWn_f12.png&v=2"}},"contentType":"figure"},{"content":"Based on the fact that MSDK treatment did not completely inhibit osteoclastogenesis, we conclude that MSDK is favoring bone remodeling to proceed towards equilibrium by allowing osteoclastogenesis to some extent. These <i>in vitro</i> studies support our MOTS clinical trial findings demonstrating that MSDK reduces bone turnover rate by increasing P1NP expression, while maintaining steady levels of CTx. Results from this study underscore the complexity but therapeutically relevant effects of MSDK on bone cell development and activity making MSDK a viable and potential alternative therapy for managing and/or treating osteopenia in postmenopausal women. Large-scale, multicenter randomized control trials testing the efficacy of MSDK to prevent and treat osteopenia are warranted. Limitations to this study include low number of subjects, lack of a diverse cohort and lack of different micronutrient combinations on primary and secondary endpoints in MOTS clinical trial.","contentType":"p"}],"title":"Discussion","type":null,"headerLevel":1},{"content":[{"content":[{"content":"A randomized double-blind placebo controlled one-year study was designed. Investigation has been conducted in accordance with the ethical standards and according to the Declaration of Helsinki and national and international guidelines; and has been approved by the Duquesne University Institutional Review Board (ClinicalTrials.gov Identifier: NCT01870115 and IRB Grant protocol number 13-59). Inclusion criteria included being postmenopausal with osteopenia (T-score between -1 to -2.5); willingness to participate in a 12-month study; willingness to take daily therapy right before bed; willingness to undergo testing of bone markers and other biochemical parameters; and to provide a self-assessment on quality of life throughout the program. Exclusion criteria included being diagnosed with osteoporosis (T-score less than -2.5); being osteopenic as a consequence of other medical conditions such as hyperparathyroidism, metastatic bone disease, multiple myeloma or chronic steroid use; current use of hormone therapy or birth control; current use of prescription medications for osteoporosis, sleep, depression, anxiety, ulcerative colitis or regulation of blood pressure; current use of steroid medications or chronic use in the past 6 months; other medical conditions such as uncontrolled high blood pressure, liver disease, severe sleep apnea, chronic obstructive pulmonary disease; and current use of tobacco. Individuals who satisfied the eligibility criteria were invited to schedule an initial visit to the Center for Pharmacy Care at Duquesne University. At the first visit, participantsâ osteopenia was confirmed by DXA. Blood pressure readings were taken from both arms to ensure that participants had an average blood pressure between 140/90 and 100/60. Women who fulfilled the bone density and blood pressure requirements were invited to enroll in the study. Informed consent was obtained from all study participants. During the first visit, subjects completed forms detailing basic demographic information and listed all prescription and nonprescription drugs and/or supplement usage.","contentType":"p"}],"title":"Participant screening and recruitment","contentType":"subsection","headerLevel":2},{"content":[{"content":"The recruited postmenopausal women were randomly assigned to receive either placebo (n=11) or MSDK (n=11) treatments based on a computer-generated block randomization scheme. Allocation concealment was maintained among the participants and principal investigators throughout the randomization and throughout the study. Treatment capsules, referred to as âMSDKâ were formulated using 5 mg melatonin, 450 mg strontium (citrate), 2000 IU vitamin D<sub>3</sub> and 60Î¼g vitamin K<sub>2</sub>, divided into two capsules. Identical placebo capsules matching in size, shape and color contained plant fiber. Study capsules were formulated and manufactured according to the principal investigatorsâ specifications and supplied by Pure Encapsulations, Inc. (Sudbury, MA, USA). Subjects were instructed to take two capsules by mouth daily at their usual bedtime. After the first visit, bimonthly visits (at months 2, 4, 6, 8, 10 and 12) were arranged at the Center for Pharmacy Care (Duquesne University) over a 12-month period. During each visit, a registered nurse blinded to the group assignments performed the study-related health assessments. Participants received a 2-month supply of medication and daily diaries at each visit to keep track of their daily pill intake, sleep duration, physical activity and any other information that the participant would feel was important to note about their general well-being. In addition to study medication, participants were allowed to take <1000 IU of vitamin D<sub>3</sub> and <1000 mg of calcium daily.","contentType":"p"}],"title":"Randomization and follow-up","contentType":"subsection","headerLevel":2},{"content":[{"content":"Bone mineral density (BMD) was measured at baseline and at month 12 in the left femoral neck, total left hip and lumbar spine L1-L4 via Dual-energy X-ray absorptiometry (DXA). Mean changes in bone density (BMD) from baseline to month 12 were evaluated and compared between groups.","contentType":"p"}],"title":"Bone density","contentType":"subsection","headerLevel":2},{"content":[{"content":"Bone marker turnover was assessed in serum by collecting blood samples at months 0, 6 and 12. Serum was stored at -20Â°C until the time of analysis. All samples were tested at a similar time point to minimize any analytical variation. Bone formation markers total procollagen type 1 amino-terminal propeptide (P1NP) and osteocalcin (OC; both intact and N-terminal mid-fragments) were measured in the serum samples via ELISA using the human total P1NP ELISA kit for serum (Mybiosource, CA, USA) and osteocalcin (1-43/49) enzyme immunoassay assay kit for serum (ALPCO Diagnostic, NH, USA), respectively, per kit instructions. Bone resorption marker, collagen type I c-telopeptide (CTx), was measured via ELISA using Human Cross-linked Carboxy-terminal Telopeptide Of Type I Collagen (CTX-I) ELISA kit for serum (Mybiosource, CA, USA) following kit instructions. Mean concentration changes in bone markers P1NP (in pg/mL), OC (in ng/mL) and CTx (in ng/mL) were calculated for each time point and compared within and between groups. Ratios of bone resorption: bone formation (CTx:P1NP and CTx:OC) were calculated over time and compared within and between groups. All controls contained within each of the kits were within normal ranges.","contentType":"p"}],"title":"Bone turnover rate","contentType":"subsection","headerLevel":2},{"content":[{"content":"Fracture risk was assessed at months 0 and 12 using the FRAX<sup>Â®</sup>âa computer-generated algorithm (<a href=\"http://www.shef.ac.uk/FRAX/\"  target=\"_BLANK\">http://www.shef.ac.uk/FRAX/</a>) that estimates 10 year probability of a major osteoporotic fracture and a hip fracture in men and women based on their current femoral neck bone density, body composition, previous fractures, parental history of hip fracture and current risk factors [<a href=\"#r79\"  class=\"anchor\">79</a>,<a href=\"#r80\"  class=\"anchor\">80</a>]. Information required calculating FRAX<sup>Â®</sup> scores were collected at months 0 and 12. Mean percent changes in fracture risk from month 0 to month 12 were calculated and compared between groups.","contentType":"p"}],"title":"Fracture risk","contentType":"subsection","headerLevel":2},{"content":[{"content":"Serum vitamin D<sub>3</sub> and CRP levels were measured at months 0 and 12 by ELISA using 25(OH) Vitamin D ELISA kit (Enzo Life Science, NY, USA) and High sensitivity human C-reactive protein (hsCRP) ELISA kit (Biomatik LLC. DE, USA), respectively, according to the manufacturerâs instructions. Nocturnal urinary melatonin-sulfate levels were measured at the end of the study via ELISA using the Melatonin-Sulfate Urine ELISA kit (IBL International, Germany), following kit instructions. Participants were asked to collect all of their urine between 10pm to 6am throughout the night preceding the day of their last visit. Means Â± S.E.M. of vitamin D<sub>3</sub> (in ng/mL), CRP (in ng/mL) and melatonin (in ng/mL/hr) were calculated for each time point and compared between groups.","contentType":"p"}],"title":"Vitamin D<sub>3</sub>, C-reactive protein (CRP) and melatonin level","contentType":"subsection","headerLevel":2},{"content":[{"content":"Participantsâ blood pressure was measured at the initial visit and then every two months until the end of the study. Systolic and diastolic blood pressure measurements were taken on three separate occasions from right and left arms and average blood pressure readings for each time point were reported. Morphometric analysis was carried out at months 0 and 12 to assess the treatment effect on body composition. Participantsâ height, weight, body mass index (BMI), basal metabolic rate (BMR), fat percentage, fat mass (FM), lean body mass (FFM) and total body water (TBW) were measured using TANITAâ¢ body composition analyzer. Mean changes in blood pressure at each time point and mean changes in body composition from month 0 to month 12 were calculated and compared within and between groups.","contentType":"p"}],"title":"Blood pressure and body composition","contentType":"subsection","headerLevel":2},{"content":[{"content":"Treatment effects on our participantsâ menopause quality of life, perception of anxiety, non-specific stress and clinical depression states were assessed at months 0, 6 and 12 using four validated questionnaires: MENQOL [<a href=\"#r81\"  class=\"anchor\">81</a>,<a href=\"#r82\"  class=\"anchor\">82</a>], Spielbergerâs State-Trait Anxiety Inventory (STAI) [<a href=\"#r83\"  class=\"anchor\">83</a>,<a href=\"#r84\"  class=\"anchor\">84</a>], Cohenâs Perceived Stress Scale (PSS) [<a href=\"#r84\"  class=\"anchor\">84</a>-<a href=\"#r86\"  class=\"anchor\">86</a>] and the Center for Epidemiologic Studies Depression (CES-D) Scale [<a href=\"#r87\"  class=\"anchor\">87</a>], respectively. Questionnaires were administered to the study cohort at months 0, 6 and 12. MENQOL, PSS, STAI and CES-D scores were calculated for each time point; compared within and between groups and reported as mean Â± S.E.M.","contentType":"p"},{"content":"A daily diary appropriate for a postmenopausal cohort was prepared by modifying the daily diary used in our previous MOPS clinical trial [<a href=\"#r11\"  class=\"anchor\">11</a>]. Participants were asked to record daily information regarding their sleep quality and duration, use of any prescription and non-prescription medication, exercise, and general well-being. Diary pages were collected at each visit and then collated at the end of the study. General well-being was assessed by stratifying the comments into four categories: sleep quality, general mood, GI symptoms and general aches and pains and then sub-stratifying into positive, negative or neutral comments. Comments related to improvement in physical condition or positive feelings were classified as positive comments, whereas comments related to worsening of any existing condition or emerging of a new problem, as well as negative feelings fell under the negative category. Comments made about their daily activities, weather etc., which reflected indifferent thoughts, were classified as neutral comments. For data analyses, the positive and neutral comments made in each cohort were combined per category and then compared to the negative comments made for that same category (placebo vs. MSDK). In addition to their daily logs, compliance was assessed by counting the number of pills remaining from the last visit. Safety and tolerability were assessed at each visit through regular physical examinations and from the daily logs. Treatment effects on sleep duration and exercise intensity were calculated off of the participantsâ diary log. Exercise intensity was determined following the US Centers for Disease Control and Prevention (CDC) guideline [<a href=\"#r88\"  class=\"anchor\">88</a>]. Based on exercise type and intensity, participants fell into four different groups: no exercise=0; light exercise=1; moderate exercise=2; and high intensity or vigorous exercise=3. Sleep hours and exercise scores were compared between groups and reported as mean Â± S.E.M. Use of multivitamins/herbal/OTC supplements were also documented using the diary logs and compared between groups.","contentType":"p"}],"title":"Psychometric analyses","contentType":"subsection","headerLevel":2},{"content":[{"content":"<i>In vitro</i> MSDK treatment concentrations were calculated based on the doses used in the MOTS clinical trial. Hence, 50 nM melatonin (M), 191.5 Î¼M strontium citrate (SC), 26 nM vitamin D<sub>3</sub> (D) and 18.5 nM vitamin K<sub>2</sub> (K) were dissolved into 100% pure ethanol. Human adult mesenchymal stem cells (hMSCs) (Lonza, MD, USA) were maintained at 37Â°C, 5% CO<sub>2</sub> and 90% humidity. Cells were grown and passaged at 80% confluence in mesenchymal stem basal cell growth medium (Os-) (Lonza, USA). Cells were then seeded (at passage 3-5) at an initial density of 3 Ã 10<sup>3</sup> cells/cm<sup>2</sup> in the bottom chamber of transwell plates or in 6-well cell culture plates (Corning, NY, USA), treated with either basal growth media (Os-) or osteogenic media (Os+) (Lonza, USA) with or without treatments (Mel, SC, D3 and K2 either alone or in combination as MSDK) for 21 days. Ethanol (100%) only was used as vehicle (Veh) control. Ascorbate, dexamethasone and Î²-glycerophosphate present in the osteogenic media (Os+) induced the differentiation of hMSCs into osteoblasts [<a href=\"#r89\"  class=\"anchor\">89</a>]. Full media change occurred once every 3 days. On day 13, blood was taken from healthy consenting female volunteers unrelated to the MOTS clinical trial by the MOTS nurse via venous puncture. Human peripheral mononuclear cells were freshly collected from blood using Ficoll-Paque<sup>TM</sup> Plus (Amersham Pharmacia Biotech, Sweden) followed by two repeated centrifugations at 400xg for 30-40 min at 18-20<sup>o</sup>C without break. Monocytes were collected from cells by suspending in RoboSep<sup>TM</sup> buffer (Stemcell technologies, USA) and using the Easysepâ¢ negative selection human monocyte enrichment kit without CD16 depletion (Stemcell technologies, USA) and purple Easysepâ¢ magnet (Stemcell technologies, USA), following manufacturerâs instructions. Monocytes were then seeded (5 Ã 10<sup>3</sup> cells/cm<sup>2</sup>) in the top chamber of transwell plate to initiate the transwell co-culture or applied directly on top of the hMSCs to initiate the layered co-culture. Full media changes resumed and occurred once every 3 days until day 21. Parallel studies using hMSCs monocultures were run to determine the influence of osteoclasts on MSDK-mediated osteoblast differentiation. Similar hMSCs plating densities and treatment paradigms were used with the exception being that no hPBMCs were added on day 13.","contentType":"p"}],"title":"<i>In-vitro</i> sample preparation and osteoblast:osteoclast co-cultures","contentType":"subsection","headerLevel":2},{"content":[{"content":"On day 21, calcium mineralization was measured via alizarin red staining assayâthis time period was chosen based on past published studies using melatonin to induce differentiation of hMSCs into osteoblasts [<a href=\"#r33\"  class=\"anchor\">33</a>]. Human PBMCs were added to osteoblastic cultures on day 13 because past studies using osteogenic medium have shown that pre-osteoblasts proliferate and start to differentiate into mature osteoblasts between 14 to 21 days [<a href=\"#r33\"  class=\"anchor\">33</a>]; and RANKL, M-CSF and/or OPG levels would be high enough to modulate osteoclastogenesis [<a href=\"#r41\"  class=\"anchor\">41</a>,<a href=\"#r90\"  class=\"anchor\">90</a>]. Alizarin red staining was performed on the bottom chamber of the transwell co-culture and directly on 6-well plates (both hMSCs and hPBMCs) of the layered co-culture using the commercially available osteogenesis quantification kit (EMD Millipore, MA, USA) per manufacturerâs instructions. Microscopic evaluation of osteogenesis was performed using a Vistavision microscope (VWR International) with a progress C3 camera (Zenoptik; Data not shown). Osteogenic differentiation was quantified by spectrophotometry at 405 nm using the Perkin Elmer Victor 1420 Multilabel plate reader (Waltham, MA, USA). Concentrations of alizarin red reflecting osteoblast mineralization activity were calculated, normalized against Os-/Veh and compared between groups.","contentType":"p"}],"title":"Osteoblast differentiation and mineralization","contentType":"subsection","headerLevel":2},{"content":[{"content":"On day 21, tartrate resistant acid phosphatase (TRAP) assays were carried out on the top chamber of transwell co-culture and directly on the 6-well plate (layered co-culture) to measure osteoclastic differentiation and TRAP releasing activity. Quantitative analysis of total TRAP was performed as described by Janckila <i>et al.</i>, with modification [<a href=\"#r91\"  class=\"anchor\">91</a>]. Briefly, Naphthol-ASBI phosphate (N-ASBI-P) was used as a substrate for TRAP. TRAP buffer was prepared by dissolving N-ASBI-P (2.5mM) in a solution containing 1% ethylene glycol monomethyl ether (EGME), 2% NP40, Na-acetate (100mM) and Na-tartrate (50mM) with pH adjusted at 5.5-6.1. Cells were lysed with 50mM TRIS and treated with TRAP buffer (1mL/well). Cells were then scraped into a 5mL tube along with the buffer and incubated at 37Â°C for 30 min. Reactions were stopped upon the addition of 2.5 ml 0.1 M NaOH containing 0.05% NP-40. Fluorescence readings were taken at 405nm excitation and 515nm emission wavelength using a Perkin Elmer Victor 1420 Multilabel plate reader. Data were normalized against Os-/Veh and compared between groups.","contentType":"p"},{"content":"Qualitative analysis of TRAP was performed directly over the cells attached to plates using the commercially available Acid Phosphatase Leukocyte assay kit (Sigma, USA) per manufacturerâs instructions. The blue nuclei were visualized using a Vistavision microscope (VWR international) with progress C3 camera (Zenoptik; Data not shown). Purple staining indicates TRAP deposition by osteoclasts where the amount of TRAP deposition is proportional to the differentiation of osteoclasts.","contentType":"p"}],"title":"Osteoclast differentiation and activity","contentType":"subsection","headerLevel":2},{"content":[{"content":"On day 21, osteoblast or osteoclast lysates were prepared from the bottom and top chambers of the transwell co-cultures, respectively, or from layered co-cultures containing both osteoblasts and osteoclasts by scraping into Laemmli sample buffer containing Î²-mercaptoethanol (19:1 ratio), heated for 5 min at 95<sup>o</sup>C, cooled and then stored at -20<sup>o</sup>C until use.","contentType":"p"},{"content":"Western blotting was performed to measure protein expression of osteoprotegerin (OPG), receptor activator of nuclear factor kappa-B ligand (RANKL), extracellular signal-regulated protein kinases 1 and 2 (ERK1/MAPK3 and MAPK1/ERK2), extracellular-signal-regulated kinase 5 (ERK5/MAPK7), runt-related transcription factor 2 (RUNX2), integrin Î²1 (ITGB1), nuclear factor kappa B (NFÎºB), peroxisome proliferator-activated receptors gamma (PPARÎ³), glucose transporter type 4 (GLUT4/SLC2A4) and beta subunit of insulin receptor (Insulin RÎ²) using the OdysseyÂ® Western Blotting Kit IV RD (Licor bioscience, USA). Primary antibodies included rabbit anti-OPG/TNFRSF11B (ab73400, Abcam, USA), rabbit anti-RANKL/TNFSF11 (ab9957, Abcam, USA), rabbit anti-phospho ERK1/2 (9101, Cell Signaling, USA), rabbit anti-total ERK1/2 (9102, Cell Signaling, USA), rabbit anti-phospho ERK5 (3371, Cell Signaling, USA), rabbit anti-total ERK5 (3372, Cell Signaling, USA), rabbit anti-RUNX2 (sc10758, Santa Cruz Biotech, USA), rabbit anti-Integrin Î²1 (sc8978, Santa Cruz Biotech, USA), rabbit anti-NFÎºB (sc298, Santa Cruz Biotech, USA), rabbit anti-PPARÎ³ (sc7196, Santa Cruz Biotech, USA), rabbit anti-GLUT4 (sc7938, Santa Cruz Biotech, USA), rabbit anti-insulin RÎ² (sc711, Santa Cruz Biotech, USA) and mouse anti-Î²-actin (926-42212, Licor, USA). Secondary antibodies included either goat anti-rabbit (800nm) or goat anti-mouse (680nm), which were supplied with the Licor western blotting kit. Proteins were normalized against Î²-actin to control for differences in protein loading between treatment groups. Protein levels were then normalized against Os-/Veh or Os-/MSDK and compared between groups.","contentType":"p"}],"title":"Cell lysate preparation and western blotting","contentType":"subsection","headerLevel":2},{"content":[{"content":"Concentrations of secreted proteins (sOPG and sRANKL) in culture media were measured using human ELISA kits for Osteoprotegerin (Abcam, USA) and Total sRANKL (Enzo Life Science, USA), respectively, per manufacturerâs instructions. Culture media was collected immediately before preparing the cell lysates from the bottom chamber of transwell plate (contains hMSCs) or from the layered or monocultures and stored at -20<sup>o</sup>C until use. Mean concentration changes of sOPG and sRANKL (in pg/mL) and the ratios of sOPG: sRANKL were calculated, normalized against Os-/MSDK and compared between groups.","contentType":"p"}],"title":"Measurement of secreted OPG and RANKL","contentType":"subsection","headerLevel":2},{"content":[{"content":"Mesenchymal stem cells were isolated from the perivascular fraction of adipose tissues obtained from consenting healthy donors and with approval from the Mayo Clinic IRB as described previously [<a href=\"#r92\"  class=\"anchor\">92</a>,<a href=\"#r93\"  class=\"anchor\">93</a>]. Briefly, fat tissue was digested with 0.075% collagenase Type I (Worthington Biochemicals, USA) for 1.5 h at 37Â°C and adipocytes were removed from the stromal vascular fraction by low speed centrifugation (400xg for 5 min). Supernatant was aspirated and the cell pellet washed with PBS followed by sieving through 70 and 40 Âµm cell strainers (BD Biosciences, USA). Cell suspensions (1.0â2.5 Ã10<sup>3</sup> cells/cm<sup>2</sup>) were incubated at 37Â°C and 5% CO<sub>2</sub> in Advanced MEM with 5% platelet lysate, PLTMax (MillCreek LifeSciences), 2 U/ml heparin (Novaplus), 2 mM L-glutamine (Invitrogen) and antibiotics (100 U/ml penicillin, 100 g/ml streptomycin, Sigma). Adipose-derived MSCs (AMSCs, passage 7) were seeded at a density of 5000 cells per cm<sup>2</sup> on 6-well plates and were allowed to adhere overnight and media was then changed to the treatments as described previously; except that some MSCs were incubated in the presence of GSK126, a small molecule inhibitor of the lysine methyltransferase EZH2 and some MSCs were maintained for up to a maximum of 14 days with a media change done every 3-4 days. Alkaline phosphatase activity was assayed at day 7 post-treatment with Os- or Os+ in the absence (vehicle) or presence of MSDK using para-nitrophenyl phosphate (p-NPP) substrate-based chromogenic assay per manufacturer instructions and expressed as ALP activity per unit DNA. DNA was quantified by Hoechst (Sigma) dye measuring the fluorescence at 340/460 nm. Mineralization was analyzed via alizarin red staining at days 8 or 14 as already described and quantified by densitometry using Quantity One software.","contentType":"p"}],"title":"Isolation of adipose-derived stem cells in culture and osteogenic differentiation","contentType":"subsection","headerLevel":2},{"content":[{"content":"A sample size of minimum 10 per group required to detect a significant change in lumber bone density with 80% power was determined by mixed model analysis and based on the means and standard deviations obtained for the serum bone marker data from MOPS [<a href=\"#r11\"  class=\"anchor\">11</a>]. Comparisons of the baseline characteristics between MSDK and placebo groups were performed using Studentâs two-tailed <i>t</i>-test for independent samples with Welchâs correction for unequal variances (continuous data) and Fishers exact test (categorical data). Mean changes and percentage mean changes from baseline to month 12 in continuous variables were compared between treatment groups using Studentâs one-tailed <i>t</i>-test for BMD measurements and Studentâs two-tailed <i>t</i>-test for all other endpoints with Welchâs correction. Longitudinal analyses were carried out for the continuous variables with repeated measures e.g. serum bone markers, vitamin D<sub>3</sub> and CRP levels, questionnaires and BP. Generalized linear mixed model (GLMM) approach was used to study the groups, the times, and the interaction between groups and times. In this analysis, groups and times were considered as fixed effects while subjects nested within the treatment groups were considered random. Comparisons of the groups over time were studied using orthogonal contrast. Pearson correlation was performed to analyze the correlation between melatonin, vitamin D<sub>3</sub> and CRP levels with the bone density, bone markers and morphometric changes. Dairy comments were analyzed using two-tailed Fishers exact test for two categorical outcomes. All statistical testing was carried out using JMP versions 12 (SAS Institute Inc., Cary, NC, USA) and GraphPad Prism version 6 (GraphPad Software, San Diego, CA, USA) for Macintosh. Primary and secondary endpoints were analyzed following the intention-to-treat (ITT) principle. Results were presented as mean Â± S.E.M. with significance considered at <i>p</i> < 0.05. For <i>in vitro</i> assays, all data were normalized against either Os-/Veh or Os-/MSDK and analyzed by one-way ANOVA followed by Bonferroniâs post-hoc multiple comparison <i>t</i>-test with significance defined as <i>p</i> <0.05.","contentType":"p"}],"title":"Statistical analysis","contentType":"subsection","headerLevel":2}],"title":"Methods","type":null,"headerLevel":1},{"content":[],"title":null,"headerLevel":1}],"acks":[{"content":[{"content":"We thank the Duquesne University Translational Research program for funding this study and Pure Encapsulations, Inc. for providing the study capsules. Additional support for this work was provided by the National Institute for Arthritis and Musculoskeletal diseases (NIAMS R01 AR049069 to AJvW).","contentType":"p"}],"title":"Acknowledgements"}],"footnotes":[{"content":[{"content_part":"Study design: SM, MS, LTE, RMS, AD, AJVW and PWE; Study conduct: SM, MS, LTE, RMS, AJVW and PWE; Data collection: SM, LTE, RMS and PWE; Data analysis: SM, MS, FD, BJE, RMS, AJVW and PWE; Data interpretation: SM, MS, FD, BJE, RMS, AD, AJVW and PWE; Drafting manuscript: SM and PWE; Revising manuscript content: SM, MS, LTE, FD, BJE, RMS, AJVW and PWE; Approving final version of manuscript: SM, MS, LTE, FD, BJE, RMS, AD, AJVW and PWE."}],"title":"Author Contributions","label":"AUTHOR CONTRIBUTIONS"},{"content":[{"content_part":"The authors declare no financial conflict of interest with Pure Encapsulations, Inc. involving this study. The study capsules were donated free of charge at the independent request and formulation specifications of the principal investigators. Mark Swanson, ND has received compensation as a senior medical advisor and consultant for the company."}],"title":"Conflicts of Interest","label":"CONFLICTS OF INTEREST"},{"content":[{"content_part":"This study was supported by Duquesne University Translational Research Program, School of Pharmacy."}],"title":"Funding","label":"FUNDING"}],"references":[{"textContent":[{"content":"Maria S","type":"text"},{"content":", ","type":"text"},{"content":"Witt-Enderby PA","type":"text"},{"content":". ","type":"text"},{"content":"Melatonin effects on bone: potential use for the prevention and treatment for osteopenia, osteoporosis, and periodontal disease and for use in bone-grafting procedures.","type":"title"},{"content":" ","type":"text"},{"content":"J Pineal Res","type":"source"},{"content":". ","type":"text"},{"content":"2014","type":"year"},{"content":"; ","type":"text"},{"content":"56","type":"volume"},{"content":":","type":"text"},{"content":"115","type":"fpage"},{"content":"â","type":"text"},{"content":"25","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1111/jpi.12116","type":"doi"},{"content":"24372640","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"1","id":"r1","number":"1"},{"textContent":[{"content":"Sale JE","type":"text"},{"content":", ","type":"text"},{"content":"Beaton D","type":"text"},{"content":", ","type":"text"},{"content":"Bogoch E","type":"text"},{"content":". ","type":"text"},{"content":"Secondary prevention after an osteoporosis-related fracture: an overview.","type":"title"},{"content":" ","type":"text"},{"content":"Clin Geriatr Med","type":"source"},{"content":". ","type":"text"},{"content":"2014","type":"year"},{"content":"; ","type":"text"},{"content":"30","type":"volume"},{"content":":","type":"text"},{"content":"317","type":"fpage"},{"content":"â","type":"text"},{"content":"32","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1016/j.cger.2014.01.009","type":"doi"},{"content":"24721371","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"2","id":"r2","number":"2"},{"textContent":[{"content":"Pfister AK","type":"text"},{"content":", ","type":"text"},{"content":"Welch CA","type":"text"},{"content":", ","type":"text"},{"content":"John M","type":"text"},{"content":", ","type":"text"},{"content":"Emmett MK","type":"text"},{"content":". ","type":"text"},{"content":"Changes in Nonosteoporotic Bone Density and Subsequent Fractures in Women.","type":"title"},{"content":" ","type":"text"},{"content":"South Med J","type":"source"},{"content":". ","type":"text"},{"content":"2016","type":"year"},{"content":"; ","type":"text"},{"content":"109","type":"volume"},{"content":":","type":"text"},{"content":"118","type":"fpage"},{"content":"â","type":"text"},{"content":"23","type":"lpage"},{"content":". ","type":"text"},{"content":"10.14423/SMJ.0000000000000410","type":"doi"},{"content":"26840970","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"3","id":"r3","number":"3"},{"textContent":[{"content":"Pasco JA","type":"text"},{"content":", ","type":"text"},{"content":"Seeman E","type":"text"},{"content":", ","type":"text"},{"content":"Henry MJ","type":"text"},{"content":", ","type":"text"},{"content":"Merriman EN","type":"text"},{"content":", ","type":"text"},{"content":"Nicholson GC","type":"text"},{"content":", ","type":"text"},{"content":"Kotowicz MA","type":"text"},{"content":". ","type":"text"},{"content":"The population burden of fractures originates in women with osteopenia, not osteoporosis.","type":"title"},{"content":" ","type":"text"},{"content":"Osteoporos Int","type":"source"},{"content":". ","type":"text"},{"content":"2006","type":"year"},{"content":"; ","type":"text"},{"content":"17","type":"volume"},{"content":":","type":"text"},{"content":"1404","type":"fpage"},{"content":"â","type":"text"},{"content":"09","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1007/s00198-006-0135-9","type":"doi"},{"content":"16699736","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"4","id":"r4","number":"4"},{"textContent":[{"content":"Avis NE","type":"text"},{"content":", ","type":"text"},{"content":"Colvin A","type":"text"},{"content":", ","type":"text"},{"content":"Bromberger JT","type":"text"},{"content":", ","type":"text"},{"content":"Hess R","type":"text"},{"content":", ","type":"text"},{"content":"Matthews KA","type":"text"},{"content":", ","type":"text"},{"content":"Ory M","type":"text"},{"content":", ","type":"text"},{"content":"Schocken M","type":"text"},{"content":". ","type":"text"},{"content":"Change in health-related quality of life over the menopausal transition in a multiethnic cohort of middle-aged women: Study of Womenâs Health Across the Nation.","type":"title"},{"content":" ","type":"text"},{"content":"Menopause","type":"source"},{"content":". ","type":"text"},{"content":"2009","type":"year"},{"content":"; ","type":"text"},{"content":"16","type":"volume"},{"content":":","type":"text"},{"content":"860","type":"fpage"},{"content":"â","type":"text"},{"content":"69","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1097/gme.0b013e3181a3cdaf","type":"doi"},{"content":"19436224","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"5","id":"r5","number":"5"},{"textContent":[{"content":"Watts NB","type":"text"},{"content":", ","type":"text"},{"content":"Lewiecki EM","type":"text"},{"content":", ","type":"text"},{"content":"Miller PD","type":"text"},{"content":", ","type":"text"},{"content":"Baim S","type":"text"},{"content":". ","type":"text"},{"content":"National Osteoporosis Foundation 2008 Clinicianâs Guide to Prevention and Treatment of Osteoporosis and the World Health Organization Fracture Risk Assessment Tool (FRAX): what they mean to the bone densitometrist and bone technologist.","type":"title"},{"content":" ","type":"text"},{"content":"J Clin Densitom","type":"source"},{"content":". ","type":"text"},{"content":"2008","type":"year"},{"content":"; ","type":"text"},{"content":"11","type":"volume"},{"content":":","type":"text"},{"content":"473","type":"fpage"},{"content":"â","type":"text"},{"content":"77","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1016/j.jocd.2008.04.003","type":"doi"},{"content":"18562228","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"6","id":"r6","number":"6"},{"textContent":[{"content":"Avenell A","type":"text"},{"content":", ","type":"text"},{"content":"Mak JC","type":"text"},{"content":", ","type":"text"},{"content":"OâConnell D","type":"text"},{"content":". ","type":"text"},{"content":"Vitamin D and vitamin D analogues for preventing fractures in post-menopausal women and older men.","type":"title"},{"content":" ","type":"text"},{"content":"Cochrane Database Syst Rev","type":"source"},{"content":". ","type":"text"},{"content":"2014","type":"year"},{"content":"CD000227","type":"fpage"},{"content":".","type":"text"},{"content":"24729336","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"7","id":"r7","number":"7"},{"textContent":[{"content":"Bolland MJ","type":"text"},{"content":", ","type":"text"},{"content":"Leung W","type":"text"},{"content":", ","type":"text"},{"content":"Tai V","type":"text"},{"content":", ","type":"text"},{"content":"Bastin S","type":"text"},{"content":", ","type":"text"},{"content":"Gamble GD","type":"text"},{"content":", ","type":"text"},{"content":"Grey A","type":"text"},{"content":", ","type":"text"},{"content":"Reid IR","type":"text"},{"content":". ","type":"text"},{"content":"Calcium intake and risk of fracture: systematic review.","type":"title"},{"content":" ","type":"text"},{"content":"BMJ","type":"source"},{"content":". ","type":"text"},{"content":"2015","type":"year"},{"content":"; ","type":"text"},{"content":"351","type":"volume"},{"content":":","type":"text"},{"content":"h4580","type":"fpage"},{"content":". ","type":"text"},{"content":"10.1136/bmj.h4580","type":"doi"},{"content":"26420387","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"8","id":"r8","number":"8"},{"textContent":[{"content":"Lyritis GP","type":"text"},{"content":", ","type":"text"},{"content":"Georgoulas T","type":"text"},{"content":", ","type":"text"},{"content":"Zafeiris CP","type":"text"},{"content":". ","type":"text"},{"content":"Bone anabolic versus bone anticatabolic treatment of postmenopausal osteoporosis.","type":"title"},{"content":" ","type":"text"},{"content":"Ann N Y Acad Sci","type":"source"},{"content":". ","type":"text"},{"content":"2010","type":"year"},{"content":"; ","type":"text"},{"content":"1205","type":"volume"},{"content":":","type":"text"},{"content":"277","type":"fpage"},{"content":"â","type":"text"},{"content":"83","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1111/j.1749-6632.2010.05666.x","type":"doi"},{"content":"20840284","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"9","id":"r9","number":"9"},{"textContent":[{"content":"Siris ES","type":"text"},{"content":", ","type":"text"},{"content":"Chen Y-T","type":"text"},{"content":", ","type":"text"},{"content":"Abbott TA","type":"text"},{"content":", ","type":"text"},{"content":"Barrett-Connor E","type":"text"},{"content":", ","type":"text"},{"content":"Miller PD","type":"text"},{"content":", ","type":"text"},{"content":"Wehren LE","type":"text"},{"content":", ","type":"text"},{"content":"Berger ML","type":"text"},{"content":". ","type":"text"},{"content":"Bone mineral density thresholds for pharmacological intervention to prevent fractures.","type":"title"},{"content":" ","type":"text"},{"content":"Arch Intern Med","type":"source"},{"content":". ","type":"text"},{"content":"2004","type":"year"},{"content":"; ","type":"text"},{"content":"164","type":"volume"},{"content":":","type":"text"},{"content":"1108","type":"fpage"},{"content":"â","type":"text"},{"content":"12","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1001/archinte.164.10.1108","type":"doi"},{"content":"15159268","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"10","id":"r10","number":"10"},{"textContent":[{"content":"Kotlarczyk MP","type":"text"},{"content":", ","type":"text"},{"content":"Lassila HC","type":"text"},{"content":", ","type":"text"},{"content":"OâNeil CK","type":"text"},{"content":", ","type":"text"},{"content":"DâAmico F","type":"text"},{"content":", ","type":"text"},{"content":"Enderby LT","type":"text"},{"content":", ","type":"text"},{"content":"Witt-Enderby PA","type":"text"},{"content":", ","type":"text"},{"content":"Balk JL","type":"text"},{"content":". ","type":"text"},{"content":"Melatonin osteoporosis prevention study (MOPS): a randomized, double-blind, placebo-controlled study examining the effects of melatonin on bone health and quality of life in perimenopausal women.","type":"title"},{"content":" ","type":"text"},{"content":"J Pineal Res","type":"source"},{"content":". ","type":"text"},{"content":"2012","type":"year"},{"content":"; ","type":"text"},{"content":"52","type":"volume"},{"content":":","type":"text"},{"content":"414","type":"fpage"},{"content":"â","type":"text"},{"content":"26","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1111/j.1600-079X.2011.00956.x","type":"doi"},{"content":"22220591","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"11","id":"r11","number":"11"},{"textContent":[{"content":"Amstrup AK","type":"text"},{"content":", ","type":"text"},{"content":"Sikjaer T","type":"text"},{"content":", ","type":"text"},{"content":"Heickendorff L","type":"text"},{"content":", ","type":"text"},{"content":"Mosekilde L","type":"text"},{"content":", ","type":"text"},{"content":"Rejnmark L","type":"text"},{"content":". ","type":"text"},{"content":"Melatonin improves bone mineral density at the femoral neck in postmenopausal women with osteopenia: a randomized controlled trial.","type":"title"},{"content":" ","type":"text"},{"content":"J Pineal Res","type":"source"},{"content":". ","type":"text"},{"content":"2015","type":"year"},{"content":"; ","type":"text"},{"content":"59","type":"volume"},{"content":":","type":"text"},{"content":"221","type":"fpage"},{"content":"â","type":"text"},{"content":"29","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1111/jpi.12252","type":"doi"},{"content":"26036434","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"12","id":"r12","number":"12"},{"textContent":[{"content":"Reginster J-Y","type":"text"},{"content":", ","type":"text"},{"content":"Seeman E","type":"text"},{"content":", ","type":"text"},{"content":"De Vernejoul MC","type":"text"},{"content":", ","type":"text"},{"content":"Adami S","type":"text"},{"content":", ","type":"text"},{"content":"Compston J","type":"text"},{"content":", ","type":"text"},{"content":"Phenekos C","type":"text"},{"content":", ","type":"text"},{"content":"Devogelaer J-P","type":"text"},{"content":", ","type":"text"},{"content":"Curiel MD","type":"text"},{"content":", ","type":"text"},{"content":"Sawicki A","type":"text"},{"content":", ","type":"text"},{"content":"Goemaere S","type":"text"},{"content":", ","type":"text"},{"content":"Sorensen OH","type":"text"},{"content":", ","type":"text"},{"content":"Felsenberg D","type":"text"},{"content":", ","type":"text"},{"content":"Meunier PJ","type":"text"},{"content":". ","type":"text"},{"content":"Strontium ranelate reduces the risk of nonvertebral fractures in postmenopausal women with osteoporosis: Treatment of Peripheral Osteoporosis (TROPOS) study.","type":"title"},{"content":" ","type":"text"},{"content":"J Clin Endocrinol Metab","type":"source"},{"content":". ","type":"text"},{"content":"2005","type":"year"},{"content":"; ","type":"text"},{"content":"90","type":"volume"},{"content":":","type":"text"},{"content":"2816","type":"fpage"},{"content":"â","type":"text"},{"content":"22","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1210/jc.2004-1774","type":"doi"},{"content":"15728210","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"13","id":"r13","number":"13"},{"textContent":[{"content":"Meunier PJ","type":"text"},{"content":", ","type":"text"},{"content":"Roux C","type":"text"},{"content":", ","type":"text"},{"content":"Seeman E","type":"text"},{"content":", ","type":"text"},{"content":"Ortolani S","type":"text"},{"content":", ","type":"text"},{"content":"Badurski JE","type":"text"},{"content":", ","type":"text"},{"content":"Spector TD","type":"text"},{"content":", ","type":"text"},{"content":"Cannata J","type":"text"},{"content":", ","type":"text"},{"content":"Balogh A","type":"text"},{"content":", ","type":"text"},{"content":"Lemmel E-M","type":"text"},{"content":", ","type":"text"},{"content":"Pors-Nielsen S","type":"text"},{"content":", ","type":"text"},{"content":"Rizzoli R","type":"text"},{"content":", ","type":"text"},{"content":"Genant HK","type":"text"},{"content":", ","type":"text"},{"content":"Reginster JY","type":"text"},{"content":". ","type":"text"},{"content":"The effects of strontium ranelate on the risk of vertebral fracture in women with postmenopausal osteoporosis.","type":"title"},{"content":" ","type":"text"},{"content":"N Engl J Med","type":"source"},{"content":". ","type":"text"},{"content":"2004","type":"year"},{"content":"; ","type":"text"},{"content":"350","type":"volume"},{"content":":","type":"text"},{"content":"459","type":"fpage"},{"content":"â","type":"text"},{"content":"68","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1056/NEJMoa022436","type":"doi"},{"content":"14749454","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"14","id":"r14","number":"14"},{"textContent":[{"content":"Iwamoto J","type":"text"},{"content":", ","type":"text"},{"content":"Takeda T","type":"text"},{"content":", ","type":"text"},{"content":"Sato Y","type":"text"},{"content":". ","type":"text"},{"content":"Menatetrenone (vitamin K2) and bone quality in the treatment of postmenopausal osteoporosis.","type":"title"},{"content":" ","type":"text"},{"content":"Nutr Rev","type":"source"},{"content":". ","type":"text"},{"content":"2006","type":"year"},{"content":"; ","type":"text"},{"content":"64","type":"volume"},{"content":":","type":"text"},{"content":"509","type":"fpage"},{"content":"â","type":"text"},{"content":"17","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1111/j.1753-4887.2006.tb00184.x","type":"doi"},{"content":"17274493","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"15","id":"r15","number":"15"},{"textContent":[{"content":"Sato T. Vitamin K2 and bone quality. Vitam Trace Elem. 2013; S6:001. ","type":"text"}],"citationType":"mixed_citation","type":"other","label":"16","id":"r16","number":"16"},{"textContent":[{"content":"Kanellakis S","type":"text"},{"content":", ","type":"text"},{"content":"Moschonis G","type":"text"},{"content":", ","type":"text"},{"content":"Tenta R","type":"text"},{"content":", ","type":"text"},{"content":"Schaafsma A","type":"text"},{"content":", ","type":"text"},{"content":"van den Heuvel EG","type":"text"},{"content":", ","type":"text"},{"content":"Papaioannou N","type":"text"},{"content":", ","type":"text"},{"content":"Lyritis G","type":"text"},{"content":", ","type":"text"},{"content":"Manios Y","type":"text"},{"content":". ","type":"text"},{"content":"Changes in parameters of bone metabolism in postmenopausal women following a 12-month intervention period using dairy products enriched with calcium, vitamin D, and phylloquinone (vitamin K(1)) or menaquinone-7 (vitamin K (2)): the Postmenopausal Health Study II.","type":"title"},{"content":" ","type":"text"},{"content":"Calcif Tissue Int","type":"source"},{"content":". ","type":"text"},{"content":"2012","type":"year"},{"content":"; ","type":"text"},{"content":"90","type":"volume"},{"content":":","type":"text"},{"content":"251","type":"fpage"},{"content":"â","type":"text"},{"content":"62","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1007/s00223-012-9571-z","type":"doi"},{"content":"22392526","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"17","id":"r17","number":"17"},{"textContent":[{"content":"Ushiroyama T","type":"text"},{"content":", ","type":"text"},{"content":"Ikeda A","type":"text"},{"content":", ","type":"text"},{"content":"Ueki M","type":"text"},{"content":". ","type":"text"},{"content":"Effect of continuous combined therapy with vitamin K(2) and vitamin D(3) on bone mineral density and coagulofibrinolysis function in postmenopausal women.","type":"title"},{"content":" ","type":"text"},{"content":"Maturitas","type":"source"},{"content":". ","type":"text"},{"content":"2002","type":"year"},{"content":"; ","type":"text"},{"content":"41","type":"volume"},{"content":":","type":"text"},{"content":"211","type":"fpage"},{"content":"â","type":"text"},{"content":"21","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1016/S0378-5122(01)00275-4","type":"doi"},{"content":"11886767","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"18","id":"r18","number":"18"},{"textContent":[{"content":"Catalano A","type":"text"},{"content":", ","type":"text"},{"content":"Morabito N","type":"text"},{"content":", ","type":"text"},{"content":"Di Stefano A","type":"text"},{"content":", ","type":"text"},{"content":"Morini E","type":"text"},{"content":", ","type":"text"},{"content":"Basile G","type":"text"},{"content":", ","type":"text"},{"content":"Faraci B","type":"text"},{"content":", ","type":"text"},{"content":"Loddo S","type":"text"},{"content":", ","type":"text"},{"content":"Ientile R","type":"text"},{"content":", ","type":"text"},{"content":"Lasco A","type":"text"},{"content":". ","type":"text"},{"content":"Vitamin D and bone mineral density changes in postmenopausal women treated with strontium ranelate.","type":"title"},{"content":" ","type":"text"},{"content":"J Endocrinol Invest","type":"source"},{"content":". ","type":"text"},{"content":"2015","type":"year"},{"content":"; ","type":"text"},{"content":"38","type":"volume"},{"content":":","type":"text"},{"content":"859","type":"fpage"},{"content":"â","type":"text"},{"content":"63","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1007/s40618-015-0299-2","type":"doi"},{"content":"25952299","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"19","id":"r19","number":"19"},{"textContent":[{"content":"Genuis SJ","type":"text"},{"content":", ","type":"text"},{"content":"Bouchard TP","type":"text"},{"content":". ","type":"text"},{"content":"Combination of Micronutrients for Bone (COMB) Study: bone density after micronutrient intervention.","type":"title"},{"content":" ","type":"text"},{"content":"J Environ Public Health","type":"source"},{"content":". ","type":"text"},{"content":"2012","type":"year"},{"content":"; ","type":"text"},{"content":"2012","type":"volume"},{"content":":","type":"text"},{"content":"354151","type":"fpage"},{"content":". ","type":"text"},{"content":"10.1155/2012/354151","type":"doi"},{"content":"22291722","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"20","id":"r20","number":"20"},{"textContent":[{"content":"Bondi C","type":"text"},{"content":", ","type":"text"},{"content":"Khairnar R","type":"text"},{"content":", ","type":"text"},{"content":"Kamal K","type":"text"},{"content":", ","type":"text"},{"content":"Witt-Enderby P","type":"text"},{"content":". ","type":"text"},{"content":"An Early Development Budget Impact Model for the use of Melatonin in the Treatment and Prevention of Osteoporosis.","type":"title"},{"content":" ","type":"text"},{"content":"Clin Pharmacol Biopharm","type":"source"},{"content":". ","type":"text"},{"content":"2015","type":"year"},{"content":"; ","type":"text"},{"content":"4","type":"volume"},{"content":":","type":"text"},{"content":"132","type":"fpage"}],"citationType":"mixed_citation","type":"journal","label":"21","id":"r21","number":"21"},{"textContent":[{"content":"Matsuo K","type":"text"},{"content":", ","type":"text"},{"content":"Irie N","type":"text"},{"content":". ","type":"text"},{"content":"Osteoclast-osteoblast communication.","type":"title"},{"content":" ","type":"text"},{"content":"Arch Biochem Biophys","type":"source"},{"content":". ","type":"text"},{"content":"2008","type":"year"},{"content":"; ","type":"text"},{"content":"473","type":"volume"},{"content":":","type":"text"},{"content":"201","type":"fpage"},{"content":"â","type":"text"},{"content":"09","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1016/j.abb.2008.03.027","type":"doi"},{"content":"18406338","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"22","id":"r22","number":"22"},{"textContent":[{"content":"Napoli N","type":"text"},{"content":", ","type":"text"},{"content":"Strollo R","type":"text"},{"content":", ","type":"text"},{"content":"Sprini D","type":"text"},{"content":", ","type":"text"},{"content":"Maddaloni E","type":"text"},{"content":", ","type":"text"},{"content":"Rini GB","type":"text"},{"content":", ","type":"text"},{"content":"Carmina E","type":"text"},{"content":". ","type":"text"},{"content":"Serum 25-OH Vitamin D in relation to bone mineral density and bone turnover.","type":"title"},{"content":" ","type":"text"},{"content":"Int J Endocrinol","type":"source"},{"content":". ","type":"text"},{"content":"2014","type":"year"},{"content":"; ","type":"text"},{"content":"2014","type":"volume"},{"content":":","type":"text"},{"content":"487463","type":"fpage"},{"content":". ","type":"text"},{"content":"10.1155/2014/487463","type":"doi"},{"content":"25110474","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"23","id":"r23","number":"23"},{"textContent":[{"content":"Labouesse MA","type":"text"},{"content":", ","type":"text"},{"content":"Gertz ER","type":"text"},{"content":", ","type":"text"},{"content":"Piccolo BD","type":"text"},{"content":", ","type":"text"},{"content":"Souza EC","type":"text"},{"content":", ","type":"text"},{"content":"Schuster GU","type":"text"},{"content":", ","type":"text"},{"content":"Witbracht MG","type":"text"},{"content":", ","type":"text"},{"content":"Woodhouse LR","type":"text"},{"content":", ","type":"text"},{"content":"Adams SH","type":"text"},{"content":", ","type":"text"},{"content":"Keim NL","type":"text"},{"content":", ","type":"text"},{"content":"Van Loan MD","type":"text"},{"content":". ","type":"text"},{"content":"Associations among endocrine, inflammatory, and bone markers, body composition and weight loss induced bone loss.","type":"title"},{"content":" ","type":"text"},{"content":"Bone","type":"source"},{"content":". ","type":"text"},{"content":"2014","type":"year"},{"content":"; ","type":"text"},{"content":"64","type":"volume"},{"content":":","type":"text"},{"content":"138","type":"fpage"},{"content":"â","type":"text"},{"content":"46","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1016/j.bone.2014.03.047","type":"doi"},{"content":"24709689","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"24","id":"r24","number":"24"},{"textContent":[{"content":"Halleen JM","type":"text"},{"content":", ","type":"text"},{"content":"Tiitinen SL","type":"text"},{"content":", ","type":"text"},{"content":"Ylipahkala H","type":"text"},{"content":", ","type":"text"},{"content":"Fagerlund KM","type":"text"},{"content":", ","type":"text"},{"content":"VÃ¤Ã¤nÃ¤nen HK","type":"text"},{"content":". ","type":"text"},{"content":"Tartrate-resistant acid phosphatase 5b (TRACP 5b) as a marker of bone resorption.","type":"title"},{"content":" ","type":"text"},{"content":"Clin Lab","type":"source"},{"content":". ","type":"text"},{"content":"2006","type":"year"},{"content":"; ","type":"text"},{"content":"52","type":"volume"},{"content":":","type":"text"},{"content":"499","type":"fpage"},{"content":"â","type":"text"},{"content":"509","type":"lpage"},{"content":".","type":"text"},{"content":"17078477","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"25","id":"r25","number":"25"},{"textContent":[{"content":"Angel NZ","type":"text"},{"content":", ","type":"text"},{"content":"Walsh N","type":"text"},{"content":", ","type":"text"},{"content":"Forwood MR","type":"text"},{"content":", ","type":"text"},{"content":"Ostrowski MC","type":"text"},{"content":", ","type":"text"},{"content":"Cassady AI","type":"text"},{"content":", ","type":"text"},{"content":"Hume DA","type":"text"},{"content":". ","type":"text"},{"content":"Transgenic mice overexpressing tartrate-resistant acid phosphatase exhibit an increased rate of bone turnover.","type":"title"},{"content":" ","type":"text"},{"content":"J Bone Miner Res","type":"source"},{"content":". ","type":"text"},{"content":"2000","type":"year"},{"content":"; ","type":"text"},{"content":"15","type":"volume"},{"content":":","type":"text"},{"content":"103","type":"fpage"},{"content":"â","type":"text"},{"content":"10","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1359/jbmr.2000.15.1.103","type":"doi"},{"content":"10646119","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"26","id":"r26","number":"26"},{"textContent":[{"content":"Nakashima T","type":"text"},{"content":", ","type":"text"},{"content":"Kobayashi Y","type":"text"},{"content":", ","type":"text"},{"content":"Yamasaki S","type":"text"},{"content":", ","type":"text"},{"content":"Kawakami A","type":"text"},{"content":", ","type":"text"},{"content":"Eguchi K","type":"text"},{"content":", ","type":"text"},{"content":"Sasaki H","type":"text"},{"content":", ","type":"text"},{"content":"Sakai H","type":"text"},{"content":". ","type":"text"},{"content":"Protein expression and functional difference of membrane-bound and soluble receptor activator of NF-kappaB ligand: modulation of the expression by osteotropic factors and cytokines.","type":"title"},{"content":" ","type":"text"},{"content":"Biochem Biophys Res Commun","type":"source"},{"content":". ","type":"text"},{"content":"2000","type":"year"},{"content":"; ","type":"text"},{"content":"275","type":"volume"},{"content":":","type":"text"},{"content":"768","type":"fpage"},{"content":"â","type":"text"},{"content":"75","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1006/bbrc.2000.3379","type":"doi"},{"content":"10973797","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"27","id":"r27","number":"27"},{"textContent":[{"content":"Hikita A","type":"text"},{"content":", ","type":"text"},{"content":"Yana I","type":"text"},{"content":", ","type":"text"},{"content":"Wakeyama H","type":"text"},{"content":", ","type":"text"},{"content":"Nakamura M","type":"text"},{"content":", ","type":"text"},{"content":"Kadono Y","type":"text"},{"content":", ","type":"text"},{"content":"Oshima Y","type":"text"},{"content":", ","type":"text"},{"content":"Nakamura K","type":"text"},{"content":", ","type":"text"},{"content":"Seiki M","type":"text"},{"content":", ","type":"text"},{"content":"Tanaka S","type":"text"},{"content":". ","type":"text"},{"content":"Negative regulation of osteoclastogenesis by ectodomain shedding of receptor activator of NF-kappaB ligand.","type":"title"},{"content":" ","type":"text"},{"content":"J Biol Chem","type":"source"},{"content":". ","type":"text"},{"content":"2006","type":"year"},{"content":"; ","type":"text"},{"content":"281","type":"volume"},{"content":":","type":"text"},{"content":"36846","type":"fpage"},{"content":"â","type":"text"},{"content":"55","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1074/jbc.M606656200","type":"doi"},{"content":"17018528","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"28","id":"r28","number":"28"},{"textContent":[{"content":"Radio NM","type":"text"},{"content":", ","type":"text"},{"content":"Doctor JS","type":"text"},{"content":", ","type":"text"},{"content":"Witt-Enderby PA","type":"text"},{"content":". ","type":"text"},{"content":"Melatonin enhances alkaline phosphatase activity in differentiating human adult mesenchymal stem cells grown in osteogenic medium via MT2 melatonin receptors and the MEK/ERK (1/2) signaling cascade.","type":"title"},{"content":" ","type":"text"},{"content":"J Pineal Res","type":"source"},{"content":". ","type":"text"},{"content":"2006","type":"year"},{"content":"; ","type":"text"},{"content":"40","type":"volume"},{"content":":","type":"text"},{"content":"332","type":"fpage"},{"content":"â","type":"text"},{"content":"42","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1111/j.1600-079X.2006.00318.x","type":"doi"},{"content":"16635021","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"29","id":"r29","number":"29"},{"textContent":[{"content":"Matsushita T","type":"text"},{"content":", ","type":"text"},{"content":"Chan YY","type":"text"},{"content":", ","type":"text"},{"content":"Kawanami A","type":"text"},{"content":", ","type":"text"},{"content":"Balmes G","type":"text"},{"content":", ","type":"text"},{"content":"Landreth GE","type":"text"},{"content":", ","type":"text"},{"content":"Murakami S","type":"text"},{"content":". ","type":"text"},{"content":"Extracellular signal-regulated kinase 1 (ERK1) and ERK2 play essential roles in osteoblast differentiation and in supporting osteoclastogenesis.","type":"title"},{"content":" ","type":"text"},{"content":"Mol Cell Biol","type":"source"},{"content":". ","type":"text"},{"content":"2009","type":"year"},{"content":"; ","type":"text"},{"content":"29","type":"volume"},{"content":":","type":"text"},{"content":"5843","type":"fpage"},{"content":"â","type":"text"},{"content":"57","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1128/MCB.01549-08","type":"doi"},{"content":"19737917","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"30","id":"r30","number":"30"},{"textContent":[{"content":"Ge C","type":"text"},{"content":", ","type":"text"},{"content":"Xiao G","type":"text"},{"content":", ","type":"text"},{"content":"Jiang D","type":"text"},{"content":", ","type":"text"},{"content":"Yang Q","type":"text"},{"content":", ","type":"text"},{"content":"Hatch NE","type":"text"},{"content":", ","type":"text"},{"content":"Franceschi RT","type":"text"},{"content":". ","type":"text"},{"content":"Identification and functional characterization of extracellular-regulated kinase/MAPK phosphorylation sites in the Runx2 transcription factor.","type":"title"},{"content":" ","type":"text"},{"content":"J Biol Chem","type":"source"},{"content":". ","type":"text"},{"content":"2009","type":"year"},{"content":"; ","type":"text"},{"content":"284","type":"volume"},{"content":":","type":"text"},{"content":"32533","type":"fpage"},{"content":"â","type":"text"},{"content":"43","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1074/jbc.M109.040980","type":"doi"},{"content":"19801668","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"31","id":"r31","number":"31"},{"textContent":[{"content":"Ge C","type":"text"},{"content":", ","type":"text"},{"content":"Xiao G","type":"text"},{"content":", ","type":"text"},{"content":"Jiang D","type":"text"},{"content":", ","type":"text"},{"content":"Franceschi RT","type":"text"},{"content":". ","type":"text"},{"content":"Critical role of the extracellular signal-regulated kinase-MAPK pathway in osteoblast differentiation and skeletal development.","type":"title"},{"content":" ","type":"text"},{"content":"J Cell Biol","type":"source"},{"content":". ","type":"text"},{"content":"2007","type":"year"},{"content":"; ","type":"text"},{"content":"176","type":"volume"},{"content":":","type":"text"},{"content":"709","type":"fpage"},{"content":"â","type":"text"},{"content":"18","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1083/jcb.200610046","type":"doi"},{"content":"17325210","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"32","id":"r32","number":"32"},{"textContent":[{"content":"Sethi S","type":"text"},{"content":", ","type":"text"},{"content":"Radio NM","type":"text"},{"content":", ","type":"text"},{"content":"Kotlarczyk MP","type":"text"},{"content":", ","type":"text"},{"content":"Chen CT","type":"text"},{"content":", ","type":"text"},{"content":"Wei YH","type":"text"},{"content":", ","type":"text"},{"content":"Jockers R","type":"text"},{"content":", ","type":"text"},{"content":"Witt-Enderby PA","type":"text"},{"content":". ","type":"text"},{"content":"Determination of the minimal melatonin exposure required to induce osteoblast differentiation from human mesenchymal stem cells and these effects on downstream signaling pathways.","type":"title"},{"content":" ","type":"text"},{"content":"J Pineal Res","type":"source"},{"content":". ","type":"text"},{"content":"2010","type":"year"},{"content":"; ","type":"text"},{"content":"49","type":"volume"},{"content":":","type":"text"},{"content":"222","type":"fpage"},{"content":"â","type":"text"},{"content":"38","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1111/j.1600-079X.2010.00784.x","type":"doi"},{"content":"20626586","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"33","id":"r33","number":"33"},{"textContent":[{"content":"Bo Z","type":"text"},{"content":", ","type":"text"},{"content":"Bin G","type":"text"},{"content":", ","type":"text"},{"content":"Jing W","type":"text"},{"content":", ","type":"text"},{"content":"Cuifang W","type":"text"},{"content":", ","type":"text"},{"content":"Liping A","type":"text"},{"content":", ","type":"text"},{"content":"Jinglin M","type":"text"},{"content":", ","type":"text"},{"content":"Jin J","type":"text"},{"content":", ","type":"text"},{"content":"Xiaoyi T","type":"text"},{"content":", ","type":"text"},{"content":"Cong C","type":"text"},{"content":", ","type":"text"},{"content":"Ning D","type":"text"},{"content":", ","type":"text"},{"content":"Yayi X","type":"text"},{"content":". ","type":"text"},{"content":"Fluid shear stress promotes osteoblast proliferation via the GÎ±q-ERK5 signaling pathway.","type":"title"},{"content":" ","type":"text"},{"content":"Connect Tissue Res","type":"source"},{"content":". ","type":"text"},{"content":"2016","type":"year"},{"content":"; ","type":"text"},{"content":"57","type":"volume"},{"content":":","type":"text"},{"content":"299","type":"fpage"},{"content":"â","type":"text"},{"content":"306","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1080/03008207.2016.1181063","type":"doi"},{"content":"27115838","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"34","id":"r34","number":"34"},{"textContent":[{"content":"Kaneshiro S","type":"text"},{"content":", ","type":"text"},{"content":"Otsuki D","type":"text"},{"content":", ","type":"text"},{"content":"Yoshida K","type":"text"},{"content":", ","type":"text"},{"content":"Yoshikawa H","type":"text"},{"content":", ","type":"text"},{"content":"Higuchi C","type":"text"},{"content":". ","type":"text"},{"content":"MEK5 suppresses osteoblastic differentiation.","type":"title"},{"content":" ","type":"text"},{"content":"Biochem Biophys Res Commun","type":"source"},{"content":". ","type":"text"},{"content":"2015","type":"year"},{"content":"; ","type":"text"},{"content":"463","type":"volume"},{"content":":","type":"text"},{"content":"241","type":"fpage"},{"content":"â","type":"text"},{"content":"47","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1016/j.bbrc.2015.05.035","type":"doi"},{"content":"25998381","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"35","id":"r35","number":"35"},{"textContent":[{"content":"Li P","type":"text"},{"content":", ","type":"text"},{"content":"Ma YC","type":"text"},{"content":", ","type":"text"},{"content":"Sheng XY","type":"text"},{"content":", ","type":"text"},{"content":"Dong HT","type":"text"},{"content":", ","type":"text"},{"content":"Han H","type":"text"},{"content":", ","type":"text"},{"content":"Wang J","type":"text"},{"content":", ","type":"text"},{"content":"Xia YY","type":"text"},{"content":". ","type":"text"},{"content":"Cyclic fluid shear stress promotes osteoblastic cells proliferation through ERK5 signaling pathway.","type":"title"},{"content":" ","type":"text"},{"content":"Mol Cell Biochem","type":"source"},{"content":". ","type":"text"},{"content":"2012","type":"year"},{"content":"; ","type":"text"},{"content":"364","type":"volume"},{"content":":","type":"text"},{"content":"321","type":"fpage"},{"content":"â","type":"text"},{"content":"27","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1007/s11010-012-1233-y","type":"doi"},{"content":"22286747","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"36","id":"r36","number":"36"},{"textContent":[{"content":"Koyama H","type":"text"},{"content":", ","type":"text"},{"content":"Nakade O","type":"text"},{"content":", ","type":"text"},{"content":"Takada Y","type":"text"},{"content":", ","type":"text"},{"content":"Kaku T","type":"text"},{"content":", ","type":"text"},{"content":"Lau KH","type":"text"},{"content":". ","type":"text"},{"content":"Melatonin at pharmacologic doses increases bone mass by suppressing resorption through down-regulation of the RANKL-mediated osteoclast formation and activation.","type":"title"},{"content":" ","type":"text"},{"content":"J Bone Miner Res","type":"source"},{"content":". ","type":"text"},{"content":"2002","type":"year"},{"content":"; ","type":"text"},{"content":"17","type":"volume"},{"content":":","type":"text"},{"content":"1219","type":"fpage"},{"content":"â","type":"text"},{"content":"29","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1359/jbmr.2002.17.7.1219","type":"doi"},{"content":"12096835","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"37","id":"r37","number":"37"},{"textContent":[{"content":"Witt-Enderby PA","type":"text"},{"content":", ","type":"text"},{"content":"Slater JP","type":"text"},{"content":", ","type":"text"},{"content":"Johnson NA","type":"text"},{"content":", ","type":"text"},{"content":"Bondi CD","type":"text"},{"content":", ","type":"text"},{"content":"Dodda BR","type":"text"},{"content":", ","type":"text"},{"content":"Kotlarczyk MP","type":"text"},{"content":", ","type":"text"},{"content":"Clafshenkel WP","type":"text"},{"content":", ","type":"text"},{"content":"Sethi S","type":"text"},{"content":", ","type":"text"},{"content":"Higginbotham S","type":"text"},{"content":", ","type":"text"},{"content":"Rutkowski JL","type":"text"},{"content":", ","type":"text"},{"content":"Gallagher KM","type":"text"},{"content":", ","type":"text"},{"content":"Davis VL","type":"text"},{"content":". ","type":"text"},{"content":"Effects on bone by the light/dark cycle and chronic treatment with melatonin and/or hormone replacement therapy in intact female mice.","type":"title"},{"content":" ","type":"text"},{"content":"J Pineal Res","type":"source"},{"content":". ","type":"text"},{"content":"2012","type":"year"},{"content":"; ","type":"text"},{"content":"53","type":"volume"},{"content":":","type":"text"},{"content":"374","type":"fpage"},{"content":"â","type":"text"},{"content":"84","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1111/j.1600-079X.2012.01007.x","type":"doi"},{"content":"22639972","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"38","id":"r38","number":"38"},{"textContent":[{"content":"Mizuno M","type":"text"},{"content":", ","type":"text"},{"content":"Fujisawa R","type":"text"},{"content":", ","type":"text"},{"content":"Kuboki Y","type":"text"},{"content":". ","type":"text"},{"content":"Type I collagen-induced osteoblastic differentiation of bone-marrow cells mediated by collagen-Î±2Î²1 integrin interaction.","type":"title"},{"content":" ","type":"text"},{"content":"J Cell Physiol","type":"source"},{"content":". ","type":"text"},{"content":"2000","type":"year"},{"content":"; ","type":"text"},{"content":"184","type":"volume"},{"content":":","type":"text"},{"content":"207","type":"fpage"},{"content":"â","type":"text"},{"content":"13","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1002/1097-4652(200008)184:2<207::AID-JCP8>3.0.CO;2-U","type":"doi"},{"content":"10867645","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"39","id":"r39","number":"39"},{"textContent":[{"content":"Jimi E","type":"text"},{"content":", ","type":"text"},{"content":"Aoki K","type":"text"},{"content":", ","type":"text"},{"content":"Saito H","type":"text"},{"content":", ","type":"text"},{"content":"DâAcquisto F","type":"text"},{"content":", ","type":"text"},{"content":"May MJ","type":"text"},{"content":", ","type":"text"},{"content":"Nakamura I","type":"text"},{"content":", ","type":"text"},{"content":"Sudo T","type":"text"},{"content":", ","type":"text"},{"content":"Kojima T","type":"text"},{"content":", ","type":"text"},{"content":"Okamoto F","type":"text"},{"content":", ","type":"text"},{"content":"Fukushima H","type":"text"},{"content":", ","type":"text"},{"content":"Okabe K","type":"text"},{"content":", ","type":"text"},{"content":"Ohya K","type":"text"},{"content":", ","type":"text"},{"content":"Ghosh S","type":"text"},{"content":". ","type":"text"},{"content":"Selective inhibition of NF-Îº B blocks osteoclastogenesis and prevents inflammatory bone destruction in vivo.","type":"title"},{"content":" ","type":"text"},{"content":"Nat Med","type":"source"},{"content":". ","type":"text"},{"content":"2004","type":"year"},{"content":"; ","type":"text"},{"content":"10","type":"volume"},{"content":":","type":"text"},{"content":"617","type":"fpage"},{"content":"â","type":"text"},{"content":"24","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1038/nm1054","type":"doi"},{"content":"15156202","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"40","id":"r40","number":"40"},{"textContent":[{"content":"Boyce BF","type":"text"},{"content":", ","type":"text"},{"content":"Xing L","type":"text"},{"content":". ","type":"text"},{"content":"Functions of RANKL/RANK/OPG in bone modeling and remodeling.","type":"title"},{"content":" ","type":"text"},{"content":"Arch Biochem Biophys","type":"source"},{"content":". ","type":"text"},{"content":"2008","type":"year"},{"content":"; ","type":"text"},{"content":"473","type":"volume"},{"content":":","type":"text"},{"content":"139","type":"fpage"},{"content":"â","type":"text"},{"content":"46","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1016/j.abb.2008.03.018","type":"doi"},{"content":"18395508","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"41","id":"r41","number":"41"},{"textContent":[{"content":"Wada T","type":"text"},{"content":", ","type":"text"},{"content":"Nakashima T","type":"text"},{"content":", ","type":"text"},{"content":"Hiroshi N","type":"text"},{"content":", ","type":"text"},{"content":"Penninger JM","type":"text"},{"content":". ","type":"text"},{"content":"RANKL-RANK signaling in osteoclastogenesis and bone disease.","type":"title"},{"content":" ","type":"text"},{"content":"Trends Mol Med","type":"source"},{"content":". ","type":"text"},{"content":"2006","type":"year"},{"content":"; ","type":"text"},{"content":"12","type":"volume"},{"content":":","type":"text"},{"content":"17","type":"fpage"},{"content":"â","type":"text"},{"content":"25","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1016/j.molmed.2005.11.007","type":"doi"},{"content":"16356770","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"42","id":"r42","number":"42"},{"textContent":[{"content":"Chang J","type":"text"},{"content":", ","type":"text"},{"content":"Wang Z","type":"text"},{"content":", ","type":"text"},{"content":"Tang E","type":"text"},{"content":", ","type":"text"},{"content":"Fan Z","type":"text"},{"content":", ","type":"text"},{"content":"McCauley L","type":"text"},{"content":", ","type":"text"},{"content":"Franceschi R","type":"text"},{"content":", ","type":"text"},{"content":"Guan K","type":"text"},{"content":", ","type":"text"},{"content":"Krebsbach PH","type":"text"},{"content":", ","type":"text"},{"content":"Wang C-Y","type":"text"},{"content":". ","type":"text"},{"content":"Inhibition of osteoblastic bone formation by nuclear factor-kappaB.","type":"title"},{"content":" ","type":"text"},{"content":"Nat Med","type":"source"},{"content":". ","type":"text"},{"content":"2009","type":"year"},{"content":"; ","type":"text"},{"content":"15","type":"volume"},{"content":":","type":"text"},{"content":"682","type":"fpage"},{"content":"â","type":"text"},{"content":"89","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1038/nm.1954","type":"doi"},{"content":"19448637","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"43","id":"r43","number":"43"},{"textContent":[{"content":"Marie PJ","type":"text"},{"content":". ","type":"text"},{"content":"Osteoblast dysfunctions in bone diseases: from cellular and molecular mechanisms to therapeutic strategies.","type":"title"},{"content":" ","type":"text"},{"content":"Cell Mol Life Sci","type":"source"},{"content":". ","type":"text"},{"content":"2015","type":"year"},{"content":"; ","type":"text"},{"content":"72","type":"volume"},{"content":":","type":"text"},{"content":"1347","type":"fpage"},{"content":"â","type":"text"},{"content":"61","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1007/s00018-014-1801-2","type":"doi"},{"content":"25487608","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"44","id":"r44","number":"44"},{"textContent":[{"content":"Akune T","type":"text"},{"content":", ","type":"text"},{"content":"Ohba S","type":"text"},{"content":", ","type":"text"},{"content":"Kamekura S","type":"text"},{"content":", ","type":"text"},{"content":"Yamaguchi M","type":"text"},{"content":", ","type":"text"},{"content":"Chung UI","type":"text"},{"content":", ","type":"text"},{"content":"Kubota N","type":"text"},{"content":", ","type":"text"},{"content":"Terauchi Y","type":"text"},{"content":", ","type":"text"},{"content":"Harada Y","type":"text"},{"content":", ","type":"text"},{"content":"Azuma Y","type":"text"},{"content":", ","type":"text"},{"content":"Nakamura K","type":"text"},{"content":", ","type":"text"},{"content":"Kadowaki T","type":"text"},{"content":", ","type":"text"},{"content":"Kawaguchi H","type":"text"},{"content":". ","type":"text"},{"content":"PPARgamma insufficiency enhances osteogenesis through osteoblast formation from bone marrow progenitors.","type":"title"},{"content":" ","type":"text"},{"content":"J Clin Invest","type":"source"},{"content":". ","type":"text"},{"content":"2004","type":"year"},{"content":"; ","type":"text"},{"content":"113","type":"volume"},{"content":":","type":"text"},{"content":"846","type":"fpage"},{"content":"â","type":"text"},{"content":"55","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1172/JCI200419900","type":"doi"},{"content":"15067317","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"45","id":"r45","number":"45"},{"textContent":[{"content":"Li Z","type":"text"},{"content":", ","type":"text"},{"content":"Leslie J","type":"text"},{"content":", ","type":"text"},{"content":"Wong GW","type":"text"},{"content":", ","type":"text"},{"content":"Kahn B","type":"text"},{"content":", ","type":"text"},{"content":"Riddle R","type":"text"},{"content":", ","type":"text"},{"content":"Clemens T","type":"text"},{"content":". ","type":"text"},{"content":"Expression of glucose transporter-4 by the osteoblast is required for global glucose metabolism.","type":"title"},{"content":" ","type":"text"},{"content":"J Bone Miner Res","type":"source"},{"content":". ","type":"text"},{"content":"2013","type":"year"},{"content":"; ","type":"text"},{"content":"28","type":"volume"},{"content":":","type":"text"},{"content":"1044","type":"fpage"}],"citationType":"mixed_citation","type":"journal","label":"46","id":"r46","number":"46"},{"textContent":[{"content":"Takada I","type":"text"},{"content":", ","type":"text"},{"content":"Suzawa M","type":"text"},{"content":", ","type":"text"},{"content":"Matsumoto K","type":"text"},{"content":", ","type":"text"},{"content":"Kato S","type":"text"},{"content":". ","type":"text"},{"content":"Suppression of PPAR transactivation switches cell fate of bone marrow stem cells from adipocytes into osteoblasts.","type":"title"},{"content":" ","type":"text"},{"content":"Ann N Y Acad Sci","type":"source"},{"content":". ","type":"text"},{"content":"2007","type":"year"},{"content":"; ","type":"text"},{"content":"1116","type":"volume"},{"content":":","type":"text"},{"content":"182","type":"fpage"},{"content":"â","type":"text"},{"content":"95","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1196/annals.1402.034","type":"doi"},{"content":"17656564","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"47","id":"r47","number":"47"},{"textContent":[{"content":"Ferron M","type":"text"},{"content":", ","type":"text"},{"content":"Wei J","type":"text"},{"content":", ","type":"text"},{"content":"Yoshizawa T","type":"text"},{"content":", ","type":"text"},{"content":"Del Fattore A","type":"text"},{"content":", ","type":"text"},{"content":"DePinho RA","type":"text"},{"content":", ","type":"text"},{"content":"Teti A","type":"text"},{"content":", ","type":"text"},{"content":"Ducy P","type":"text"},{"content":", ","type":"text"},{"content":"Karsenty G","type":"text"},{"content":". ","type":"text"},{"content":"Insulin signaling in osteoblasts integrates bone remodeling and energy metabolism.","type":"title"},{"content":" ","type":"text"},{"content":"Cell","type":"source"},{"content":". ","type":"text"},{"content":"2010","type":"year"},{"content":"; ","type":"text"},{"content":"142","type":"volume"},{"content":":","type":"text"},{"content":"296","type":"fpage"},{"content":"â","type":"text"},{"content":"308","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1016/j.cell.2010.06.003","type":"doi"},{"content":"20655470","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"48","id":"r48","number":"48"},{"textContent":[{"content":"Dudakovic A","type":"text"},{"content":", ","type":"text"},{"content":"Camilleri ET","type":"text"},{"content":", ","type":"text"},{"content":"Xu F","type":"text"},{"content":", ","type":"text"},{"content":"Riester SM","type":"text"},{"content":", ","type":"text"},{"content":"McGee-Lawrence ME","type":"text"},{"content":", ","type":"text"},{"content":"Bradley EW","type":"text"},{"content":", ","type":"text"},{"content":"Paradise CR","type":"text"},{"content":", ","type":"text"},{"content":"Lewallen EA","type":"text"},{"content":", ","type":"text"},{"content":"Thaler R","type":"text"},{"content":", ","type":"text"},{"content":"Deyle DR","type":"text"},{"content":", ","type":"text"},{"content":"Larson AN","type":"text"},{"content":", ","type":"text"},{"content":"Lewallen DG","type":"text"},{"content":", ","type":"text"},{"content":"Dietz AB","type":"text"},{"content":", ","type":"text"},{"content":"et al","type":"etal"},{"content":". ","type":"text"},{"content":"Epigenetic control of skeletal development by the histone methyltransferase Ezh2.","type":"title"},{"content":" ","type":"text"},{"content":"J Biol Chem","type":"source"},{"content":". ","type":"text"},{"content":"2015","type":"year"},{"content":"; ","type":"text"},{"content":"290","type":"volume"},{"content":":","type":"text"},{"content":"27604","type":"fpage"},{"content":"â","type":"text"},{"content":"17","type":"lpage"},{"content":".","type":"text"},{"content":"26424790","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"49","id":"r49","number":"49"},{"textContent":[{"content":"Dudakovic A","type":"text"},{"content":", ","type":"text"},{"content":"Camilleri ET","type":"text"},{"content":", ","type":"text"},{"content":"Riester SM","type":"text"},{"content":", ","type":"text"},{"content":"Paradise CR","type":"text"},{"content":", ","type":"text"},{"content":"Gluscevic M","type":"text"},{"content":", ","type":"text"},{"content":"OâToole TM","type":"text"},{"content":", ","type":"text"},{"content":"Thaler R","type":"text"},{"content":", ","type":"text"},{"content":"Evans JM","type":"text"},{"content":", ","type":"text"},{"content":"Yan H","type":"text"},{"content":", ","type":"text"},{"content":"Subramaniam M","type":"text"},{"content":", ","type":"text"},{"content":"Hawse JR","type":"text"},{"content":", ","type":"text"},{"content":"Stein GS","type":"text"},{"content":", ","type":"text"},{"content":"Montecino MA","type":"text"},{"content":", ","type":"text"},{"content":"et al","type":"etal"},{"content":". ","type":"text"},{"content":"Enhancer of Zeste Homolog 2 Inhibition Stimulates Bone Formation and Mitigates Bone Loss Caused by Ovariectomy in Skeletally Mature Mice.","type":"title"},{"content":" ","type":"text"},{"content":"J Biol Chem","type":"source"},{"content":". ","type":"text"},{"content":"2016","type":"year"},{"content":"; ","type":"text"},{"content":"291","type":"volume"},{"content":":","type":"text"},{"content":"24594","type":"fpage"},{"content":"â","type":"text"},{"content":"606","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1074/jbc.M116.740571","type":"doi"},{"content":"27758858","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"50","id":"r50","number":"50"},{"textContent":[{"content":"Finkelstein JS","type":"text"},{"content":", ","type":"text"},{"content":"Brockwell SE","type":"text"},{"content":", ","type":"text"},{"content":"Mehta V","type":"text"},{"content":", ","type":"text"},{"content":"Greendale GA","type":"text"},{"content":", ","type":"text"},{"content":"Sowers MR","type":"text"},{"content":", ","type":"text"},{"content":"Ettinger B","type":"text"},{"content":", ","type":"text"},{"content":"Lo JC","type":"text"},{"content":", ","type":"text"},{"content":"Johnston JM","type":"text"},{"content":", ","type":"text"},{"content":"Cauley JA","type":"text"},{"content":", ","type":"text"},{"content":"Danielson ME","type":"text"},{"content":", ","type":"text"},{"content":"Neer RM","type":"text"},{"content":". ","type":"text"},{"content":"Bone mineral density changes during the menopause transition in a multiethnic cohort of women.","type":"title"},{"content":" ","type":"text"},{"content":"J Clin Endocrinol Metab","type":"source"},{"content":". ","type":"text"},{"content":"2008","type":"year"},{"content":"; ","type":"text"},{"content":"93","type":"volume"},{"content":":","type":"text"},{"content":"861","type":"fpage"},{"content":"â","type":"text"},{"content":"68","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1210/jc.2007-1876","type":"doi"},{"content":"18160467","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"51","id":"r51","number":"51"},{"textContent":[{"content":"Clarke B","type":"text"},{"content":". ","type":"text"},{"content":"Normal bone anatomy and physiology.","type":"title"},{"content":" ","type":"text"},{"content":"Clin J Am Soc Nephrol","type":"source"},{"content":". ","type":"text"},{"content":"2008","type":"year"},{"content":" (","type":"text"},{"content":"Suppl 3","type":"supplement"},{"content":"); ","type":"text"},{"content":"3","type":"volume"},{"content":":","type":"text"},{"content":"S131","type":"fpage"},{"content":"â","type":"text"},{"content":"39","type":"lpage"},{"content":". ","type":"text"},{"content":"10.2215/CJN.04151206","type":"doi"},{"content":"18988698","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"52","id":"r52","number":"52"},{"textContent":[{"content":"Amstrup AK","type":"text"},{"content":", ","type":"text"},{"content":"Sikjaer T","type":"text"},{"content":", ","type":"text"},{"content":"Pedersen SB","type":"text"},{"content":", ","type":"text"},{"content":"Heickendorff L","type":"text"},{"content":", ","type":"text"},{"content":"Mosekilde L","type":"text"},{"content":", ","type":"text"},{"content":"Rejnmark L","type":"text"},{"content":". ","type":"text"},{"content":"Reduced fat mass and increased lean mass in response to 1 year of melatonin treatment in postmenopausal women: A randomized placebo-controlled trial.","type":"title"},{"content":" ","type":"text"},{"content":"Clin Endocrinol (Oxf)","type":"source"},{"content":". ","type":"text"},{"content":"2016","type":"year"},{"content":"; ","type":"text"},{"content":"84","type":"volume"},{"content":":","type":"text"},{"content":"342","type":"fpage"},{"content":"â","type":"text"},{"content":"47","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1111/cen.12942","type":"doi"},{"content":"26352863","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"53","id":"r53","number":"53"},{"textContent":[{"content":"Franceschi RT","type":"text"},{"content":", ","type":"text"},{"content":"Xiao G","type":"text"},{"content":". ","type":"text"},{"content":"Regulation of the osteoblast-specific transcription factor, Runx2: responsiveness to multiple signal transduction pathways.","type":"title"},{"content":" ","type":"text"},{"content":"J Cell Biochem","type":"source"},{"content":". ","type":"text"},{"content":"2003","type":"year"},{"content":"; ","type":"text"},{"content":"88","type":"volume"},{"content":":","type":"text"},{"content":"446","type":"fpage"},{"content":"â","type":"text"},{"content":"54","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1002/jcb.10369","type":"doi"},{"content":"12532321","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"54","id":"r54","number":"54"},{"textContent":[{"content":"Gaur T","type":"text"},{"content":", ","type":"text"},{"content":"Lengner CJ","type":"text"},{"content":", ","type":"text"},{"content":"Hovhannisyan H","type":"text"},{"content":", ","type":"text"},{"content":"Bhat RA","type":"text"},{"content":", ","type":"text"},{"content":"Bodine PV","type":"text"},{"content":", ","type":"text"},{"content":"Komm BS","type":"text"},{"content":", ","type":"text"},{"content":"Javed A","type":"text"},{"content":", ","type":"text"},{"content":"van Wijnen AJ","type":"text"},{"content":", ","type":"text"},{"content":"Stein JL","type":"text"},{"content":", ","type":"text"},{"content":"Stein GS","type":"text"},{"content":", ","type":"text"},{"content":"Lian JB","type":"text"},{"content":". ","type":"text"},{"content":"Canonical WNT signaling promotes osteogenesis by directly stimulating Runx2 gene expression.","type":"title"},{"content":" ","type":"text"},{"content":"J Biol Chem","type":"source"},{"content":". ","type":"text"},{"content":"2005","type":"year"},{"content":"; ","type":"text"},{"content":"280","type":"volume"},{"content":":","type":"text"},{"content":"33132","type":"fpage"},{"content":"â","type":"text"},{"content":"40","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1074/jbc.M500608200","type":"doi"},{"content":"16043491","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"55","id":"r55","number":"55"},{"textContent":[{"content":"RodrÃ­guez-Carballo E","type":"text"},{"content":", ","type":"text"},{"content":"GÃ¡mez B","type":"text"},{"content":", ","type":"text"},{"content":"Ventura F","type":"text"},{"content":". ","type":"text"},{"content":"p38 MAPK Signaling in Osteoblast Differentiation.","type":"title"},{"content":" ","type":"text"},{"content":"Front Cell Dev Biol","type":"source"},{"content":". ","type":"text"},{"content":"2016","type":"year"},{"content":"; ","type":"text"},{"content":"4","type":"volume"},{"content":":","type":"text"},{"content":"40","type":"fpage"},{"content":". ","type":"text"},{"content":"10.3389/fcell.2016.00040","type":"doi"},{"content":"27200351","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"56","id":"r56","number":"56"},{"textContent":[{"content":"Sims NA, Gooi JH. (2008). Bone remodeling: Multiple cellular interactions required for coupling of bone formation and resorption. Semin Cell Dev Biol: Elsevier), pp. 444-451.","type":"text"}],"citationType":"mixed_citation","type":"book","label":"57","id":"r57","number":"57"},{"textContent":[{"content":"Eriksen EF","type":"text"},{"content":". ","type":"text"},{"content":"Cellular mechanisms of bone remodeling.","type":"title"},{"content":" ","type":"text"},{"content":"Rev Endocr Metab Disord","type":"source"},{"content":". ","type":"text"},{"content":"2010","type":"year"},{"content":"; ","type":"text"},{"content":"11","type":"volume"},{"content":":","type":"text"},{"content":"219","type":"fpage"},{"content":"â","type":"text"},{"content":"27","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1007/s11154-010-9153-1","type":"doi"},{"content":"21188536","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"58","id":"r58","number":"58"},{"textContent":[{"content":"Henriksen K","type":"text"},{"content":", ","type":"text"},{"content":"Neutzsky-Wulff AV","type":"text"},{"content":", ","type":"text"},{"content":"Bonewald LF","type":"text"},{"content":", ","type":"text"},{"content":"Karsdal MA","type":"text"},{"content":". ","type":"text"},{"content":"Local communication on and within bone controls bone remodeling.","type":"title"},{"content":" ","type":"text"},{"content":"Bone","type":"source"},{"content":". ","type":"text"},{"content":"2009","type":"year"},{"content":"; ","type":"text"},{"content":"44","type":"volume"},{"content":":","type":"text"},{"content":"1026","type":"fpage"},{"content":"â","type":"text"},{"content":"33","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1016/j.bone.2009.03.671","type":"doi"},{"content":"19345750","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"59","id":"r59","number":"59"},{"textContent":[{"content":"Silverman S","type":"text"},{"content":", ","type":"text"},{"content":"Gold DT","type":"text"},{"content":". ","type":"text"},{"content":"Compliance and persistence with osteoporosis medications: a critical review of the literature.","type":"title"},{"content":" ","type":"text"},{"content":"Rev Endocr Metab Disord","type":"source"},{"content":". ","type":"text"},{"content":"2010","type":"year"},{"content":"; ","type":"text"},{"content":"11","type":"volume"},{"content":":","type":"text"},{"content":"275","type":"fpage"},{"content":"â","type":"text"},{"content":"80","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1007/s11154-010-9138-0","type":"doi"},{"content":"20443140","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"60","id":"r60","number":"60"},{"textContent":[{"content":"Roux C","type":"text"},{"content":". ","type":"text"},{"content":"Strontium ranelate: short- and long-term benefits for post-menopausal women with osteoporosis.","type":"title"},{"content":" ","type":"text"},{"content":"Rheumatology (Oxford)","type":"source"},{"content":". ","type":"text"},{"content":"2008","type":"year"},{"content":" (","type":"text"},{"content":"Suppl 4","type":"supplement"},{"content":"); ","type":"text"},{"content":"47","type":"volume"},{"content":":","type":"text"},{"content":"iv20","type":"fpage"},{"content":"â","type":"text"},{"content":"22","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1093/rheumatology/ken166","type":"doi"},{"content":"18556647","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"61","id":"r61","number":"61"},{"textContent":[{"content":"Chen G","type":"text"},{"content":", ","type":"text"},{"content":"Chen L","type":"text"},{"content":", ","type":"text"},{"content":"Wen J","type":"text"},{"content":", ","type":"text"},{"content":"Yao J","type":"text"},{"content":", ","type":"text"},{"content":"Li L","type":"text"},{"content":", ","type":"text"},{"content":"Lin L","type":"text"},{"content":", ","type":"text"},{"content":"Tang K","type":"text"},{"content":", ","type":"text"},{"content":"Huang H","type":"text"},{"content":", ","type":"text"},{"content":"Liang J","type":"text"},{"content":", ","type":"text"},{"content":"Lin W","type":"text"},{"content":", ","type":"text"},{"content":"Chen H","type":"text"},{"content":", ","type":"text"},{"content":"Li M","type":"text"},{"content":", ","type":"text"},{"content":"Gong X","type":"text"},{"content":", ","type":"text"},{"content":"et al","type":"etal"},{"content":". ","type":"text"},{"content":"Associations between sleep duration, daytime nap duration, and osteoporosis vary by sex, menopause, and sleep quality.","type":"title"},{"content":" ","type":"text"},{"content":"J Clin Endocrinol Metab","type":"source"},{"content":". ","type":"text"},{"content":"2014","type":"year"},{"content":"; ","type":"text"},{"content":"99","type":"volume"},{"content":":","type":"text"},{"content":"2869","type":"fpage"},{"content":"â","type":"text"},{"content":"77","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1210/jc.2013-3629","type":"doi"},{"content":"24848706","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"62","id":"r62","number":"62"},{"textContent":[{"content":"Witt-Enderby PA","type":"text"},{"content":", ","type":"text"},{"content":"Radio NM","type":"text"},{"content":", ","type":"text"},{"content":"Doctor JS","type":"text"},{"content":", ","type":"text"},{"content":"Davis VL","type":"text"},{"content":". ","type":"text"},{"content":"Therapeutic treatments potentially mediated by melatonin receptors: potential clinical uses in the prevention of osteoporosis, cancer and as an adjuvant therapy.","type":"title"},{"content":" ","type":"text"},{"content":"J Pineal Res","type":"source"},{"content":". ","type":"text"},{"content":"2006","type":"year"},{"content":"; ","type":"text"},{"content":"41","type":"volume"},{"content":":","type":"text"},{"content":"297","type":"fpage"},{"content":"â","type":"text"},{"content":"305","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1111/j.1600-079X.2006.00369.x","type":"doi"},{"content":"17014686","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"63","id":"r63","number":"63"},{"textContent":[{"content":"Bellipanni G","type":"text"},{"content":", ","type":"text"},{"content":"Bianchi P","type":"text"},{"content":", ","type":"text"},{"content":"Pierpaoli W","type":"text"},{"content":", ","type":"text"},{"content":"Bulian D","type":"text"},{"content":", ","type":"text"},{"content":"Ilyia E","type":"text"},{"content":". ","type":"text"},{"content":"Effects of melatonin in perimenopausal and menopausal women: a randomized and placebo controlled study.","type":"title"},{"content":" ","type":"text"},{"content":"Exp Gerontol","type":"source"},{"content":". ","type":"text"},{"content":"2001","type":"year"},{"content":"; ","type":"text"},{"content":"36","type":"volume"},{"content":":","type":"text"},{"content":"297","type":"fpage"},{"content":"â","type":"text"},{"content":"310","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1016/S0531-5565(00)00217-5","type":"doi"},{"content":"11226744","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"64","id":"r64","number":"64"},{"textContent":[{"content":"Di W-L","type":"text"},{"content":", ","type":"text"},{"content":"Kadva A","type":"text"},{"content":", ","type":"text"},{"content":"Johnston A","type":"text"},{"content":", ","type":"text"},{"content":"Silman R","type":"text"},{"content":". ","type":"text"},{"content":"Variable bioavailability of oral melatonin.","type":"title"},{"content":" ","type":"text"},{"content":"N Engl J Med","type":"source"},{"content":". ","type":"text"},{"content":"1997","type":"year"},{"content":"; ","type":"text"},{"content":"336","type":"volume"},{"content":":","type":"text"},{"content":"1028","type":"fpage"},{"content":"â","type":"text"},{"content":"29","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1056/NEJM199704033361418","type":"doi"},{"content":"9091795","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"65","id":"r65","number":"65"},{"textContent":[{"content":"De Vita F","type":"text"},{"content":", ","type":"text"},{"content":"Lauretani F","type":"text"},{"content":", ","type":"text"},{"content":"Bauer J","type":"text"},{"content":", ","type":"text"},{"content":"Bautmans I","type":"text"},{"content":", ","type":"text"},{"content":"Shardell M","type":"text"},{"content":", ","type":"text"},{"content":"Cherubini A","type":"text"},{"content":", ","type":"text"},{"content":"Bondi G","type":"text"},{"content":", ","type":"text"},{"content":"Zuliani G","type":"text"},{"content":", ","type":"text"},{"content":"Bandinelli S","type":"text"},{"content":", ","type":"text"},{"content":"Pedrazzoni M","type":"text"},{"content":", ","type":"text"},{"content":"DallâAglio E","type":"text"},{"content":", ","type":"text"},{"content":"Ceda GP","type":"text"},{"content":", ","type":"text"},{"content":"Maggio M","type":"text"},{"content":". ","type":"text"},{"content":"Relationship between vitamin D and inflammatory markers in older individuals.","type":"title"},{"content":" ","type":"text"},{"content":"Age (Dordr)","type":"source"},{"content":". ","type":"text"},{"content":"2014","type":"year"},{"content":"; ","type":"text"},{"content":"36","type":"volume"},{"content":":","type":"text"},{"content":"9694","type":"fpage"},{"content":". ","type":"text"},{"content":"10.1007/s11357-014-9694-4","type":"doi"},{"content":"25086618","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"66","id":"r66","number":"66"},{"textContent":[{"content":"de Pablo P","type":"text"},{"content":", ","type":"text"},{"content":"Cooper MS","type":"text"},{"content":", ","type":"text"},{"content":"Buckley CD","type":"text"},{"content":". ","type":"text"},{"content":"Association between bone mineral density and C-reactive protein in a large population-based sample.","type":"title"},{"content":" ","type":"text"},{"content":"Arthritis Rheum","type":"source"},{"content":". ","type":"text"},{"content":"2012","type":"year"},{"content":"; ","type":"text"},{"content":"64","type":"volume"},{"content":":","type":"text"},{"content":"2624","type":"fpage"},{"content":"â","type":"text"},{"content":"31","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1002/art.34474","type":"doi"},{"content":"22487938","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"67","id":"r67","number":"67"},{"textContent":[{"content":"Lee Y","type":"text"},{"content":", ","type":"text"},{"content":"Kim M","type":"text"},{"content":", ","type":"text"},{"content":"Choi K","type":"text"},{"content":", ","type":"text"},{"content":"Kim J","type":"text"},{"content":", ","type":"text"},{"content":"Bae W","type":"text"},{"content":", ","type":"text"},{"content":"Kim S","type":"text"},{"content":", ","type":"text"},{"content":"Sohn C","type":"text"},{"content":". ","type":"text"},{"content":"Relationship between inflammation biomarkers, antioxidant vitamins, and bone mineral density in patients with metabolic syndrome.","type":"title"},{"content":" ","type":"text"},{"content":"Nutr Res Pract","type":"source"},{"content":". ","type":"text"},{"content":"2011","type":"year"},{"content":"; ","type":"text"},{"content":"5","type":"volume"},{"content":":","type":"text"},{"content":"150","type":"fpage"},{"content":"â","type":"text"},{"content":"56","type":"lpage"},{"content":". ","type":"text"},{"content":"10.4162/nrp.2011.5.2.150","type":"doi"},{"content":"21556229","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"68","id":"r68","number":"68"},{"textContent":[{"content":"Koh J-M","type":"text"},{"content":", ","type":"text"},{"content":"Khang Y-H","type":"text"},{"content":", ","type":"text"},{"content":"Jung C-H","type":"text"},{"content":", ","type":"text"},{"content":"Bae S","type":"text"},{"content":", ","type":"text"},{"content":"Kim DJ","type":"text"},{"content":", ","type":"text"},{"content":"Chung Y-E","type":"text"},{"content":", ","type":"text"},{"content":"Kim GS","type":"text"},{"content":". ","type":"text"},{"content":"Higher circulating hsCRP levels are associated with lower bone mineral density in healthy pre- and postmenopausal women: evidence for a link between systemic inflammation and osteoporosis.","type":"title"},{"content":" ","type":"text"},{"content":"Osteoporos Int","type":"source"},{"content":". ","type":"text"},{"content":"2005","type":"year"},{"content":"; ","type":"text"},{"content":"16","type":"volume"},{"content":":","type":"text"},{"content":"1263","type":"fpage"},{"content":"â","type":"text"},{"content":"71","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1007/s00198-005-1840-5","type":"doi"},{"content":"15702263","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"69","id":"r69","number":"69"},{"textContent":[{"content":"Ishii S","type":"text"},{"content":", ","type":"text"},{"content":"Cauley JA","type":"text"},{"content":", ","type":"text"},{"content":"Greendale GA","type":"text"},{"content":", ","type":"text"},{"content":"Crandall CJ","type":"text"},{"content":", ","type":"text"},{"content":"Danielson ME","type":"text"},{"content":", ","type":"text"},{"content":"Ouchi Y","type":"text"},{"content":", ","type":"text"},{"content":"Karlamangla AS","type":"text"},{"content":". ","type":"text"},{"content":"C-reactive protein, bone strength, and nine-year fracture risk: data from the Study of Womenâs Health Across the Nation (SWAN).","type":"title"},{"content":" ","type":"text"},{"content":"J Bone Miner Res","type":"source"},{"content":". ","type":"text"},{"content":"2013","type":"year"},{"content":"; ","type":"text"},{"content":"28","type":"volume"},{"content":":","type":"text"},{"content":"1688","type":"fpage"},{"content":"â","type":"text"},{"content":"98","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1002/jbmr.1915","type":"doi"},{"content":"23456822","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"70","id":"r70","number":"70"},{"textContent":[{"content":"Mavroeidi A","type":"text"},{"content":", ","type":"text"},{"content":"Aucott L","type":"text"},{"content":", ","type":"text"},{"content":"Black AJ","type":"text"},{"content":", ","type":"text"},{"content":"Fraser WD","type":"text"},{"content":", ","type":"text"},{"content":"Reid DM","type":"text"},{"content":", ","type":"text"},{"content":"Macdonald HM","type":"text"},{"content":". ","type":"text"},{"content":"Seasonal variation in 25(OH)D at Aberdeen (57Â°N) and bone health indicators--could holidays in the sun and cod liver oil supplements alleviate deficiency?.","type":"title"},{"content":" ","type":"text"},{"content":"PLoS One","type":"source"},{"content":". ","type":"text"},{"content":"2013","type":"year"},{"content":"; ","type":"text"},{"content":"8","type":"volume"},{"content":":","type":"text"},{"content":"e53381","type":"fpage"},{"content":". ","type":"text"},{"content":"10.1371/journal.pone.0053381","type":"doi"},{"content":"23308207","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"71","id":"r71","number":"71"},{"textContent":[{"content":"Emaus N","type":"text"},{"content":", ","type":"text"},{"content":"Wilsgaard T","type":"text"},{"content":", ","type":"text"},{"content":"Ahmed LA","type":"text"},{"content":". ","type":"text"},{"content":"Impacts of body mass index, physical activity, and smoking on femoral bone loss: the TromsÃ¸ study.","type":"title"},{"content":" ","type":"text"},{"content":"J Bone Miner Res","type":"source"},{"content":". ","type":"text"},{"content":"2014","type":"year"},{"content":"; ","type":"text"},{"content":"29","type":"volume"},{"content":":","type":"text"},{"content":"2080","type":"fpage"},{"content":"â","type":"text"},{"content":"89","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1002/jbmr.2232","type":"doi"},{"content":"24676861","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"72","id":"r72","number":"72"},{"textContent":[{"content":"Lecka-Czernik B","type":"text"},{"content":". ","type":"text"},{"content":"Bone loss in diabetes: use of antidiabetic thiazolidinediones and secondary osteoporosis.","type":"title"},{"content":" ","type":"text"},{"content":"Curr Osteoporos Rep","type":"source"},{"content":". ","type":"text"},{"content":"2010","type":"year"},{"content":"; ","type":"text"},{"content":"8","type":"volume"},{"content":":","type":"text"},{"content":"178","type":"fpage"},{"content":"â","type":"text"},{"content":"84","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1007/s11914-010-0027-y","type":"doi"},{"content":"20809203","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"73","id":"r73","number":"73"},{"textContent":[{"content":"Lecka-Czernik B","type":"text"},{"content":", ","type":"text"},{"content":"Suva LJ","type":"text"},{"content":". ","type":"text"},{"content":"Resolving the two âbonyâ faces of PPAR-Î³.","type":"title"},{"content":" ","type":"text"},{"content":"PPAR Res","type":"source"},{"content":". ","type":"text"},{"content":"2006","type":"year"},{"content":"; ","type":"text"},{"content":"2006","type":"volume"},{"content":":","type":"text"},{"content":"27489","type":"fpage"},{"content":". ","type":"text"},{"content":"10.1155/PPAR/2006/27489","type":"doi"},{"content":"17259664","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"74","id":"r74","number":"74"},{"textContent":[{"content":"Zhang L","type":"text"},{"content":", ","type":"text"},{"content":"Su P","type":"text"},{"content":", ","type":"text"},{"content":"Xu C","type":"text"},{"content":", ","type":"text"},{"content":"Chen C","type":"text"},{"content":", ","type":"text"},{"content":"Liang A","type":"text"},{"content":", ","type":"text"},{"content":"Du K","type":"text"},{"content":", ","type":"text"},{"content":"Peng Y","type":"text"},{"content":", ","type":"text"},{"content":"Huang D","type":"text"},{"content":". ","type":"text"},{"content":"Melatonin inhibits adipogenesis and enhances osteogenesis of human mesenchymal stem cells by suppressing PPARÎ³ expression and enhancing Runx2 expression.","type":"title"},{"content":" ","type":"text"},{"content":"J Pineal Res","type":"source"},{"content":". ","type":"text"},{"content":"2010","type":"year"},{"content":"; ","type":"text"},{"content":"49","type":"volume"},{"content":":","type":"text"},{"content":"364","type":"fpage"},{"content":"â","type":"text"},{"content":"72","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1111/j.1600-079X.2010.00803.x","type":"doi"},{"content":"20738756","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"75","id":"r75","number":"75"},{"textContent":[{"content":"Saidak Z","type":"text"},{"content":", ","type":"text"},{"content":"HaÃ¿ E","type":"text"},{"content":", ","type":"text"},{"content":"Marty C","type":"text"},{"content":", ","type":"text"},{"content":"Barbara A","type":"text"},{"content":", ","type":"text"},{"content":"Marie PJ","type":"text"},{"content":". ","type":"text"},{"content":"Strontium ranelate rebalances bone marrow adipogenesis and osteoblastogenesis in senescent osteopenic mice through NFATc/Maf and Wnt signaling.","type":"title"},{"content":" ","type":"text"},{"content":"Aging Cell","type":"source"},{"content":". ","type":"text"},{"content":"2012","type":"year"},{"content":"; ","type":"text"},{"content":"11","type":"volume"},{"content":":","type":"text"},{"content":"467","type":"fpage"},{"content":"â","type":"text"},{"content":"74","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1111/j.1474-9726.2012.00804.x","type":"doi"},{"content":"22321691","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"76","id":"r76","number":"76"},{"textContent":[{"content":"Liao W","type":"text"},{"content":", ","type":"text"},{"content":"Nguyen MT","type":"text"},{"content":", ","type":"text"},{"content":"Yoshizaki T","type":"text"},{"content":", ","type":"text"},{"content":"Favelyukis S","type":"text"},{"content":", ","type":"text"},{"content":"Patsouris D","type":"text"},{"content":", ","type":"text"},{"content":"Imamura T","type":"text"},{"content":", ","type":"text"},{"content":"Verma IM","type":"text"},{"content":", ","type":"text"},{"content":"Olefsky JM","type":"text"},{"content":". ","type":"text"},{"content":"Suppression of PPAR-Î³ attenuates insulin-stimulated glucose uptake by affecting both GLUT1 and GLUT4 in 3T3-L1 adipocytes.","type":"title"},{"content":" ","type":"text"},{"content":"Am J Physiol Endocrinol Metab","type":"source"},{"content":". ","type":"text"},{"content":"2007","type":"year"},{"content":"; ","type":"text"},{"content":"293","type":"volume"},{"content":":","type":"text"},{"content":"E219","type":"fpage"},{"content":"â","type":"text"},{"content":"27","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1152/ajpendo.00695.2006","type":"doi"},{"content":"17389706","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"77","id":"r77","number":"77"},{"textContent":[{"content":"Armoni M","type":"text"},{"content":", ","type":"text"},{"content":"Harel C","type":"text"},{"content":", ","type":"text"},{"content":"Karnieli E","type":"text"},{"content":". ","type":"text"},{"content":"Transcriptional regulation of the GLUT4 gene: from PPAR-Î³ and FOXO1 to FFA and inflammation.","type":"title"},{"content":" ","type":"text"},{"content":"Trends Endocrinol Metab","type":"source"},{"content":". ","type":"text"},{"content":"2007","type":"year"},{"content":"; ","type":"text"},{"content":"18","type":"volume"},{"content":":","type":"text"},{"content":"100","type":"fpage"},{"content":"â","type":"text"},{"content":"07","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1016/j.tem.2007.02.001","type":"doi"},{"content":"17317207","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"78","id":"r78","number":"78"},{"textContent":[{"content":"Kanis JA","type":"text"},{"content":", ","type":"text"},{"content":"McCloskey EV","type":"text"},{"content":", ","type":"text"},{"content":"Johansson H","type":"text"},{"content":", ","type":"text"},{"content":"Oden A","type":"text"},{"content":", ","type":"text"},{"content":"StrÃ¶m O","type":"text"},{"content":", ","type":"text"},{"content":"BorgstrÃ¶m F","type":"text"},{"content":". ","type":"text"},{"content":"Development and use of FRAX in osteoporosis.","type":"title"},{"content":" ","type":"text"},{"content":"Osteoporos Int","type":"source"},{"content":". ","type":"text"},{"content":"2010","type":"year"},{"content":" (","type":"text"},{"content":"Suppl 2","type":"supplement"},{"content":"); ","type":"text"},{"content":"21","type":"volume"},{"content":":","type":"text"},{"content":"S407","type":"fpage"},{"content":"â","type":"text"},{"content":"13","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1007/s00198-010-1253-y","type":"doi"},{"content":"20464374","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"79","id":"r79","number":"79"},{"textContent":[{"content":"Kanis JA","type":"text"},{"content":", ","type":"text"},{"content":"Hans D","type":"text"},{"content":", ","type":"text"},{"content":"Cooper C","type":"text"},{"content":", ","type":"text"},{"content":"Baim S","type":"text"},{"content":", ","type":"text"},{"content":"Bilezikian JP","type":"text"},{"content":", ","type":"text"},{"content":"Binkley N","type":"text"},{"content":", ","type":"text"},{"content":"Cauley JA","type":"text"},{"content":", ","type":"text"},{"content":"Compston JE","type":"text"},{"content":", ","type":"text"},{"content":"Dawson-Hughes B","type":"text"},{"content":", ","type":"text"},{"content":"El-Hajj Fuleihan G","type":"text"},{"content":", ","type":"text"},{"content":"Johansson H","type":"text"},{"content":", ","type":"text"},{"content":"Leslie WD","type":"text"},{"content":", ","type":"text"},{"content":"Lewiecki EM","type":"text"},{"content":", ","type":"text"},{"content":"et al","type":"etal"},{"content":", and ","type":"text"},{"content":"Task Force of the FRAX Initiative","type":"collab"},{"content":". ","type":"text"},{"content":"Interpretation and use of FRAX in clinical practice.","type":"title"},{"content":" ","type":"text"},{"content":"Osteoporos Int","type":"source"},{"content":". ","type":"text"},{"content":"2011","type":"year"},{"content":"; ","type":"text"},{"content":"22","type":"volume"},{"content":":","type":"text"},{"content":"2395","type":"fpage"},{"content":"â","type":"text"},{"content":"411","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1007/s00198-011-1713-z","type":"doi"},{"content":"21779818","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"80","id":"r80","number":"80"},{"textContent":[{"content":"Lewis JE","type":"text"},{"content":", ","type":"text"},{"content":"Hilditch JR","type":"text"},{"content":", ","type":"text"},{"content":"Wong CJ","type":"text"},{"content":". ","type":"text"},{"content":"Further psychometric property development of the Menopause-Specific Quality of Life questionnaire and development of a modified version, MENQOL-Intervention questionnaire.","type":"title"},{"content":" ","type":"text"},{"content":"Maturitas","type":"source"},{"content":". ","type":"text"},{"content":"2005","type":"year"},{"content":"; ","type":"text"},{"content":"50","type":"volume"},{"content":":","type":"text"},{"content":"209","type":"fpage"},{"content":"â","type":"text"},{"content":"21","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1016/j.maturitas.2004.06.015","type":"doi"},{"content":"15734602","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"81","id":"r81","number":"81"},{"textContent":[{"content":"Hilditch JR","type":"text"},{"content":", ","type":"text"},{"content":"Lewis J","type":"text"},{"content":", ","type":"text"},{"content":"Peter A","type":"text"},{"content":", ","type":"text"},{"content":"van Maris B","type":"text"},{"content":", ","type":"text"},{"content":"Ross A","type":"text"},{"content":", ","type":"text"},{"content":"Franssen E","type":"text"},{"content":", ","type":"text"},{"content":"Guyatt GH","type":"text"},{"content":", ","type":"text"},{"content":"Norton PG","type":"text"},{"content":", ","type":"text"},{"content":"Dunn E","type":"text"},{"content":". ","type":"text"},{"content":"A menopause-specific quality of life questionnaire: development and psychometric properties.","type":"title"},{"content":" ","type":"text"},{"content":"Maturitas","type":"source"},{"content":". ","type":"text"},{"content":"2008","type":"year"},{"content":"; ","type":"text"},{"content":"61","type":"volume"},{"content":":","type":"text"},{"content":"107","type":"fpage"},{"content":"â","type":"text"},{"content":"21","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1016/j.maturitas.2008.09.014","type":"doi"},{"content":"19434884","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"82","id":"r82","number":"82"},{"textContent":[{"content":"Spielberger CD, Gorsuch RL, Lushene R. The state-trait anxiety inventory: A Test Manual. Consulting Psychologists press, Palo Alto, CA. 1970; 22.","type":"text"}],"citationType":"mixed_citation","type":"book","label":"83","id":"r83","number":"83"},{"textContent":[{"content":"Yu R","type":"text"},{"content":", ","type":"text"},{"content":"Ho SC","type":"text"},{"content":". ","type":"text"},{"content":"Psychometric evaluation of the perceived stress scale in early postmenopausal Chinese women.","type":"title"},{"content":" ","type":"text"},{"content":"Psychology (Irvine)","type":"source"},{"content":". ","type":"text"},{"content":"2010","type":"year"},{"content":"; ","type":"text"},{"content":"1","type":"volume"},{"content":":","type":"text"},{"content":"1","type":"fpage"},{"content":"â","type":"text"},{"content":"8","type":"lpage"},{"content":". ","type":"text"},{"content":"10.4236/psych.2010.11001","type":"doi"}],"citationType":"mixed_citation","type":"journal","label":"84","id":"r84","number":"84"},{"textContent":[{"content":"Cohen S, Williamson GM. Perceived stress in a probability sample of the United States. In The Social Psychology of Health (Eds: S. Spacapan and S. Oskamp). Newbury Park, CA, 1988.","type":"text"}],"citationType":"mixed_citation","type":"book","label":"85","id":"r85","number":"85"},{"textContent":[{"content":"Cohen S","type":"text"},{"content":", ","type":"text"},{"content":"Kamarck T","type":"text"},{"content":", ","type":"text"},{"content":"Mermelstein R","type":"text"},{"content":". ","type":"text"},{"content":"A global measure of perceived stress.","type":"title"},{"content":" ","type":"text"},{"content":"J Health Soc Behav","type":"source"},{"content":". ","type":"text"},{"content":"1983","type":"year"},{"content":"; ","type":"text"},{"content":"24","type":"volume"},{"content":":","type":"text"},{"content":"385","type":"fpage"},{"content":"â","type":"text"},{"content":"96","type":"lpage"},{"content":". ","type":"text"},{"content":"10.2307/2136404","type":"doi"},{"content":"6668417","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"86","id":"r86","number":"86"},{"textContent":[{"content":"Radloff LS","type":"text"},{"content":". ","type":"text"},{"content":"The CES-D scale a self-report depression scale for research in the general population.","type":"title"},{"content":" ","type":"text"},{"content":"Appl Psychol Meas","type":"source"},{"content":". ","type":"text"},{"content":"1977","type":"year"},{"content":"; ","type":"text"},{"content":"1","type":"volume"},{"content":":","type":"text"},{"content":"385","type":"fpage"},{"content":"â","type":"text"},{"content":"401","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1177/014662167700100306","type":"doi"}],"citationType":"mixed_citation","type":"journal","label":"87","id":"r87","number":"87"},{"textContent":[{"content":"American College of Sports Medicine. ACSM's guidelines for exercise testing and prescription: Lippincott Williams & Wilkins. 2013.","type":"text"}],"citationType":"mixed_citation","type":"book","label":"88","id":"r88","number":"88"},{"textContent":[{"content":"Langenbach F","type":"text"},{"content":", ","type":"text"},{"content":"Handschel J","type":"text"},{"content":". ","type":"text"},{"content":"Effects of dexamethasone, ascorbic acid and Î²-glycerophosphate on the osteogenic differentiation of stem cells in vitro.","type":"title"},{"content":" ","type":"text"},{"content":"Stem Cell Res Ther","type":"source"},{"content":". ","type":"text"},{"content":"2013","type":"year"},{"content":"; ","type":"text"},{"content":"4","type":"volume"},{"content":":","type":"text"},{"content":"117","type":"fpage"},{"content":". ","type":"text"},{"content":"10.1186/scrt328","type":"doi"},{"content":"24073831","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"89","id":"r89","number":"89"},{"textContent":[{"content":"Atkins GJ","type":"text"},{"content":", ","type":"text"},{"content":"Kostakis P","type":"text"},{"content":", ","type":"text"},{"content":"Pan B","type":"text"},{"content":", ","type":"text"},{"content":"Farrugia A","type":"text"},{"content":", ","type":"text"},{"content":"Gronthos S","type":"text"},{"content":", ","type":"text"},{"content":"Evdokiou A","type":"text"},{"content":", ","type":"text"},{"content":"Harrison K","type":"text"},{"content":", ","type":"text"},{"content":"Findlay DM","type":"text"},{"content":", ","type":"text"},{"content":"Zannettino AC","type":"text"},{"content":". ","type":"text"},{"content":"RANKL expression is related to the differentiation state of human osteoblasts.","type":"title"},{"content":" ","type":"text"},{"content":"J Bone Miner Res","type":"source"},{"content":". ","type":"text"},{"content":"2003","type":"year"},{"content":"; ","type":"text"},{"content":"18","type":"volume"},{"content":":","type":"text"},{"content":"1088","type":"fpage"},{"content":"â","type":"text"},{"content":"98","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1359/jbmr.2003.18.6.1088","type":"doi"},{"content":"12817763","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"90","id":"r90","number":"90"},{"textContent":[{"content":"Janckila AJ","type":"text"},{"content":", ","type":"text"},{"content":"Takahashi K","type":"text"},{"content":", ","type":"text"},{"content":"Sun SZ","type":"text"},{"content":", ","type":"text"},{"content":"Yam LT","type":"text"},{"content":". ","type":"text"},{"content":"Naphthol-ASBI phosphate as a preferred substrate for tartrate-resistant acid phosphatase isoform 5b.","type":"title"},{"content":" ","type":"text"},{"content":"J Bone Miner Res","type":"source"},{"content":". ","type":"text"},{"content":"2001","type":"year"},{"content":"; ","type":"text"},{"content":"16","type":"volume"},{"content":":","type":"text"},{"content":"788","type":"fpage"},{"content":"â","type":"text"},{"content":"93","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1359/jbmr.2001.16.4.788","type":"doi"},{"content":"11316008","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"91","id":"r91","number":"91"},{"textContent":[{"content":"Crespo-Diaz R","type":"text"},{"content":", ","type":"text"},{"content":"Behfar A","type":"text"},{"content":", ","type":"text"},{"content":"Butler GW","type":"text"},{"content":", ","type":"text"},{"content":"Padley DJ","type":"text"},{"content":", ","type":"text"},{"content":"Sarr MG","type":"text"},{"content":", ","type":"text"},{"content":"Bartunek J","type":"text"},{"content":", ","type":"text"},{"content":"Dietz AB","type":"text"},{"content":", ","type":"text"},{"content":"Terzic A","type":"text"},{"content":". ","type":"text"},{"content":"Platelet lysate consisting of a natural repair proteome supports human mesenchymal stem cell proliferation and chromosomal stability.","type":"title"},{"content":" ","type":"text"},{"content":"Cell Transplant","type":"source"},{"content":". ","type":"text"},{"content":"2011","type":"year"},{"content":"; ","type":"text"},{"content":"20","type":"volume"},{"content":":","type":"text"},{"content":"797","type":"fpage"},{"content":"â","type":"text"},{"content":"811","type":"lpage"},{"content":". ","type":"text"},{"content":"10.3727/096368910X543376","type":"doi"},{"content":"21092406","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"92","id":"r92","number":"92"},{"textContent":[{"content":"Lawitz E","type":"text"},{"content":", ","type":"text"},{"content":"Lalezari JP","type":"text"},{"content":", ","type":"text"},{"content":"Hassanein T","type":"text"},{"content":", ","type":"text"},{"content":"Kowdley KV","type":"text"},{"content":", ","type":"text"},{"content":"Poordad FF","type":"text"},{"content":", ","type":"text"},{"content":"Sheikh AM","type":"text"},{"content":", ","type":"text"},{"content":"Afdhal NH","type":"text"},{"content":", ","type":"text"},{"content":"Bernstein DE","type":"text"},{"content":", ","type":"text"},{"content":"Dejesus E","type":"text"},{"content":", ","type":"text"},{"content":"Freilich B","type":"text"},{"content":", ","type":"text"},{"content":"Nelson DR","type":"text"},{"content":", ","type":"text"},{"content":"Dieterich DT","type":"text"},{"content":", ","type":"text"},{"content":"Jacobson IM","type":"text"},{"content":", ","type":"text"},{"content":"et al","type":"etal"},{"content":". ","type":"text"},{"content":"Sofosbuvir in combination with peginterferon alfa-2a and ribavirin for non-cirrhotic, treatment-naive patients with genotypes 1, 2, and 3 hepatitis C infection: a randomised, double-blind, phase 2 trial.","type":"title"},{"content":" ","type":"text"},{"content":"Lancet Infect Dis","type":"source"},{"content":". ","type":"text"},{"content":"2013","type":"year"},{"content":"; ","type":"text"},{"content":"13","type":"volume"},{"content":":","type":"text"},{"content":"401","type":"fpage"},{"content":"â","type":"text"},{"content":"08","type":"lpage"},{"content":". ","type":"text"},{"content":"10.1016/S1473-3099(13)70033-1","type":"doi"},{"content":"23499158","type":"pmid"}],"citationType":"mixed_citation","type":"journal","label":"93","id":"r93","number":"93"}]}}

/***/ }),
/* 185 */
/***/ (function(module, exports) {

module.exports = {"volume":9,"issue":"4","pub_date":"2017-04-30T04:00:00.000+0000","date_settings":{"day":false,"month":true,"year":true},"display":true,"current":false,"caption":"<p>The cover for issue 4 of Aging features Figure 1, ''Scatter plots and density plots of LTL as a function of age for males and females residing in different countries\" from <a href=\"http://www.aging-us.com/article/101216/text\" target=\"_blank\">Steenstrup et al.</a></p>","issue_linkable":"4","cover":"5CfAJ7st288NsGrFC.png","prev_next":{"prev":{"volume":9,"issue":"3","issue_linkable":"3","param":"v9i3"},"next":{"volume":9,"issue":"5","issue_linkable":"5","param":"v9i5"}},"optimized":true,"optimized_file":"5CfAJ7st288NsGrFC.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"pages":{"start":1084,"end":1350},"coverPath":"https://s3-us-west-1.amazonaws.com/paperchase-aging/covers/5CfAJ7st288NsGrFC.png","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/covers_optimized/original/5CfAJ7st288NsGrFC.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/covers_optimized/hero/5CfAJ7st288NsGrFC.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/covers_optimized/large/5CfAJ7st288NsGrFC.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/covers_optimized/medium/5CfAJ7st288NsGrFC.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/covers_optimized/small/5CfAJ7st288NsGrFC.png"},"articles":[{"files":{"figures":[{"id":"f1","label":"Figure 1","caption":"Human <i>MYCN</i>-upregulated cancer entities and appropriate established mouse models.","file":"YtrADPg9tSHFDLYLA_f1.tif","version":1,"optimized":true,"optimized_file":"YtrADPg9tSHFDLYLA_f1.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/YtrADPg9tSHFDLYLA_f1.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/YtrADPg9tSHFDLYLA_f1.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/YtrADPg9tSHFDLYLA_f1.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/YtrADPg9tSHFDLYLA_f1.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/YtrADPg9tSHFDLYLA_f1.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/YtrADPg9tSHFDLYLA_f1.png"}}],"pdf":{"file":"YtrADPg9tSHFDLYLA.pdf","display":true,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/pdf/YtrADPg9tSHFDLYLA.pdf"},"xml":{"file":"YtrADPg9tSHFDLYLA.xml","display":false,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/xml/YtrADPg9tSHFDLYLA.xml"}},"title":"MYCN-mediated murine cancer models","page_start":1084,"page_end":1085,"ids":{"pii":"101222","publisher-id":"101222","doi":"10.18632/aging.101222","pmid":"28377536"},"abstract":null,"article_type":{"short_name":"editorial","nlm_type":"editorial","plural":"Editorials","name":"Editorial","count":3,"pluralize":true},"authors":[{"name_first":"Kristina","name_middle":"","name_last":"Althoff","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Alexander","name_middle":"","name_last":"Schramm","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]}],"start_group":true},{"files":{"pdf":{"file":"J79mYZaysxLDsyCWE.pdf","display":true,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/pdf/J79mYZaysxLDsyCWE.pdf"},"xml":{"file":"J79mYZaysxLDsyCWE.xml","display":false,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/xml/J79mYZaysxLDsyCWE.xml"}},"title":"Metabolism, microbiome and colorectal cancer","page_start":1086,"page_end":1087,"ids":{"pii":"101234","publisher-id":"101234","doi":"10.18632/aging.101234","pmid":"28455972"},"abstract":null,"article_type":{"short_name":"editorial","nlm_type":"editorial","plural":"Editorials","name":"Editorial"},"authors":[{"name_first":"Somenath","name_middle":"","name_last":"Datta","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Sanjib","name_middle":"","name_last":"Chowdhury","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Hemant K.","name_middle":"","name_last":"Roy","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]}]},{"files":{"pdf":{"file":"njeKKNy4d7o9efjKt.pdf","display":true,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/pdf/njeKKNy4d7o9efjKt.pdf"},"xml":{"display":false,"file":"njeKKNy4d7o9efjKt.xml","url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/xml/njeKKNy4d7o9efjKt.xml"}},"title":"Strategies for HCC target discovery","page_start":1088,"page_end":1089,"ids":{"pii":"101233","publisher-id":"101233","doi":"10.18632/aging.101233","pmid":"28455974"},"abstract":null,"article_type":{"short_name":"editorial","nlm_type":"editorial","plural":"Editorials","name":"Editorial"},"authors":[{"name_first":"Pedro","name_middle":"","name_last":"Molina-Sánchez","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0,1],"author_notes_ids":[]},{"name_first":"Amaia","name_middle":"","name_last":"Lujambio","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0,1,2],"author_notes_ids":[]}]},{"files":{"figures":[{"id":"f1","caption":"Fusion logo","file":"YCmm45TcoevafuLGc_f1.tif","version":2,"optimized":true,"optimized_file":"YCmm45TcoevafuLGc_f1.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/YCmm45TcoevafuLGc_f1.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/YCmm45TcoevafuLGc_f1.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/YCmm45TcoevafuLGc_f1.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/YCmm45TcoevafuLGc_f1.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/YCmm45TcoevafuLGc_f1.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/YCmm45TcoevafuLGc_f1.png"}},{"id":"f2","caption":"Aging logo","file":"YCmm45TcoevafuLGc_f2.tif","version":3,"optimized":true,"optimized_file":"YCmm45TcoevafuLGc_f2.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/YCmm45TcoevafuLGc_f2.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/YCmm45TcoevafuLGc_f2.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/YCmm45TcoevafuLGc_f2.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/YCmm45TcoevafuLGc_f2.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/YCmm45TcoevafuLGc_f2.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/YCmm45TcoevafuLGc_f2.png"}},{"id":"f3","caption":"Group photo of Conference participants.","file":"YCmm45TcoevafuLGc_f3.tif","version":1,"optimized":true,"optimized_file":"YCmm45TcoevafuLGc_f3.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/YCmm45TcoevafuLGc_f3.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/YCmm45TcoevafuLGc_f3.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/YCmm45TcoevafuLGc_f3.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/YCmm45TcoevafuLGc_f3.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/YCmm45TcoevafuLGc_f3.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/YCmm45TcoevafuLGc_f3.png"}},{"id":"f4","caption":"Linda Partridge and Brian Kennedy.","file":"YCmm45TcoevafuLGc_f4.tif","version":1,"optimized":true,"optimized_file":"YCmm45TcoevafuLGc_f4.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/YCmm45TcoevafuLGc_f4.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/YCmm45TcoevafuLGc_f4.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/YCmm45TcoevafuLGc_f4.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/YCmm45TcoevafuLGc_f4.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/YCmm45TcoevafuLGc_f4.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/YCmm45TcoevafuLGc_f4.png"}},{"id":"f5","caption":"Scientific discussion.","file":"YCmm45TcoevafuLGc_f5.tif","version":1,"optimized":true,"optimized_file":"YCmm45TcoevafuLGc_f5.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/YCmm45TcoevafuLGc_f5.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/YCmm45TcoevafuLGc_f5.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/YCmm45TcoevafuLGc_f5.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/YCmm45TcoevafuLGc_f5.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/YCmm45TcoevafuLGc_f5.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/YCmm45TcoevafuLGc_f5.png"}},{"id":"f6","caption":"Keetae Kim and Eline Slagboom.","file":"YCmm45TcoevafuLGc_f6.tif","version":1,"optimized":true,"optimized_file":"YCmm45TcoevafuLGc_f6.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/YCmm45TcoevafuLGc_f6.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/YCmm45TcoevafuLGc_f6.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/YCmm45TcoevafuLGc_f6.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/YCmm45TcoevafuLGc_f6.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/YCmm45TcoevafuLGc_f6.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/YCmm45TcoevafuLGc_f6.png"}},{"id":"f7","caption":"Poster session.","file":"YCmm45TcoevafuLGc_f7.tif","version":1,"optimized":true,"optimized_file":"YCmm45TcoevafuLGc_f7.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/YCmm45TcoevafuLGc_f7.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/YCmm45TcoevafuLGc_f7.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/YCmm45TcoevafuLGc_f7.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/YCmm45TcoevafuLGc_f7.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/YCmm45TcoevafuLGc_f7.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/YCmm45TcoevafuLGc_f7.png"}},{"id":"f8","caption":"Poster competition winners.","file":"YCmm45TcoevafuLGc_f8.tif","version":1,"optimized":true,"optimized_file":"YCmm45TcoevafuLGc_f8.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/YCmm45TcoevafuLGc_f8.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/YCmm45TcoevafuLGc_f8.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/YCmm45TcoevafuLGc_f8.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/YCmm45TcoevafuLGc_f8.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/YCmm45TcoevafuLGc_f8.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/YCmm45TcoevafuLGc_f8.png"}},{"id":"f9","caption":"Aging Conference sponsors.","file":"YCmm45TcoevafuLGc_f9.tif","version":1,"optimized":true,"optimized_file":"YCmm45TcoevafuLGc_f9.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/YCmm45TcoevafuLGc_f9.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/YCmm45TcoevafuLGc_f9.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/YCmm45TcoevafuLGc_f9.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/YCmm45TcoevafuLGc_f9.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/YCmm45TcoevafuLGc_f9.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/YCmm45TcoevafuLGc_f9.png"}}],"pdf":{"file":"YCmm45TcoevafuLGc.pdf","display":true,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/pdf/YCmm45TcoevafuLGc.pdf"},"xml":{"file":"YCmm45TcoevafuLGc.xml","display":true,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/xml/YCmm45TcoevafuLGc.xml"}},"title":"2nd interventions in aging conference","page_start":1090,"page_end":1095,"ids":{"pii":"101221","publisher-id":"101221","doi":"10.18632/aging.101221","pmid":"28455971"},"abstract":"","article_type":{"short_name":"meeting-report","nlm_type":"meeting-report","plural":"Meeting Reports","name":"Meeting Report","count":1},"authors":[{"name_first":"Brian K.","name_middle":"","name_last":"Kennedy","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0,1],"author_notes_ids":[]},{"name_first":"Linda","name_middle":"","name_last":"Partridge","name_suffix":"","equal_contrib":false,"affiliations_numbers":[2,3],"author_notes_ids":[]}],"start_group":true},{"files":{"figures":[{"id":"f1","label":"Figure 1","caption":"<b>Study design.</b> Study design (<b>A</b>) involved an initial phone screening, screening visit, outpatient testing for body composition and physical function, and inpatient testing of mitochondrial physiology and muscle protein metabolism. Older adults repeated study visits following 16 weeks of n3-PUFA supplementation. Inpatient study procedures (<b>B</b>) involved basal postabsorptive muscle protein synthesis measurements on Day 1 by infusing <sup>13</sup>C<sub>6</sub>-Phenylalanine and serial muscle biopsies on the right leg. Following a standardized meal, a single bout of unaccustomed resistance exercise was performed at 1600 hr using the left leg. A second tracer infusion began on day 2, followed by serial biopsies to assess muscle protein synthesis 15-18 hours following exercise.","file":"eF658jdFHaWW8K7im_f1.tif","version":1,"optimized":true,"optimized_file":"eF658jdFHaWW8K7im_f1.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/eF658jdFHaWW8K7im_f1.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/eF658jdFHaWW8K7im_f1.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/eF658jdFHaWW8K7im_f1.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/eF658jdFHaWW8K7im_f1.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/eF658jdFHaWW8K7im_f1.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/eF658jdFHaWW8K7im_f1.png"}},{"id":"f2","label":"Figure 2","caption":"<b>Mitochondrial physiology.</b>  Respiration of isolated mitochondria was measured by high-resolution respirometry using substrates providing electron flow from carbohydrate based substrates (glutamate, malate, succinate) (<b>A, C</b>) and lipid substrates (palmitoyl carnitine, malate) (<b>B, D</b>). Older adults exhibited lower skeletal muscle mitochondrial oxidative capacity compared to young adults, with no effect of n3-PUFA supplementation regardless of whether respiration was expressed per tissue wet weight (<b>A, B</b>) or mitochondrial protein content (<b>C, D</b>). Mitochondrial reactive oxygen species (ROS) production was measured by spectrofluorometric monitoring of Amplex Red oxidation (<b>E, F</b>). ROS production was similar in young and old at baseline, but n3-PUFA significantly decreased ROS production in older adults when expressed per tissue wet weight (<b>E</b>) and normalized to mitochondrial protein content (<b>F</b>). <i>JO<sub>2</sub></i>; mitochondrial oxygen consumption. Cyto c; cytochrome c, control of mitochondrial membrane integrity, FCCP; carbonyl cyanide-p-trifluoro-methoxy-phenyl-hydrazone, a chemical uncoupler, AA; Antimycin A, complex III inhibitor.  GM; glutamate+malate.  GMS; glutamate+malate+succinate. * Significantly (p≤0.05) different from young.  # Significantly different from old baseline. Data bars are mean ± SEM.","file":"eF658jdFHaWW8K7im_f2.tif","version":1,"optimized":true,"optimized_file":"eF658jdFHaWW8K7im_f2.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/eF658jdFHaWW8K7im_f2.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/eF658jdFHaWW8K7im_f2.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/eF658jdFHaWW8K7im_f2.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/eF658jdFHaWW8K7im_f2.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/eF658jdFHaWW8K7im_f2.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/eF658jdFHaWW8K7im_f2.png"}},{"id":"f3","label":"Figure 3","caption":"<b>Selected gene transcripts related to muscle protein turnover.</b> Gene expression was measured in skeletal muscle by RT-PCR.  At baseline, pre-exercise, older adults demonstrated lower expression of myostatin (<b>A</b>), tripartite motif containing 63 (<b>D</b>), sarcolipin (<b>E</b>), and calpain 1 (<b>H</b>).  Calpain 2 (<b>I</b>), follistatin (<b>C</b>) and F-box protein 32 (<b>F</b>) were higher in older adults at baseline.  Several genes exhibited significant changes in expression with exercise in young but not old (<b>A, B, D, F, H, I</b>) with no effects of n3-PUFA. FOXO3B; forkhead box O3B pseudogene, forkhead box O3, MSTN; myostatin, TRIM 63; tripartite motif containing 63, E3 ubiquitin protein ligase, SLN; sarcolipin, CAPN1; calpain 1, large subunit, MYOD1; myogenic differentiation 1, FBX032; F-box protein 32, CAPN2; calpain 2, large subunit, FST; follistatin, pre-ex; pre-exercise, post-ex; post-exercise. * Significantly (p≤0.05) different from corresponding pre-exercise value.  # Significantly different from young. Data bars are mean ± SEM.","file":"eF658jdFHaWW8K7im_f3.tif","version":1,"optimized":true,"optimized_file":"eF658jdFHaWW8K7im_f3.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/eF658jdFHaWW8K7im_f3.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/eF658jdFHaWW8K7im_f3.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/eF658jdFHaWW8K7im_f3.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/eF658jdFHaWW8K7im_f3.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/eF658jdFHaWW8K7im_f3.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/eF658jdFHaWW8K7im_f3.png"}},{"id":"f4","label":"Figure 4","caption":"<b>Postabsorptive and exercise-stimulated muscle protein synthesis.</b>  Muscle protein synthesis was measured from the rate of incorporation of isotopically labeled amino acid into muscle proteins.  Protein synthesis was measured at baseline (postabsorptive) and 15-18 hours following a single bout of exercise for mixed muscle (MMP) (<b>A, E</b>), mitochondrial fraction (Mito) (<b>B, F</b>), sarcoplasmic fraction (Sarco) (<b>C, G</b>), and myofibrillar fraction (Myo) (<b>D, H</b>).  Postabsorptive protein synthesis was similar in young and old in all fractions.  Mixed muscle and myofibrillar protein synthesis increased with exercise in young but not old.  Mitochondrial and sarcoplasmic protein synthesis increased with exercise in old but not young. n3-PUFA supplementation increased mitochondrial and myofibrillar protein synthesis after exercise. The change in FSR (Δ=post exercise-baseline) is shown in the right panel (<b>E-H</b>), illustrating responders and non-responders.  * Significantly (p≤0.05) different from corresponding baseline value.  Ψ Significantly different from corresponding pre-intervention value. # Significantly different from young.  Data bars are mean ± SEM. Circles denote men and triangles denote women.","file":"eF658jdFHaWW8K7im_f4.tif","version":1,"optimized":true,"optimized_file":"eF658jdFHaWW8K7im_f4.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/eF658jdFHaWW8K7im_f4.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/eF658jdFHaWW8K7im_f4.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/eF658jdFHaWW8K7im_f4.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/eF658jdFHaWW8K7im_f4.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/eF658jdFHaWW8K7im_f4.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/eF658jdFHaWW8K7im_f4.png"}},{"id":"f5","label":"Figure 5","caption":"<b>Whole muscle transcriptomics.</b> Transcriptional patterns in skeletal muscle were evaluated by RNA sequencing.  Volcano plots (<b>A-E</b>) show log fold change (FC) vs. –log false discovery rate (FDR) for transcripts that were significantly (p≤0.05) different between young and old at baseline (<b>A</b>), old before and after intervention at baseline (<b>B</b>), young before and after exercise (<b>C</b>), old before and after exercise (<b>D</b>), and old before and after exercise following n3-PUFA supplementation (<b>E</b>).  Downregulated genes are on the negative x axis while upregulated genes are on the positive x axis.  Mitochondrial related genes are red and genes involved in muscle protein metabolism are blue.  The Venn Diagram (<b>F</b>) shows transcripts (<a href=\"#SD2\"  class=\"anchor\">Supplemental Table 2</a>) that were differentially expressed with exercise in Young, Old (pre-intervention) and Old n-3 (post-intervention).","file":"eF658jdFHaWW8K7im_f5.tif","version":1,"optimized":true,"optimized_file":"eF658jdFHaWW8K7im_f5.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/eF658jdFHaWW8K7im_f5.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/eF658jdFHaWW8K7im_f5.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/eF658jdFHaWW8K7im_f5.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/eF658jdFHaWW8K7im_f5.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/eF658jdFHaWW8K7im_f5.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/eF658jdFHaWW8K7im_f5.png"}}],"supplemental":[{"id":"SD1","label":"Supplemental File","file":"eF658jdFHaWW8K7im_sd1.pdf","version":1,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/supplemental_materials/eF658jdFHaWW8K7im_sd1.pdf"},{"id":"SD2","label":"Supplemental File 2","file":"eF658jdFHaWW8K7im_sd2.xlsx","version":1,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/supplemental_materials/eF658jdFHaWW8K7im_sd2.xlsx"}],"pdf":{"file":"eF658jdFHaWW8K7im.pdf","display":true,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/pdf/eF658jdFHaWW8K7im.pdf"},"xml":{"file":"eF658jdFHaWW8K7im.xml","display":true,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/xml/eF658jdFHaWW8K7im.xml"}},"title":"Influence of omega-3 fatty acids on skeletal muscle protein metabolism and mitochondrial bioenergetics in older adults","page_start":1096,"page_end":1129,"ids":{"pii":"101210","publisher-id":"101210","doi":"10.18632/aging.101210","pmid":"28379838"},"abstract":"<p>Omega-3 polyunsaturated fatty acids (n3-PUFA) are recognized for their anti-inflammatory effects and may be beneficial in the context of sarcopenia. We determined the influence of n3-PUFA on muscle mitochondrial physiology and protein metabolism in older adults. Twelve young (18-35 years) and older (65-85 years) men and women were studied at baseline. Older adults were studied again following n3-PUFA supplementation (3.9g/day, 16 weeks). Muscle biopsies were used to evaluate respiratory capacity (high resolution respirometry) and oxidant emissions (spectrofluorometry) in isolated mitochondria. Maximal respiration was significantly lower in older compared to young. n3-PUFA did not change respiration, but significantly reduced oxidant emissions. Participants performed a single bout of resistance exercise, followed by biopsies at 15 and 18 hours post exercise. Several genes involved in muscle protein turnover were significantly altered in older adults at baseline and following exercise, yet muscle protein synthesis was similar between age groups under both conditions. Following n3-PUFA supplementation, mixed muscle, mitochondrial, and sarcoplasmic protein synthesis rates were increased in older adults before exercise. n3-PUFA increased post-exercise mitochondrial and myofibrillar protein synthesis in older adults. These results demonstrate that n3-PUFA reduce mitochondrial oxidant emissions, increase postabsorptive muscle protein synthesis, and enhance anabolic responses to exercise in older adults.</p>","article_type":{"short_name":"research_paper","nlm_type":"research-article","plural":"Research Papers","name":"Research Paper","count":15,"pluralize":true},"authors":[{"name_first":"Antigoni Z.","name_middle":"","name_last":"Lalia","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Surendra","name_middle":"","name_last":"Dasari","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Matthew M.","name_middle":"","name_last":"Robinson","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Hinnah","name_middle":"","name_last":"Abid","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Dawn M.","name_middle":"","name_last":"Morse","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Katherine A.","name_middle":"","name_last":"Klaus","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Ian R.","name_middle":"","name_last":"Lanza","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]}],"start_group":true},{"files":{"figures":[{"id":"f1","label":"Figure 1","caption":"<b>Scatter plots and density plots of LTL as a function of age for males and females residing in different countries.</b> Measurements of LTL were performed in the same laboratory on DNA donated by participants in different studies in different countries (Supplemental Table 1). The horizontal dashed lines in the top panels and vertical dashed lines in the bottom panels indicate LTL values of 5 kb. The bottom plots are smoothed histograms obtained by kernel density estimation.","file":"nYyi6tbim7xRhj2zu_f1.tif","version":1,"optimized":true,"optimized_file":"nYyi6tbim7xRhj2zu_f1.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/nYyi6tbim7xRhj2zu_f1.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/nYyi6tbim7xRhj2zu_f1.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/nYyi6tbim7xRhj2zu_f1.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/nYyi6tbim7xRhj2zu_f1.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/nYyi6tbim7xRhj2zu_f1.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/nYyi6tbim7xRhj2zu_f1.png"}},{"id":"f2","label":"Figure 2","caption":"<b>Predicted proportion of the composite study population reaching the telomere brink (TB; 5 kb) based on period life table mortality (period), life expectancy of 100 years (LE-100) and LTL attrition.</b> The panels display findings for four age groups: 35 years (range 30-40 years); 50 years (range 45-55 years); 60 years (range 55-65 years); 80 years (range 75-85 years), based on different LTL attrition rates (15-45 bp/year). For period mortality, the proportion (in %) of individuals reaching an LTL of 5 kb before their life expectancy is based on the aggregate mortality data for a given country and sex at the time of blood collection.","file":"nYyi6tbim7xRhj2zu_f2.tif","version":1,"optimized":true,"optimized_file":"nYyi6tbim7xRhj2zu_f2.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/nYyi6tbim7xRhj2zu_f2.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/nYyi6tbim7xRhj2zu_f2.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/nYyi6tbim7xRhj2zu_f2.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/nYyi6tbim7xRhj2zu_f2.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/nYyi6tbim7xRhj2zu_f2.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/nYyi6tbim7xRhj2zu_f2.png"}},{"id":"f3","label":"Figure 3","caption":"<b>Predicted proportion of the composite study population of males and females reaching the telomere brink (TB; 5 kb) based on period life table mortality (period), life expectancy of 100 years (LE-100), LTL ranking and LTL attrition.</b> The panels display findings for four age groups: 35 years (range 30-40 years); 50 years (range 45-55 years); 60 years (range 55-65 years); 80 years (range 75-85 years), based on different LTL attrition rates (15-45 bp/year).","file":"nYyi6tbim7xRhj2zu_f3.tif","version":1,"optimized":true,"optimized_file":"nYyi6tbim7xRhj2zu_f3.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/nYyi6tbim7xRhj2zu_f3.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/nYyi6tbim7xRhj2zu_f3.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/nYyi6tbim7xRhj2zu_f3.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/nYyi6tbim7xRhj2zu_f3.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/nYyi6tbim7xRhj2zu_f3.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/nYyi6tbim7xRhj2zu_f3.png"}},{"id":"f4","label":"Figure 4","caption":"<b>Predicted proportion of the composite study population reaching the telomere brink (TB; 5 kb) based on period life table mortality (period), life expectancy of 100 years (LE-100), LTL ranking and LTL attrition.</b> Individuals were ranked by quintiles, where the shortest (1st) LTL quintile is 0-19% and the longest (5th) LTL quintile is 80-99%. The panels display findings for four age groups: 35 years (range 30-40 years); 50 years (range 45-55 years); 60 years (range 55-65 years); 80 years (range 75-85 years), based on different LTL attrition rates (15-45 bp/year).","file":"nYyi6tbim7xRhj2zu_f4.tif","version":1,"optimized":true,"optimized_file":"nYyi6tbim7xRhj2zu_f4.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/nYyi6tbim7xRhj2zu_f4.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/nYyi6tbim7xRhj2zu_f4.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/nYyi6tbim7xRhj2zu_f4.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/nYyi6tbim7xRhj2zu_f4.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/nYyi6tbim7xRhj2zu_f4.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/nYyi6tbim7xRhj2zu_f4.png"}}],"supplemental":[{"id":"SD1","label":"Supplementary File","file":"nYyi6tbim7xRhj2zu_sd1.pdf","version":1,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/supplemental_materials/nYyi6tbim7xRhj2zu_sd1.pdf"}],"pdf":{"file":"nYyi6tbim7xRhj2zu.pdf","display":true,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/pdf/nYyi6tbim7xRhj2zu.pdf"},"xml":{"file":"nYyi6tbim7xRhj2zu.xml","display":true,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/xml/nYyi6tbim7xRhj2zu.xml"}},"title":"Telomeres and the natural lifespan limit in humans","page_start":1130,"page_end":1142,"ids":{"pii":"101216","publisher-id":"101216","doi":"10.18632/aging.101216","pmid":"28394764"},"abstract":"<p>An ongoing debate in demography has focused on whether the human lifespan has a maximal natural limit. Taking a mechanistic perspective, and knowing that short telomeres are associated with diminished longevity, we examined whether telomere length dynamics during adult life could set a maximal natural lifespan limit. We define leukocyte telomere length of 5 kb as the ‘telomeric brink’, which denotes a high risk of imminent death. We show that a subset of adults may reach the telomeric brink within the current life expectancy and more so for a 100-year life expectancy. Thus, secular trends in life expectancy should confront a biological limit due to crossing the telomeric brink.</p>","article_type":{"short_name":"research_paper","nlm_type":"research-article","plural":"Research Papers","name":"Research Paper"},"authors":[{"name_first":"Troels","name_middle":"","name_last":"Steenstrup","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Jeremy D.","name_middle":"","name_last":"Kark","name_suffix":"","equal_contrib":false,"affiliations_numbers":[1],"author_notes_ids":[]},{"name_first":"Simon","name_middle":"","name_last":"Verhulst","name_suffix":"","equal_contrib":false,"affiliations_numbers":[2],"author_notes_ids":[]},{"name_first":"Mikael","name_middle":"","name_last":"Thinggaard","name_suffix":"","equal_contrib":false,"affiliations_numbers":[3,4],"author_notes_ids":[]},{"name_first":"Jacob V. B.","name_middle":"","name_last":"Hjelmborg","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0,5],"author_notes_ids":[]},{"name_first":"Christine","name_middle":"","name_last":"Dalgård","name_suffix":"","equal_contrib":false,"affiliations_numbers":[6],"author_notes_ids":[]},{"name_first":"Kirsten Ohm","name_middle":"","name_last":"Kyvik","name_suffix":"","equal_contrib":false,"affiliations_numbers":[7],"author_notes_ids":[]},{"name_first":"Lene","name_middle":"","name_last":"Christiansen","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0,4,5],"author_notes_ids":[]},{"name_first":"Massimo","name_middle":"","name_last":"Mangino","name_suffix":"","equal_contrib":false,"affiliations_numbers":[8,9],"author_notes_ids":[]},{"name_first":"Timothy D.","name_middle":"","name_last":"Spector","name_suffix":"","equal_contrib":false,"affiliations_numbers":[8],"author_notes_ids":[]},{"name_first":"Inge","name_middle":"","name_last":"Petersen","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Masayuki","name_middle":"","name_last":"Kimura","name_suffix":"","equal_contrib":false,"affiliations_numbers":[10],"author_notes_ids":[]},{"name_first":"Athanase","name_middle":"","name_last":"Benetos","name_suffix":"","equal_contrib":false,"affiliations_numbers":[11,12,13],"author_notes_ids":[]},{"name_first":"Carlos","name_middle":"","name_last":"Labat","name_suffix":"","equal_contrib":false,"affiliations_numbers":[12,13],"author_notes_ids":[]},{"name_first":"Ronit","name_middle":"","name_last":"Sinnreich","name_suffix":"","equal_contrib":false,"affiliations_numbers":[1],"author_notes_ids":[]},{"name_first":"Shih-Jen","name_middle":"","name_last":"Hwang","name_suffix":"","equal_contrib":false,"affiliations_numbers":[14],"author_notes_ids":[]},{"name_first":"Daniel","name_middle":"","name_last":"Levy","name_suffix":"","equal_contrib":false,"affiliations_numbers":[14],"author_notes_ids":[]},{"name_first":"Steven C.","name_middle":"","name_last":"Hunt","name_suffix":"","equal_contrib":false,"affiliations_numbers":[15],"author_notes_ids":[]},{"name_first":"Annette L.","name_middle":"","name_last":"Fitzpatrick","name_suffix":"","equal_contrib":false,"affiliations_numbers":[16],"author_notes_ids":[]},{"name_first":"Wei","name_middle":"","name_last":"Chen","name_suffix":"","equal_contrib":false,"affiliations_numbers":[17],"author_notes_ids":[]},{"name_first":"Gerald S.","name_middle":"","name_last":"Berenson","name_suffix":"","equal_contrib":false,"affiliations_numbers":[17],"author_notes_ids":[]},{"name_first":"Michelangela","name_middle":"","name_last":"Barbieri","name_suffix":"","equal_contrib":false,"affiliations_numbers":[18],"author_notes_ids":[]},{"name_first":"Giuseppe","name_middle":"","name_last":"Paolisso","name_suffix":"","equal_contrib":false,"affiliations_numbers":[18],"author_notes_ids":[]},{"name_first":"Shahinaz M.","name_middle":"","name_last":"Gadalla","name_suffix":"","equal_contrib":false,"affiliations_numbers":[19],"author_notes_ids":[]},{"name_first":"Sharon A.","name_middle":"","name_last":"Savage","name_suffix":"","equal_contrib":false,"affiliations_numbers":[19],"author_notes_ids":[]},{"name_first":"Kaare","name_middle":"","name_last":"Christensen","name_suffix":"","equal_contrib":false,"affiliations_numbers":[3,4,5],"author_notes_ids":[]},{"name_first":"Anatoliy I.","name_middle":"","name_last":"Yashin","name_suffix":"","equal_contrib":false,"affiliations_numbers":[20],"author_notes_ids":[]},{"name_first":"Konstantin G.","name_middle":"","name_last":"Arbeev","name_suffix":"","equal_contrib":false,"affiliations_numbers":[20],"author_notes_ids":[]},{"name_first":"Abraham","name_middle":"","name_last":"Aviv","name_suffix":"","equal_contrib":false,"affiliations_numbers":[10],"author_notes_ids":[]}]},{"files":{"pdf":{"file":"4wLkjQProyo2sA6Tr.pdf","display":true,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/pdf/4wLkjQProyo2sA6Tr.pdf"},"xml":{"file":"4wLkjQProyo2sA6Tr.xml","display":true,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/xml/4wLkjQProyo2sA6Tr.xml"},"figures":[{"id":"f1","label":"Figure 1","caption":"<b>Epigenetic age analysis of Werner syndrome.</b> (<b>A</b>) DNA methylation age (y-axis) versus chronological age (x-axis). Dots correspond to subjects and are colored by WS status (red=case, black=control). We define three measures of epigenetic age acceleration. (<b>B</b>) presents results for the \"universal\" measure of epigenetic age acceleration, which is defined as residual to a regression line through the control samples, i.e. the vertical distance of a point from the line. By definition, the mean age acceleration in controls is zero. (<b>C</b>) The bar plots relate measures of intrinsic epigenetic age acceleration to WS status. This measure is independent of blood cell counts. (<b>D</b>) shows findings for the measure of extrinsic epigenetic age acceleration, which does relate to changes in cell composition. Each bar plot depicts the mean value (y-axis), 1 standard error, and the group size (underneath the bar). The p-value results from the Kruskal Wallis test, which is a non-parametric group comparison test.","file":"4wLkjQProyo2sA6Tr_f1.tif","version":1,"optimized":true,"optimized_file":"4wLkjQProyo2sA6Tr_f1.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/4wLkjQProyo2sA6Tr_f1.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/4wLkjQProyo2sA6Tr_f1.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/4wLkjQProyo2sA6Tr_f1.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/4wLkjQProyo2sA6Tr_f1.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/4wLkjQProyo2sA6Tr_f1.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/4wLkjQProyo2sA6Tr_f1.png"}},{"id":"f2","label":"Figure 2","caption":"<b>Age adjusted blood cell counts versus Werner syndrome status</b>. WS status (x-axis) versus the age adjusted estimate of (<b>A</b>) plasma blasts, (<b>B</b>) exhausted CD8+ T cells (defined as CD8+CD28-CD45RA-), (<b>C</b>) naïve CD8+ T cell count, (<b>D</b>) naïve CD4+ T cell count, (<b>E</b>) CD8+ T cells, (<b>F</b>) CD4+ T cells, (<b>G</b>) natural killer cells, (<b>H</b>) B cells, (<b>I</b>) monocytes, (<b>J</b>) granulocytes. The abundance measures of blood cell counts were estimated based on DNA methylation levels using the epigenetic clock software. Each bar plot depicts the mean value (y-axis), one standard error, and the group size (underneath the bar). The p-value results from a non-parametric group comparison test (Kruskal Wallis).","file":"4wLkjQProyo2sA6Tr_f2.tif","version":3,"optimized":true,"optimized_file":"4wLkjQProyo2sA6Tr_f2.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/4wLkjQProyo2sA6Tr_f2.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/4wLkjQProyo2sA6Tr_f2.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/4wLkjQProyo2sA6Tr_f2.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/4wLkjQProyo2sA6Tr_f2.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/4wLkjQProyo2sA6Tr_f2.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/4wLkjQProyo2sA6Tr_f2.png"}}]},"title":"Accelerated epigenetic aging in Werner syndrome","page_start":1143,"page_end":1152,"ids":{"pii":"101217","publisher-id":"101217","doi":"10.18632/aging.101217","pmid":"28377537"},"abstract":"<p>Individuals suffering from Werner syndrome (WS) exhibit many clinical signs of accelerated aging. While the underlying constitutional mutation leads to accelerated rates of DNA damage, it is not yet known whether WS is also associated with an increased epigenetic age according to a DNA methylation based biomarker of aging (the \"Epigenetic Clock\"). Using whole blood methylation data from 18 WS cases and 18 age matched controls, we find that WS is associated with increased extrinsic epigenetic age acceleration (p=0.0072) and intrinsic epigenetic age acceleration (p=0.04), the latter of which is independent of age-related changes in the composition of peripheral blood cells. A multivariate model analysis reveals that WS is associated with an increase in DNA methylation age (on average 6.4 years, p=0.011) even after adjusting for chronological age, gender, and blood cell counts. Further, WS might be associated with a reduction in naïve CD8+ T cells (p=0.025) according to imputed measures of blood cell counts. Overall, this study shows that WS is associated with an increased epigenetic age of blood cells which is independent of changes in blood cell composition. The extent to which this alteration is a cause or effect of WS disease phenotypes remains unknown.</p>","article_type":{"short_name":"research_paper","nlm_type":"research-article","plural":"Research Papers","name":"Research Paper"},"authors":[{"name_first":"Anna","name_middle":"","name_last":"Maierhofer","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Julia","name_middle":"","name_last":"Flunkert","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Junko","name_middle":"","name_last":"Oshima","name_suffix":"","equal_contrib":false,"affiliations_numbers":[1,2],"author_notes_ids":[]},{"name_first":"George M.","name_middle":"","name_last":"Martin","name_suffix":"","equal_contrib":false,"affiliations_numbers":[1],"author_notes_ids":[]},{"name_first":"Thomas","name_middle":"","name_last":"Haaf","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0,5],"author_notes_ids":[]},{"name_first":"Steve","name_middle":"","name_last":"Horvath","name_suffix":"","equal_contrib":false,"affiliations_numbers":[3,4,5],"author_notes_ids":[]}]},{"files":{"pdf":{"file":"ENWbSTvmmSr4rNwz8.pdf","display":true,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/pdf/ENWbSTvmmSr4rNwz8.pdf"},"xml":{"file":"ENWbSTvmmSr4rNwz8.xml","display":true,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/xml/ENWbSTvmmSr4rNwz8.xml"},"figures":[{"id":"f1","label":"Figure 1","caption":"<b>Hydrogen peroxide resistance declines with age.</b> (<b>A-D</b>) Males and females of the Actin-GS-255B strain crossed to the w[1118] strain were aged to 3 days or 60 days and then transferred to vials containing kimwipes soaked in 1.0M to 8.0M H<sub>2</sub>O<sub>2</sub> dissolved in 5% sucrose solution, and flies were scored as dead when completely immobile, as described previously [<a href=\"#r43\"  class=\"anchor\">43</a>]. (<b>A</b>) 3 day old females. (<b>B</b>) 3 day old males. (<b>C</b>) 60 day old females. (<b>D</b>) 60 day old males.","file":"ENWbSTvmmSr4rNwz8_f1.tif","version":1,"optimized":true,"optimized_file":"ENWbSTvmmSr4rNwz8_f1.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/ENWbSTvmmSr4rNwz8_f1.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/ENWbSTvmmSr4rNwz8_f1.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/ENWbSTvmmSr4rNwz8_f1.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/ENWbSTvmmSr4rNwz8_f1.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/ENWbSTvmmSr4rNwz8_f1.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/ENWbSTvmmSr4rNwz8_f1.png"}},{"id":"f2","label":"Figure 2","caption":"<b>Adaptation to hydrogen peroxide declines with age in females.</b> Progeny of the Actin-GS-255B strain crossed to the w[1118] strain were aged to 3 days and 60 days prior to H<sub>2</sub>O<sub>2</sub> pretreatment. Following recovery, flies were fed H<sub>2</sub>O<sub>2</sub> challenge dose: 4.4M in 3 day old males and females, 2M in 60 day old females, and 1M in 60 day old males. (<b>A</b>) 3 day old females showed increased survival following pretreatment. (<b>B</b>) 3 day old males showed no change in survival following pretreatment. (<b>C</b>) With age, 60 day old females no longer show increased survival. (<b>D</b>) 60 day old males show no change in adaptation following pretreatment. Statistical difference in survival (p < 0.05) was calculated using the Log-Rank test. Statistical summary is located in <a href=\"#SD1\"  class=\"anchor\">Supplementary Table S1</a>.","file":"ENWbSTvmmSr4rNwz8_f2.tif","version":1,"optimized":true,"optimized_file":"ENWbSTvmmSr4rNwz8_f2.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/ENWbSTvmmSr4rNwz8_f2.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/ENWbSTvmmSr4rNwz8_f2.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/ENWbSTvmmSr4rNwz8_f2.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/ENWbSTvmmSr4rNwz8_f2.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/ENWbSTvmmSr4rNwz8_f2.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/ENWbSTvmmSr4rNwz8_f2.png"}},{"id":"f3","label":"Figure 3","caption":"<b>Adaptive de novo expression of the 20S proteasome diminishes with age in a sex-dependent manner.</b> (<b>A,B</b>) Virgin females of the Actin-GS-255B strain were crossed to males of the w[1118] strain and progeny were assayed for 20Sα expression without H<sub>2</sub>O<sub>2</sub> pretreatment, or after pretreatment with [10µM or 100µM] H<sub>2</sub>O<sub>2</sub>. (<b>A</b>) 3 day and 60 day aged females. (<b>B</b>) 3 day and 60 day aged males. All samples were compared to the 3 day old 0µM H<sub>2</sub>O<sub>2</sub> controls (<b>C</b>) Basal expression of the 20S proteasome α subunits was measured between 3 day old females, 60 day old females, 3 day old males, and 60 day old males, with samples normalized to the 3 day old female. Western blots were performed in triplicate, normalized to Actin-HRP, and quantified using ImageJ. Error bars denote standard error of the mean (S.E.M) values. * <i>P</i> <0.05 and ** <i>P</i> < 0.01, relative to control using one-way ANOVA. Asterisks color indicates the age of the sample, young female (pink <b>*</b>) and aged female (black <b>*</b>). All statistical significance was calculated relative to the young controls.","file":"ENWbSTvmmSr4rNwz8_f3.tif","version":1,"optimized":true,"optimized_file":"ENWbSTvmmSr4rNwz8_f3.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/ENWbSTvmmSr4rNwz8_f3.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/ENWbSTvmmSr4rNwz8_f3.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/ENWbSTvmmSr4rNwz8_f3.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/ENWbSTvmmSr4rNwz8_f3.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/ENWbSTvmmSr4rNwz8_f3.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/ENWbSTvmmSr4rNwz8_f3.png"}},{"id":"f4","label":"Figure 4","caption":"<b>Adaptive proteolytic capacity of the 20S proteasome diminishes with age in a sex-dependent manner.</b> Virgin females of the Actin-GS-255B strain were crossed to males of the w[1118] strain and progeny were assayed for the proteolytic activity of the three catalytic subunits of the 20S proteasome in 3 day-old (red or blue) and 60 day-old flies (checked pattern). Caspase-like activity in (<b>A</b>) Females and males. Trypsin-like activity in (<b>B</b>) Females and males. Chymotrypsin-like activity in (<b>C</b>) Females and males. (<b>D</b>) Proteolytic degradation of oxidized [<sup>3</sup>H] hemoglobin in flies pretreated with hydrogen peroxide at 3 days and 60 days. Statistical significance for proteolysis of oxidized substrate was compared to young control females. Error bars denote standard error of the mean (S.E.M) values. * <i>P</i> <0.05, ** <i>P</i> < 0.01, *** <i>P</i> < 0.001 relative to control using one-way ANOVA. Asterisk color corresponds to young females (pink <b>*</b>), aged females (black <b>*</b>), young males (green #), and aged males (black #). Statistical significance was calculated relative to the young control females (<b>A-D</b>).","file":"ENWbSTvmmSr4rNwz8_f4.tif","version":1,"optimized":true,"optimized_file":"ENWbSTvmmSr4rNwz8_f4.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/ENWbSTvmmSr4rNwz8_f4.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/ENWbSTvmmSr4rNwz8_f4.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/ENWbSTvmmSr4rNwz8_f4.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/ENWbSTvmmSr4rNwz8_f4.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/ENWbSTvmmSr4rNwz8_f4.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/ENWbSTvmmSr4rNwz8_f4.png"}},{"id":"f5","label":"Figure 5","caption":"<b>The adaptive expression of the 20S proteasome is age and tissue-dependent in females.</b> Body segments collected from females of the Actin-GS-255B strain crossed to the w[1118] strain were used as controls, or were pretreated with either 10µM or 100µM hydrogen peroxide. (<b>A,B</b>) 20Sα expression in female abdominal tissue following pretreatment. (<b>A</b>) 3 day old. (<b>B</b>) 60 day old. (<b>C,D</b>) 20Sα expression in female head following pretreatment. (<b>C</b>) 3 day old. (<b>D</b>) 60 day old. (<b>E,F</b>) 20Sα expression in female thorax following pretreatment. (<b>E</b>) 3 day old. (<b>F</b>) 60 day old. Western blots were performed in triplicate, normalized to Actin-HRP, and quantified using ImageJ. The bar charts represent the quantification. Error bars denote standard error of the mean (S.E.M) values. * <i>P</i> <0.05, ** <i>P</i> <0.01, *** <i>P</i> < 0.001, relative to the female control using one-way ANOVA. Statistical significance is indicated in young females with pink asterisks (pink <b>*</b>).","file":"ENWbSTvmmSr4rNwz8_f5.tif","version":1,"optimized":true,"optimized_file":"ENWbSTvmmSr4rNwz8_f5.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/ENWbSTvmmSr4rNwz8_f5.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/ENWbSTvmmSr4rNwz8_f5.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/ENWbSTvmmSr4rNwz8_f5.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/ENWbSTvmmSr4rNwz8_f5.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/ENWbSTvmmSr4rNwz8_f5.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/ENWbSTvmmSr4rNwz8_f5.png"}},{"id":"f6","label":"Figure 6","caption":"<b>Tissue-specific differences of the adaptive proteolytic capacity, and age-dependent changes in basal activity, of the 20S proteasome in females.</b> Body segments collected from female progeny of the Actin-GS-255B strain crossed to the w[1118] strain were used as controls, or were pretreated with either 10µM or 100µM hydrogen peroxide. Individual proteolytic capacity of the 20S proteasome (caspase/peptidyl glutamyl-peptide hydrolyzing-like activity, trypsin-like, and chymotrypsin-like activity) was measured in the abdomen, head, and thorax. (<b>A-C</b>) Abdomen isolated from 3 day old (pink) and 60 day old (black) females following hydrogen peroxide pretreatment. (<b>A</b>) Caspase-like activity. (<b>B</b>) Trypsin-like activity. (<b>C</b>) Chymotrypsin-like activity. (<b>D-F</b>) Head isolated from 3 day old (pink) and 60 day old (black) females following hydrogen peroxide pretreatment. (<b>D</b>) Caspase-like activity. (<b>E</b>) Trypsin-like activity. (<b>F</b>) Chymotrypsin-like activity. (<b>G-I</b>) Thorax isolated from 3 day old (pink) and 60 day old (black) females following hydrogen peroxide pretreatment. (<b>G</b>) Caspase-like activity. (<b>H</b>) Trypsin-like activity. (<b>I</b>) Chymotrypsin-like activity. Error bars indicate the standard error of the mean (S.E.M) values. * <i>P</i> <0.05, ** <i>P</i> <0.01, *** <i>P</i> < 0.001, relative to the young female control using one-way ANOVA. Statistical significance is shown with pink asterisks (pink <b>*</b>) for young females and black asterisks (black <b>*</b>) in aged females.","file":"ENWbSTvmmSr4rNwz8_f6.tif","version":1,"optimized":true,"optimized_file":"ENWbSTvmmSr4rNwz8_f6.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/ENWbSTvmmSr4rNwz8_f6.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/ENWbSTvmmSr4rNwz8_f6.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/ENWbSTvmmSr4rNwz8_f6.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/ENWbSTvmmSr4rNwz8_f6.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/ENWbSTvmmSr4rNwz8_f6.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/ENWbSTvmmSr4rNwz8_f6.png"}},{"id":"f7","label":"Figure 7","caption":"<b>Males show no tissue-specific or age-related adaptive changes in 20S proteasome protein levels.</b> Body segments were collected from males of the Actin-GS-255B strain crossed to the w[1118] strain that were used as controls, or that were pretreated with either 10µM or 100µM hydrogen peroxide. (<b>A,B</b>) 20Sα expression in male abdominal tissue following pretreatment. (<b>A</b>) 3 day old. (<b>B</b>) 60 day old. (<b>C,D</b>) 20Sα expression in male head following pretreatment. (<b>C</b>) 3 day old. (<b>D</b>) 60 day old. (<b>E,F</b>) 20Sα expression in male thorax following pretreatment. (<b>E</b>) 3 day old. (<b>F</b>) 60 day old. Western blots were performed in triplicate, normalized to Actin-HRP, and quantified using ImageJ. The bar charts represent the quantification. Error bars denote standard error of the mean (S.E.M) values, relative to the male control using one-way ANOVA.","file":"ENWbSTvmmSr4rNwz8_f7.tif","version":1,"optimized":true,"optimized_file":"ENWbSTvmmSr4rNwz8_f7.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/ENWbSTvmmSr4rNwz8_f7.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/ENWbSTvmmSr4rNwz8_f7.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/ENWbSTvmmSr4rNwz8_f7.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/ENWbSTvmmSr4rNwz8_f7.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/ENWbSTvmmSr4rNwz8_f7.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/ENWbSTvmmSr4rNwz8_f7.png"}},{"id":"f8","label":"Figure 8","caption":"<b>Males show no tissue-specific differences in the adaptive proteolytic capacity of the 20S proteasome, but do exhibit age-dependent changes in proteasomal basal activity.</b> Body segments were collected from male progeny of the Actin-GS-255B strain crossed to the w[1118] strain that were used as controls, or that were pretreated with either 10µM or 100µM hydrogen peroxide. Individual proteolytic capacity of the 20S proteasome (caspase/peptidyl glutamyl-peptide hydrolyzing-like activity, trypsin-like, and chymotrypsin-like activity) was measured in the abdomen, head, and thorax. (<b>A-C</b>) Abdomen isolated from 3 day old (green) and 60 day old (black) males following hydrogen peroxide pretreatment. (<b>A</b>) Caspase-like activity. (<b>B</b>) Trypsin-like activity. (<b>C</b>) Chymotrypsin-like activity. (<b>D-F</b>) Head isolated from 3 day old (green) and 60 day old (black) males following hydrogen peroxide pretreatment. (<b>D</b>) Caspase-like activity. (<b>E</b>) Trypsin-like activity. (<b>F</b>) Chymotrypsin-like activity. (<b>G-I</b>) Thorax isolated from 3 day old (green) and 60 day old (black) males following hydrogen peroxide pretreatment. (<b>G</b>) Caspase-like activity. (<b>H</b>) Trypsin-like activity. (<b>I</b>) Chymotrypsin-like activity.","file":"ENWbSTvmmSr4rNwz8_f8.tif","version":1,"optimized":true,"optimized_file":"ENWbSTvmmSr4rNwz8_f8.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/ENWbSTvmmSr4rNwz8_f8.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/ENWbSTvmmSr4rNwz8_f8.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/ENWbSTvmmSr4rNwz8_f8.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/ENWbSTvmmSr4rNwz8_f8.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/ENWbSTvmmSr4rNwz8_f8.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/ENWbSTvmmSr4rNwz8_f8.png"}},{"id":"f9","label":"Figure 9","caption":"<b>Adaptation is dependent upon the 20S proteasome.</b> Progeny of the Actin-GS-255B strain crossed to the β<sub>1</sub> or β<sub>2</sub> RNAi strains were aged for 5 days in the absence or presence of RU486 prior to H<sub>2</sub>O<sub>2</sub> pretreatment. (<b>A-D</b>). The purpose of the experiment was not to completely knockdown the entire pool of 20S proteasome, but only to block the transcription/translation-dependent adaptive increase in proteasome expression following hydrogen peroxide pretreatment. Thus, we used RNAi conditions that blocked increased proteasome expression, without depressing basal proteasome protein levels. Using this approach, we found at least a 50% decrease in mRNA in RNAi strains, and within proteasome western blots and activity, we found blockage of the adaptive increase. After pretreatment, proteolytic capacity of the individual subunits of the 20S proteasome (trypsin-like, caspase/peptidyl glutamyl-peptide hydrolyzing-like activity, and chymotrypsin-like activity) were measured in whole fly lysate. (<b>A-B</b>) Proteolytic capacity in β<sub>1</sub> RNAi flies in the absence (black) “control” or presence (pink in females or blue in males, denoted with “+RU486”) of RU486. (<b>A</b>) Females. (<b>B</b>) Males. (<b>C-D</b>) Proteolytic capacity in β<sub>2</sub> RNAi flies in the absence (black) “control” or presence (pink in females or blue in males, denoted with “+RU486”) of RU486. (<b>C</b>) Females. (<b>D</b>) Males. (<b>E,G</b>) Females of the β<sub>1</sub> and β<sub>2</sub> RNAi strains raised in the absence of RU486 were either not pretreated “control” (black circle) or were pretreated with either 10µM H<sub>2</sub>O<sub>2</sub> (grey squares) or 100µM H<sub>2</sub>O<sub>2</sub> (grey circles) for 8 hours, followed by a 16-hour recovery prior to H<sub>2</sub>O<sub>2</sub> [4.4M] challenge. Females of the β<sub>1</sub> and β<sub>2</sub> RNAi strains raised in the presence of RU486 were either not pretreated “+RU486” (pink triangle) or were pretreated with either 10µM H<sub>2</sub>O<sub>2</sub> (pink diamonds) or 100µM H<sub>2</sub>O<sub>2</sub> (pink squares) for 8 hours, followed by a 16-hour recovery prior to H<sub>2</sub>O<sub>2</sub> [4.4M] challenge. (<b>F,H</b>) Males of the β<sub>1</sub> and β<sub>2</sub> RNAi strains raised in the absence of RU486 were either not pretreated “control” (black circle) or were pretreated with either 10µM H<sub>2</sub>O<sub>2</sub> (grey circles) or 100µM H<sub>2</sub>O<sub>2</sub> (grey triangles) for 8 hours, followed by a 16-hour recovery prior to H<sub>2</sub>O<sub>2</sub> [4.4M] challenge. Males of the β<sub>1</sub> and β<sub>2</sub> RNAi strains raised in the presence of RU486 were either not pretreated “+RU486” (green circle) or were pretreated with either 10µM H<sub>2</sub>O<sub>2</sub> (blue square) or 100µM H<sub>2</sub>O<sub>2</sub> (blue circle) for 8 hours, followed by a 16-hour recovery prior to H<sub>2</sub>O<sub>2</sub> [4.4M] challenge. Statistical difference in survival (p < 0.05) was calculated using the Log-Rank test. Statistical summary is located in <a href=\"#SD1\"  class=\"anchor\">Supplementary Table S2</a>.","file":"ENWbSTvmmSr4rNwz8_f9.tif","version":1,"optimized":true,"optimized_file":"ENWbSTvmmSr4rNwz8_f9.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/ENWbSTvmmSr4rNwz8_f9.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/ENWbSTvmmSr4rNwz8_f9.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/ENWbSTvmmSr4rNwz8_f9.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/ENWbSTvmmSr4rNwz8_f9.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/ENWbSTvmmSr4rNwz8_f9.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/ENWbSTvmmSr4rNwz8_f9.png"}},{"id":"f10","label":"Figure 10","caption":"<b>Decline in 20S proteasome induction is accompanied by an accumulation of oxidized proteins.</b> Carbonyl content was detected with a DNP antibody in progeny of the Actin-GS-255B strain crossed to w[1118] strain following [0, 10, or 100µM] H<sub>2</sub>O<sub>2</sub> pre-treatment for 8 hours, followed by a 16-hour recovery to allow for adaption before challenged with H<sub>2</sub>O<sub>2</sub> [4.4M] for an additional 24 hours. (<b>A</b>) Carbonyl content showed significant decrease following H<sub>2</sub>O<sub>2</sub> pretreatment in 3 day old females. (<b>B</b>) Carbonyl content showed no significant change in 60 day old females, irrespective H<sub>2</sub>O<sub>2</sub> pretreatment. (<b>C</b>) Carbonyl content was measured in 3 day old males that were pre-treated with H<sub>2</sub>O<sub>2</sub>. (<b>D</b>) 60 day old males showed no change in carbonyl content upon H<sub>2</sub>O<sub>2</sub> pre-treatment and subsequent recovery. Western blots were performed in triplicate and carbonyl content was normalized to Actin-HRP. Error bars denote standard error of the mean (S.E.M) values. * <i>P</i> <0.05, ** <i>P</i> <0.01, *** <i>P</i> < 0.001, relative to the young control using one-way ANOVA. Statistical significance is shown with asterisks (pink <b>*</b>) in young females.","file":"ENWbSTvmmSr4rNwz8_f10.tif","version":1,"optimized":true,"optimized_file":"ENWbSTvmmSr4rNwz8_f10.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/ENWbSTvmmSr4rNwz8_f10.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/ENWbSTvmmSr4rNwz8_f10.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/ENWbSTvmmSr4rNwz8_f10.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/ENWbSTvmmSr4rNwz8_f10.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/ENWbSTvmmSr4rNwz8_f10.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/ENWbSTvmmSr4rNwz8_f10.png"}},{"id":"f11","label":"Figure 11","caption":"<b>Loss of proteasomal subunits or regulators impacts lifespan.</b> (<b>A,B</b>) To control for the effect of RU486 on males and females, lifespan of progeny from the Actin-GS-255B strain crossed to w[1118] strain raised in the absence/control (black line) or presence of RU486, pink line for females and blue line for males. (<b>A</b>) Females. (<b>B</b>) Males. (<b>C-F</b>) Effect of removal of proteasome subunits on life span. The Actin-GS-255B strain was crossed to the β<sub>1</sub> RNAi or β<sub>2</sub> RNAi strains and the progeny were assayed for life span in the absence/control (black line) or presence (pink line in females and blue line in males) of RU486, as indicated. (<b>C</b>) β<sub>1</sub> RNAi females. (<b>D</b>) β<sub>1</sub> RNAi males. (<b>E</b>) β<sub>2</sub> RNAi females. (<b>F</b>) β<sub>2</sub> RNAi males. (<b>G,H</b>) Effect of removal of the Cap-n-collar (CncC)/Nrf2 orthologue upon lifespan. The Actin-GS-255B strain was crossed to the CncC RNAi strain. Male and female lifespan was measured in the absence/control (black line) or presence (pink line for females and blue line for males) of RU486. (<b>G</b>) CncC RNAi female. (<b>H</b>) CncC RNAi male. (<b>I,J</b>) Effect of removal of Keap1 upon lifespan. The Actin-GS-255B strain was crossed to the Keap1 RNAi strain. Males and female lifespan was assessed in the absence/control (black line) and presence (pink line for females and blue line for males) of RU486. (<b>I</b>) Keap1 RNAi female. (<b>J</b>) Keap1 RNAi male. Statistical difference in survival (p < 0.05) was calculated using the Log-Rank test. Statistical summary is located in <a href=\"#SD1\"  class=\"anchor\">Supplementary Table S3</a>","file":"ENWbSTvmmSr4rNwz8_f11.tif","version":1,"optimized":true,"optimized_file":"ENWbSTvmmSr4rNwz8_f11.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/ENWbSTvmmSr4rNwz8_f11.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/ENWbSTvmmSr4rNwz8_f11.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/ENWbSTvmmSr4rNwz8_f11.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/ENWbSTvmmSr4rNwz8_f11.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/ENWbSTvmmSr4rNwz8_f11.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/ENWbSTvmmSr4rNwz8_f11.png"}},{"id":"f12","label":"Figure 12","caption":"<b>Hydrogen peroxide stress resistance improves with continual knockdown of Keap1 in aged (60 days) flies.</b> In panels <b>A</b> and <b>B</b>, male and female progeny of the Actin-GS-255B strain crossed to Keap1 RNAi strain were collected and aged to 60 days. (<b>A</b>) Females raised in the absence of RU486 were either pretreated with 10µM H<sub>2</sub>O<sub>2</sub> (gray line) “10µM H<sub>2</sub>O<sub>2</sub>” or not pre-treated with H<sub>2</sub>O<sub>2</sub> (black line) “No Additions”. Females raised in the presence of RU486 were either pretreated with 10µM H<sub>2</sub>O<sub>2</sub> (red line) “10µM H<sub>2</sub>O<sub>2</sub> (+RU486)” or not pretreated with H<sub>2</sub>O<sub>2</sub> (pink line) “+RU486”. (<b>B</b>) Males raised in the absence of RU486 were either pretreated with 10µM H<sub>2</sub>O<sub>2</sub> (gray line) “10µM H<sub>2</sub>O<sub>2</sub>” or not pre-treated with H<sub>2</sub>O<sub>2</sub> (black line) “No Additions”. Males raised in the presence of RU486 were either pretreated with 10µM H<sub>2</sub>O<sub>2</sub> (blue line) “10µM H<sub>2</sub>O<sub>2</sub> (+RU486)” or not pretreated with H<sub>2</sub>O<sub>2</sub> (green line) “+RU486”. Statistical difference in survival (p < 0.05) was calculated using the Log-Rank test. Statistical summary is located in <a href=\"#SD1\"  class=\"anchor\">Supplementary Table S4</a>.","file":"ENWbSTvmmSr4rNwz8_f12.tif","version":1,"optimized":true,"optimized_file":"ENWbSTvmmSr4rNwz8_f12.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/ENWbSTvmmSr4rNwz8_f12.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/ENWbSTvmmSr4rNwz8_f12.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/ENWbSTvmmSr4rNwz8_f12.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/ENWbSTvmmSr4rNwz8_f12.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/ENWbSTvmmSr4rNwz8_f12.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/ENWbSTvmmSr4rNwz8_f12.png"}}],"supplemental":[{"id":"SD1","label":"Supplementary File","file":"ENWbSTvmmSr4rNwz8_sd1.pdf","version":1,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/supplemental_materials/ENWbSTvmmSr4rNwz8_sd1.pdf"}]},"title":"The age- and sex-specific decline of the 20s proteasome and the Nrf2/CncC signal transduction pathway in adaption and resistance to oxidative stress in <i>Drosophila melanogaster</i>","page_start":1153,"page_end":1185,"ids":{"pii":"101218","publisher-id":"101218","doi":"10.18632/aging.101218","pmid":"28373600"},"abstract":"<p>Hallmarks of aging include loss of protein homeostasis and dysregulation of stress-adaptive pathways. Loss of adaptive homeostasis, increases accumulation of DNA, protein, and lipid damage. During acute stress, the Cnc-C (<i>Drosophila</i> Nrf2 orthologue) transcriptionally-regulated 20S proteasome degrades damaged proteins in an ATP-independent manner. Exposure to very low, non-toxic, signaling concentrations of the redox-signaling agent hydrogen peroxide (H<sub>2</sub>O<sub>2</sub>) cause adaptive increases in the <i>de novo</i> expression and proteolytic activity/capacity of the 20S proteasome in female <i>D. melanogaster</i> (fruit-flies). Female 20S proteasome induction was accompanied by increased tolerance to a subsequent normally toxic but sub-lethal amount of H<sub>2</sub>O<sub>2</sub>, and blocking adaptive increases in proteasome expression also prevented full adaptation. We find, however, that this adaptive response is both sex- and age-dependent. Both increased proteasome expression and activity, and increased oxidative-stress resistance, in female flies, were lost with age. In contrast, male flies exhibited no H<sub>2</sub>O<sub>2</sub> adaptation, irrespective of age. Furthermore, aging caused a generalized increase in basal 20S proteasome expression, but proteolytic activity and adaptation were both compromised. Finally, continual knockdown of Keep1 (the cytosolic inhibitor of Cnc-C) in adults resulted in older flies with greater stress resistance than their age-matched controls, but who still exhibited an age-associated loss of adaptive homeostasis.</p>","article_type":{"short_name":"research_paper","nlm_type":"research-article","plural":"Research Papers","name":"Research Paper"},"authors":[{"name_first":"Laura","name_middle":"C.D.","name_last":"Pomatto","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Sarah","name_middle":"","name_last":"Wong","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Caroline","name_middle":"","name_last":"Carney","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Brenda","name_middle":"","name_last":"Shen","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"John","name_middle":"","name_last":"Tower","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0,1],"author_notes_ids":[]},{"name_first":"Kelvin","name_middle":"J. A.","name_last":"Davies","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0,1],"author_notes_ids":[]}]},{"files":{"pdf":{"file":"ikCkZYNqL7MJ7tTko.pdf","display":true,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/pdf/ikCkZYNqL7MJ7tTko.pdf"},"xml":{"file":"ikCkZYNqL7MJ7tTko.xml","display":true,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/xml/ikCkZYNqL7MJ7tTko.xml"},"figures":[{"id":"f1","label":"Figure 1","caption":"<b>A microarray assay of miRNA expression profiles and a KEGG pathway enrichment analysis of target mRNAs predicted from differentially-expressed (DE) miRNAs in mouse oocytes aging for different times.</b> (<b>A</b>) Heat map and cluster analysis of miRNA expression in oocytes aging for different times. Red indicates high relative expression and green indicates low relative expression. Fold changes greater than 2 (FC>2) were used as threshold for miRNA differential expression. (<b>B</b>) A table shows number of DE miRNAs, number of target mRNAs predicted from DE miRNAs and number of enriched KEGG pathways in oocytes aging for different times.","file":"ikCkZYNqL7MJ7tTko_f1.tif","version":1,"optimized":true,"optimized_file":"ikCkZYNqL7MJ7tTko_f1.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/ikCkZYNqL7MJ7tTko_f1.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/ikCkZYNqL7MJ7tTko_f1.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/ikCkZYNqL7MJ7tTko_f1.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/ikCkZYNqL7MJ7tTko_f1.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/ikCkZYNqL7MJ7tTko_f1.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/ikCkZYNqL7MJ7tTko_f1.png"}},{"id":"f2","label":"Figure 2","caption":"<b>RT-qPCR verification of microarray assay results for apoptosis-related miRNAs.</b> Each treatment was repeated 3-4 times and each replicate contained ~600 oocytes. a-c: Values with a different letter above bars differ significantly (P < 0.05).","file":"ikCkZYNqL7MJ7tTko_f2.tif","version":1,"optimized":true,"optimized_file":"ikCkZYNqL7MJ7tTko_f2.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/ikCkZYNqL7MJ7tTko_f2.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/ikCkZYNqL7MJ7tTko_f2.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/ikCkZYNqL7MJ7tTko_f2.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/ikCkZYNqL7MJ7tTko_f2.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/ikCkZYNqL7MJ7tTko_f2.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/ikCkZYNqL7MJ7tTko_f2.png"}},{"id":"f3","label":"Figure 3","caption":"<b>Levels of p-MAPK, TrkB, and ceramide expression in oocytes aging for different times.</b> Graphs <b>A</b>, <b>B</b> and <b>C</b> show quantification of p-MAPK, TrkB, and ceramide expression, respectively. For ceramide quantification, the fluorescence intensity value in oocytes recovered at 13 h post hCG injection was set as one and the other values were expressed relative to this value. Each treatment was repeated 3-4 times and each replicate contained 35-40 oocytes. a-c: Values with a different letter above bars differ significantly (P < 0.05). <b>D</b>, <b>E</b>, <b>F</b> and <b>G</b> are micrographs from laser confocal images showing expression of ceramide in oocytes recovered at different times after hCG injection. Ceramide was colored green in the laser confocal images. The bar is 18 µm and applies to all images.","file":"ikCkZYNqL7MJ7tTko_f3.tif","version":1,"optimized":true,"optimized_file":"ikCkZYNqL7MJ7tTko_f3.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/ikCkZYNqL7MJ7tTko_f3.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/ikCkZYNqL7MJ7tTko_f3.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/ikCkZYNqL7MJ7tTko_f3.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/ikCkZYNqL7MJ7tTko_f3.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/ikCkZYNqL7MJ7tTko_f3.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/ikCkZYNqL7MJ7tTko_f3.png"}},{"id":"f4","label":"Figure 4","caption":"<b>Effects of supplementation with U0126, ceramide or BDNF during in vitro aging on STAS of mouse oocytes.</b> Cumulus-denuded oocytes (DOs) recovered 13 h post hCG injection were used. For U0126 and BDNF treatment, the DOs were aged for 36 h in CZB medium supplemented with different concentrations of U0126 or BDNF before ethanol and 6-DMAP treatment for activation. For ceramide treatment, DOs were microinjected with 6 pl DMSO alone (control) or DMSO containing 1 mM ceramide and then aged for 36 h in CZB medium before ethanol and 6-DMAP treatment for activation. Each treatment was repeated 4-5 times with each replicate containing about 30 oocytes. a,b: Values with a different letter above bars differ significantly (P < 0.05).","file":"ikCkZYNqL7MJ7tTko_f4.tif","version":1,"optimized":true,"optimized_file":"ikCkZYNqL7MJ7tTko_f4.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/ikCkZYNqL7MJ7tTko_f4.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/ikCkZYNqL7MJ7tTko_f4.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/ikCkZYNqL7MJ7tTko_f4.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/ikCkZYNqL7MJ7tTko_f4.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/ikCkZYNqL7MJ7tTko_f4.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/ikCkZYNqL7MJ7tTko_f4.png"}},{"id":"f5","label":"Figure 5","caption":"<b>Activation rates and calcium stores in oocytes microinjected with miR-98 mimic (upper row) or inhibitor (lower row).</b> Freshly ovulated oocytes recovered at 13 h post hCG were injected with miR-98 mimic (MM) or miRNA mimic negative control (MC), or with miR-98 inhibitor (IN) or inhibitor negative control (IC), before aging culture in CZB medium. To observe activation, oocytes were treated with ethanol and 6-DMAP at 36 h (mimic) or 30 h (inhibitor) of aging culture, and activation was checked 6 h later. Each treatment was repeated 3 to 4 times and each replicate contained 35-40 oocytes. For calcium measurement, at 3 h and 36 h (mimic) or 30 h (inhibitor) of aging culture, oocytes were loaded with Fura-2 AM and the loaded oocytes were measured for calcium stores (ΔF340/380) using a Ca<sup>2+</sup> imaging system. Oocytes were monitored for 5 min to record baseline F340/380 ratio before ionomycin stimulation to release Ca<sup>2+</sup> into cytoplasm. Following ionomycin addition, oocytes were monitored for 20 min to record peak F340/380 ratio. The difference between peak and baseline F340/380 ratios represents the calcium stores (ΔF340/380) of an oocyte. Each treatment was repeated 3 to 4 times and each replicate contained 35-40 oocytes. a-c: Values with a different letter above bars differ significantly (P < 0.05).","file":"ikCkZYNqL7MJ7tTko_f5.tif","version":1,"optimized":true,"optimized_file":"ikCkZYNqL7MJ7tTko_f5.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/ikCkZYNqL7MJ7tTko_f5.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/ikCkZYNqL7MJ7tTko_f5.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/ikCkZYNqL7MJ7tTko_f5.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/ikCkZYNqL7MJ7tTko_f5.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/ikCkZYNqL7MJ7tTko_f5.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/ikCkZYNqL7MJ7tTko_f5.png"}},{"id":"f6","label":"Figure 6","caption":"<b>Caspase-3 expression in oocytes microinjected with miR-98 mimic or inhibitor.</b> Freshly ovulated oocytes recovered at 13 h post hCG were injected with miR-98 mimic (MM) or miRNA mimic negative control (MC), or with miR-98 inhibitor (IN) or inhibitor negative control (IC), before aging culture in CZB medium. At 36 h (mimic) or 30 h (inhibitor) of aging culture, oocytes were processed for immunofluorescence microscopy. Caspase-3 was colored red in the laser confocal images. The bar is 12 µm and applies to all images. For quantification, the fluorescence intensity values in control oocytes injected with MC or IC were set as one and the values in oocytes injected with MM or IN were expressed relative to the values in control oocytes. Each treatment was repeated 3-4 times and each replicate contained 35-40 oocytes. a,b: Values with a different letter above bars differ significantly (P < 0.05).","file":"ikCkZYNqL7MJ7tTko_f6.tif","version":1,"optimized":true,"optimized_file":"ikCkZYNqL7MJ7tTko_f6.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/ikCkZYNqL7MJ7tTko_f6.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/ikCkZYNqL7MJ7tTko_f6.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/ikCkZYNqL7MJ7tTko_f6.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/ikCkZYNqL7MJ7tTko_f6.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/ikCkZYNqL7MJ7tTko_f6.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/ikCkZYNqL7MJ7tTko_f6.png"}}]},"title":"Expression profiles and function analysis of microRNAs in postovulatory aging mouse oocytes","page_start":1186,"page_end":1201,"ids":{"pii":"101219","publisher-id":"101219","doi":"10.18632/aging.101219","pmid":"28394765"},"abstract":"<p>In this study, microRNA (miRNA) profiles in postovulatory aging mouse oocytes were analyzed by microarray screening and RT-qPCR. Hierarchical cluster analysis on the microarray data and KEGG pathway enrichment analysis on the mRNAs targeted by differentially expressed (DE) miRNAs between two adjacent egg-ages suggest that while only a mild alteration in miRNA expression occurred from 13 to 18 h, a great change took place from 18 to 24 h post hCG injection. Theoretical exploration on functions of the predicted target genes suggest that KEGG pathways enriched by 13-18 h DE miRNAs are correlated with early events of oocyte aging while pathways most enriched by 18-24 h or 24-30 h DE miRNAs are correlated with the late symptoms of aged oocytes. Experimental verification on functions of the key proteins predicted by the KEGG analysis and injection of miR-98 mimics or inhibitors further confirmed that miRNAs played stimulatory/inhibitory roles in postovulatory oocyte aging. In conclusion, marked changes in miRNA expression are associated with significant alterations in function and morphology of postovulatory aging oocytes.</p>","article_type":{"short_name":"research_paper","nlm_type":"research-article","plural":"Research Papers","name":"Research Paper"},"authors":[{"name_first":"Tian-Yang","name_middle":"","name_last":"Wang","name_suffix":"","equal_contrib":true,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Jie","name_middle":"","name_last":"Zhang","name_suffix":"","equal_contrib":true,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Jiang","name_middle":"","name_last":"Zhu","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Hua-Yu","name_middle":"","name_last":"Lian","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Hong-Jie","name_middle":"","name_last":"Yuan","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Min","name_middle":"","name_last":"Gao","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Ming-Jiu","name_middle":"","name_last":"Luo","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Jing-He","name_middle":"","name_last":"Tan","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]}]},{"files":{"figures":[{"id":"f1","label":"Figure 1","caption":"Study design and analysis workflow followed in the present study.","file":"ghsorsYMeYNLJNMpt_f1.tif","version":1,"optimized":true,"optimized_file":"ghsorsYMeYNLJNMpt_f1.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/ghsorsYMeYNLJNMpt_f1.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/ghsorsYMeYNLJNMpt_f1.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/ghsorsYMeYNLJNMpt_f1.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/ghsorsYMeYNLJNMpt_f1.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/ghsorsYMeYNLJNMpt_f1.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/ghsorsYMeYNLJNMpt_f1.png"}},{"id":"f2","label":"Figure 2","caption":"(<b>A</b>) Age distribution of subjects included in the study. (<b>B</b>) Expression of the sncRNA that progresively change with age according to the correlation analysis. y-axis represents the mean z-score values of the sncRNAs that correlate with age. Blue line represents the decreasing sncRNAs and red line represents the increasing sncRNAs. (<b>C</b>) Heatmap that represents the z-score value of the expression of the 69 sncRNAs correlated with age. Columns represent the mean age of the 28 sliding windows and rows are the 69 sncRNAs.","file":"ghsorsYMeYNLJNMpt_f2.tif","version":1,"optimized":true,"optimized_file":"ghsorsYMeYNLJNMpt_f2.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/ghsorsYMeYNLJNMpt_f2.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/ghsorsYMeYNLJNMpt_f2.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/ghsorsYMeYNLJNMpt_f2.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/ghsorsYMeYNLJNMpt_f2.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/ghsorsYMeYNLJNMpt_f2.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/ghsorsYMeYNLJNMpt_f2.png"}},{"id":"f3","label":"Figure 3","caption":"Number of miRNA (top) and snoRNA (bottom) identified by correlation and differential expression analysis and the overlapping probes between two analyses.","file":"ghsorsYMeYNLJNMpt_f3.tif","version":1,"optimized":true,"optimized_file":"ghsorsYMeYNLJNMpt_f3.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/ghsorsYMeYNLJNMpt_f3.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/ghsorsYMeYNLJNMpt_f3.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/ghsorsYMeYNLJNMpt_f3.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/ghsorsYMeYNLJNMpt_f3.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/ghsorsYMeYNLJNMpt_f3.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/ghsorsYMeYNLJNMpt_f3.png"}},{"id":"f4","label":"Figure 4","caption":"Summary of the number of interesting miRNA identified in each analysis step.","file":"ghsorsYMeYNLJNMpt_f4.tif","version":1,"optimized":true,"optimized_file":"ghsorsYMeYNLJNMpt_f4.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/ghsorsYMeYNLJNMpt_f4.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/ghsorsYMeYNLJNMpt_f4.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/ghsorsYMeYNLJNMpt_f4.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/ghsorsYMeYNLJNMpt_f4.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/ghsorsYMeYNLJNMpt_f4.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/ghsorsYMeYNLJNMpt_f4.png"}},{"id":"f5","label":"Figure 5","caption":"Results of the validation experiment of candidate miRNA. (<b>A</b>) The expression of candidate miRNA in elder (over 50) and young (under 50) is shown measured by RT-qPCR in the discovery cohort (upper row) and validation cohort (lower row). In the validation cohort miR-1281 was not analysed. (<b>B</b>) The expression of the validated 4 miRNA with age ranges.","file":"ghsorsYMeYNLJNMpt_f5.tif","version":1,"optimized":true,"optimized_file":"ghsorsYMeYNLJNMpt_f5.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/ghsorsYMeYNLJNMpt_f5.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/ghsorsYMeYNLJNMpt_f5.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/ghsorsYMeYNLJNMpt_f5.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/ghsorsYMeYNLJNMpt_f5.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/ghsorsYMeYNLJNMpt_f5.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/ghsorsYMeYNLJNMpt_f5.png"}}],"pdf":{"file":"ghsorsYMeYNLJNMpt.pdf","display":true,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/pdf/ghsorsYMeYNLJNMpt.pdf"},"xml":{"file":"ghsorsYMeYNLJNMpt.xml","display":true,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/xml/ghsorsYMeYNLJNMpt.xml"}},"title":"Progressive changes in non-coding RNA profile in leucocytes with age","page_start":1202,"page_end":1218,"ids":{"pii":"101220","publisher-id":"101220","doi":"10.18632/aging.101220","pmid":"28448962"},"abstract":"<p>It has been observed that immune cell deterioration occurs in the elderly, as well as a chronic low-grade inflammation called inflammaging. These cellular changes must be driven by numerous changes in gene expression and in fact, both protein-coding and non-coding RNA expression alterations have been observed in peripheral blood mononuclear cells from elder people. In the present work we have studied the expression of small non-coding RNA (microRNA and small nucleolar RNA -snoRNA-) from healthy individuals from 24 to 79 years old. We have observed that the expression of 69 non-coding RNAs (56 microRNAs and 13 snoRNAs) changes progressively with chronological age. According to our results, the age range from 47 to 54 is critical given that it is the period when the expression trend (increasing or decreasing) of age-related small non-coding RNAs is more pronounced. Furthermore, age-related miRNAs regulate genes that are involved in immune, cell cycle and cancer-related processes, which had already been associated to human aging. Therefore, human aging could be studied as a result of progressive molecular changes, and different age ranges should be analysed to cover the whole aging process.</p>","article_type":{"short_name":"research_paper","nlm_type":"research-article","plural":"Research Papers","name":"Research Paper"},"authors":[{"name_first":"Maider","name_middle":"","name_last":"Muñoz-Culla","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0,2],"author_notes_ids":[]},{"name_first":"Haritz","name_middle":"","name_last":"Irizar","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0,3],"author_notes_ids":[]},{"name_first":"Ana","name_middle":"","name_last":"Gorostidi","name_suffix":"","equal_contrib":false,"affiliations_numbers":[4,5],"author_notes_ids":[]},{"name_first":"Ainhoa","name_middle":"","name_last":"Alberro","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Iñaki","name_middle":"","name_last":"Osorio-Querejeta","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Javier","name_middle":"","name_last":"Ruiz-Martínez","name_suffix":"","equal_contrib":false,"affiliations_numbers":[4,6],"author_notes_ids":[]},{"name_first":"Javier","name_middle":"","name_last":"Olascoaga","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0,2,6],"author_notes_ids":[]},{"name_first":"Adolfo","name_middle":"","name_last":"López de Munain","name_suffix":"","equal_contrib":false,"affiliations_numbers":[1,6,7,8],"author_notes_ids":[]},{"name_first":"David","name_middle":"","name_last":"Otaegui","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0,2],"author_notes_ids":[]}]},{"files":{"figures":[{"id":"f1","label":"Figure 1","caption":"<b>Shelterin components are differentially expressed during development and adulthood.</b> Quantitative RT-PCRs for Shelterin components Trf1, Trf2, Rap1, Tpp1, Tin2, Pot1a, and Pot1b and PCNA as a marker for proliferation in mouse brains, hearts, livers, and kidneys at different time-points of development and in adulthood (<i>n</i>=4 each, the four samples for E10 were each pooled from 7 organs, at E12 and 14 the four samples were pooled from four organs each). Expression of each gene was normalized to the respective <i>Gapdh, actin, and Rplp0</i> expression. Next, the average of all organs and samples at E10.5 was calculated. Individual samples were then normalized against this average value. Significance was tested between E10 and P100 (adult). Data are mean ± SEM. *p<0.05, **p<0.01, ***p<0.001.","file":"Ax5W2bq4xqMYpdR5G_f1.tif","version":1,"optimized":true,"optimized_file":"Ax5W2bq4xqMYpdR5G_f1.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/Ax5W2bq4xqMYpdR5G_f1.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/Ax5W2bq4xqMYpdR5G_f1.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/Ax5W2bq4xqMYpdR5G_f1.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/Ax5W2bq4xqMYpdR5G_f1.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/Ax5W2bq4xqMYpdR5G_f1.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/Ax5W2bq4xqMYpdR5G_f1.png"}},{"id":"f2","label":"Figure 2","caption":"<b>TRF2 is highly and ubiquitously expressed during embryonic development up to E16 and persists afterwards specifically in the brain.</b> Representative photomicrographs of TRF2 immunostaining on sections of mouse embryos (3,3' diaminobenzidine (DAB) substrate, brown, hematoxylin counterstaining) at different stages before birth. B: brain, H: heart, L: liver, K: kidney. Unless otherwise indicated, scale bars represent 50µm.","file":"Ax5W2bq4xqMYpdR5G_f2.tif","version":1,"optimized":true,"optimized_file":"Ax5W2bq4xqMYpdR5G_f2.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/Ax5W2bq4xqMYpdR5G_f2.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/Ax5W2bq4xqMYpdR5G_f2.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/Ax5W2bq4xqMYpdR5G_f2.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/Ax5W2bq4xqMYpdR5G_f2.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/Ax5W2bq4xqMYpdR5G_f2.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/Ax5W2bq4xqMYpdR5G_f2.png"}},{"id":"f3","label":"Figure 3","caption":"<b>TRF2 expression remains high in the brain during adulthood.</b> Representative photomicrographs of TRF2 immunostaining for the brain, heart, liver, and kidney (3,3' diaminobenzidine (DAB) substrate, brown, hematoxylin counterstaining) at different stages after birth. Note the persistent high expression of TRF2 in neurons of the brain (see also <a href=\"#SD1\"  class=\"anchor\">Supplementary Figure S1</a>), the specific expression in subepicardial endothelial cells of the heart, and glomerular podocytes and juxta-glomerular cells of the kidney (arrows). Scale bars indicate 50µm.","file":"Ax5W2bq4xqMYpdR5G_f3.tif","version":1,"optimized":true,"optimized_file":"Ax5W2bq4xqMYpdR5G_f3.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/Ax5W2bq4xqMYpdR5G_f3.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/Ax5W2bq4xqMYpdR5G_f3.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/Ax5W2bq4xqMYpdR5G_f3.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/Ax5W2bq4xqMYpdR5G_f3.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/Ax5W2bq4xqMYpdR5G_f3.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/Ax5W2bq4xqMYpdR5G_f3.png"}},{"id":"f4","label":"Figure 4","caption":"<b>Shelterin genes are differentially expressed during zebrafish life span.</b> Quantitative RT-qPCRs for Shelterin components TRF1, TRF2 (TERFA), RAP1, TPP1, TIN2 and POT1 in zebrafish’s brain, heart, liver, intestine, muscle, gill, tail and ovary at different time-points of life span from 3 month to 36 month (n=6 each). Significance was tested between 3 month and 36 month. Data are mean ± SEM. *p<0.05, **p<0.01, ***p<0.001.","file":"Ax5W2bq4xqMYpdR5G_f4.tif","version":1,"optimized":true,"optimized_file":"Ax5W2bq4xqMYpdR5G_f4.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/Ax5W2bq4xqMYpdR5G_f4.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/Ax5W2bq4xqMYpdR5G_f4.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/Ax5W2bq4xqMYpdR5G_f4.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/Ax5W2bq4xqMYpdR5G_f4.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/Ax5W2bq4xqMYpdR5G_f4.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/Ax5W2bq4xqMYpdR5G_f4.png"}},{"id":"f5","label":"Figure 5","caption":"<b>TERFA expression increase since neural development at embryonic stage and remains high in the brain during larval stage development.</b> Representative photomicrographs of whole-mount in situ hybridization of <i>TERFA</i>, <i>Neurog1</i> and <i>c-MYB</i> mRNA. The RNA probe labelled with DIG was stained in dark blue. The green arrow indicates the dorsal root ganglion neuron and the blue arrow indicates the lateral line neuromasts. The black arrow in 24hpf indicates the midbrain boundary. The red arrow indicates the <i>c-MYB</i> signal marked hematopoietic tissue.","file":"Ax5W2bq4xqMYpdR5G_f5.tif","version":1,"optimized":true,"optimized_file":"Ax5W2bq4xqMYpdR5G_f5.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/Ax5W2bq4xqMYpdR5G_f5.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/Ax5W2bq4xqMYpdR5G_f5.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/Ax5W2bq4xqMYpdR5G_f5.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/Ax5W2bq4xqMYpdR5G_f5.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/Ax5W2bq4xqMYpdR5G_f5.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/Ax5W2bq4xqMYpdR5G_f5.png"}},{"id":"f6","label":"Figure 6","caption":"<b>TERFA activates the expression of neuronal gene in zebrafish embryos.</b> (<b>A</b>) Gene expression measured by RT-qPCRs in zebrafish embryos 24h after microinjection of MO targeting <i>TERFA</i> gene. (<b>B</b>) PPP2R2C expression upon co-injection of <i>TERFA</i> mRNA or <i>PPP2R2C</i> mRNA in zebrafish embryos after microinjection of MO targeting <i>TERFA</i> gene. (<b>C</b>) Expression of PP2A subunit genes in zebrafish embryos 24h after microinjection of MO targeting <i>TERFA</i> gene. Each qRT-PCR was repeated three times and the mRNA level of the PP2A genes was expressed relative to β-actin and normalized to the Morpholino -control. Data are mean ± SEM. *p<0.05, **p<0.01, ***p<0.001.","file":"Ax5W2bq4xqMYpdR5G_f6.tif","version":1,"optimized":true,"optimized_file":"Ax5W2bq4xqMYpdR5G_f6.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/Ax5W2bq4xqMYpdR5G_f6.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/Ax5W2bq4xqMYpdR5G_f6.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/Ax5W2bq4xqMYpdR5G_f6.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/Ax5W2bq4xqMYpdR5G_f6.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/Ax5W2bq4xqMYpdR5G_f6.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/Ax5W2bq4xqMYpdR5G_f6.png"}}],"supplemental":[{"id":"SD1","label":"Supplementary File","file":"Ax5W2bq4xqMYpdR5G_sd1.pdf","version":1,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/supplemental_materials/Ax5W2bq4xqMYpdR5G_sd1.pdf"}],"pdf":{"file":"Ax5W2bq4xqMYpdR5G.pdf","display":true,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/pdf/Ax5W2bq4xqMYpdR5G.pdf"},"xml":{"file":"Ax5W2bq4xqMYpdR5G.xml","display":true,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/xml/Ax5W2bq4xqMYpdR5G.xml"}},"title":"The differential spatiotemporal expression pattern of shelterin genes throughout lifespan","page_start":1219,"page_end":1232,"ids":{"pii":"101223","publisher-id":"101223","doi":"10.18632/aging.101223","pmid":"28437249"},"abstract":"<p>Shelterin forms the core complex of telomere proteins and plays critical roles in protecting telomeres against unwanted activation of the DNA damage response and in Emaintaining telomere length homeostasis. Although shelterin expression is believed to be ubiquitous for stabilization of chromosomal ends. Evidences suggest that some shelterin subunits have tissue-specific functions. However, very little is known regarding how shelterin subunit gene expression is regulated during development and aging. Using two different animal models, the mouse and zebrafish, we reveal herein that shelterin subunits exhibit distinct spatial and temporal expression patterns that do not correlate with the proliferative status of the organ systems examined. Together, this work shows that the shelterin subunits exhibit distinct spatiotemporal expression patterns, suggesting important tissue-specific functions during development and aging.</p>","article_type":{"short_name":"research_paper","nlm_type":"research-article","plural":"Research Papers","name":"Research Paper"},"authors":[{"name_first":"Kay-Dietrich","name_middle":"","name_last":"Wagner","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0,1],"author_notes_ids":["afn1"]},{"name_first":"Yilin","name_middle":"","name_last":"Ying","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0,2],"author_notes_ids":["afn1"]},{"name_first":"Waiian","name_middle":"","name_last":"Leong","name_suffix":"","equal_contrib":false,"affiliations_numbers":[2],"author_notes_ids":["afn1"]},{"name_first":"Jie","name_middle":"","name_last":"Jiang","name_suffix":"","equal_contrib":false,"affiliations_numbers":[2],"author_notes_ids":[]},{"name_first":"Xuefei","name_middle":"","name_last":"Hu","name_suffix":"","equal_contrib":false,"affiliations_numbers":[2],"author_notes_ids":[]},{"name_first":"Yi","name_middle":"","name_last":"Chen","name_suffix":"","equal_contrib":false,"affiliations_numbers":[2,6],"author_notes_ids":[]},{"name_first":"Jean-François","name_middle":"","name_last":"Michiels","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0,3],"author_notes_ids":[]},{"name_first":"Yiming","name_middle":"","name_last":"Lu","name_suffix":"","equal_contrib":false,"affiliations_numbers":[2,5],"author_notes_ids":[]},{"name_first":"Eric","name_middle":"","name_last":"Gilson","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0,2,4],"author_notes_ids":["afn2"]},{"name_first":"Nicole","name_middle":"","name_last":"Wagner","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0,1],"author_notes_ids":["afn2"]},{"name_first":"Jing","name_middle":"","name_last":"Ye","name_suffix":"","equal_contrib":false,"affiliations_numbers":[2,5,6],"author_notes_ids":["afn2"]}]},{"files":{"figures":[{"id":"f1","label":"Figure 1","caption":"<b>Effects of aspirin on glioma cells survival and proliferation.</b> (<b>A</b>) U87 and T98G cells were treated with increasing concentrations of aspirin for 24 h. Cell survival was analyzed by CCK-8 assay. (<b>B</b>) U87 and T98G cells were treated with indicated concentrations of aspirin and harvested after 24, 48 and 72 h. Cell proliferation was analyzed by CCK-8 assay. (<b>C</b>) The glioma cells viability upon indicated concentrations of aspirin treatment were determined by colony formation assay. Data are shown as mean±SEM for the three replicates. Statistical significance levels are indicated as: *P < 0.05; **P < 0.01 and ***P < 0.001.","file":"4Wczmsva9jg3uTXKg_f1.tif","version":1,"optimized":true,"optimized_file":"4Wczmsva9jg3uTXKg_f1.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/4Wczmsva9jg3uTXKg_f1.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/4Wczmsva9jg3uTXKg_f1.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/4Wczmsva9jg3uTXKg_f1.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/4Wczmsva9jg3uTXKg_f1.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/4Wczmsva9jg3uTXKg_f1.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/4Wczmsva9jg3uTXKg_f1.png"}},{"id":"f2","label":"Figure 2","caption":"<b>Aspirin treatment on the invasive property of glioma cells.</b> (<b>A</b>) U87 and T98G cells migration were analyzed using the scratch-wound assay. (<b>B</b>) U87 and T98G cells invasive ability were analyzed by the transwell assay after 24 h of treatment with indicated concentrations of aspirin. Bars represent 50 μm. (<b>C</b>) Western blot analysis showed that expression of EMT-related markers was altered by aspirin treatment. β-actin was used as an internal control. Data are shown as mean±SEM for the three replicates. Statistical significance levels are indicated as: *P < 0.05; **P < 0.01 and ***P < 0.001.","file":"4Wczmsva9jg3uTXKg_f2.tif","version":1,"optimized":true,"optimized_file":"4Wczmsva9jg3uTXKg_f2.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/4Wczmsva9jg3uTXKg_f2.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/4Wczmsva9jg3uTXKg_f2.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/4Wczmsva9jg3uTXKg_f2.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/4Wczmsva9jg3uTXKg_f2.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/4Wczmsva9jg3uTXKg_f2.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/4Wczmsva9jg3uTXKg_f2.png"}},{"id":"f3","label":"Figure 3","caption":"<b>Aspirin induced apoptosis through the internal pathway in glioma cells.</b> (<b>A</b>)The U87 and T98G cells were treated with indicated concentrations of aspirin for 24 h, and the promotion of apoptosis was measured by AnnexinV-FITC/PI double staining. A representative experiment of three replicated assays was shown. (<b>B</b>) Western blot analysis showed Bcl-2, Bax, Caspase 3 and cleaved PARP proteins expression in U87 and T98G cells treated with the indicated concentrations of aspirin for 24h. β-actin was used as an internal control.","file":"4Wczmsva9jg3uTXKg_f3.tif","version":1,"optimized":true,"optimized_file":"4Wczmsva9jg3uTXKg_f3.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/4Wczmsva9jg3uTXKg_f3.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/4Wczmsva9jg3uTXKg_f3.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/4Wczmsva9jg3uTXKg_f3.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/4Wczmsva9jg3uTXKg_f3.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/4Wczmsva9jg3uTXKg_f3.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/4Wczmsva9jg3uTXKg_f3.png"}},{"id":"f4","label":"Figure 4","caption":"<b>Aspirin inhibited SHH/GLI1 signaling pathway.</b> (<b>A</b>) QRT-PCR analysis of SHH, SMO, and GLI1 mRNA from U87 and T98G cells following indicated concentrations of aspirin treatment for 24 h. (<b>B</b>) Western blot analysis showed SHH, SMO, GLI1, Bcl-2 and Foxm1 proteins expression in U87 and T98G cells treated with indicated concentrations of aspirin for 24 h. GAPDH was used as an internal control. (<b>C</b>) Western blot analysis showed SHH, SMO, GLI1, Bcl-2 and Foxm1 proteins expression in U87 and T98G cells treated with the indicated concentrations of aspirin (8 mM for U87, 10 mM for T98G) for different time intervals (8, 16 and 24 h). GAPDH was used as an internal control. (<b>D</b>) U87 cells treated with 8mM aspirin for 24 h were subjected to immunofluorescent assay using anti-GLI1 antibody. Data are shown as mean±SEM for the three replicates. Statistical significance levels are indicated as: *P < 0.05; **P < 0.01 and ***P < 0.001.","file":"4Wczmsva9jg3uTXKg_f4.tif","version":1,"optimized":true,"optimized_file":"4Wczmsva9jg3uTXKg_f4.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/4Wczmsva9jg3uTXKg_f4.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/4Wczmsva9jg3uTXKg_f4.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/4Wczmsva9jg3uTXKg_f4.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/4Wczmsva9jg3uTXKg_f4.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/4Wczmsva9jg3uTXKg_f4.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/4Wczmsva9jg3uTXKg_f4.png"}},{"id":"f5","label":"Figure 5","caption":"<b>GLI1 acted as an effector inducing non-canonical TMZ-resistance in glioma cells.</b> (<b>A</b>) Relative expression of GLI1 in U87, U87 OE and U87 KD. (<b>B</b>) Effect of GLI1 on cell proliferation was evaluated by CCK8 assays in U87, U87 OE and U87 KD cells. (<b>C</b>) Western blot analysis showed GLI1, γH2AX, p-ATM and ATM proteins expression in U87 and U87 OE treated with GANT61 (5 μM) for 48 h. β-actin was used as an internal control. (<b>D</b>) U87, U87 OE and U87 KD were examined for their sensitivity to TMZ at concentration of 100 µM. (<b>E</b>) Western blot analysis showed γH2AX, p-ATM and ATM proteins expression in U87, U87 OE and U87 KD treated with TMZ. β-actin was used as an internal control. Data are shown as mean±SEM for the three replicates. Statistical significance levels are indicated as: *P < 0.05; **P < 0.01 and ***P < 0.001.","file":"4Wczmsva9jg3uTXKg_f5.tif","version":1,"optimized":true,"optimized_file":"4Wczmsva9jg3uTXKg_f5.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/4Wczmsva9jg3uTXKg_f5.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/4Wczmsva9jg3uTXKg_f5.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/4Wczmsva9jg3uTXKg_f5.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/4Wczmsva9jg3uTXKg_f5.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/4Wczmsva9jg3uTXKg_f5.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/4Wczmsva9jg3uTXKg_f5.png"}},{"id":"f6","label":"Figure 6","caption":"<b>Aspirin sensitized TMZ therapy.</b> (<b>A</b>) U87 and T98G cells were treated with aspirin (1 mM) alone, TMZ (100 µM) alone or both for 72 h. Cell survival was analyzed using CCK-8 assay. (<b>B</b>) U87 and T98G cells were treated by aspirin (1 mM) alone, TMZ (100 µM) alone or both for 72 h. Western blot analysis showed GLI1, Foxm1, p-p65, p65, γH2AX, p-ATM, ATM, N-GLI1 and Sufu proteins expression. β-actin and Histone H3 were used as an internal control. T98G and U87 cells were treated with aspirin (1 mM) alone, TMZ (100 µM) alone or both for 72 h and then collected for comet assay (<b>C</b>) and immunofluorescence (<b>D</b>) respectively. (E) TMZ-induced upregulation of MGMT in T98G cells after exposed to the TMZ (100 µM) with or without aspirin (1 mM) were assayed at the end of each time-point by Western blot. Data are shown as mean±SEM for the three replicates. Statistical significance levels are indicated as: *P < 0.05; **P < 0.01 and ***P < 0.001.","file":"4Wczmsva9jg3uTXKg_f6.tif","version":1,"optimized":true,"optimized_file":"4Wczmsva9jg3uTXKg_f6.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/4Wczmsva9jg3uTXKg_f6.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/4Wczmsva9jg3uTXKg_f6.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/4Wczmsva9jg3uTXKg_f6.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/4Wczmsva9jg3uTXKg_f6.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/4Wczmsva9jg3uTXKg_f6.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/4Wczmsva9jg3uTXKg_f6.png"}},{"id":"f7","label":"Figure 7","caption":"<b>Verification of aspirin sensitizing TMZ treatment through SHH/GLI1 Signaling <i>in vivo</i>.</b> (<b>A</b>) Representative luminescence imaging and mean Fluc activity values of different treatment groups every week. (<b>B</b>) The subcutaneous U87 xenografts tissue were removed and subjected to Western blot analysis of GLI1, p-p65, p65, γH2AX, p-ATM and ATM. GAPDH was used as an internal control.","file":"4Wczmsva9jg3uTXKg_f7.tif","version":1,"optimized":true,"optimized_file":"4Wczmsva9jg3uTXKg_f7.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/4Wczmsva9jg3uTXKg_f7.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/4Wczmsva9jg3uTXKg_f7.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/4Wczmsva9jg3uTXKg_f7.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/4Wczmsva9jg3uTXKg_f7.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/4Wczmsva9jg3uTXKg_f7.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/4Wczmsva9jg3uTXKg_f7.png"}}],"pdf":{"file":"4Wczmsva9jg3uTXKg.pdf","display":true,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/pdf/4Wczmsva9jg3uTXKg.pdf"},"xml":{"file":"4Wczmsva9jg3uTXKg.xml","display":true,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/xml/4Wczmsva9jg3uTXKg.xml"}},"title":"Aspirin inhibits the SHH/GLI1 signaling pathway and sensitizes malignant glioma cells to temozolomide therapy","page_start":1233,"page_end":1247,"ids":{"pii":"101224","publisher-id":"101224","doi":"10.18632/aging.101224","pmid":"28446712"},"abstract":"<p>Aberrant activation of sonic hedgehog (SHH)/glioma-associated oncogene homolog 1 (GLI1) pathway plays an important role in the tumorigenicity of malignant glioma cells and resistance to temozolomide (TMZ). Here we investigated the aspirin’s antineoplastic molecular route by targeting SHH/GLI1 pathway and examined the feasibility of aspirin combined with TMZ therapy. Western blot and quantitative real-time polymerase chain reaction (qRT-PCR) revealed that the activity of the SHH/GLI1 pathway was strongly inhibited by aspirin. Aspirin acted as the glioma growth-inhibitory and pro-apoptosis roles by inhibiting the SHH/GLI1 pathway and reprogramming the epithelial to mesenchymal transition (EMT). The immunofluorescence assay showed aspirin could prevent the nuclear translocation of GLI1 to inhibit its transcriptional regulation. The stable lentiviral overexpression of GLI1 reversed the DNA double strand breaks (DSBs) caused by the GANT61 and TMZ. Furthermore, aspirin combined with TMZ enhanced chemosensitivity and GLI1-induced chemoprotection was partly blocked by aspirin <i>in vitro</i> and <i>in vivo</i>. Collectively, aspirin has a therapeutic potential for SHH/GLI1 targeted therapy against glioma cells. Acquired activation of GLI1 protects glioma cells against TMZ therapy. Impairment of DNA DSBs repair activity might be involved in the route of aspirin-induced chemosensitivity. Combined aspirin with TMZ may be a promising strategy against malignant glioma.</p>","article_type":{"short_name":"research_paper","nlm_type":"research-article","plural":"Research Papers","name":"Research Paper"},"authors":[{"name_first":"Jianguang","name_middle":"","name_last":"Ming","name_suffix":"","equal_contrib":true,"affiliations_numbers":[0,1],"author_notes_ids":[]},{"name_first":"Bo","name_middle":"","name_last":"Sun","name_suffix":"","equal_contrib":true,"affiliations_numbers":[0,1],"author_notes_ids":[]},{"name_first":"Ziwei","name_middle":"","name_last":"Li","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0,1],"author_notes_ids":[]},{"name_first":"Lin","name_middle":"","name_last":"Lin","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0,1],"author_notes_ids":[]},{"name_first":"Xiangqi","name_middle":"","name_last":"Meng","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0,1],"author_notes_ids":[]},{"name_first":"Bo","name_middle":"","name_last":"Han","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0,1],"author_notes_ids":[]},{"name_first":"Ruijia","name_middle":"","name_last":"Wang","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0,1],"author_notes_ids":[]},{"name_first":"Pengfei","name_middle":"","name_last":"Wu","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0,1],"author_notes_ids":[]},{"name_first":"Jianlong","name_middle":"","name_last":"Li","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0,1],"author_notes_ids":[]},{"name_first":"Jinquan","name_middle":"","name_last":"Cai","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0,1,2],"author_notes_ids":[]},{"name_first":"Chuanlu","name_middle":"","name_last":"Jiang","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0,1,2],"author_notes_ids":[]}]},{"files":{"figures":[{"id":"f1","label":"Figure 1","caption":"<b>Radiation inhibits proliferation, induces cell death and hypertrophy in brain endothelial cells.</b> Mouse bEnd.3 cells were delivered a dose of 20 Gy ionizing radiation by linear accelerator. (<b>A</b>) Floating and adherent cells were collected at day 6 and cell viability/death measured by trypan blue staining and counting in a Neubauer chamber. Data show trypan blue positive cells as a percentage of total cells. Mean of 3 independent experiments ± SEM. (<b>B</b>) Representative images of non-irradiated (control) and irradiated bEnd.3 cells stained after permeabilization for caveolin-1 or α-tubulin showing cell hypertrophy and cytoskeletal rearrangement at day 6 (red, 200× magnification), or proliferation marker Ki67 (lower panels, red, 100× magnification). Nuclei were counterstained with DAPI (green). Co-localization (yellow). (<b>C</b>) The proportion of Ki67 positive cells was determined using Image J. Data represent mean ± SEM calculated in 5 fields of view (100×) from 2 independent experiments. Student’s <i>t</i>-test, ****P<0.0001.","file":"hPkYjuZfeC9ohGmQ6_f1.tif","version":1,"optimized":true,"optimized_file":"hPkYjuZfeC9ohGmQ6_f1.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/hPkYjuZfeC9ohGmQ6_f1.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/hPkYjuZfeC9ohGmQ6_f1.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/hPkYjuZfeC9ohGmQ6_f1.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/hPkYjuZfeC9ohGmQ6_f1.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/hPkYjuZfeC9ohGmQ6_f1.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/hPkYjuZfeC9ohGmQ6_f1.png"}},{"id":"f2","label":"Figure 2","caption":"<b>Radiation induces senescence-associated markers.</b> (<b>A</b>) Representative bright field images of non-irradiated (control) and irradiated bEnd.3 cells stained for lysosomal SA-β-gal activity (perinuclear blue staining) at day 6 post-IR or sham (100× magnification). (<b>B</b>) The proportion of SA-β-gal-positive cells was quantitated at day 3 and day 6 in 3–4 independent experiments. (<b>C</b>) Representative immunofluorescent images of nuclear accumulation of CDK inhibitors, p21 and p16 (red), in irradiated cells after 6 days (red, 100× magnification). (<b>D</b>) Representative immunofluorescent images of ICAM-1 and PAI-1 staining in control and irradiated cells after 6 days (red, 200× magnification). Cells were counterstained with cell surface marker wheat germ agglutinin conjugated to AF488 (blue). Cell nuclei were stained with DAPI in all merged images (green). (<b>E</b>) ICAM-1 and PAI-1 expression were determined in control and irradiated cells by western blotting and quantitated after normalization to GAPDH using Image J (Figure F; n=4 independent experiments). All data are shown as mean ± SEM. Student’s <i>t</i>-test *P<0.05, *** P<0.01, ***P<0.001, ****p<0.0001. C, control; IR, irradiated.","file":"hPkYjuZfeC9ohGmQ6_f2.tif","version":1,"optimized":true,"optimized_file":"hPkYjuZfeC9ohGmQ6_f2.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/hPkYjuZfeC9ohGmQ6_f2.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/hPkYjuZfeC9ohGmQ6_f2.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/hPkYjuZfeC9ohGmQ6_f2.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/hPkYjuZfeC9ohGmQ6_f2.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/hPkYjuZfeC9ohGmQ6_f2.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/hPkYjuZfeC9ohGmQ6_f2.png"}},{"id":"f3","label":"Figure 3","caption":"<b>Radiation stimulates accumulation of autophagy-associated markers in brain endothelial cells.</b> bEnd.3 cells were delivered a dose of 20 Gy ionizing radiation and monitored for 3–6 days. (<b>A</b>) Representative immunofluorescent images showing increased perinuclear p62 or L3CB-positive puncta accumulating in permeabilized cells at day 3 and day 6 post-IR or sham (red, 100× magnification). Cells were counterstained with DAPI (green). The percentage of cells positive for p62 (<b>B</b>) or L3CBI/II puncta (<b>C</b>) were quantitated using Image J (n=3 independent experiments; positive cells were counted in n=8 fields of view). (<b>D</b>) Representative western blots of p62, L3CBI and II autophagosomal markers in whole cell lysates of control and irradiated cells after 6 days. (<b>E</b>) and (<b>F</b>) Bands were quantitated after normalization to GAPDH using Image J (n=4 independent experiments). All data are shown as mean ± SEM. Student’s <i>t</i>-test, *P<0.05, *** P<0.01, ***P<0.001, ****p<0.0001. C, control; IR, irradiated.","file":"hPkYjuZfeC9ohGmQ6_f3.tif","version":1,"optimized":true,"optimized_file":"hPkYjuZfeC9ohGmQ6_f3.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/hPkYjuZfeC9ohGmQ6_f3.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/hPkYjuZfeC9ohGmQ6_f3.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/hPkYjuZfeC9ohGmQ6_f3.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/hPkYjuZfeC9ohGmQ6_f3.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/hPkYjuZfeC9ohGmQ6_f3.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/hPkYjuZfeC9ohGmQ6_f3.png"}},{"id":"f4","label":"Figure 4","caption":"<b>Radiation modulates expression of the alpha-secretase, ADAM10.</b> (<b>A</b>) Representative immunofluorescent images of ADAM10 expression 6 days after radiation (20 Gy) or sham treatment; ADAM10 (red), DAPI-stained nuclei (green); 100× magnification, n=2 independent experiments. Dotted lines in merged images indicate the boundary of several large senescent cells with reduced ADAM10 immunostaining. (<b>B</b>) Representative western blots of whole cell lysates (15 μg) probed for pro-ADAM10 and mature ADAM10. (<b>C</b>) Protein bands (ADAM10) were quantitated after normalization to GAPDH using Image J. Data represent mean ± SEM of 4 independent experiments. Student’s <i>t</i>-test **P<0.01. (<b>D</b>–<b>F</b>) Representative images of fractionated extracts (10 μg each lane) from biotin-labelled cells before and after streptavidin enrichment: (<b>D</b>) Coomassie-stained SDS-PAGE gel; (<b>E</b>) streptavidin-HRP-probed membrane; (<b>F</b>) anti-ADAM10-probed membrane. IN, total cell extract prior to streptavidin enrichment; BB, biotin-bound fraction; OUT, non-biotinylated fraction eluted post-streptavidin binding; C, control; IR, irradiated.","file":"hPkYjuZfeC9ohGmQ6_f4.tif","version":1,"optimized":true,"optimized_file":"hPkYjuZfeC9ohGmQ6_f4.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/hPkYjuZfeC9ohGmQ6_f4.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/hPkYjuZfeC9ohGmQ6_f4.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/hPkYjuZfeC9ohGmQ6_f4.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/hPkYjuZfeC9ohGmQ6_f4.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/hPkYjuZfeC9ohGmQ6_f4.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/hPkYjuZfeC9ohGmQ6_f4.png"}},{"id":"f5","label":"Figure 5","caption":"<b>Immunofluorescent localization of ADAM10 target proteins.</b> (<b>A</b>) Representative immunofluorescent images of non-permeabilized cells stained for L1CAM, NEST, NEO1, DDX58 and TLR2 after 6 days post-IR or sham (controls). Cells were co-stained with DAPI (nuclei, green) and wheat germ agglutinin–AF488 (surface marker, blue). All images are shown at 200× magnification. (<b>B</b>) Percentage of cells staining positively for each target protein 6 days after IR or sham. Data represent at least 3 independent experiments, positive cells were counted in n=3 fields of view. All data shown as mean ± SEM. Student’s <i>t</i>-test **P<0.01, ***P<0.001. C, control; IR, irradiated.","file":"hPkYjuZfeC9ohGmQ6_f5.tif","version":1,"optimized":true,"optimized_file":"hPkYjuZfeC9ohGmQ6_f5.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/hPkYjuZfeC9ohGmQ6_f5.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/hPkYjuZfeC9ohGmQ6_f5.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/hPkYjuZfeC9ohGmQ6_f5.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/hPkYjuZfeC9ohGmQ6_f5.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/hPkYjuZfeC9ohGmQ6_f5.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/hPkYjuZfeC9ohGmQ6_f5.png"}}],"supplemental":[{"id":"SD1","label":"Supplementary File","file":"hPkYjuZfeC9ohGmQ6_sd1.pdf","version":1,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/supplemental_materials/hPkYjuZfeC9ohGmQ6_sd1.pdf"}],"pdf":{"file":"hPkYjuZfeC9ohGmQ6.pdf","display":true,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/pdf/hPkYjuZfeC9ohGmQ6.pdf"},"xml":{"file":"hPkYjuZfeC9ohGmQ6.xml","display":true,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/xml/hPkYjuZfeC9ohGmQ6.xml"}},"title":"Ionizing radiation reduces ADAM10 expression in brain microvascular endothelial cells undergoing stress-induced senescence","page_start":1248,"page_end":1268,"ids":{"pii":"101225","publisher-id":"101225","doi":"10.18632/aging.101225","pmid":"28437250"},"abstract":"<p>Cellular senescence is associated with aging and is considered a potential contributor to age-associated neurodegenerative disease. Exposure to ionizing radiation increases the risk of developing premature neurovascular degeneration and dementia but also induces premature senescence. As cells of the cerebrovascular endothelium are particularly susceptible to radiation and play an important role in brain homeostasis, we investigated radiation-induced senescence in brain microvascular endothelial cells (EC). Using biotinylation to label surface proteins, streptavidin enrichment and proteomic analysis, we analyzed the surface proteome of stress-induced senescent EC in culture. An array of both recognized and novel senescence-associated proteins were identified. Most notably, we identified and validated the novel radiation-stimulated down-regulation of the protease, a disintegrin and metalloprotease 10 (ADAM10). ADAM10 is an important modulator of amyloid beta protein production, accumulation of which is central to the pathologies of Alzheimer’s disease and cerebral amyloid angiopathy. Concurrently, we identified and validated increased surface expression of ADAM10 proteolytic targets with roles in neural proliferation and survival, inflammation and immune activation (L1CAM, NEO1, NEST, TLR2, DDX58). ADAM10 may be a key molecule linking radiation, senescence and endothelial dysfunction with increased risk of premature neurodegenerative diseases normally associated with aging.</p>","article_type":{"short_name":"research_paper","nlm_type":"research-article","plural":"Research Papers","name":"Research Paper"},"authors":[{"name_first":"Lucinda S.","name_middle":"","name_last":"McRobb","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Matthew J.","name_middle":"","name_last":"McKay","name_suffix":"","equal_contrib":false,"affiliations_numbers":[1],"author_notes_ids":[]},{"name_first":"Jennifer R.","name_middle":"","name_last":"Gamble","name_suffix":"","equal_contrib":false,"affiliations_numbers":[2],"author_notes_ids":[]},{"name_first":"Michael","name_middle":"","name_last":"Grace","name_suffix":"","equal_contrib":false,"affiliations_numbers":[3],"author_notes_ids":[]},{"name_first":"Vaughan","name_middle":"","name_last":"Moutrie","name_suffix":"","equal_contrib":false,"affiliations_numbers":[3],"author_notes_ids":[]},{"name_first":"Estevam D.","name_middle":"","name_last":"Santos","name_suffix":"","equal_contrib":false,"affiliations_numbers":[3],"author_notes_ids":[]},{"name_first":"Vivienne S.","name_middle":"","name_last":"Lee","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Zhenjun","name_middle":"","name_last":"Zhao","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Mark P.","name_middle":"","name_last":"Molloy","name_suffix":"","equal_contrib":false,"affiliations_numbers":[1],"author_notes_ids":[]},{"name_first":"Marcus A.","name_middle":"","name_last":"Stoodley","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]}]},{"files":{"figures":[{"id":"f1","label":"Figure 1","caption":"<b>Effect of calretinin on Leydig cell proliferation.</b> (<b>A</b>) Calretinin expression in MLTC-1 cells transfected with LV-calb2. The vector was used as the negative control. (<b>B</b>) Calretinin expression in R2C cells transfected with LV-siRNA-calb2 or vector (as control). (<b>C</b>-<b>H</b>) After MLTC-1 and R2C cells were transfected with LV-calb2, LV-siRNA-calb2 and vector (as negative control), cell viability was detected using CCK8 kits, cell proliferation was tested with BrdU proliferation assay kits and cell cycle position was analyzed by flow cytometry. (<b>C</b>) The viability of MLTC-1 cells with up-regulated calretinin was significantly higher when compared with the control group. (<b>D</b>) The viability of R2C cells with down-regulated calretinin was significantly lower. (<b>E</b>) The OD of MLTC-1 cells with up-regulated calretinin was significantly higher compared with the control group. (<b>F</b>) The OD of R2C cells with down-regulated calretinin was significantly decreased. (<b>G</b>) When calretinin was up-regulated in MLTC-1 cells, the number of cells in the G2 phase significantly decreased while the number of S phase cells significantly increased. (<b>H</b>) When calretinin was down-regulated in the R2C cells, the number of cells in the G2 phase significantly increased while the number of S phase cells significantly decreased. * <i>p</i><0.05; **: <i>p</i><0.01.","file":"XcEMNzWy7Xg8oZCcW_f1.tif","version":1,"optimized":true,"optimized_file":"XcEMNzWy7Xg8oZCcW_f1.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/XcEMNzWy7Xg8oZCcW_f1.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/XcEMNzWy7Xg8oZCcW_f1.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/XcEMNzWy7Xg8oZCcW_f1.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/XcEMNzWy7Xg8oZCcW_f1.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/XcEMNzWy7Xg8oZCcW_f1.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/XcEMNzWy7Xg8oZCcW_f1.png"}},{"id":"f2","label":"Figure 2","caption":"<b>Regulation of calretinin on Leydig cell proliferation partially via the ERK1/2 and AKT pathways.</b> (<b>A</b>) AKT, p-AKT, ERK1/2 and p-ERK1/2 expression in MLTC-1 cells with over-expressed calretinin. (<b>B</b>) AKT, p-AKT, ERK1/2 and p-ERK1/2 expression in R2C cells with down-regulated calretinin. (<b>C</b>) The ratio of p-ERK1/2 /total ERK1/2 was significantly higher when calretinin was up-regulated in MLTC-1 cells. (<b>D</b>) The ratio of p-ERK1/2/total ERK1/2 was significantly lower when calretinin was down-regulated in R2C cells. (<b>E</b>) In MLTC-1 cells with up-regulated calretinin, the ratio of p-AKT/total AKT was significantly higher. (<b>F</b>) In R2C cells with down-regulated calretinin, the ratio of p-AKT/total AKT was significantly lower. The vector was used as the negative control(s). * <i>p</i><0.05; **: <i>p</i><0.01.","file":"XcEMNzWy7Xg8oZCcW_f2.tif","version":1,"optimized":true,"optimized_file":"XcEMNzWy7Xg8oZCcW_f2.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/XcEMNzWy7Xg8oZCcW_f2.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/XcEMNzWy7Xg8oZCcW_f2.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/XcEMNzWy7Xg8oZCcW_f2.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/XcEMNzWy7Xg8oZCcW_f2.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/XcEMNzWy7Xg8oZCcW_f2.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/XcEMNzWy7Xg8oZCcW_f2.png"}},{"id":"f3","label":"Figure 3","caption":"<b>Effect of calretinin on the apoptosis of Leydig cells.</b> (<b>A</b>) The calretinin expression in the MLTC-1 cells transfected with LV-calb2 was significantly higher (<b>B</b>) The calretinin expression in R2C cells transfected with LV-siRNA-calb2 was significantly lower. (<b>C</b>) The number of apoptotic cells were significantly decreased in MLTC-1 cells with up-regulated calretinin. (<b>D</b>) The apoptotic cells were significantly increased in R2C cells with down-regulated calretinin. (<b>E</b>) In MLTC-1 cells transfected with LV-calb2, the apoptotic index was significantly decreased when compared with the control group. (<b>F</b>) In R2C cells transfected with LV-siRNA-calb2, the apoptotic index was significantly higher when compared with the control group. The vector was used as the negative control(s). *: <i>p</i><0.05; ***: <i>p</i><0.001.","file":"XcEMNzWy7Xg8oZCcW_f3.tif","version":1,"optimized":true,"optimized_file":"XcEMNzWy7Xg8oZCcW_f3.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/XcEMNzWy7Xg8oZCcW_f3.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/XcEMNzWy7Xg8oZCcW_f3.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/XcEMNzWy7Xg8oZCcW_f3.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/XcEMNzWy7Xg8oZCcW_f3.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/XcEMNzWy7Xg8oZCcW_f3.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/XcEMNzWy7Xg8oZCcW_f3.png"}},{"id":"f4","label":"Figure 4","caption":"<b>Calretinin inhibits the apoptosis of Leydig cells partially via mitochondrial-related apoptotic pathways.</b> After MLTC-1 cells and R2C cells were transfected with LV-calb2, LV-siRNA-calb2 or vector alone, the expression of factors in the mitochondrial-related apoptotic pathways was analyzed by Western blotting. (<b>A</b>) In MLTC-1 cells with up-regulated calretinin expression, thecaspase-3/9, cleaved caspase-3/9, PARP, and cleaved-PARP expression levels were decreased. (<b>B</b>) In R2C cells with down-regulated calretinin expression, the caspase-3/9, cleaved caspase-3/9, PARP, and cleaved-PARP expression levels were increased. (<b>C</b>) Cyto C expression was significantly lower in MLTC-1 cells with up-regulated calretinin. (<b>D</b>) The Bcl2/Bax ratio was significantly increased in MLTC-1 cells with up-regulated calretinin expression. (<b>E</b>) In R2C cells with the down-regulated calretinin, cyto C expression was significantly increased. (<b>F</b>) In R2C cells with down-regulated calretinin, the Bcl2/Bax ratio was significantly lower. The vector was used as the negative control(s). *: <i>p</i><0.05.","file":"XcEMNzWy7Xg8oZCcW_f4.tif","version":1,"optimized":true,"optimized_file":"XcEMNzWy7Xg8oZCcW_f4.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/XcEMNzWy7Xg8oZCcW_f4.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/XcEMNzWy7Xg8oZCcW_f4.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/XcEMNzWy7Xg8oZCcW_f4.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/XcEMNzWy7Xg8oZCcW_f4.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/XcEMNzWy7Xg8oZCcW_f4.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/XcEMNzWy7Xg8oZCcW_f4.png"}},{"id":"f5","label":"Figure 5","caption":"<b>Calretinin plays multiple protective roles in Leydig cells.</b> Calretinin increases the cell viability and proliferation of Leydig cells possibly via the activation of the ERK1/2 and AKT pathways, and suppresses cell apoptosis possibly via the inhibition of the mitochondrial-related apoptotic pathway.","file":"XcEMNzWy7Xg8oZCcW_f5.tif","version":1,"optimized":true,"optimized_file":"XcEMNzWy7Xg8oZCcW_f5.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/XcEMNzWy7Xg8oZCcW_f5.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/XcEMNzWy7Xg8oZCcW_f5.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/XcEMNzWy7Xg8oZCcW_f5.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/XcEMNzWy7Xg8oZCcW_f5.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/XcEMNzWy7Xg8oZCcW_f5.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/XcEMNzWy7Xg8oZCcW_f5.png"}}],"pdf":{"file":"XcEMNzWy7Xg8oZCcW.pdf","display":true,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/pdf/XcEMNzWy7Xg8oZCcW.pdf"},"xml":{"file":"XcEMNzWy7Xg8oZCcW.xml","display":true,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/xml/XcEMNzWy7Xg8oZCcW.xml"}},"title":"Protective effect of calretinin on testicular Leydig cells via the inhibition of apoptosis","page_start":1269,"page_end":1279,"ids":{"pii":"101226","publisher-id":"101226","doi":"10.18632/aging.101226","pmid":"28437248"},"abstract":"<p>The core mechanism of Late-onset hypogonadism (LOH) is the deficiency of androgen due to the functional and quantitative decline of testicular Leydig cells. Here we explored the protective effect of calretinin, a Ca<sup>2+</sup>-binding protein, on Leydig cells. We found in MLTC-1 cells transfected with LV-calb2, the cell viability and optical density (OD) were higher (<i>p</i>&lt;0.05), cells in the S phase of the cell cycle were increased (<i>p</i>&lt;0.01) and p-ERK1/2 and p-AKT levels were significantly higher (<i>p</i>&lt;0.01 and <i>p</i>&lt;0.05), while in R2C cells transfected with LV-siRNA-calb2, all of the results mentioned above were adverse (<i>p</i>&lt;0.05). The cell apoptotic index after calretinin over-expressed was significantly lower (<i>p</i>&lt;0.001), while the expression levels of mitochondria-related apoptotic factors such as cleaved caspase-9 and cytochrome C (cyto C) were lower and ratio of Bcl2/Bax was higher (<i>p&lt;</i>0.05). After calretinin down-regulated, the apoptotic index was higher (<i>p&lt;</i>0.05), while the expression levels of mitochondria-related apoptotic factors were higher and the ratio of Bcl2/Bax was lower (<i>p&lt;</i>0.05). Therefore, calretinin increases Leydig cell viability and proliferation, possibly via ERK1/2 and AKT pathways, and suppresses apoptosis possibly via the mitochondria-related apoptotic pathway, which could be beneficial in understanding the pathophysiology of LOH and could lead to the study of new treatments.</p>","article_type":{"short_name":"research_paper","nlm_type":"research-article","plural":"Research Papers","name":"Research Paper"},"authors":[{"name_first":"Wendan","name_middle":"","name_last":"Xu","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Qian","name_middle":"","name_last":"Zhu","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Bei","name_middle":"","name_last":"Zhang","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Shan","name_middle":"","name_last":"Liu","name_suffix":"","equal_contrib":false,"affiliations_numbers":[1],"author_notes_ids":[]},{"name_first":"Xiaonan","name_middle":"","name_last":"Dai","name_suffix":"","equal_contrib":false,"affiliations_numbers":[2],"author_notes_ids":[]},{"name_first":"Chao","name_middle":"","name_last":"Gao","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Li","name_middle":"","name_last":"Gao","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Yugui","name_middle":"","name_last":"Cui","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]}]},{"files":{"figures":[{"id":"f1","label":"Figure 1","caption":"Correlation of the top predictors with age in female cohort.","file":"hr2GRi5J3cjFBcFCC_f1.tif","version":1,"optimized":true,"optimized_file":"hr2GRi5J3cjFBcFCC_f1.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/hr2GRi5J3cjFBcFCC_f1.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/hr2GRi5J3cjFBcFCC_f1.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/hr2GRi5J3cjFBcFCC_f1.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/hr2GRi5J3cjFBcFCC_f1.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/hr2GRi5J3cjFBcFCC_f1.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/hr2GRi5J3cjFBcFCC_f1.png"}},{"id":"f2","label":"Figure 2","caption":"Difference between predicted age and chronological age in heath-stratified cohorts of women.","file":"hr2GRi5J3cjFBcFCC_f2.tif","version":1,"optimized":true,"optimized_file":"hr2GRi5J3cjFBcFCC_f2.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/hr2GRi5J3cjFBcFCC_f2.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/hr2GRi5J3cjFBcFCC_f2.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/hr2GRi5J3cjFBcFCC_f2.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/hr2GRi5J3cjFBcFCC_f2.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/hr2GRi5J3cjFBcFCC_f2.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/hr2GRi5J3cjFBcFCC_f2.png"}},{"id":"f3","label":"Figure 3","caption":"Correlation of predictors with male age.","file":"hr2GRi5J3cjFBcFCC_f3.tif","version":1,"optimized":true,"optimized_file":"hr2GRi5J3cjFBcFCC_f3.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/hr2GRi5J3cjFBcFCC_f3.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/hr2GRi5J3cjFBcFCC_f3.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/hr2GRi5J3cjFBcFCC_f3.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/hr2GRi5J3cjFBcFCC_f3.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/hr2GRi5J3cjFBcFCC_f3.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/hr2GRi5J3cjFBcFCC_f3.png"}},{"id":"f4","label":"Figure 4","caption":"Difference between predicted age and chronological age in health-stratified cohorts of men.","file":"hr2GRi5J3cjFBcFCC_f4.tif","version":1,"optimized":true,"optimized_file":"hr2GRi5J3cjFBcFCC_f4.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/hr2GRi5J3cjFBcFCC_f4.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/hr2GRi5J3cjFBcFCC_f4.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/hr2GRi5J3cjFBcFCC_f4.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/hr2GRi5J3cjFBcFCC_f4.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/hr2GRi5J3cjFBcFCC_f4.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/hr2GRi5J3cjFBcFCC_f4.png"}}],"pdf":{"file":"hr2GRi5J3cjFBcFCC.pdf","display":true,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/pdf/hr2GRi5J3cjFBcFCC.pdf"},"xml":{"file":"hr2GRi5J3cjFBcFCC.xml","display":true,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/xml/hr2GRi5J3cjFBcFCC.xml"}},"title":"Markers of arterial health could serve as accurate non-invasive predictors of human biological and chronological age","page_start":1280,"page_end":1292,"ids":{"pii":"101227","publisher-id":"101227","doi":"10.18632/aging.101227","pmid":"28455973"},"abstract":"<p>The decline in functional capacity is unavoidable consequence of the process of aging. While many anti-aging interventions have been proposed, clinical investigations into anti-aging medicine are limited by lack of reliable techniques for evaluating the rate of ageing. Here we present simple, accurate and cost-efficient techniques for estimation of human biological age, Male and Female Arterial Indices. We started with developing a model which accurately predicts chronological age. Using machine learning, we arrived on a set of four predictors, all of which reflect the functioning of the cardiovascular system. In Arterial Indices models, results of carotid artery duplex scan that show the thickness of the intima media complex and quantitatively describe the degree of stenosis are combined with pulse wave velocity and augmentation index measurements performed by applanation tonometry. In our cohort, the age of men was determined with MAE = 6.91 years (adjusted R-squared = 0.55), and the age of women with MAE = 5.87 years (adjusted R<sup>2</sup> = 0.69). The Epsilon-accuracies of age-predicting models were at 86.5% and 80% for women and men, respectively. Substantially higher differences between the predicted age and the calendar age were noted for patients with Type 2 Diabetes Mellitus (T2D) as compared to non-T2D controls, indicating that the model could serve as a good approximation for an elusive biological age. Notably, in females with chronological and biological ages mismatching by 5 or more years, significant increases in in Framingham CVD scores and lower levels of IGF-1 were observed. </p><p>Proposed Male and Female Arterial Indices derive biological age from the results of functional tests which do not require specialized laboratory equipment and, therefore, could be performed in hospitals and community health clinics.</p>","article_type":{"short_name":"research_paper","nlm_type":"research-article","plural":"Research Papers","name":"Research Paper"},"authors":[{"name_first":"Alexander","name_middle":"","name_last":"Fedintsev","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Daria","name_middle":"","name_last":"Kashtanova","name_suffix":"","equal_contrib":false,"affiliations_numbers":[1],"author_notes_ids":[]},{"name_first":"Olga","name_middle":"","name_last":"Tkacheva","name_suffix":"","equal_contrib":false,"affiliations_numbers":[1],"author_notes_ids":[]},{"name_first":"Irina","name_middle":"","name_last":"Strazhesko","name_suffix":"","equal_contrib":false,"affiliations_numbers":[2],"author_notes_ids":[]},{"name_first":"Anna","name_middle":"","name_last":"Kudryavtseva","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Ancha","name_middle":"","name_last":"Baranova","name_suffix":"","equal_contrib":false,"affiliations_numbers":[3,4,5,6],"author_notes_ids":[]},{"name_first":"Alexey","name_middle":"","name_last":"Moskalev","name_suffix":"","equal_contrib":false,"ids":{},"affiliations_numbers":[0,3,4,6,7],"author_notes_ids":[]}]},{"files":{"figures":[{"id":"f1","label":"Figure 1","caption":"<b>Binding of recombinant Elk-1 protein to dsDNAs containing the rs3764030 variant A allele from the human GRIN2B gene promoter.</b> Double-stranded DNA targets (Methods) were incubated with1 μg recombinant human Elk-1 protein on in EMSA buffer. DNA-protein complexes were electrophoresed through 6% polyacrylamide gels in HEPES buffer pH 6.3, without polydIdC. The gel was then stained with the SYBR Green to visualize DNA (<b>A</b>) and SYPRO Ruby for protein bound to DNA (<b>B</b>). The stained gel was scanned in G:BOX (Syngene, US) for imaging. Elk-1 bound to DNA is indicated by the arrow.","file":"rzxf7iqt5oB8a5tC8_f1.tif","version":1,"optimized":true,"optimized_file":"rzxf7iqt5oB8a5tC8_f1.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/rzxf7iqt5oB8a5tC8_f1.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/rzxf7iqt5oB8a5tC8_f1.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/rzxf7iqt5oB8a5tC8_f1.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/rzxf7iqt5oB8a5tC8_f1.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/rzxf7iqt5oB8a5tC8_f1.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/rzxf7iqt5oB8a5tC8_f1.png"}},{"id":"f2","label":"Figure 2","caption":"<b>Concentration dependent response of human <i>GRIN2B</i> promoter in N2a cells carrying either the A or G alleles of rs3764030 to NMDA.</b> Luciferase reporter gene plasmids were constructed in pGL 4.10 (to produce Firefly luciferase, Promega, US). Luciferase reporter plasmids and the pGL4.75 plasmid (to produce Renilla luciferase as a reference) were co-transfected into retinoic acid differentiated N2a cells and assayed for (Methods). After 24 hours of transfection, the cells were incubated for six hours with 0, 30, 50, 70 or 90 μM NMDA for transcription factors binding and then replaced with complete media (with 10% FBS) and cultured for an additional 40-44 hrs. Data are presented as means ± SE.","file":"rzxf7iqt5oB8a5tC8_f2.tif","version":1,"optimized":true,"optimized_file":"rzxf7iqt5oB8a5tC8_f2.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/rzxf7iqt5oB8a5tC8_f2.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/rzxf7iqt5oB8a5tC8_f2.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/rzxf7iqt5oB8a5tC8_f2.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/rzxf7iqt5oB8a5tC8_f2.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/rzxf7iqt5oB8a5tC8_f2.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/rzxf7iqt5oB8a5tC8_f2.png"}},{"id":"f3","label":"Figure 3","caption":"<b>Reaction time in Experiment 1 participants with increasing age based on stratification by GG genotype and A allele carriers (AA and AG genotypes) group differences.</b> A significant difference in the slopes of the regression lines was observed for A allele carriers (-3.99 ± SE 3.47) versus the GG genotype group (5.84 ± SE 2.28) (<i>p</i> = 0.026). R<sup>2</sup> for GG regression was 0.336 while R<sup>2</sup> for A allele carriers was 0.107.","file":"rzxf7iqt5oB8a5tC8_f3.tif","version":1,"optimized":true,"optimized_file":"rzxf7iqt5oB8a5tC8_f3.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/rzxf7iqt5oB8a5tC8_f3.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/rzxf7iqt5oB8a5tC8_f3.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/rzxf7iqt5oB8a5tC8_f3.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/rzxf7iqt5oB8a5tC8_f3.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/rzxf7iqt5oB8a5tC8_f3.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/rzxf7iqt5oB8a5tC8_f3.png"}},{"id":"f4","label":"Figure 4","caption":"Reaction time in Experiment 2 participants with increasing age was examined in GG homozygotes.","file":"rzxf7iqt5oB8a5tC8_f4.tif","version":1,"optimized":true,"optimized_file":"rzxf7iqt5oB8a5tC8_f4.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/rzxf7iqt5oB8a5tC8_f4.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/rzxf7iqt5oB8a5tC8_f4.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/rzxf7iqt5oB8a5tC8_f4.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/rzxf7iqt5oB8a5tC8_f4.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/rzxf7iqt5oB8a5tC8_f4.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/rzxf7iqt5oB8a5tC8_f4.png"}},{"id":"f5","label":"Figure 5","caption":"<b>Reaction time in Experiment 2 participants with increasing age based on A allele carrier status (AA and AG genotypes).</b> A significant difference in the slopes of the regression lines was observed for A allele carriers (-3.58 ± SE 0.21) versus the GG genotype (13.1 ± SE 0.20) (<i>p</i> < 0.001).","file":"rzxf7iqt5oB8a5tC8_f5.tif","version":1,"optimized":true,"optimized_file":"rzxf7iqt5oB8a5tC8_f5.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/rzxf7iqt5oB8a5tC8_f5.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/rzxf7iqt5oB8a5tC8_f5.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/rzxf7iqt5oB8a5tC8_f5.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/rzxf7iqt5oB8a5tC8_f5.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/rzxf7iqt5oB8a5tC8_f5.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/rzxf7iqt5oB8a5tC8_f5.png"}},{"id":"f6","label":"Figure 6","caption":"<b>The modified Delayed Match to Sample (DMS) task.</b> Schematic shows a typical memory trial at the test phase of the task. Repeated retrieval of a target memory item (Match) occurs. Participants were first presented with a sample target object and then viewed test objects (target or distracters) in rapid succession for each memory trial. Subjects were instructed to forget the previous sample target object only when a new sample target object appeared. For Experiment 1, a study phase was included. During the study phase, participants memorized 80 line drawing pictures until they reach 95% accuracy in immediate recognition. Thus, half of the images were studied during the test phase. The sample target object was followed by 10 successive old and new distracter objects at a rate of 2 sec per picture. The DMS task consisted of 80 trials separated into eight blocks of 10 trials each. It took about 50 minutes to complete the task for each participant. The protocol for Experiment 2 used a shorter and simpler version of the task [<a href=\"#r47\"  class=\"anchor\">47</a>], which did not include a study phase, and total time is about 20 minutes for each participant.","file":"rzxf7iqt5oB8a5tC8_f6.tif","version":1,"optimized":true,"optimized_file":"rzxf7iqt5oB8a5tC8_f6.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/rzxf7iqt5oB8a5tC8_f6.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/rzxf7iqt5oB8a5tC8_f6.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/rzxf7iqt5oB8a5tC8_f6.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/rzxf7iqt5oB8a5tC8_f6.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/rzxf7iqt5oB8a5tC8_f6.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/rzxf7iqt5oB8a5tC8_f6.png"}}],"supplemental":[{"id":"SD1","label":"Supplementary File","file":"rzxf7iqt5oB8a5tC8_sd1.pdf","version":1,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/supplemental_materials/rzxf7iqt5oB8a5tC8_sd1.pdf"}],"pdf":{"file":"rzxf7iqt5oB8a5tC8.pdf","display":true,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/pdf/rzxf7iqt5oB8a5tC8.pdf"},"xml":{"file":"rzxf7iqt5oB8a5tC8.xml","display":true,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/xml/rzxf7iqt5oB8a5tC8.xml"}},"title":"Functional human <i>GRIN2B</i> promoter polymorphism and variation of mental processing speed in older adults","page_start":1293,"page_end":1306,"ids":{"pii":"101228","publisher-id":"101228","doi":"10.18632/aging.101228","pmid":"28439047"},"abstract":"<p>We investigated the role of a single nucleotide polymorphism rs3764030 (G&gt;A) within the human <i>GRIN2B</i> promoter in mental processing speed in healthy, cognitively intact, older adults. <i>In vitro</i> DNA-binding and reporter gene assays of different allele combinations in transfected cells showed that the A allele was a gain-of-function variant associated with increasing <i>GRIN2B</i> mRNA levels. We tested the hypothesis that individuals with A allele will have better memory performance (i.e. faster reaction times) in older age. Twenty-eight older adults (ages 65-86) from a well-characterized longitudinal cohort were recruited and performed a modified delayed match-to-sample task. The rs3764030 polymorphism was genotyped and participants were grouped based on the presence of the A allele into GG and AA/AG. Carriers of the A allele maintained their speed of memory retrieval over age compared to GG carriers (<i>p</i> = 0.026 slope of the regression line between AA and AG versus GG groups). To validate the results, 12 older adults from the same cohort participated in a different version of the short-term memory task. Reaction times were significantly slower with age in older adults with G allele (<i>p</i> &lt; 0.001). These findings support a role for rs3764030 in maintaining faster mental processing speed over aging.</p>","article_type":{"short_name":"research_paper","nlm_type":"research-article","plural":"Research Papers","name":"Research Paper"},"authors":[{"name_first":"Yang","name_middle":"","name_last":"Jiang","name_suffix":"","equal_contrib":true,"affiliations_numbers":[0,2],"author_notes_ids":[]},{"name_first":"Ming Kuan","name_middle":"","name_last":"Lin","name_suffix":"","equal_contrib":true,"affiliations_numbers":[1],"author_notes_ids":[]},{"name_first":"Gregory A.","name_middle":"","name_last":"Jicha","name_suffix":"","equal_contrib":false,"affiliations_numbers":[2,3],"author_notes_ids":[]},{"name_first":"Xiuhua","name_middle":"","name_last":"Ding","name_suffix":"","equal_contrib":false,"affiliations_numbers":[2,4],"author_notes_ids":[]},{"name_first":"Sabrina L.","name_middle":"","name_last":"McIlwrath","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"David W.","name_middle":"","name_last":"Fardo","name_suffix":"","equal_contrib":false,"affiliations_numbers":[2,4],"author_notes_ids":[]},{"name_first":"Lucas S.","name_middle":"","name_last":"Broster","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Frederick A.","name_middle":"","name_last":"Schmitt","name_suffix":"","equal_contrib":false,"affiliations_numbers":[2,3],"author_notes_ids":[]},{"name_first":"Richard","name_middle":"","name_last":"Kryscio","name_suffix":"","equal_contrib":false,"affiliations_numbers":[2,4],"author_notes_ids":[]},{"name_first":"Robert H.","name_middle":"","name_last":"Lipsky","name_suffix":"","equal_contrib":false,"affiliations_numbers":[1,5],"author_notes_ids":[]}]},{"files":{"figures":[{"id":"f1","label":"Figure 1","caption":"<b>Serological response to H1N1 in HIV</b> (Black) <b>and HC</b> (Grey). (<b>A</b>) H1N1 specific HAI titer at T0, T1 and T2 between young and old HIV (black) and HC (grey) participants. Statistical significance (p value <0.05, Wilcoxon test) is depicted as * and †. (<b>B</b>) Mean ±SEM of fold change, (T2/T0) in H1N1-specific HAI titer; Mann-Whitney test did not show differences to be significant. (<b>C</b>) Correlation of biological age with HAI titer at T2 in HC (left) and HIV (right) by Spearman correlation test. Serological values are expressed in log2 scale. Age groups are depicted as squares (young, <40 years), triangles (middle, 40-60 years) and circles (old, ≥60 years).","file":"CRGtFagjpcZNdfwGH_f1.tif","version":1,"optimized":true,"optimized_file":"CRGtFagjpcZNdfwGH_f1.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/CRGtFagjpcZNdfwGH_f1.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/CRGtFagjpcZNdfwGH_f1.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/CRGtFagjpcZNdfwGH_f1.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/CRGtFagjpcZNdfwGH_f1.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/CRGtFagjpcZNdfwGH_f1.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/CRGtFagjpcZNdfwGH_f1.png"}},{"id":"f2","label":"Figure 2","caption":"<b>Spontaneous H1N1-specific ASCs at T1 in HIV</b> (Black) <b>and HC</b> (Grey). (<b>A</b>) Mean ±SEM of H1N1 specific spontaneous ASC was assessed by ELISpot using PBMC 7 days after vaccination without any pre-activation. Mann-Whitney test was performed; *, Statistical significance at p <0.05. (<b>B</b>) H1N1 specific spontaneous ASC assessed in 60 Healthy controls (<b>Left</b>) and 64 HIV infected individuals (<b>Right</b>). ELISpot values are expressed as log2 scale. Age groups depicted as squares (young, <40 years), triangles (middle, 40-59 years) and circles (old, ≥60 years). Spearman correlation was performed.","file":"CRGtFagjpcZNdfwGH_f2.tif","version":1,"optimized":true,"optimized_file":"CRGtFagjpcZNdfwGH_f2.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/CRGtFagjpcZNdfwGH_f2.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/CRGtFagjpcZNdfwGH_f2.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/CRGtFagjpcZNdfwGH_f2.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/CRGtFagjpcZNdfwGH_f2.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/CRGtFagjpcZNdfwGH_f2.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/CRGtFagjpcZNdfwGH_f2.png"}},{"id":"f3","label":"Figure 3","caption":"<b>Correlation between age and H1N1-specific Memory B cells and plasmablasts response in HIV</b> (Black) <b>and HC</b> (Grey). (<b>A</b>) Evaluation of the H1N1 specific memory B cells at T0 and T2. Lines represent mean ±SEM. For comparisons between age groups at same time point, Mann-Whitney test was performed and for comparisons between time points of the same age group, Wilcoxon signed-rank test was performed; *, Statistical significance at p <0.05. (<b>B</b>) Age was correlated with (<b>Top</b>) H1N1 specific memory B cells at T0 assessed with ELISpot using PBMC pre vaccination stimulated for 5 days with H1N1 (5µg/ml) and (<b>Bottom</b>) H1N1 specific memory B cells at T2 assessed with ELISpot using PBMC 21 days after vaccination stimulated for 5 days with H1N1 (5µg/ml) in (<b>Left</b>) 60 Healthy controls and (<b>Right</b>) 64 HIV infected individuals. ELISpot values are expressed as log2 scale. Age groups depicted as squares (young, <40 years), triangles (middle, 40-59 years) and circles (old, ≥60 years). Spearman correlation was performed.","file":"CRGtFagjpcZNdfwGH_f3.tif","version":1,"optimized":true,"optimized_file":"CRGtFagjpcZNdfwGH_f3.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/CRGtFagjpcZNdfwGH_f3.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/CRGtFagjpcZNdfwGH_f3.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/CRGtFagjpcZNdfwGH_f3.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/CRGtFagjpcZNdfwGH_f3.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/CRGtFagjpcZNdfwGH_f3.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/CRGtFagjpcZNdfwGH_f3.png"}},{"id":"f4","label":"Figure 4","caption":"<b>Evaluation of B cell subsets in HIV</b> (Black) <b>and HC</b> (Grey). B cells subsets are reported as frequencies of the CD20+CD3- B cells. Age groups are depicted as squares (young, <40 years) and circles (old, ≥60 years). *, Statistical significance at p <0.05 by Mann-Whitney test.","file":"CRGtFagjpcZNdfwGH_f4.tif","version":1,"optimized":true,"optimized_file":"CRGtFagjpcZNdfwGH_f4.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/CRGtFagjpcZNdfwGH_f4.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/CRGtFagjpcZNdfwGH_f4.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/CRGtFagjpcZNdfwGH_f4.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/CRGtFagjpcZNdfwGH_f4.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/CRGtFagjpcZNdfwGH_f4.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/CRGtFagjpcZNdfwGH_f4.png"}},{"id":"f5","label":"Figure 5","caption":"<b>B Cells of young HIV exhibit markers of Immune activation and exhaustion.</b> (<b>A</b>) Example of gating strategy for CD80+, PDL1+ and FcRL4+ B cells. (<b>B</b>) Frequencies of CD80+ B cell and (<b>C</b>) Frequencies of PDL1+ B cell in HC (Grey) and HIV (Black). Age groups are depicted as squares (young, <40 years) and circles (old, ≥60 years). *, Statistical significance at p <0.05 by Mann-Whitney test.","file":"CRGtFagjpcZNdfwGH_f5.tif","version":1,"optimized":true,"optimized_file":"CRGtFagjpcZNdfwGH_f5.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/CRGtFagjpcZNdfwGH_f5.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/CRGtFagjpcZNdfwGH_f5.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/CRGtFagjpcZNdfwGH_f5.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/CRGtFagjpcZNdfwGH_f5.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/CRGtFagjpcZNdfwGH_f5.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/CRGtFagjpcZNdfwGH_f5.png"}},{"id":"f6","label":"Figure 6","caption":"<b>Plasmablasts at T0 are positively correlated with B cellular response to H1N1 in HIV</b> (Black) <b>and HC</b> (Grey). Frequencies of plasmablast before vaccination were correlated with the H1N1 specific spontaneous ASC by ELISpot in PBMC at 7 days after vaccination. ELISpot values are expressed as log2 scale. Age groups depicted as squares (young, <40 years), triangles (middle, 40-59 years) and circles (old, ≥60 years). Spearman correlation was performed.","file":"CRGtFagjpcZNdfwGH_f6.tif","version":1,"optimized":true,"optimized_file":"CRGtFagjpcZNdfwGH_f6.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/CRGtFagjpcZNdfwGH_f6.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/CRGtFagjpcZNdfwGH_f6.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/CRGtFagjpcZNdfwGH_f6.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/CRGtFagjpcZNdfwGH_f6.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/CRGtFagjpcZNdfwGH_f6.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/CRGtFagjpcZNdfwGH_f6.png"}},{"id":"f7","label":"Figure 7","caption":"<b>Immune activation and immune regulation influence influenza Ab responses in HIV.</b> (<b>A</b>) The frequency of the PDL1+ B cells before vaccination was correlated with the frequency of the plasmablasts before vaccination. (<b>B</b>) Frequencies of the CD80+ Naïve B cells at T0 were correlated with the H1N1 specific HAI titer fold change (T2/T0). Age groups are depicted as squares (young, <40 years), triangles (middle, 40-59 years) and circles (old, ≥60 years). Spearman correlation was performed.","file":"CRGtFagjpcZNdfwGH_f7.tif","version":1,"optimized":true,"optimized_file":"CRGtFagjpcZNdfwGH_f7.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/CRGtFagjpcZNdfwGH_f7.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/CRGtFagjpcZNdfwGH_f7.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/CRGtFagjpcZNdfwGH_f7.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/CRGtFagjpcZNdfwGH_f7.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/CRGtFagjpcZNdfwGH_f7.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/CRGtFagjpcZNdfwGH_f7.png"}},{"id":"f8","label":"Figure 8","caption":"<b>PDL1+ B cells are related to immune aging and exhaustion of B cells.</b> Frequencies of PDL1+ B cells at T0 were correlated with (<b>A, B</b>) frequencies of double negative B cells; (<b>C, D</b>) frequencies of exhausted B cells (DN/FcRL4+) and (<b>E, F</b>) with frequencies of exhausted T cells (CD4/PD1+) in 60 healthy controls (<b>Left,</b> Grey) and 64 HIV infected individuals (<b>Right,</b> Black). Age groups are depicted as squares (young, <40 years), triangles (middle, 40-59 years) and circles (old, ≥60 years). Spearman correlation was performed in all the correlation tests.","file":"CRGtFagjpcZNdfwGH_f8.tif","version":1,"optimized":true,"optimized_file":"CRGtFagjpcZNdfwGH_f8.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/CRGtFagjpcZNdfwGH_f8.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/CRGtFagjpcZNdfwGH_f8.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/CRGtFagjpcZNdfwGH_f8.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/CRGtFagjpcZNdfwGH_f8.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/CRGtFagjpcZNdfwGH_f8.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/CRGtFagjpcZNdfwGH_f8.png"}},{"id":"f9","label":"Figure 9","caption":"<b>Time under cART reduces B cell immune activation and immune senescence but has no effect on PDL1 expression on B cells.</b> (<b>A</b>) The frequency of the CD80+ B cells (<b>Left</b>) and CD80+ Naïve B cells (<b>Right</b>) before vaccination was correlated with duration of cART. (<b>B</b>) Frequencies of the double negative B cells were correlated with the years under cART. (<b>C</b>) Frequencies of the PDL1+ B cells at T0 were correlated with the years under cART. Age groups are depicted as squares (young, <40 years), triangles (middle, 40-59 years) and circles (old, ≥60 years). Spearman correlation was performed.","file":"CRGtFagjpcZNdfwGH_f9.tif","version":1,"optimized":true,"optimized_file":"CRGtFagjpcZNdfwGH_f9.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/CRGtFagjpcZNdfwGH_f9.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/CRGtFagjpcZNdfwGH_f9.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/CRGtFagjpcZNdfwGH_f9.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/CRGtFagjpcZNdfwGH_f9.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/CRGtFagjpcZNdfwGH_f9.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/CRGtFagjpcZNdfwGH_f9.png"}}],"supplemental":[{"id":"SD1","label":"Supplementary File","file":"CRGtFagjpcZNdfwGH_sd1.pdf","version":1,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/supplemental_materials/CRGtFagjpcZNdfwGH_sd1.pdf"}],"pdf":{"file":"CRGtFagjpcZNdfwGH.pdf","display":true,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/pdf/CRGtFagjpcZNdfwGH.pdf"},"xml":{"file":"CRGtFagjpcZNdfwGH.xml","display":true,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/xml/CRGtFagjpcZNdfwGH.xml"}},"title":"Paradoxical aging in HIV: immune senescence of B Cells is most prominent in young age","page_start":1307,"page_end":1325,"ids":{"pii":"101229","publisher-id":"101229","doi":"10.18632/aging.101229","pmid":"28448963"},"abstract":"<p>Combination antiretroviral therapies (cART)can lead to normal life expectancy in HIV-infected persons, and people aged &gt;50 yrs represent the fastest growing HIV group. Although HIV and aging are independently associated with impaired humoral immunity, immune status in people aging with HIV is relatively unexplored. In this study influenza vaccination was used to probe age associated perturbations in the B cell compartment of HIV-negative “healthy controls” (HC) and virologically controlled HIV-infected participants on cART (HIV) (n=124), grouped by age as young (&lt;40 yrs), middle-aged (40-59yrs) or old (<underline>&gt;</underline>60 yrs). H1N1 antibody response at d21 post-vaccination correlated inversely with age in both HC and HIV. Immunophenotyping of cryopreserved PBMC demonstrated increased frequencies of double negative B cells and decreased plasmablasts in old compared to young HC. Remarkably, young HIV were different from young HC but similar to old HC in B cell phenotype, influenza specific spontaneous (d7) or memory (d21) antibody secreting cells. We conclude that B cell immune senescence is a prominent phenomenon in young HIV in comparison to young HC, but distinctions between old HIV and old HC are less evident though both groups manifest age-associated B cell dysfunction.</p>","article_type":{"short_name":"research_paper","nlm_type":"research-article","plural":"Research Papers","name":"Research Paper"},"authors":[{"name_first":"Stefano","name_middle":"","name_last":"Rinaldi","name_suffix":"","equal_contrib":true,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Suresh","name_middle":"","name_last":"Pallikkuth","name_suffix":"","equal_contrib":true,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Varghese K.","name_middle":"","name_last":"George","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Lesley R.","name_middle":"","name_last":"de Armas","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Rajendra","name_middle":"","name_last":"Pahwa","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Celeste M.","name_middle":"","name_last":"Sanchez","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Maria Fernanda","name_middle":"","name_last":"Pallin","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Li","name_middle":"","name_last":"Pan","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Nicola","name_middle":"","name_last":"Cotugno","name_suffix":"","equal_contrib":false,"affiliations_numbers":[3],"author_notes_ids":[]},{"name_first":"Gordon","name_middle":"","name_last":"Dickinson","name_suffix":"","equal_contrib":false,"affiliations_numbers":[1],"author_notes_ids":[]},{"name_first":"Allan","name_middle":"","name_last":"Rodriguez","name_suffix":"","equal_contrib":false,"affiliations_numbers":[1],"author_notes_ids":[]},{"name_first":"Margaret","name_middle":"","name_last":"Fischl","name_suffix":"","equal_contrib":false,"affiliations_numbers":[2],"author_notes_ids":[]},{"name_first":"Maria","name_middle":"","name_last":"Alcaide","name_suffix":"","equal_contrib":false,"affiliations_numbers":[1],"author_notes_ids":[]},{"name_first":"Louis","name_middle":"","name_last":"Gonzalez","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Paolo","name_middle":"","name_last":"Palma","name_suffix":"","equal_contrib":false,"affiliations_numbers":[3],"author_notes_ids":[]},{"name_first":"Savita","name_middle":"","name_last":"Pahwa","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]}]},{"files":{"pdf":{"file":"EN4xki4qvPJj56Nir.pdf","display":true,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/pdf/EN4xki4qvPJj56Nir.pdf"},"xml":{"file":"EN4xki4qvPJj56Nir.xml","display":true,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/xml/EN4xki4qvPJj56Nir.xml"},"figures":[{"id":"f1","label":"Figure 1","caption":"<b>The expression of BMP2 is up-regulated in NPC and correlates with poor prognosis.</b> (<b>A</b>) qRT-PCR analysis showed that the expression of BMP2 mRNA was significantly higher in NPC tumor tissues (n=22) than non-cancerous nasopharyngitis tissues (n=14) (** p<0.01, independent Student’s t-test). (<b>B</b>) The expression level of BMP2 in NPC cell lines (HONE1, SUNE1, CNE2, C666-1, S18, S26, 6-10B and 5-8F) and the normal epithelial NP69 was analyzed by Western blot. NP69 showed a relative low level of endogenous BMP2 protein expression and the protein expression level of BMP2 was obviously higher in S-18 and 5-8F cells with high tumorigenic and metastatic potential compared with their paired subclones S-26 and 6-10B cells with low tumorigenic and metastatic potential. (<b>C</b>) BMP2 immunostaining of representative images of NPC patients with different IHC scores. (<b>D</b>, <b>E</b>, <b>F).</b> Patients with high expression of BMP2 had shorter overall survival (OS) (D), progression-free survival (PFS) (E), and distant-metastasis-free survival (DMFS) (F) than those with low levels of BMP2.","file":"EN4xki4qvPJj56Nir_f1.tif","version":1,"optimized":true,"optimized_file":"EN4xki4qvPJj56Nir_f1.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/EN4xki4qvPJj56Nir_f1.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/EN4xki4qvPJj56Nir_f1.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/EN4xki4qvPJj56Nir_f1.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/EN4xki4qvPJj56Nir_f1.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/EN4xki4qvPJj56Nir_f1.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/EN4xki4qvPJj56Nir_f1.png"}},{"id":"f2","label":"Figure 2","caption":"<b>BMP2 enhances NPC cells growth.</b> (<b>A</b>) The over-expression efficiency of BMP2 in S18 and 6-10B cells were confirmed by Western blot, respectively. And CCK-8 assays showed that BMP2 could significantly promote proliferation of S18-BMP2 and 6-10-BMP2 cells compared with the controls. (<b>B</b>) BMP2 knockdown in 5-8F cell via three specific siRNA was confirmed by Western blot and CCK-8 assays showed that BMP2 knockdown reduced the proliferation of 5-8F cell. (<b>C</b>) In colony formation assays, the number of colonies was significantly higher in the S18-BMP2 and 6-10B-BMP2 cells than the controls.","file":"EN4xki4qvPJj56Nir_f2.tif","version":1,"optimized":true,"optimized_file":"EN4xki4qvPJj56Nir_f2.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/EN4xki4qvPJj56Nir_f2.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/EN4xki4qvPJj56Nir_f2.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/EN4xki4qvPJj56Nir_f2.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/EN4xki4qvPJj56Nir_f2.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/EN4xki4qvPJj56Nir_f2.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/EN4xki4qvPJj56Nir_f2.png"}},{"id":"f3","label":"Figure 3","caption":"<b>BMP2 promotes NPC cell migration, invasion and epithelial-mesenchymal transition.</b> (<b>A</b>) Wound-healing assays demonstrated that BMP2 upregulated cells had higher migration rate than control cells. (<b>B</b>) Matrigel invasion chambers were used to evaluate the ability of NPC cell invasion. Upregulation of BMP2 significantly increased the number of invaded cell in S18 and 6-10B compared with the controls. (<b>C</b>) silencing expression of BMP2 in 5-8F much reduced the invaded cell numbers. (<b>D</b>) Western blotting revealed that overexpression of BMP2 in S18 and 6-10B cells decreased the expression of epithelial makers (E-cadherin) and increased the expression of mesenchymal markers (N-cadherin, Vimentin and β-catenin) in comparison with the controls. (<b>E</b>) Western blotting showed that knockdown of BMP2 increased the expression of E-cadherin and decreased the expression of N-cadherin, Vimentin and β-catenin.","file":"EN4xki4qvPJj56Nir_f3.tif","version":1,"optimized":true,"optimized_file":"EN4xki4qvPJj56Nir_f3.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/EN4xki4qvPJj56Nir_f3.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/EN4xki4qvPJj56Nir_f3.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/EN4xki4qvPJj56Nir_f3.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/EN4xki4qvPJj56Nir_f3.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/EN4xki4qvPJj56Nir_f3.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/EN4xki4qvPJj56Nir_f3.png"}},{"id":"f4","label":"Figure 4","caption":"<b>BMP2 activates mTOR signal pathway in NPC cells.</b> (<b>A</b>) Western blotting analysis revealed that in S18-BMP2 and 6-10B-BMP2 cells, the expression of phosphorylated (active) mTOR, P70S6K and 4EBP1 (p-mTOR, p-p70S6k and p-4EBP1) were upregulated compared to those control cells. (<b>B</b>) The expression of p-mTOR, p-p70S6k and p-4EBP1 were downregulated in 5-8F knockdown BMP2 cell. (<b>C</b>) Proliferation abilities of S-18 and 6-10B cells expressing BMP2 or the empty vector was evaluated by CCK8 assay after pretreatment with or without 20 nM of rapamycin. (<b>D</b>) Invasive abilities of S-18 and 6-10B cells expressing BMP2 or the empty vector was evaluated by transwell assay after pretreatment with or without 20 nM of rapamycin.","file":"EN4xki4qvPJj56Nir_f4.tif","version":1,"optimized":true,"optimized_file":"EN4xki4qvPJj56Nir_f4.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/EN4xki4qvPJj56Nir_f4.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/EN4xki4qvPJj56Nir_f4.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/EN4xki4qvPJj56Nir_f4.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/EN4xki4qvPJj56Nir_f4.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/EN4xki4qvPJj56Nir_f4.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/EN4xki4qvPJj56Nir_f4.png"}}],"supplemental":[{"id":"SD1","label":"Supplementary Table","file":"EN4xki4qvPJj56Nir_sd1.pdf","version":1,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/supplemental_materials/EN4xki4qvPJj56Nir_sd1.pdf"}]},"title":"BMP2 promotes proliferation and invasion of nasopharyngeal carcinoma cells via mTORC1 pathway","page_start":1326,"page_end":1340,"ids":{"pii":"101230","publisher-id":"101230","doi":"10.18632/aging.101230","pmid":"28455969"},"abstract":"<p>Bone morphogenetic protein-2 (BMP2) is a secreted protein that highly expressed in a variety of cancers and contributes to cell proliferation, migration, invasiveness, mobility, metastasis and EMT. However, its clinical significance and biological function in nasopharyngeal carcinoma (NPC) remain unknown up to now. Up-regulation of BMP2 was first observed in NPC cell lines by a genome-wide transcriptome analysis in our previous study. In this study, BMP2 mRNA was detected by qRT-PCR and data showed that it was upregulated in NPC compared with non-cancerous nasopharynx samples. Immunohistochemistry (IHC) analysis in NPC specimens revealed that high BMP2 expression was significantly associated with clinical stage, distant metastasis and shorter survival of NPC patients. Moreover, overexpression of BMP2 in NPC cells promoted cell proliferation, migration, invasiveness and epithelial-mesenchymal transition (EMT). Mechanistically, BMP2 overexpression increase phosphorylated protein level of mTOR, S6K and 4EBP1. Correspondingly, mTORC1 inhibitor rapamycin blocked the effect of BMP2 on NPC cell proliferation and invasion. In conclusion, our results suggest that BMP2 overexpression in NPC enhances proliferation, invasion and EMT of tumor cells through the mTORC1 signaling pathway.</p>","article_type":{"short_name":"research_paper","nlm_type":"research-article","plural":"Research Papers","name":"Research Paper"},"authors":[{"name_first":"Meng-He","name_middle":"","name_last":"Wang","name_suffix":"","equal_contrib":true,"affiliations_numbers":[0,1],"author_notes_ids":[]},{"name_first":"Xiao-Min","name_middle":"","name_last":"Zhou","name_suffix":"","equal_contrib":true,"affiliations_numbers":[2],"author_notes_ids":[]},{"name_first":"Mei-Yin","name_middle":"","name_last":"Zhang","name_suffix":"","equal_contrib":true,"affiliations_numbers":[0,1],"author_notes_ids":[]},{"name_first":"Lu","name_middle":"","name_last":"Shi","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0,1],"author_notes_ids":[]},{"name_first":"Ruo-Wen","name_middle":"","name_last":"Xiao","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0,1],"author_notes_ids":[]},{"name_first":"Li-Si","name_middle":"","name_last":"Zeng","name_suffix":"","equal_contrib":false,"affiliations_numbers":[3],"author_notes_ids":[]},{"name_first":"Xian-Zi","name_middle":"","name_last":"Yang","name_suffix":"","equal_contrib":false,"affiliations_numbers":[3],"author_notes_ids":[]},{"name_first":"X.F. Steven","name_middle":"","name_last":"Zheng","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0,4],"author_notes_ids":[]},{"name_first":"Hui-Yun","name_middle":"","name_last":"Wang","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0,1],"author_notes_ids":[]},{"name_first":"Shi-Juan","name_middle":"","name_last":"Mai","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0,1],"author_notes_ids":[]}]},{"files":{"figures":[{"id":"f1","label":"Figure 1","caption":"<b>Using cybrid transfer to generate mutation-free LHON fibroblasts and iPSCs.</b> (<b>A</b>) Diagram of cybrid generation. Fibroblasts were pre-treated with the mitochondrial toxin rhodamine 6-G (R6G) then fused with healthy donor mitochondria obtained from normal keratinocytes. On day 29-32, proliferating colonies were picked and expanded. (<b>B</b>) Representative images of control fibroblasts (no fusion) and fused fibroblasts that received donor mitochondria (cybrid fusion) at 8, 11, 27 days post R6G treatment. (<b>C</b>) Genotype confirming cybrid correction of mutation in fibroblasts and the corresponding iPSCs. Red arrows indicate LHON mutations at m.4160T>C and m.14484T>C, blue arrows indicate wild-type genotype. Note that the genotype of the parental LHON fibroblasts (LHON Q1-4) was reported previously [<a href=\"#r12\"  class=\"anchor\">12</a>]. (<b>D</b>) Microsatellite analysis confirming cybrid originated from LHON fibroblasts, but not donor keratinocytes. (<b>E-G</b>) Characterization of cybrid iPSCs (CYB iPSC c1). (<b>E</b>) Immunostaining showed expression of the pluripotency markers OCT-4 and TRA-1-60 in cybrid iPSCs. Scale bars: 100 μm. (<b>F</b>) Top panel: Differentiation of cybrid iPSCs by embryoid body formation contained cells positive for NESTIN (ectoderm), SMA (mesoderm) and AFP (endoderm) expression. Cells were counterstained with DAPI (blue). Scale bars: 100 μm. Bottom panel: Teratoma formation upon transplantation of cybrid iPSCs in nude rats, showing differentiation to endoderm, mesoderm (Ku80 staining, the arrow indicates an endothelial-lined blood vessel with lumen filled with red blood cells) and ectoderm. Scale bars: 50 μm. (<b>G</b>) Copy number variation analysis showing normal karyotype in cybrid iPSCs.","file":"sCzYdtpkTeioX4tfc_f1.tif","version":1,"optimized":true,"optimized_file":"sCzYdtpkTeioX4tfc_f1.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/sCzYdtpkTeioX4tfc_f1.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/sCzYdtpkTeioX4tfc_f1.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/sCzYdtpkTeioX4tfc_f1.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/sCzYdtpkTeioX4tfc_f1.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/sCzYdtpkTeioX4tfc_f1.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/sCzYdtpkTeioX4tfc_f1.png"}},{"id":"f2","label":"Figure 2","caption":"<b>LHON disease phenotype in iPSC-derived RGCs can be reversed in corrected cybrid lines.</b> (<b>A</b>) Efficiency in RGC differentiation as assessed by the % of THY1.1 positive cells obtained post MACS sorting for control, LHON and corrected cybrid lines. Data are expressed as mean + SEM of independent samples (n=11 for control, n=8 for LHON and n=8 for corrected cybrid, expressed as pooled data of experimental repeats and biological repeats (3 clones)). (<b>B</b>) TUNEL assay revealed increased susceptibility to apoptosis in LHON RGCs and reversal in corrected cybrid lines. Data are expressed as mean of each clone, n = 3 clones, error bars = mean ± SEM. (<b>C</b>) Quantification of mitochondrial superoxide levels using MitoSOX in control, LHON and corrected cybrid RGCs. Error bars = ± SEM, n = 3 clones. Statistical significance was established by one way ANOVA followed by Dunnett’s test for multiple comparisons, ** p<0.01, * p<0.05, ns: not significant.","file":"sCzYdtpkTeioX4tfc_f2.tif","version":1,"optimized":true,"optimized_file":"sCzYdtpkTeioX4tfc_f2.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/sCzYdtpkTeioX4tfc_f2.tif","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/original/sCzYdtpkTeioX4tfc_f2.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/sCzYdtpkTeioX4tfc_f2.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/large/sCzYdtpkTeioX4tfc_f2.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/medium/sCzYdtpkTeioX4tfc_f2.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/sCzYdtpkTeioX4tfc_f2.png"}}],"supplemental":[{"id":"SD1","label":"Supplementary File","file":"sCzYdtpkTeioX4tfc_sd1.pdf","version":1,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/supplemental_materials/sCzYdtpkTeioX4tfc_sd1.pdf"}],"pdf":{"file":"sCzYdtpkTeioX4tfc.pdf","display":true,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/pdf/sCzYdtpkTeioX4tfc.pdf"},"xml":{"file":"sCzYdtpkTeioX4tfc.xml","display":true,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/xml/sCzYdtpkTeioX4tfc.xml"}},"title":"Mitochondrial replacement in an iPSC model of Leber’s hereditary optic neuropathy","page_start":1341,"page_end":1350,"ids":{"pii":"101231","publisher-id":"101231","doi":"10.18632/aging.101231","pmid":"28455970"},"abstract":"<p>Cybrid technology was used to replace Leber hereditary optic neuropathy (LHON) causing mitochondrial DNA (mtDNA) mutations from patient-specific fibroblasts with wildtype mtDNA, and mutation-free induced pluripotent stem cells (iPSCs) were generated subsequently. Retinal ganglion cell (RGC) differentiation demonstrates increased cell death in LHON-RGCs and can be rescued in cybrid corrected RGCs.</p>","article_type":{"short_name":"research_paper","nlm_type":"research-article","plural":"Research Papers","name":"Research Paper"},"authors":[{"name_first":"Raymond C.B.","name_middle":"","name_last":"Wong","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0,1],"author_notes_ids":[]},{"name_first":"Shiang Y.","name_middle":"","name_last":"Lim","name_suffix":"","equal_contrib":false,"affiliations_numbers":[2],"author_notes_ids":[]},{"name_first":"Sandy S.C.","name_middle":"","name_last":"Hung","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0,1],"author_notes_ids":[]},{"name_first":"Stacey","name_middle":"","name_last":"Jackson","name_suffix":"","equal_contrib":false,"ids":{},"affiliations_numbers":[0,1],"author_notes_ids":[]},{"name_first":"Shahnaz","name_middle":"","name_last":"Khan","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0,1],"author_notes_ids":[]},{"name_first":"Nicole J.","name_middle":"","name_last":"Van Bergen","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0,1],"author_notes_ids":[]},{"name_first":"Elisabeth","name_middle":"","name_last":"De Smit","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0,1],"author_notes_ids":[]},{"name_first":"Helena H.","name_middle":"","name_last":"Liang","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0,1],"author_notes_ids":[]},{"name_first":"Lisa S","name_middle":"","name_last":"Kearns","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0,1],"author_notes_ids":[]},{"name_first":"Linda","name_middle":"","name_last":"Clarke","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0,1],"author_notes_ids":[]},{"name_first":"David A.","name_middle":"","name_last":"Mackey","name_suffix":"","equal_contrib":false,"affiliations_numbers":[3,4],"author_notes_ids":[]},{"name_first":"Alex W.","name_middle":"","name_last":"Hewitt","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0,1,4],"author_notes_ids":[]},{"name_first":"Ian A.","name_middle":"","name_last":"Trounce","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0,1,5],"author_notes_ids":[]},{"name_first":"Alice","name_middle":"","name_last":"Pébay","name_suffix":"","equal_contrib":false,"ids":{},"affiliations_numbers":[0,1,5],"author_notes_ids":[]}]}]}

/***/ }),
/* 186 */
/***/ (function(module, exports) {

module.exports = {"issues":[{"id":1,"articleType":"Article Type","title":"Headline Headline headline 1","doi":"10.18632/oncotarget.12909","authors":["Brooke R. Druliner","Daniel Vera","Ruth Johnson","Xiaoyang Ruan","Lynn M. Apone","Eileen T. Dimalanta","Fiona J. Stewart","Lisa Boardman","Jonathan H. Dennis"],"image":"IssueCover.png","video":"img/temp/test_video.png","description":"Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget.","fullText":"Gastrointestinal stromal tumors (GIST) arise within the interstitial cell of Cajal (ICC) lineage due to activating KIT/PDGFRA mutations. Both ICC and GIST possess primary cilia (PC), which coordinate PDGFRA and Hedgehog signaling, regulators of gastrointestinal mesenchymal development. Therefore, we hypothesized that Hedgehog signaling may be altered in human GIST and controls KIT expression. Quantitative RT-PCR, microarrays, and next generation sequencing were used to describe Hedgehog/PC-related genes in purified human ICC and GIST. Genetic and pharmacologic approaches were employed to investigate the effects of GLI manipulation on KIT expression and GIST cell viability. We report that Hedgehog pathway and PC components are expressed in ICC and GIST and subject to dysregulation during GIST oncogenesis, irrespective of KIT/PDGFRA mutation status. Using genomic profiling, 10.2% of 186 GIST studied had potentially deleterious genomic alterations in 5 Hedgehog-related genes analyzed, including in the PTCH1 tumor suppressor (1.6%). Expression of the predominantly repressive GLI isoform, GLI3, was inversely correlated with KIT mRNA levels in GIST cells and non-KIT/non-PDGFRA mutant GIST. Overexpression of the 83-kDa repressive form of GLI3 or small interfering RNA-mediated knockdown of the activating isoforms GLI1/2 reduced KIT mRNA. Treatment with GLI1/2 inhibitors, including arsenic trioxide, significantly increased GLI3 binding to the KIT promoter, decreased KIT expression, and reduced viability in imatinib-sensitive and imatinib-resistant GIST cells. These data offer new evidence that genes necessary for Hedgehog signaling and PC function in ICC are dysregulated in GIST. Hedgehog signaling activates KIT expression irrespective of mutation status, offering a novel approach to treat imatinib-resistant GIST."},{"id":2,"articleType":"Article Type","title":"Headline Headline headline 2","doi":"10.18632/oncotarget.12909","authors":["Brooke R. Druliner","Daniel Vera","Ruth Johnson","Xiaoyang Ruan","Lynn M. Apone","Eileen T. Dimalanta","Fiona J. Stewart","Lisa Boardman","Jonathan H. Dennis"],"image":"IssueCover.png","video":"img/temp/test_video.png","description":"Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget.","fullText":"Gastrointestinal stromal tumors (GIST) arise within the interstitial cell of Cajal (ICC) lineage due to activating KIT/PDGFRA mutations. Both ICC and GIST possess primary cilia (PC), which coordinate PDGFRA and Hedgehog signaling, regulators of gastrointestinal mesenchymal development. Therefore, we hypothesized that Hedgehog signaling may be altered in human GIST and controls KIT expression. Quantitative RT-PCR, microarrays, and next generation sequencing were used to describe Hedgehog/PC-related genes in purified human ICC and GIST. Genetic and pharmacologic approaches were employed to investigate the effects of GLI manipulation on KIT expression and GIST cell viability. We report that Hedgehog pathway and PC components are expressed in ICC and GIST and subject to dysregulation during GIST oncogenesis, irrespective of KIT/PDGFRA mutation status. Using genomic profiling, 10.2% of 186 GIST studied had potentially deleterious genomic alterations in 5 Hedgehog-related genes analyzed, including in the PTCH1 tumor suppressor (1.6%). Expression of the predominantly repressive GLI isoform, GLI3, was inversely correlated with KIT mRNA levels in GIST cells and non-KIT/non-PDGFRA mutant GIST. Overexpression of the 83-kDa repressive form of GLI3 or small interfering RNA-mediated knockdown of the activating isoforms GLI1/2 reduced KIT mRNA. Treatment with GLI1/2 inhibitors, including arsenic trioxide, significantly increased GLI3 binding to the KIT promoter, decreased KIT expression, and reduced viability in imatinib-sensitive and imatinib-resistant GIST cells. These data offer new evidence that genes necessary for Hedgehog signaling and PC function in ICC are dysregulated in GIST. Hedgehog signaling activates KIT expression irrespective of mutation status, offering a novel approach to treat imatinib-resistant GIST."},{"id":3,"articleType":"Article Type","title":"Headline Headline headline 3","doi":"10.18632/oncotarget.12909","authors":["Brooke R. Druliner","Daniel Vera","Ruth Johnson","Xiaoyang Ruan","Lynn M. Apone","Eileen T. Dimalanta","Fiona J. Stewart","Lisa Boardman","Jonathan H. Dennis"],"image":"IssueCover.png","video":"img/temp/test_video.png","description":"Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget.","fullText":"Gastrointestinal stromal tumors (GIST) arise within the interstitial cell of Cajal (ICC) lineage due to activating KIT/PDGFRA mutations. Both ICC and GIST possess primary cilia (PC), which coordinate PDGFRA and Hedgehog signaling, regulators of gastrointestinal mesenchymal development. Therefore, we hypothesized that Hedgehog signaling may be altered in human GIST and controls KIT expression. Quantitative RT-PCR, microarrays, and next generation sequencing were used to describe Hedgehog/PC-related genes in purified human ICC and GIST. Genetic and pharmacologic approaches were employed to investigate the effects of GLI manipulation on KIT expression and GIST cell viability. We report that Hedgehog pathway and PC components are expressed in ICC and GIST and subject to dysregulation during GIST oncogenesis, irrespective of KIT/PDGFRA mutation status. Using genomic profiling, 10.2% of 186 GIST studied had potentially deleterious genomic alterations in 5 Hedgehog-related genes analyzed, including in the PTCH1 tumor suppressor (1.6%). Expression of the predominantly repressive GLI isoform, GLI3, was inversely correlated with KIT mRNA levels in GIST cells and non-KIT/non-PDGFRA mutant GIST. Overexpression of the 83-kDa repressive form of GLI3 or small interfering RNA-mediated knockdown of the activating isoforms GLI1/2 reduced KIT mRNA. Treatment with GLI1/2 inhibitors, including arsenic trioxide, significantly increased GLI3 binding to the KIT promoter, decreased KIT expression, and reduced viability in imatinib-sensitive and imatinib-resistant GIST cells. These data offer new evidence that genes necessary for Hedgehog signaling and PC function in ICC are dysregulated in GIST. Hedgehog signaling activates KIT expression irrespective of mutation status, offering a novel approach to treat imatinib-resistant GIST."},{"id":4,"articleType":"Article Type","title":"Headline Headline headline 4","doi":"10.18632/oncotarget.12909","authors":["Brooke R. Druliner","Daniel Vera","Ruth Johnson","Xiaoyang Ruan","Lynn M. Apone","Eileen T. Dimalanta","Fiona J. Stewart","Lisa Boardman","Jonathan H. Dennis"],"image":"IssueCover.png","video":"img/temp/test_video.png","description":"Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget.","fullText":"Gastrointestinal stromal tumors (GIST) arise within the interstitial cell of Cajal (ICC) lineage due to activating KIT/PDGFRA mutations. Both ICC and GIST possess primary cilia (PC), which coordinate PDGFRA and Hedgehog signaling, regulators of gastrointestinal mesenchymal development. Therefore, we hypothesized that Hedgehog signaling may be altered in human GIST and controls KIT expression. Quantitative RT-PCR, microarrays, and next generation sequencing were used to describe Hedgehog/PC-related genes in purified human ICC and GIST. Genetic and pharmacologic approaches were employed to investigate the effects of GLI manipulation on KIT expression and GIST cell viability. We report that Hedgehog pathway and PC components are expressed in ICC and GIST and subject to dysregulation during GIST oncogenesis, irrespective of KIT/PDGFRA mutation status. Using genomic profiling, 10.2% of 186 GIST studied had potentially deleterious genomic alterations in 5 Hedgehog-related genes analyzed, including in the PTCH1 tumor suppressor (1.6%). Expression of the predominantly repressive GLI isoform, GLI3, was inversely correlated with KIT mRNA levels in GIST cells and non-KIT/non-PDGFRA mutant GIST. Overexpression of the 83-kDa repressive form of GLI3 or small interfering RNA-mediated knockdown of the activating isoforms GLI1/2 reduced KIT mRNA. Treatment with GLI1/2 inhibitors, including arsenic trioxide, significantly increased GLI3 binding to the KIT promoter, decreased KIT expression, and reduced viability in imatinib-sensitive and imatinib-resistant GIST cells. These data offer new evidence that genes necessary for Hedgehog signaling and PC function in ICC are dysregulated in GIST. Hedgehog signaling activates KIT expression irrespective of mutation status, offering a novel approach to treat imatinib-resistant GIST."},{"id":5,"articleType":"Article Type","title":"Headline Headline headline 5","doi":"10.18632/oncotarget.12909","authors":["Brooke R. Druliner","Daniel Vera","Ruth Johnson","Xiaoyang Ruan","Lynn M. Apone","Eileen T. Dimalanta","Fiona J. Stewart","Lisa Boardman","Jonathan H. Dennis"],"image":"IssueCover.png","video":"img/temp/test_video.png","description":"Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget.","fullText":"Gastrointestinal stromal tumors (GIST) arise within the interstitial cell of Cajal (ICC) lineage due to activating KIT/PDGFRA mutations. Both ICC and GIST possess primary cilia (PC), which coordinate PDGFRA and Hedgehog signaling, regulators of gastrointestinal mesenchymal development. Therefore, we hypothesized that Hedgehog signaling may be altered in human GIST and controls KIT expression. Quantitative RT-PCR, microarrays, and next generation sequencing were used to describe Hedgehog/PC-related genes in purified human ICC and GIST. Genetic and pharmacologic approaches were employed to investigate the effects of GLI manipulation on KIT expression and GIST cell viability. We report that Hedgehog pathway and PC components are expressed in ICC and GIST and subject to dysregulation during GIST oncogenesis, irrespective of KIT/PDGFRA mutation status. Using genomic profiling, 10.2% of 186 GIST studied had potentially deleterious genomic alterations in 5 Hedgehog-related genes analyzed, including in the PTCH1 tumor suppressor (1.6%). Expression of the predominantly repressive GLI isoform, GLI3, was inversely correlated with KIT mRNA levels in GIST cells and non-KIT/non-PDGFRA mutant GIST. Overexpression of the 83-kDa repressive form of GLI3 or small interfering RNA-mediated knockdown of the activating isoforms GLI1/2 reduced KIT mRNA. Treatment with GLI1/2 inhibitors, including arsenic trioxide, significantly increased GLI3 binding to the KIT promoter, decreased KIT expression, and reduced viability in imatinib-sensitive and imatinib-resistant GIST cells. These data offer new evidence that genes necessary for Hedgehog signaling and PC function in ICC are dysregulated in GIST. Hedgehog signaling activates KIT expression irrespective of mutation status, offering a novel approach to treat imatinib-resistant GIST."},{"id":6,"articleType":"Article Type","title":"Headline Headline headline 6","doi":"10.18632/oncotarget.12909","authors":["Brooke R. Druliner","Daniel Vera","Ruth Johnson","Xiaoyang Ruan","Lynn M. Apone","Eileen T. Dimalanta","Fiona J. Stewart","Lisa Boardman","Jonathan H. Dennis"],"image":"IssueCover.png","video":"img/temp/test_video.png","description":"Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget.","fullText":"Gastrointestinal stromal tumors (GIST) arise within the interstitial cell of Cajal (ICC) lineage due to activating KIT/PDGFRA mutations. Both ICC and GIST possess primary cilia (PC), which coordinate PDGFRA and Hedgehog signaling, regulators of gastrointestinal mesenchymal development. Therefore, we hypothesized that Hedgehog signaling may be altered in human GIST and controls KIT expression. Quantitative RT-PCR, microarrays, and next generation sequencing were used to describe Hedgehog/PC-related genes in purified human ICC and GIST. Genetic and pharmacologic approaches were employed to investigate the effects of GLI manipulation on KIT expression and GIST cell viability. We report that Hedgehog pathway and PC components are expressed in ICC and GIST and subject to dysregulation during GIST oncogenesis, irrespective of KIT/PDGFRA mutation status. Using genomic profiling, 10.2% of 186 GIST studied had potentially deleterious genomic alterations in 5 Hedgehog-related genes analyzed, including in the PTCH1 tumor suppressor (1.6%). Expression of the predominantly repressive GLI isoform, GLI3, was inversely correlated with KIT mRNA levels in GIST cells and non-KIT/non-PDGFRA mutant GIST. Overexpression of the 83-kDa repressive form of GLI3 or small interfering RNA-mediated knockdown of the activating isoforms GLI1/2 reduced KIT mRNA. Treatment with GLI1/2 inhibitors, including arsenic trioxide, significantly increased GLI3 binding to the KIT promoter, decreased KIT expression, and reduced viability in imatinib-sensitive and imatinib-resistant GIST cells. These data offer new evidence that genes necessary for Hedgehog signaling and PC function in ICC are dysregulated in GIST. Hedgehog signaling activates KIT expression irrespective of mutation status, offering a novel approach to treat imatinib-resistant GIST."},{"id":7,"articleType":"Article Type","title":"Headline Headline headline 7","doi":"10.18632/oncotarget.12909","authors":["Brooke R. Druliner","Daniel Vera","Ruth Johnson","Xiaoyang Ruan","Lynn M. Apone","Eileen T. Dimalanta","Fiona J. Stewart","Lisa Boardman","Jonathan H. Dennis"],"image":"IssueCover.png","video":"img/temp/test_video.png","description":"Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget.","fullText":"Gastrointestinal stromal tumors (GIST) arise within the interstitial cell of Cajal (ICC) lineage due to activating KIT/PDGFRA mutations. Both ICC and GIST possess primary cilia (PC), which coordinate PDGFRA and Hedgehog signaling, regulators of gastrointestinal mesenchymal development. Therefore, we hypothesized that Hedgehog signaling may be altered in human GIST and controls KIT expression. Quantitative RT-PCR, microarrays, and next generation sequencing were used to describe Hedgehog/PC-related genes in purified human ICC and GIST. Genetic and pharmacologic approaches were employed to investigate the effects of GLI manipulation on KIT expression and GIST cell viability. We report that Hedgehog pathway and PC components are expressed in ICC and GIST and subject to dysregulation during GIST oncogenesis, irrespective of KIT/PDGFRA mutation status. Using genomic profiling, 10.2% of 186 GIST studied had potentially deleterious genomic alterations in 5 Hedgehog-related genes analyzed, including in the PTCH1 tumor suppressor (1.6%). Expression of the predominantly repressive GLI isoform, GLI3, was inversely correlated with KIT mRNA levels in GIST cells and non-KIT/non-PDGFRA mutant GIST. Overexpression of the 83-kDa repressive form of GLI3 or small interfering RNA-mediated knockdown of the activating isoforms GLI1/2 reduced KIT mRNA. Treatment with GLI1/2 inhibitors, including arsenic trioxide, significantly increased GLI3 binding to the KIT promoter, decreased KIT expression, and reduced viability in imatinib-sensitive and imatinib-resistant GIST cells. These data offer new evidence that genes necessary for Hedgehog signaling and PC function in ICC are dysregulated in GIST. Hedgehog signaling activates KIT expression irrespective of mutation status, offering a novel approach to treat imatinib-resistant GIST."},{"id":8,"articleType":"Article Type","title":"Headline Headline headline 8","doi":"10.18632/oncotarget.12909","authors":["Brooke R. Druliner","Daniel Vera","Ruth Johnson","Xiaoyang Ruan","Lynn M. Apone","Eileen T. Dimalanta","Fiona J. Stewart","Lisa Boardman","Jonathan H. Dennis"],"image":"IssueCover.png","video":"img/temp/test_video.png","description":"Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget.","fullText":"Gastrointestinal stromal tumors (GIST) arise within the interstitial cell of Cajal (ICC) lineage due to activating KIT/PDGFRA mutations. Both ICC and GIST possess primary cilia (PC), which coordinate PDGFRA and Hedgehog signaling, regulators of gastrointestinal mesenchymal development. Therefore, we hypothesized that Hedgehog signaling may be altered in human GIST and controls KIT expression. Quantitative RT-PCR, microarrays, and next generation sequencing were used to describe Hedgehog/PC-related genes in purified human ICC and GIST. Genetic and pharmacologic approaches were employed to investigate the effects of GLI manipulation on KIT expression and GIST cell viability. We report that Hedgehog pathway and PC components are expressed in ICC and GIST and subject to dysregulation during GIST oncogenesis, irrespective of KIT/PDGFRA mutation status. Using genomic profiling, 10.2% of 186 GIST studied had potentially deleterious genomic alterations in 5 Hedgehog-related genes analyzed, including in the PTCH1 tumor suppressor (1.6%). Expression of the predominantly repressive GLI isoform, GLI3, was inversely correlated with KIT mRNA levels in GIST cells and non-KIT/non-PDGFRA mutant GIST. Overexpression of the 83-kDa repressive form of GLI3 or small interfering RNA-mediated knockdown of the activating isoforms GLI1/2 reduced KIT mRNA. Treatment with GLI1/2 inhibitors, including arsenic trioxide, significantly increased GLI3 binding to the KIT promoter, decreased KIT expression, and reduced viability in imatinib-sensitive and imatinib-resistant GIST cells. These data offer new evidence that genes necessary for Hedgehog signaling and PC function in ICC are dysregulated in GIST. Hedgehog signaling activates KIT expression irrespective of mutation status, offering a novel approach to treat imatinib-resistant GIST."},{"id":9,"articleType":"Article Type","title":"Headline Headline headline 9","doi":"10.18632/oncotarget.12909","authors":["Brooke R. Druliner","Daniel Vera","Ruth Johnson","Xiaoyang Ruan","Lynn M. Apone","Eileen T. Dimalanta","Fiona J. Stewart","Lisa Boardman","Jonathan H. Dennis"],"video":"img/temp/test_video.png","description":"Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget.","fullText":"Gastrointestinal stromal tumors (GIST) arise within the interstitial cell of Cajal (ICC) lineage due to activating KIT/PDGFRA mutations. Both ICC and GIST possess primary cilia (PC), which coordinate PDGFRA and Hedgehog signaling, regulators of gastrointestinal mesenchymal development. Therefore, we hypothesized that Hedgehog signaling may be altered in human GIST and controls KIT expression. Quantitative RT-PCR, microarrays, and next generation sequencing were used to describe Hedgehog/PC-related genes in purified human ICC and GIST. Genetic and pharmacologic approaches were employed to investigate the effects of GLI manipulation on KIT expression and GIST cell viability. We report that Hedgehog pathway and PC components are expressed in ICC and GIST and subject to dysregulation during GIST oncogenesis, irrespective of KIT/PDGFRA mutation status. Using genomic profiling, 10.2% of 186 GIST studied had potentially deleterious genomic alterations in 5 Hedgehog-related genes analyzed, including in the PTCH1 tumor suppressor (1.6%). Expression of the predominantly repressive GLI isoform, GLI3, was inversely correlated with KIT mRNA levels in GIST cells and non-KIT/non-PDGFRA mutant GIST. Overexpression of the 83-kDa repressive form of GLI3 or small interfering RNA-mediated knockdown of the activating isoforms GLI1/2 reduced KIT mRNA. Treatment with GLI1/2 inhibitors, including arsenic trioxide, significantly increased GLI3 binding to the KIT promoter, decreased KIT expression, and reduced viability in imatinib-sensitive and imatinib-resistant GIST cells. These data offer new evidence that genes necessary for Hedgehog signaling and PC function in ICC are dysregulated in GIST. Hedgehog signaling activates KIT expression irrespective of mutation status, offering a novel approach to treat imatinib-resistant GIST."}],"editorsInChief":[{"id":1,"firstName":"Name","lastName":"Lastname","institution":"Roswell Park Cancer Institute","location":"Buffalo, NY","photoUrl":"no-image-available.png","email":"test@test.com","mediaLinks":{"facebookUrl":"https://www.facebook.com/Oncotarget/?ref=hl","twitterUrl":"https://twitter.com/ONCOTARGETJRNL","youTubeUrl":"https://www.youtube.com/channel/UC9KZZbhJRXBvBdwE97az3GQ","googlePlusUrl":"https://plus.google.com/101019847429993649149","linkedInUrl":"https://www.linkedin.com/company-beta/10546478/"},"description":"Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget."},{"id":2,"firstName":"Test","lastName":"Lastname","institution":"Roswell Park Cancer Institute","location":"Buffalo, NY","photoUrl":"no-image-available.png","mediaLinks":{"facebookUrl":"https://www.facebook.com/Oncotarget/?ref=hl","googlePlusUrl":"https://plus.google.com/101019847429993649149","linkedInUrl":"https://www.linkedin.com/company-beta/10546478/"},"email":"test@test.com","description":"Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget."},{"id":3,"firstName":"Name","lastName":"Lastname","institution":"Roswell Park Cancer Institute","location":"Buffalo, NY","photoUrl":"no-image-available.png","email":"test@test.com","mediaLinks":{"facebookUrl":"https://www.facebook.com/Oncotarget/?ref=hl","twitterUrl":"https://twitter.com/ONCOTARGETJRNL","youTubeUrl":"https://www.youtube.com/channel/UC9KZZbhJRXBvBdwE97az3GQ"},"description":"Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget."},{"id":4,"firstName":"Name","lastName":"Lastname","institution":"Roswell Park Cancer Institute","location":"Buffalo, NY","photoUrl":"no-image-available.png","mediaLinks":{"facebookUrl":"https://www.facebook.com/Oncotarget/?ref=hl","googlePlusUrl":"https://plus.google.com/101019847429993649149","linkedInUrl":"https://www.linkedin.com/company-beta/10546478/"},"email":"test@test.com","description":"Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget."}],"editorialBoardMembers":[{"id":1,"firstName":"Name","lastName":"BoardMember","institution":"Roswell Park Cancer Institute","location":"Buffalo, NY","photoUrl":"no-image-available.png","email":"test@test.com","mediaLinks":{"googlePlusUrl":"https://plus.google.com/101019847429993649149","linkedInUrl":"https://www.linkedin.com/company-beta/10546478/"},"description":"Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget."},{"id":2,"firstName":"Name","lastName":"BoardMember","institution":"Roswell Park Cancer Institute","location":"Buffalo, NY","photoUrl":"no-image-available.png","email":"test@test.com","mediaLinks":{"facebookUrl":"https://www.facebook.com/Oncotarget/?ref=hl","googlePlusUrl":"https://plus.google.com/101019847429993649149","linkedInUrl":"https://www.linkedin.com/company-beta/10546478/"},"description":"Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget."}],"specialCollectionArchives":[{"title":"Cover Papers","text":"Description of the collection goes here dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget."},{"title":"Spotlight on MTOR","text":"Description of the collection goes here dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget."},{"title":"Collection Title","text":"Description of the collection goes here dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget."}],"sectionsBeyondOncology":[{"title":"Gerotaget / Aging","text":"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. "},{"title":"Pathology beyond Oncology","text":"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. "},{"title":"Immunology & Microbiology","text":"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. "},{"title":"Autophagy & Cell Death","text":"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. "},{"title":"Autophagy & Cell Death","text":"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. "}]}

/***/ }),
/* 187 */
/***/ (function(module, exports) {

module.exports = {"videos":[{"ids":{"pmid":"20157571","pmc":"2815741","pii":"100101","doi":"10.18632/aging.100101"},"title":"p53, sex, and aging: lessons from the fruit fly","advance":false,"volume":1,"issue":{"volume":1,"issue":"11","issue_linkable":"11","display":true,"cover":"hmEg7MQKMLbWjfo3Q.png","pub_date":"2009-11-01T07:00:00.000+0000","date_settings":{"day":false,"month":true,"year":true},"current":false,"caption":"","pages":{"start":881,"end":960},"optimized":true,"optimized_file":"hmEg7MQKMLbWjfo3Q.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true,"xsmall":true},"prev_next":{"prev":{"_id":"e83C7xrecYb7rgDv4","volume":1,"issue":"10","issue_linkable":"10","param":"v1i10"},"next":{"_id":"Lim5Ndx6TGPx9xkBJ","volume":1,"issue":"12","issue_linkable":"12","param":"v1i12"}},"coverPath":"https://s3-us-west-1.amazonaws.com/paperchase-aging/covers/hmEg7MQKMLbWjfo3Q.png","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/covers_optimized/original/hmEg7MQKMLbWjfo3Q.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/covers_optimized/hero/hmEg7MQKMLbWjfo3Q.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/covers_optimized/large/hmEg7MQKMLbWjfo3Q.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/covers_optimized/medium/hmEg7MQKMLbWjfo3Q.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/covers_optimized/small/hmEg7MQKMLbWjfo3Q.png","xsmall":"https://s3-us-west-1.amazonaws.com/paperchase-aging/covers_optimized/xsmall/hmEg7MQKMLbWjfo3Q.png"}},"page_start":881,"page_end":883,"keywords":["Drosophila melanogaster","sexual antagonistic pleoitropy","longevity"],"article_type":{"short_name":"news","nlm_type":"news","plural":"News","name":"News"},"description":"Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget.","authors":[{"name_first":"Jae H.","name_middle":"","name_last":"Hur","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"David W.","name_middle":"","name_last":"Walker","name_suffix":"","equal_contrib":false,"ids":{},"affiliations_numbers":[0,1],"author_notes_ids":[]}],"affiliations":["Department of Physiological Science, University of California, Los Angeles, CA 90095, USA","Molecular Biology Institute, University of California, Los Angeles, CA 90095, USA"],"dates":{"epub":"2009-11-13T06:00:00.000Z"},"history":{"received":"2009-11-09T06:00:00.000Z","accepted":"2009-11-12T06:00:00.000Z"},"publisher":"Impact Journals LLC","video_url":"https://youtu.be/668nUCeBHyY","files":{"pdf":{"file":"9EdnXEakSw9F8pp8J.pdf","display":true,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/pdf/9EdnXEakSw9F8pp8J.pdf"},"xml":{"file":"9EdnXEakSw9F8pp8J.xml","display":true,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/xml/9EdnXEakSw9F8pp8J.xml"},"journal":"aging"},"correspondence":[{"text":"David W. Walker, PhD, Department of Physiological Science, University of California, Los Angeles, 621 Charles E. Young Dr. South, Los Angeles, CA 90095-1527, USA","email":"davidwalker@ucla.edu"}],"display":true,"feature":false,"abstract":"","pdfPageCount":17,"issue_pub_date_year":2009,"vi":"v1i11"},{"files":{"pdf":{"file":"ikCkZYNqL7MJ7tTko.pdf","display":true,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/pdf/ikCkZYNqL7MJ7tTko.pdf"},"xml":{"file":"ikCkZYNqL7MJ7tTko.xml","display":true,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/xml/ikCkZYNqL7MJ7tTko.xml"},"figures":[{"id":"f1","label":"Figure 1","caption":"<b>A microarray assay of miRNA expression profiles and a KEGG pathway enrichment analysis of target mRNAs predicted from differentially-expressed (DE) miRNAs in mouse oocytes aging for different times.</b> (<b>A</b>) Heat map and cluster analysis of miRNA expression in oocytes aging for different times. Red indicates high relative expression and green indicates low relative expression. Fold changes greater than 2 (FC>2) were used as threshold for miRNA differential expression. (<b>B</b>) A table shows number of DE miRNAs, number of target mRNAs predicted from DE miRNAs and number of enriched KEGG pathways in oocytes aging for different times.","file":"ikCkZYNqL7MJ7tTko_f1.tif","version":1,"optimized":true,"optimized_file":"ikCkZYNqL7MJ7tTko_f1.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/ikCkZYNqL7MJ7tTko_f1.tif","optimized_urls":{"original":"/img?size=original&img=ikCkZYNqL7MJ7tTko_f1.png&v=1","hero":"/img?size=hero&img=ikCkZYNqL7MJ7tTko_f1.png&v=1","large":"/img?size=large&img=ikCkZYNqL7MJ7tTko_f1.png&v=1","medium":"/img?size=medium&img=ikCkZYNqL7MJ7tTko_f1.png&v=1","small":"/img?size=small&img=ikCkZYNqL7MJ7tTko_f1.png&v=1"}},{"id":"f2","label":"Figure 2","caption":"<b>RT-qPCR verification of microarray assay results for apoptosis-related miRNAs.</b> Each treatment was repeated 3-4 times and each replicate contained ~600 oocytes. a-c: Values with a different letter above bars differ significantly (P < 0.05).","file":"ikCkZYNqL7MJ7tTko_f2.tif","version":1,"optimized":true,"optimized_file":"ikCkZYNqL7MJ7tTko_f2.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/ikCkZYNqL7MJ7tTko_f2.tif","optimized_urls":{"original":"/img?size=original&img=ikCkZYNqL7MJ7tTko_f2.png&v=1","hero":"/img?size=hero&img=ikCkZYNqL7MJ7tTko_f2.png&v=1","large":"/img?size=large&img=ikCkZYNqL7MJ7tTko_f2.png&v=1","medium":"/img?size=medium&img=ikCkZYNqL7MJ7tTko_f2.png&v=1","small":"/img?size=small&img=ikCkZYNqL7MJ7tTko_f2.png&v=1"}},{"id":"f3","label":"Figure 3","caption":"<b>Levels of p-MAPK, TrkB, and ceramide expression in oocytes aging for different times.</b> Graphs <b>A</b>, <b>B</b> and <b>C</b> show quantification of p-MAPK, TrkB, and ceramide expression, respectively. For ceramide quantification, the fluorescence intensity value in oocytes recovered at 13 h post hCG injection was set as one and the other values were expressed relative to this value. Each treatment was repeated 3-4 times and each replicate contained 35-40 oocytes. a-c: Values with a different letter above bars differ significantly (P < 0.05). <b>D</b>, <b>E</b>, <b>F</b> and <b>G</b> are micrographs from laser confocal images showing expression of ceramide in oocytes recovered at different times after hCG injection. Ceramide was colored green in the laser confocal images. The bar is 18 µm and applies to all images.","file":"ikCkZYNqL7MJ7tTko_f3.tif","version":1,"optimized":true,"optimized_file":"ikCkZYNqL7MJ7tTko_f3.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/ikCkZYNqL7MJ7tTko_f3.tif","optimized_urls":{"original":"/img?size=original&img=ikCkZYNqL7MJ7tTko_f3.png&v=1","hero":"/img?size=hero&img=ikCkZYNqL7MJ7tTko_f3.png&v=1","large":"/img?size=large&img=ikCkZYNqL7MJ7tTko_f3.png&v=1","medium":"/img?size=medium&img=ikCkZYNqL7MJ7tTko_f3.png&v=1","small":"/img?size=small&img=ikCkZYNqL7MJ7tTko_f3.png&v=1"}},{"id":"f4","label":"Figure 4","caption":"<b>Effects of supplementation with U0126, ceramide or BDNF during in vitro aging on STAS of mouse oocytes.</b> Cumulus-denuded oocytes (DOs) recovered 13 h post hCG injection were used. For U0126 and BDNF treatment, the DOs were aged for 36 h in CZB medium supplemented with different concentrations of U0126 or BDNF before ethanol and 6-DMAP treatment for activation. For ceramide treatment, DOs were microinjected with 6 pl DMSO alone (control) or DMSO containing 1 mM ceramide and then aged for 36 h in CZB medium before ethanol and 6-DMAP treatment for activation. Each treatment was repeated 4-5 times with each replicate containing about 30 oocytes. a,b: Values with a different letter above bars differ significantly (P < 0.05).","file":"ikCkZYNqL7MJ7tTko_f4.tif","version":1,"optimized":true,"optimized_file":"ikCkZYNqL7MJ7tTko_f4.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/ikCkZYNqL7MJ7tTko_f4.tif","optimized_urls":{"original":"/img?size=original&img=ikCkZYNqL7MJ7tTko_f4.png&v=1","hero":"/img?size=hero&img=ikCkZYNqL7MJ7tTko_f4.png&v=1","large":"/img?size=large&img=ikCkZYNqL7MJ7tTko_f4.png&v=1","medium":"/img?size=medium&img=ikCkZYNqL7MJ7tTko_f4.png&v=1","small":"/img?size=small&img=ikCkZYNqL7MJ7tTko_f4.png&v=1"}},{"id":"f5","label":"Figure 5","caption":"<b>Activation rates and calcium stores in oocytes microinjected with miR-98 mimic (upper row) or inhibitor (lower row).</b> Freshly ovulated oocytes recovered at 13 h post hCG were injected with miR-98 mimic (MM) or miRNA mimic negative control (MC), or with miR-98 inhibitor (IN) or inhibitor negative control (IC), before aging culture in CZB medium. To observe activation, oocytes were treated with ethanol and 6-DMAP at 36 h (mimic) or 30 h (inhibitor) of aging culture, and activation was checked 6 h later. Each treatment was repeated 3 to 4 times and each replicate contained 35-40 oocytes. For calcium measurement, at 3 h and 36 h (mimic) or 30 h (inhibitor) of aging culture, oocytes were loaded with Fura-2 AM and the loaded oocytes were measured for calcium stores (ΔF340/380) using a Ca<sup>2+</sup> imaging system. Oocytes were monitored for 5 min to record baseline F340/380 ratio before ionomycin stimulation to release Ca<sup>2+</sup> into cytoplasm. Following ionomycin addition, oocytes were monitored for 20 min to record peak F340/380 ratio. The difference between peak and baseline F340/380 ratios represents the calcium stores (ΔF340/380) of an oocyte. Each treatment was repeated 3 to 4 times and each replicate contained 35-40 oocytes. a-c: Values with a different letter above bars differ significantly (P < 0.05).","file":"ikCkZYNqL7MJ7tTko_f5.tif","version":1,"optimized":true,"optimized_file":"ikCkZYNqL7MJ7tTko_f5.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/ikCkZYNqL7MJ7tTko_f5.tif","optimized_urls":{"original":"/img?size=original&img=ikCkZYNqL7MJ7tTko_f5.png&v=1","hero":"/img?size=hero&img=ikCkZYNqL7MJ7tTko_f5.png&v=1","large":"/img?size=large&img=ikCkZYNqL7MJ7tTko_f5.png&v=1","medium":"/img?size=medium&img=ikCkZYNqL7MJ7tTko_f5.png&v=1","small":"/img?size=small&img=ikCkZYNqL7MJ7tTko_f5.png&v=1"}},{"id":"f6","label":"Figure 6","caption":"<b>Caspase-3 expression in oocytes microinjected with miR-98 mimic or inhibitor.</b> Freshly ovulated oocytes recovered at 13 h post hCG were injected with miR-98 mimic (MM) or miRNA mimic negative control (MC), or with miR-98 inhibitor (IN) or inhibitor negative control (IC), before aging culture in CZB medium. At 36 h (mimic) or 30 h (inhibitor) of aging culture, oocytes were processed for immunofluorescence microscopy. Caspase-3 was colored red in the laser confocal images. The bar is 12 µm and applies to all images. For quantification, the fluorescence intensity values in control oocytes injected with MC or IC were set as one and the values in oocytes injected with MM or IN were expressed relative to the values in control oocytes. Each treatment was repeated 3-4 times and each replicate contained 35-40 oocytes. a,b: Values with a different letter above bars differ significantly (P < 0.05).","file":"ikCkZYNqL7MJ7tTko_f6.tif","version":1,"optimized":true,"optimized_file":"ikCkZYNqL7MJ7tTko_f6.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures/ikCkZYNqL7MJ7tTko_f6.tif","optimized_urls":{"original":"/img?size=original&img=ikCkZYNqL7MJ7tTko_f6.png&v=1","hero":"/img?size=hero&img=ikCkZYNqL7MJ7tTko_f6.png&v=1","large":"/img?size=large&img=ikCkZYNqL7MJ7tTko_f6.png&v=1","medium":"/img?size=medium&img=ikCkZYNqL7MJ7tTko_f6.png&v=1","small":"/img?size=small&img=ikCkZYNqL7MJ7tTko_f6.png&v=1"}}],"journal":"aging"},"video_url":"https://youtu.be/668nUCeBHyY","feature":false,"advance":false,"display":true,"description":"Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget.","title":"Expression profiles and function analysis of microRNAs in postovulatory aging mouse oocytes","page_start":1186,"page_end":1201,"ids":{"pii":"101219","publisher-id":"101219","doi":"10.18632/aging.101219","pmid":"28394765"},"abstract":"<p>In this study, microRNA (miRNA) profiles in postovulatory aging mouse oocytes were analyzed by microarray screening and RT-qPCR. Hierarchical cluster analysis on the microarray data and KEGG pathway enrichment analysis on the mRNAs targeted by differentially expressed (DE) miRNAs between two adjacent egg-ages suggest that while only a mild alteration in miRNA expression occurred from 13 to 18 h, a great change took place from 18 to 24 h post hCG injection. Theoretical exploration on functions of the predicted target genes suggest that KEGG pathways enriched by 13-18 h DE miRNAs are correlated with early events of oocyte aging while pathways most enriched by 18-24 h or 24-30 h DE miRNAs are correlated with the late symptoms of aged oocytes. Experimental verification on functions of the key proteins predicted by the KEGG analysis and injection of miR-98 mimics or inhibitors further confirmed that miRNAs played stimulatory/inhibitory roles in postovulatory oocyte aging. In conclusion, marked changes in miRNA expression are associated with significant alterations in function and morphology of postovulatory aging oocytes.</p>","article_type":{"short_name":"research_paper","nlm_type":"research-article","plural":"Research Papers","name":"Research Paper"},"affiliations":["College of Animal Science and Veterinary Medicine, Shandong Agricultural University, Tai-an City 271018, P. R. China"],"dates":{"epub":"2017-04-08T04:00:00.000Z"},"history":{"received":"2017-03-03T05:00:00.000Z","accepted":"2017-03-28T04:00:00.000Z"},"keywords":["microRNA","oocyte","aging","signaling pathway","molecular function"],"coi":"","previous":{"files":{"pdf":{"file":"ikCkZYNqL7MJ7tTko.pdf","display":true},"xml":{"file":"ikCkZYNqL7MJ7tTko.xml","display":true},"figures":[{"id":"f1","label":"Figure 1","caption":"<b>A microarray assay of miRNA expression profiles and a KEGG pathway enrichment analysis of target mRNAs predicted from differentially-expressed (DE) miRNAs in mouse oocytes aging for different times.</b> (<b>A</b>) Heat map and cluster analysis of miRNA expression in oocytes aging for different times. Red indicates high relative expression and green indicates low relative expression. Fold changes greater than 2 (FC>2) were used as threshold for miRNA differential expression. (<b>B</b>) A table shows number of DE miRNAs, number of target mRNAs predicted from DE miRNAs and number of enriched KEGG pathways in oocytes aging for different times.","file":"ikCkZYNqL7MJ7tTko_f1.tif","version":1,"optimized":true,"optimized_file":"ikCkZYNqL7MJ7tTko_f1.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true}},{"id":"f2","label":"Figure 2","caption":"<b>RT-qPCR verification of microarray assay results for apoptosis-related miRNAs.</b> Each treatment was repeated 3-4 times and each replicate contained ~600 oocytes. a-c: Values with a different letter above bars differ significantly (P < 0.05).","file":"ikCkZYNqL7MJ7tTko_f2.tif","version":1,"optimized":true,"optimized_file":"ikCkZYNqL7MJ7tTko_f2.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true}},{"id":"f3","label":"Figure 3","caption":"<b>Levels of p-MAPK, TrkB, and ceramide expression in oocytes aging for different times.</b> Graphs <b>A</b>, <b>B</b> and <b>C</b> show quantification of p-MAPK, TrkB, and ceramide expression, respectively. For ceramide quantification, the fluorescence intensity value in oocytes recovered at 13 h post hCG injection was set as one and the other values were expressed relative to this value. Each treatment was repeated 3-4 times and each replicate contained 35-40 oocytes. a-c: Values with a different letter above bars differ significantly (P < 0.05). <b>D</b>, <b>E</b>, <b>F</b> and <b>G</b> are micrographs from laser confocal images showing expression of ceramide in oocytes recovered at different times after hCG injection. Ceramide was colored green in the laser confocal images. The bar is 18 µm and applies to all images.","file":"ikCkZYNqL7MJ7tTko_f3.tif","version":1,"optimized":true,"optimized_file":"ikCkZYNqL7MJ7tTko_f3.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true}},{"id":"f4","label":"Figure 4","caption":"<b>Effects of supplementation with U0126, ceramide or BDNF during in vitro aging on STAS of mouse oocytes.</b> Cumulus-denuded oocytes (DOs) recovered 13 h post hCG injection were used. For U0126 and BDNF treatment, the DOs were aged for 36 h in CZB medium supplemented with different concentrations of U0126 or BDNF before ethanol and 6-DMAP treatment for activation. For ceramide treatment, DOs were microinjected with 6 pl DMSO alone (control) or DMSO containing 1 mM ceramide and then aged for 36 h in CZB medium before ethanol and 6-DMAP treatment for activation. Each treatment was repeated 4-5 times with each replicate containing about 30 oocytes. a,b: Values with a different letter above bars differ significantly (P < 0.05).","file":"ikCkZYNqL7MJ7tTko_f4.tif","version":1,"optimized":true,"optimized_file":"ikCkZYNqL7MJ7tTko_f4.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true}},{"id":"f5","label":"Figure 5","caption":"<b>Activation rates and calcium stores in oocytes microinjected with miR-98 mimic (upper row) or inhibitor (lower row).</b> Freshly ovulated oocytes recovered at 13 h post hCG were injected with miR-98 mimic (MM) or miRNA mimic negative control (MC), or with miR-98 inhibitor (IN) or inhibitor negative control (IC), before aging culture in CZB medium. To observe activation, oocytes were treated with ethanol and 6-DMAP at 36 h (mimic) or 30 h (inhibitor) of aging culture, and activation was checked 6 h later. Each treatment was repeated 3 to 4 times and each replicate contained 35-40 oocytes. For calcium measurement, at 3 h and 36 h (mimic) or 30 h (inhibitor) of aging culture, oocytes were loaded with Fura-2 AM and the loaded oocytes were measured for calcium stores (ΔF340/380) using a Ca<sup>2+</sup> imaging system. Oocytes were monitored for 5 min to record baseline F340/380 ratio before ionomycin stimulation to release Ca<sup>2+</sup> into cytoplasm. Following ionomycin addition, oocytes were monitored for 20 min to record peak F340/380 ratio. The difference between peak and baseline F340/380 ratios represents the calcium stores (ΔF340/380) of an oocyte. Each treatment was repeated 3 to 4 times and each replicate contained 35-40 oocytes. a-c: Values with a different letter above bars differ significantly (P < 0.05).","file":"ikCkZYNqL7MJ7tTko_f5.tif","version":1,"optimized":true,"optimized_file":"ikCkZYNqL7MJ7tTko_f5.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true}},{"id":"f6","label":"Figure 6","caption":"<b>Caspase-3 expression in oocytes microinjected with miR-98 mimic or inhibitor.</b> Freshly ovulated oocytes recovered at 13 h post hCG were injected with miR-98 mimic (MM) or miRNA mimic negative control (MC), or with miR-98 inhibitor (IN) or inhibitor negative control (IC), before aging culture in CZB medium. At 36 h (mimic) or 30 h (inhibitor) of aging culture, oocytes were processed for immunofluorescence microscopy. Caspase-3 was colored red in the laser confocal images. The bar is 12 µm and applies to all images. For quantification, the fluorescence intensity values in control oocytes injected with MC or IC were set as one and the values in oocytes injected with MM or IN were expressed relative to the values in control oocytes. Each treatment was repeated 3-4 times and each replicate contained 35-40 oocytes. a,b: Values with a different letter above bars differ significantly (P < 0.05).","file":"ikCkZYNqL7MJ7tTko_f6.tif","version":1,"optimized":true,"optimized_file":"ikCkZYNqL7MJ7tTko_f6.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true}}]},"feature":false,"advance":false,"display":true,"title":"Expression profiles and function analysis of microRNAs in postovulatory aging mouse oocytes","page_start":1186,"page_end":1201,"ids":{"pii":"101219","publisher-id":"101219","doi":"10.18632/aging.101219","pmid":"28394765"},"abstract":"<p>In this study, microRNA (miRNA) profiles in postovulatory aging mouse oocytes were analyzed by microarray screening and RT-qPCR. Hierarchical cluster analysis on the microarray data and KEGG pathway enrichment analysis on the mRNAs targeted by differentially expressed (DE) miRNAs between two adjacent egg-ages suggest that while only a mild alteration in miRNA expression occurred from 13 to 18 h, a great change took place from 18 to 24 h post hCG injection. Theoretical exploration on functions of the predicted target genes suggest that KEGG pathways enriched by 13-18 h DE miRNAs are correlated with early events of oocyte aging while pathways most enriched by 18-24 h or 24-30 h DE miRNAs are correlated with the late symptoms of aged oocytes. Experimental verification on functions of the key proteins predicted by the KEGG analysis and injection of miR-98 mimics or inhibitors further confirmed that miRNAs played stimulatory/inhibitory roles in postovulatory oocyte aging. In conclusion, marked changes in miRNA expression are associated with significant alterations in function and morphology of postovulatory aging oocytes.</p>","article_type":{"short_name":"research_paper","nlm_type":"research-article","plural":"Research Papers","name":"Research Paper"},"affiliations":["College of Animal Science and Veterinary Medicine, Shandong Agricultural University, Tai-an City 271018, P. R. China"],"dates":{"epub":"2017-04-08T04:00:00.000Z"},"history":{"received":"2017-03-03T05:00:00.000Z","accepted":"2017-03-28T04:00:00.000Z"},"keywords":["microRNA","oocyte","aging","signaling pathway","molecular function"],"coi":"","authors":[{"name_first":"Tian-Yang","name_middle":"","name_last":"Wang","name_suffix":"","equal_contrib":true,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Jie","name_middle":"","name_last":"Zhang","name_suffix":"","equal_contrib":true,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Jiang","name_middle":"","name_last":"Zhu","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Hua-Yu","name_middle":"","name_last":"Lian","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Hong-Jie","name_middle":"","name_last":"Yuan","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Min","name_middle":"","name_last":"Gao","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Ming-Jiu","name_middle":"","name_last":"Luo","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Jing-He","name_middle":"","name_last":"Tan","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]}],"correspondence":[{"text":"Jing-He Tan","email":"tanjh@sdau.edu.cn"}],"section":"ThGWnHeyhxdRzxfbA","pub_status":null,"submissions":[{"submission_id":"HT4JPm5MYsNe7zNab","created_date":"2017-04-10T16:28:05.330Z","pub_status":"aheadofprint"}],"issue_id":"5CfAJ7st288NsGrFC","author_notes":null,"volume":9,"issue":"4","aop":false},"authors":[{"name_first":"Tian-Yang","name_middle":"","name_last":"Wang","name_suffix":"","equal_contrib":"*","affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Jie","name_middle":"","name_last":"Zhang","name_suffix":"","equal_contrib":"*","affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Jiang","name_middle":"","name_last":"Zhu","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Hua-Yu","name_middle":"","name_last":"Lian","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Hong-Jie","name_middle":"","name_last":"Yuan","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Min","name_middle":"","name_last":"Gao","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Ming-Jiu","name_middle":"","name_last":"Luo","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"Jing-He","name_middle":"","name_last":"Tan","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]}],"correspondence":[{"text":"Jing-He Tan","email":"tanjh@sdau.edu.cn"}],"pub_status":"ppublish","submissions":[{"submission_id":"HT4JPm5MYsNe7zNab","created_date":"2017-04-10T16:28:05.330Z","pub_status":"aheadofprint"},{"submission_id":"KPDTYnttsgrnZcjnZ","created_date":"2017-05-05T22:52:34.858Z","pub_status":"ppublish"}],"author_notes":null,"volume":9,"issue":{"volume":9,"issue":"4","pub_date":"2017-04-30T04:00:00.000+0000","date_settings":{"day":false,"month":true,"year":true},"display":true,"current":false,"caption":"<p>The cover for issue 4 of Aging features Figure 1, ''Scatter plots and density plots of LTL as a function of age for males and females residing in different countries\" from <a href=\"http://www.aging-us.com/article/101216/text\" target=\"_blank\">Steenstrup et al.</a></p>","issue_linkable":"4","cover":"5CfAJ7st288NsGrFC.png","prev_next":{"prev":{"volume":9,"issue":"3","issue_linkable":"3","param":"v9i3"},"next":{"volume":9,"issue":"5","issue_linkable":"5","param":"v9i5"}},"optimized":true,"optimized_file":"5CfAJ7st288NsGrFC.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true},"pages":{"start":1084,"end":1350},"coverPath":"https://s3-us-west-1.amazonaws.com/paperchase-aging/covers/5CfAJ7st288NsGrFC.png","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/covers_optimized/original/5CfAJ7st288NsGrFC.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/covers_optimized/hero/5CfAJ7st288NsGrFC.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/covers_optimized/large/5CfAJ7st288NsGrFC.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/covers_optimized/medium/5CfAJ7st288NsGrFC.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/covers_optimized/small/5CfAJ7st288NsGrFC.png"}},"aop":false,"pdfPageCount":12,"issue_pub_date_year":2017,"vi":"v9i4","equal_contribs":"*"},{"ids":{"pmid":"20157571","pmc":"2815741","pii":"100101","doi":"10.18632/aging.100101"},"title":"p53, sex, and aging: lessons from the fruit fly","advance":false,"volume":1,"issue":{"volume":1,"issue":"11","issue_linkable":"11","display":true,"cover":"hmEg7MQKMLbWjfo3Q.png","pub_date":"2009-11-01T07:00:00.000+0000","date_settings":{"day":false,"month":true,"year":true},"current":false,"caption":"","pages":{"start":881,"end":960},"optimized":true,"optimized_file":"hmEg7MQKMLbWjfo3Q.png","optimized_sizes":{"original":true,"hero":true,"large":true,"medium":true,"small":true,"xsmall":true},"prev_next":{"prev":{"_id":"e83C7xrecYb7rgDv4","volume":1,"issue":"10","issue_linkable":"10","param":"v1i10"},"next":{"_id":"Lim5Ndx6TGPx9xkBJ","volume":1,"issue":"12","issue_linkable":"12","param":"v1i12"}},"coverPath":"https://s3-us-west-1.amazonaws.com/paperchase-aging/covers/hmEg7MQKMLbWjfo3Q.png","optimized_urls":{"original":"https://s3-us-west-1.amazonaws.com/paperchase-aging/covers_optimized/original/hmEg7MQKMLbWjfo3Q.png","hero":"https://s3-us-west-1.amazonaws.com/paperchase-aging/covers_optimized/hero/hmEg7MQKMLbWjfo3Q.png","large":"https://s3-us-west-1.amazonaws.com/paperchase-aging/covers_optimized/large/hmEg7MQKMLbWjfo3Q.png","medium":"https://s3-us-west-1.amazonaws.com/paperchase-aging/covers_optimized/medium/hmEg7MQKMLbWjfo3Q.png","small":"https://s3-us-west-1.amazonaws.com/paperchase-aging/covers_optimized/small/hmEg7MQKMLbWjfo3Q.png","xsmall":"https://s3-us-west-1.amazonaws.com/paperchase-aging/covers_optimized/xsmall/hmEg7MQKMLbWjfo3Q.png"}},"page_start":881,"page_end":883,"keywords":["Drosophila melanogaster","sexual antagonistic pleoitropy","longevity"],"article_type":{"short_name":"news","nlm_type":"news","plural":"News","name":"News"},"description":"Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget.","authors":[{"name_first":"Jae H.","name_middle":"","name_last":"Hur","name_suffix":"","equal_contrib":false,"affiliations_numbers":[0],"author_notes_ids":[]},{"name_first":"David W.","name_middle":"","name_last":"Walker","name_suffix":"","equal_contrib":false,"ids":{},"affiliations_numbers":[0,1],"author_notes_ids":[]}],"affiliations":["Department of Physiological Science, University of California, Los Angeles, CA 90095, USA","Molecular Biology Institute, University of California, Los Angeles, CA 90095, USA"],"dates":{"epub":"2009-11-13T06:00:00.000Z"},"history":{"received":"2009-11-09T06:00:00.000Z","accepted":"2009-11-12T06:00:00.000Z"},"publisher":"Impact Journals LLC","video_url":"https://youtu.be/668nUCeBHyY","files":{"pdf":{"file":"9EdnXEakSw9F8pp8J.pdf","display":true,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/pdf/9EdnXEakSw9F8pp8J.pdf"},"xml":{"file":"9EdnXEakSw9F8pp8J.xml","display":true,"url":"https://s3-us-west-1.amazonaws.com/paperchase-aging/xml/9EdnXEakSw9F8pp8J.xml"},"journal":"aging"},"correspondence":[{"text":"David W. Walker, PhD, Department of Physiological Science, University of California, Los Angeles, 621 Charles E. Young Dr. South, Los Angeles, CA 90095-1527, USA","email":"davidwalker@ucla.edu"}],"display":true,"feature":false,"abstract":"","pdfPageCount":17,"issue_pub_date_year":2009,"vi":"v1i11"}]}

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(1482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home_HomePage__ = __webpack_require__(1325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home_HomePage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home_HomePage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_search_results_SearchResultsPage__ = __webpack_require__(1371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_search_results_SearchResultsPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_search_results_SearchResultsPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_editorial_board_EditorialBoardMembersPage__ = __webpack_require__(1309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_editorial_board_EditorialBoardMembersPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_editorial_board_EditorialBoardMembersPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_AuthorDetailsComponent__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_AuthorDetailsComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_shared_AuthorDetailsComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_editorial_board_HundredPlusPapersPage__ = __webpack_require__(1310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_editorial_board_HundredPlusPapersPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_editorial_board_HundredPlusPapersPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_publications_IssueDetailPage__ = __webpack_require__(1347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_publications_IssueDetailPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_publications_IssueDetailPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_publications_AdvanceOnlinePublicationsPage__ = __webpack_require__(1342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_publications_AdvanceOnlinePublicationsPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_publications_AdvanceOnlinePublicationsPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_publications_article_detail_ArticlePage__ = __webpack_require__(1351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_publications_article_detail_ArticlePage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_publications_article_detail_ArticlePage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_publications_article_detail_ArticleDetailPage__ = __webpack_require__(1350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_publications_article_detail_ArticleDetailPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_publications_article_detail_ArticleDetailPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_publications_article_detail_AuthorsPage__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_publications_article_detail_AuthorsPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_publications_article_detail_AuthorsPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_publications_article_detail_RelatedArticlesPage__ = __webpack_require__(1368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_publications_article_detail_RelatedArticlesPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_publications_article_detail_RelatedArticlesPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_publications_article_detail_ArticleDataPage__ = __webpack_require__(1349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_publications_article_detail_ArticleDataPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_publications_article_detail_ArticleDataPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_publications_article_detail_MetricsPage__ = __webpack_require__(1367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_publications_article_detail_MetricsPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_publications_article_detail_MetricsPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_publications_article_detail_GeographicsPage__ = __webpack_require__(1354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_publications_article_detail_GeographicsPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_publications_article_detail_GeographicsPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_publications_article_detail_DemographicsPage__ = __webpack_require__(1353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_publications_article_detail_DemographicsPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_publications_article_detail_DemographicsPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_publications_article_detail_InteractPage__ = __webpack_require__(1356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_publications_article_detail_InteractPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_publications_article_detail_InteractPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_publications_article_detail_InteractTablesPage__ = __webpack_require__(1357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_publications_article_detail_InteractTablesPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_publications_article_detail_InteractTablesPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_publications_article_detail_InteractFiguresPage__ = __webpack_require__(1355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_publications_article_detail_InteractFiguresPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_publications_article_detail_InteractFiguresPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_publications_article_detail_InteractVideoPage__ = __webpack_require__(1359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_publications_article_detail_InteractVideoPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_publications_article_detail_InteractVideoPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_publications_article_detail_InteractTriviaPage__ = __webpack_require__(1358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_publications_article_detail_InteractTriviaPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_publications_article_detail_InteractTriviaPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_publications_article_detail_MediaPage__ = __webpack_require__(1364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_publications_article_detail_MediaPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_publications_article_detail_MediaPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_publications_article_detail_MediaNewsPage__ = __webpack_require__(1363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_publications_article_detail_MediaNewsPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_publications_article_detail_MediaNewsPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_publications_article_detail_MediaTwitterPage__ = __webpack_require__(1365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_publications_article_detail_MediaTwitterPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_publications_article_detail_MediaTwitterPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_publications_article_detail_MediaFacebookPage__ = __webpack_require__(1360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_publications_article_detail_MediaFacebookPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_publications_article_detail_MediaFacebookPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_publications_article_detail_MediaYoutubePage__ = __webpack_require__(1366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_publications_article_detail_MediaYoutubePage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_publications_article_detail_MediaYoutubePage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_publications_article_detail_MediaLinkedInPage__ = __webpack_require__(1362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_publications_article_detail_MediaLinkedInPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_publications_article_detail_MediaLinkedInPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_publications_article_detail_MediaGooglePage__ = __webpack_require__(1361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_publications_article_detail_MediaGooglePage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_publications_article_detail_MediaGooglePage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_publications_ArchivedIssuesPage__ = __webpack_require__(1343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_publications_ArchivedIssuesPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_publications_ArchivedIssuesPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_publications_CollectionsPage__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_publications_CollectionsPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_publications_CollectionsPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_publications_CollectionDetailPage__ = __webpack_require__(1345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_publications_CollectionDetailPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_publications_CollectionDetailPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_publications_VideosPage__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_publications_VideosPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_publications_VideosPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_publications_AuthorInterviewsPage__ = __webpack_require__(1344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_publications_AuthorInterviewsPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__components_publications_AuthorInterviewsPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_for_authors_ForAuthorsPage__ = __webpack_require__(1311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_for_authors_ForAuthorsPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__components_for_authors_ForAuthorsPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_for_authors_for_authors_policies_ForAuthorsPoliciesPage__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_for_authors_for_authors_policies_ForAuthorsPoliciesPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__components_for_authors_for_authors_policies_ForAuthorsPoliciesPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_for_authors_for_authors_submission_ForAuthorsSubmissionPage__ = __webpack_require__(1324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_for_authors_for_authors_submission_ForAuthorsSubmissionPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__components_for_authors_for_authors_submission_ForAuthorsSubmissionPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_for_authors_for_authors_style_guide_ForAutorsStyleGuidePage__ = __webpack_require__(1319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_for_authors_for_authors_style_guide_ForAutorsStyleGuidePage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__components_for_authors_for_authors_style_guide_ForAutorsStyleGuidePage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_about_AnnouncementsPage__ = __webpack_require__(1302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_about_AnnouncementsPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__components_about_AnnouncementsPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_about_HistoryPage__ = __webpack_require__(1307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_about_HistoryPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__components_about_HistoryPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_about_EthicsAndMalpracticePage__ = __webpack_require__(1306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_about_EthicsAndMalpracticePage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__components_about_EthicsAndMalpracticePage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_about_AimsAndScopePage__ = __webpack_require__(1301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_about_AimsAndScopePage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__components_about_AimsAndScopePage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_about_EmployeesPage__ = __webpack_require__(1305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_about_EmployeesPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__components_about_EmployeesPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_about_CareersPage__ = __webpack_require__(1303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_about_CareersPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__components_about_CareersPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_about_ContactPage__ = __webpack_require__(1304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_about_ContactPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__components_about_ContactPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_about_SponsorshipRequestPage__ = __webpack_require__(1308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_about_SponsorshipRequestPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__components_about_SponsorshipRequestPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_StyleGuidePage__ = __webpack_require__(1300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_StyleGuidePage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__components_StyleGuidePage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_NotFoundPage__ = __webpack_require__(1299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_NotFoundPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__components_NotFoundPage__);





















































__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  mode: 'history',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_3__components_home_HomePage___default.a
  }, {
    path: '/editorial-board-members/',
    name: 'editorialBoardMembers',
    meta: { breadcrumbObject: { 'Editorial Board': '' } },
    component: __WEBPACK_IMPORTED_MODULE_5__components_editorial_board_EditorialBoardMembersPage___default.a
  }, {
    path: '/editorial-board-members/:id',
    name: 'editorialBoardMemberDetail',
    meta: { breadcrumbObject: { 'Editorial Board': '' } },
    component: __WEBPACK_IMPORTED_MODULE_6__components_shared_AuthorDetailsComponent___default.a
  }, {
    path: '/search-results/:request',
    name: 'searchResults',
    component: __WEBPACK_IMPORTED_MODULE_4__components_search_results_SearchResultsPage___default.a,
    meta: { filterIsAvailable: true },
    beforeEnter: function beforeEnter(to, from, next) {
      to.meta['breadcrumbObject'] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'Publications': '',
        'Search': { name: 'searchResults' }
      }, 'searched for: ' + to.params['request'] + ' ', '');
      next();
    }
  }, {
    path: '/100-plus-papers',
    name: 'hundredPlus',
    meta: {
      filterIsAvailable: true,
      breadcrumbObject: {
        'Editorial Board': ''
      }
    },
    component: __WEBPACK_IMPORTED_MODULE_7__components_editorial_board_HundredPlusPapersPage___default.a
  }, {
    path: 'current-issue',
    name: 'currentIssue',
    meta: { breadcrumbObject: { 'Publications': '' } },
    component: __WEBPACK_IMPORTED_MODULE_8__components_publications_IssueDetailPage___default.a
  }, {
    path: '/issue/volume/:volumeId/number/:issueId',
    name: 'issueDetail',
    component: __WEBPACK_IMPORTED_MODULE_8__components_publications_IssueDetailPage___default.a,
    beforeEnter: function beforeEnter(to, from, next) {
      to.meta['breadcrumbObject'] = {
        'Publications': ''
      };
      next();
    }
  }, {
    path: '/advance-online-publications',
    name: 'advanceOnlinePublications',
    meta: { filterIsAvailable: true },
    component: __WEBPACK_IMPORTED_MODULE_9__components_publications_AdvanceOnlinePublicationsPage___default.a,
    beforeEnter: function beforeEnter(to, from, next) {
      to.meta['breadcrumbObject'] = {
        'Publications': ''
      };
      next();
    }
  }, {
    path: '/article/pii/:pii',
    name: 'article-page',
    component: __WEBPACK_IMPORTED_MODULE_10__components_publications_article_detail_ArticlePage___default.a,
    children: [{
      path: 'detail',
      name: 'article-detail',
      component: __WEBPACK_IMPORTED_MODULE_11__components_publications_article_detail_ArticleDetailPage___default.a,
      beforeEnter: function beforeEnter(to, from, next) {
        to.meta['breadcrumbObject'] = {
          'Publications': ''
        };
        next();
      }
    }, {
      path: 'detail-authors',
      name: 'article-detail-authors',
      component: __WEBPACK_IMPORTED_MODULE_12__components_publications_article_detail_AuthorsPage___default.a,
      beforeEnter: function beforeEnter(to, from, next) {
        to.meta['breadcrumbObject'] = {
          'Publications': ''
        };
        next();
      }
    }, {
      path: 'detail-related',
      name: 'article-detail-related',
      component: __WEBPACK_IMPORTED_MODULE_13__components_publications_article_detail_RelatedArticlesPage___default.a,
      beforeEnter: function beforeEnter(to, from, next) {
        to.meta['breadcrumbObject'] = {
          'Publications': ''
        };
        next();
      }
    }, {
      path: 'detail-data',
      name: 'article-data',
      component: __WEBPACK_IMPORTED_MODULE_14__components_publications_article_detail_ArticleDataPage___default.a,
      beforeEnter: function beforeEnter(to, from, next) {
        to.meta['breadcrumbObject'] = {
          'Publications': ''
        };
        next();
      }
    }, {
      path: 'metrics',
      name: 'article-metrics',
      component: __WEBPACK_IMPORTED_MODULE_15__components_publications_article_detail_MetricsPage___default.a,
      beforeEnter: function beforeEnter(to, from, next) {
        to.meta['breadcrumbObject'] = {
          'Publications': ''
        };
        next();
      }
    }, {
      path: 'geographics',
      name: 'article-metrics-geographics',
      component: __WEBPACK_IMPORTED_MODULE_16__components_publications_article_detail_GeographicsPage___default.a
    }, {
      path: 'demographics',
      name: 'article-metrics-demographics',
      component: __WEBPACK_IMPORTED_MODULE_17__components_publications_article_detail_DemographicsPage___default.a
    }, {
      path: 'interact',
      name: 'article-interact',
      component: __WEBPACK_IMPORTED_MODULE_18__components_publications_article_detail_InteractPage___default.a
    }, {
      path: 'tables',
      name: 'article-interact-tables',
      component: __WEBPACK_IMPORTED_MODULE_19__components_publications_article_detail_InteractTablesPage___default.a
    }, {
      path: 'figures',
      name: 'article-interact-figures',
      component: __WEBPACK_IMPORTED_MODULE_20__components_publications_article_detail_InteractFiguresPage___default.a
    }, {
      path: 'video',
      name: 'article-interact-video',
      component: __WEBPACK_IMPORTED_MODULE_21__components_publications_article_detail_InteractVideoPage___default.a
    }, {
      path: 'trivia',
      name: 'article-interact-trivia',
      component: __WEBPACK_IMPORTED_MODULE_22__components_publications_article_detail_InteractTriviaPage___default.a
    }, {
      path: 'media',
      name: 'article-media',
      component: __WEBPACK_IMPORTED_MODULE_23__components_publications_article_detail_MediaPage___default.a
    }, {
      path: 'news',
      name: 'article-media-news',
      component: __WEBPACK_IMPORTED_MODULE_24__components_publications_article_detail_MediaNewsPage___default.a
    }, {
      path: 'twitter',
      name: 'article-media-twitter',
      component: __WEBPACK_IMPORTED_MODULE_25__components_publications_article_detail_MediaTwitterPage___default.a
    }, {
      path: 'facebook',
      name: 'article-media-facebook',
      component: __WEBPACK_IMPORTED_MODULE_26__components_publications_article_detail_MediaFacebookPage___default.a
    }, {
      path: 'youtube',
      name: 'article-media-youtube',
      component: __WEBPACK_IMPORTED_MODULE_27__components_publications_article_detail_MediaYoutubePage___default.a
    }, {
      path: 'linkedin',
      name: 'article-media-linkedin',
      component: __WEBPACK_IMPORTED_MODULE_28__components_publications_article_detail_MediaLinkedInPage___default.a
    }, {
      path: 'google',
      name: 'article-media-google',
      component: __WEBPACK_IMPORTED_MODULE_29__components_publications_article_detail_MediaGooglePage___default.a
    }]
  }, {
    path: '/archived-issues',
    name: 'archivedIssues',
    beforeEnter: function beforeEnter(to, from, next) {
      to.meta['breadcrumbObject'] = {
        'Publications': ''
      };
      next();
    },
    component: __WEBPACK_IMPORTED_MODULE_30__components_publications_ArchivedIssuesPage___default.a
  }, {
    path: '/collections',
    name: 'collections',
    beforeEnter: function beforeEnter(to, from, next) {
      to.meta['breadcrumbObject'] = {
        'Publications': ''
      };
      next();
    },
    component: __WEBPACK_IMPORTED_MODULE_31__components_publications_CollectionsPage___default.a
  }, {
    path: '/collections/:id',
    name: 'collectionDetail',
    meta: {
      filterIsAvailable: true,
      breadcrumbObject: {
        'Publications': '',
        'Collections': { name: 'collections' }
      }
    },
    component: __WEBPACK_IMPORTED_MODULE_32__components_publications_CollectionDetailPage___default.a
  }, {
    path: '/videos',
    name: 'videos',
    beforeEnter: function beforeEnter(to, from, next) {
      to.meta['breadcrumbObject'] = {
        'Publications': ''
      };
      next();
    },
    component: __WEBPACK_IMPORTED_MODULE_33__components_publications_VideosPage___default.a
  }, {
    path: '/author-interviews',
    name: 'authorInterviews',
    beforeEnter: function beforeEnter(to, from, next) {
      to.meta['breadcrumbObject'] = {
        'Publications': ''
      };
      next();
    },
    component: __WEBPACK_IMPORTED_MODULE_34__components_publications_AuthorInterviewsPage___default.a
  }, {
    path: '/for-authors',
    name: 'forAuthors',
    component: __WEBPACK_IMPORTED_MODULE_35__components_for_authors_ForAuthorsPage___default.a,
    children: [{
      path: 'policies',
      name: 'forAuthorsPolicies',
      meta: { breadcrumbObject: { 'For Authors': '' } },
      component: __WEBPACK_IMPORTED_MODULE_36__components_for_authors_for_authors_policies_ForAuthorsPoliciesPage___default.a
    }, {
      path: 'submission-guidelines',
      name: 'forAuthorsSubmissionGuidelines',
      meta: { breadcrumbObject: { 'For Authors': '' } },
      component: __WEBPACK_IMPORTED_MODULE_37__components_for_authors_for_authors_submission_ForAuthorsSubmissionPage___default.a
    }, {
      path: 'style-guidelines',
      name: 'forAuthorsStyleGuidelines',
      meta: { breadcrumbObject: { 'For Authors': '' } },
      component: __WEBPACK_IMPORTED_MODULE_38__components_for_authors_for_authors_style_guide_ForAutorsStyleGuidePage___default.a
    }]
  }, {
    path: '/announcements',
    name: 'announcements',
    meta: { breadcrumbObject: { 'About': '' } },
    component: __WEBPACK_IMPORTED_MODULE_39__components_about_AnnouncementsPage___default.a
  }, {
    path: '/history',
    name: 'history',
    meta: { breadcrumbObject: { 'About': '' } },
    component: __WEBPACK_IMPORTED_MODULE_40__components_about_HistoryPage___default.a
  }, {
    path: '/aims-and-scope',
    name: 'aimsAndScope',
    meta: { breadcrumbObject: { 'About': '' } },
    component: __WEBPACK_IMPORTED_MODULE_42__components_about_AimsAndScopePage___default.a
  }, {
    path: '/employees',
    name: 'employees',
    meta: { breadcrumbObject: { 'About': '' } },
    component: __WEBPACK_IMPORTED_MODULE_43__components_about_EmployeesPage___default.a
  }, {
    path: '/aims-and-scope',
    name: 'ethicsAndMalpractice',
    meta: { breadcrumbObject: { 'About': '' } },
    component: __WEBPACK_IMPORTED_MODULE_41__components_about_EthicsAndMalpracticePage___default.a
  }, {
    path: '/careers',
    name: 'careers',
    meta: { breadcrumbObject: { 'About/': '' } },
    component: __WEBPACK_IMPORTED_MODULE_44__components_about_CareersPage___default.a
  }, {
    path: '/contact',
    name: 'contact',
    meta: { breadcrumbObject: { 'About/': '' } },
    component: __WEBPACK_IMPORTED_MODULE_45__components_about_ContactPage___default.a
  }, {
    path: '/sponsorship-request',
    name: 'sponsorshipRequest',
    meta: { breadcrumbObject: { 'About/': '' } },
    component: __WEBPACK_IMPORTED_MODULE_46__components_about_SponsorshipRequestPage___default.a
  }, {
    path: '/style-guide',
    name: 'styleGuide',
    component: __WEBPACK_IMPORTED_MODULE_47__components_StyleGuidePage___default.a
  }, { path: '*',
    component: __WEBPACK_IMPORTED_MODULE_48__components_NotFoundPage___default.a
  }]
});

router.afterEach(function (to, from) {
  var collapseNav = document.getElementById('nav_collapse');
  if (collapseNav && collapseNav.classList.contains('show')) {
    router.app.$emit('collapse::toggle', 'nav_collapse');
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 189 */,
/* 190 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 191 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 192 */,
/* 193 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(395)
__webpack_require__(394)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(200),
  /* template */
  __webpack_require__(1429),
  /* scopeId */
  "data-v-50780142",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_touch_events__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_touch_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_touch_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_vue__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_icons__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_awesome_components_Icon__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_awesome_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_awesome_components_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_resize__ = __webpack_require__(194);










__webpack_require__(191);
__webpack_require__(27);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_vue_resize__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue2_touch_events___default.a, {
  disableClick: false,
  touchClass: 'touch',
  tapTolerance: 10,
  swipeTolerance: 30
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('icon', __WEBPACK_IMPORTED_MODULE_8_vue_awesome_components_Icon___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

var store = new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  state: {
    isEnhanced: localStorage.getItem('enhancedView') === 'true',
    dataUrlArticle: __webpack_require__(29),
    dataUrlArticleList: __webpack_require__(28),
    dataUrlIssue: __webpack_require__(30),

    dataUrlMockFile: __webpack_require__(31)
  },
  mutations: {
    setMode: function setMode(state, isEnhanced) {
      state.isEnhanced = isEnhanced;
      localStorage.setItem('enhancedView', isEnhanced);
    }
  }
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  store: store,
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_4__App___default.a }
});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var icons = {};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val) {
          if (!(val in icons)) {
            console.warn('Invalid prop: prop "name" is referring to an unregistered icon "' + val + '".' + '\nPlease make sure you have imported this icon before using it.');
            return false;
          }
          return true;
        }
        console.warn('Invalid prop: prop "name" is required.');
        return false;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        console.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    klass: function klass() {
      return {
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      };
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    },
    raw: function raw() {
      if (!this.icon || !this.icon.raw) {
        return null;
      }
      var raw = this.icon.raw;
      var ids = {};
      raw = raw.replace(/\s(?:xml:)?id=(["']?)([^"')\s]+)\1/g, function (match, quote, id) {
        var uniqueId = getId();
        ids[id] = uniqueId;
        return ' id="' + uniqueId + '"';
      });
      raw = raw.replace(/#(?:([^'")\s]+)|xpointer\(id\((['"]?)([^')]+)\2\)\))/g, function (match, rawId, _, pointerId) {
        var id = rawId || pointerId;
        if (!id || !ids[id]) {
          return match;
        }

        return '#' + ids[id];
      });

      return raw;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.icon) {
      return;
    }
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;
    });
    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
});

var cursor = 0xd4937;
function getId() {
  return 'fa-' + (cursor++).toString(16);
}

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_main_layout_header_area_HeaderAreaComponent__ = __webpack_require__(1330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_main_layout_header_area_HeaderAreaComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_main_layout_header_area_HeaderAreaComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_main_layout_sidebar_SidebarComponent__ = __webpack_require__(1341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_main_layout_sidebar_SidebarComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_main_layout_sidebar_SidebarComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_main_layout_shared_SortBarComponent__ = __webpack_require__(1339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_main_layout_shared_SortBarComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_main_layout_shared_SortBarComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_main_layout_footer_area_FooterAreaComponent__ = __webpack_require__(1326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_main_layout_footer_area_FooterAreaComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_main_layout_footer_area_FooterAreaComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_main_layout_header_area_HeaderBreadcrumbsComponent__ = __webpack_require__(1331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_main_layout_header_area_HeaderBreadcrumbsComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_main_layout_header_area_HeaderBreadcrumbsComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_main_layout_header_area_HeaderEventsBlockComponent__ = __webpack_require__(1332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_main_layout_header_area_HeaderEventsBlockComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_main_layout_header_area_HeaderEventsBlockComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_search_results_SearchFilterComponent__ = __webpack_require__(1370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_search_results_SearchFilterComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_search_results_SearchFilterComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_shared_OrderReprintComponent__ = __webpack_require__(1373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_shared_OrderReprintComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_shared_OrderReprintComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_shared_EnhancedViewComponent__ = __webpack_require__(1372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_shared_EnhancedViewComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_shared_EnhancedViewComponent__);












/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    HeaderArea: __WEBPACK_IMPORTED_MODULE_0__components_main_layout_header_area_HeaderAreaComponent___default.a,
    HeaderBreadcrumbs: __WEBPACK_IMPORTED_MODULE_4__components_main_layout_header_area_HeaderBreadcrumbsComponent___default.a,
    HeaderEventsBlock: __WEBPACK_IMPORTED_MODULE_5__components_main_layout_header_area_HeaderEventsBlockComponent___default.a,
    SearchFilter: __WEBPACK_IMPORTED_MODULE_6__components_search_results_SearchFilterComponent___default.a,
    SortBar: __WEBPACK_IMPORTED_MODULE_2__components_main_layout_shared_SortBarComponent___default.a,
    Sidebar: __WEBPACK_IMPORTED_MODULE_1__components_main_layout_sidebar_SidebarComponent___default.a,
    FooterArea: __WEBPACK_IMPORTED_MODULE_3__components_main_layout_footer_area_FooterAreaComponent___default.a,
    OrderReprintModal: __WEBPACK_IMPORTED_MODULE_7__components_shared_OrderReprintComponent___default.a,
    EnhancedView: __WEBPACK_IMPORTED_MODULE_8__components_shared_EnhancedViewComponent___default.a
  },
  data: function data() {
    return {
      sortBar: false,
      faviconPath: 'img/' + "oncoscience" + '/favicon.ico',
      title: 'Impact Journals - ' + 'Oncoscience'
    };
  },

  methods: {
    insertFavicon: function insertFavicon() {
      var src = __webpack_require__(182)("./" + this.faviconPath);
      document.head || (document.head = document.getElementsByTagName('head')[0]);
      var link = document.createElement('link');
      link.id = 'dynamic-favicon';
      link.rel = 'shortcut icon';
      link.href = src;
      document.head.appendChild(link);
    },
    insertTitle: function insertTitle() {
      document.title = this.title;
    },
    isArticlePage: function isArticlePage() {
      return this.$route.matched[0].name === 'article-page';
    }
  },
  created: function created() {
    this.insertFavicon();
    this.insertTitle();
  },

  name: 'app'
});

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'not-found',
  data: function data() {
    return {
      msg: ''
    };
  }
});

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'style-guide',
  data: function data() {
    return {
      msg: ''
    };
  }
});

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'aims-and-scope',
  data: function data() {
    return {
      siteName: 'Oncoscience'
    };
  }
});

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_TitleBlockComponent__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_TitleBlockComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_TitleBlockComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_CondensedIssueComponent__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_CondensedIssueComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_CondensedIssueComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_mixins_UtilityMixin__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_mixins_UtilityMixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_shared_mixins_UtilityMixin__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'announcements',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__components_shared_mixins_UtilityMixin___default.a],
  components: {
    TitleBlock: __WEBPACK_IMPORTED_MODULE_0__components_shared_TitleBlockComponent___default.a,
    CondensedIssue: __WEBPACK_IMPORTED_MODULE_1__components_shared_CondensedIssueComponent___default.a
  },
  data: function data() {
    return {
      siteName: 'Oncoscience',
      issues: [],
      announcements: [{
        postedDate: new Date(Date.now()),
        title: 'September 24-26, 2016',
        titlePrefix: 'Upcoming Event',
        description: 'Oncotarget journal is a Sponsor of Rare Cells in Circulation Gordon Research Conference, South Hadley, MA.',
        url: 'http://www.grc.org/programs.aspx?id=16786'
      }, {
        postedDate: new Date('2016-02-09'),
        title: 'August 7-12, 2016',
        titlePrefix: 'Upcoming Event',
        description: 'Oncotarget journal is a Sponsor of Rare Cells in Circulation Gordon Research Conference, South Hadley, MA.',
        url: 'http://www.grc.org/programs.aspx?id=16786'
      }, {
        postedDate: new Date('2015-02-09'),
        title: 'Starting August 2015, Oncotarget goes weekly',
        description: 'Our mission is to make scientific results rapidly and widely available. To maximize the impact of research via insightful review. To allow exceptional discoveries to be shared quickly. To eliminate the border between specialties. To link different fields of biomedical science. To foster applications of basic and clinical science to fight disease.'
      }]
    };
  },
  created: function created() {
    this.$http.get(this.$store.state.dataUrlArticleList).then(function (response) {
      this.issues = response.body.articles;
    }, function () {});
  }
});

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_TitleBlockComponent__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_TitleBlockComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_TitleBlockComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_mixins_UtilityMixin__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_mixins_UtilityMixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_mixins_UtilityMixin__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'careers',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__components_shared_mixins_UtilityMixin___default.a],
  components: {
    TitleBlock: __WEBPACK_IMPORTED_MODULE_0__components_shared_TitleBlockComponent___default.a
  },
  data: function data() {
    return {
      siteName: 'Oncoscience',
      positions: [{
        postedDate: new Date(Date.now()),
        title: 'Junior Editor',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi',
        url: 'http://www.grc.org/programs.aspx?id=16786'
      }, {
        postedDate: new Date('2016-02-09'),
        title: 'Junior Editor',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi',
        url: 'http://www.grc.org/programs.aspx?id=16786'
      }, {
        postedDate: new Date('2015-02-09'),
        title: 'Junior Editor',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi',
        url: 'http://www.grc.org/programs.aspx?id=16786'
      }]
    };
  }
});

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'contact',
  data: function data() {
    return {
      topicsList: [{
        text: 'Please choose a Department/Topic:*',
        value: ''
      }, 'Billing', 'Editorial', 'External Affairs', 'Altmetric', 'Other'],
      form: {
        topic: '',
        title: '',
        name: '',
        email: '',
        question: ''
      },
      siteName: 'Oncoscience'
    };
  }
});

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_AuthorComponent__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_AuthorComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_AuthorComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_mixins_UtilityMixin__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_mixins_UtilityMixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_mixins_UtilityMixin__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Author: __WEBPACK_IMPORTED_MODULE_0__components_shared_AuthorComponent___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__components_shared_mixins_UtilityMixin___default.a],
  name: 'employees',
  data: function data() {
    return {
      employees: []
    };
  },
  created: function created() {
    this.$http.get(this.$store.state.dataUrlMockFile).then(function (response) {
      this.employees = response.body.editorsInChief;
    }, function () {});
  }
});

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ethics-and-malpractice-content',
  data: function data() {
    return {
      siteName: 'Oncoscience'
    };
  }
});

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_about_EthicsAndMalpracticeComponent__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_about_EthicsAndMalpracticeComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_about_EthicsAndMalpracticeComponent__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    EthicsAndMalpracticeContent: __WEBPACK_IMPORTED_MODULE_0__components_about_EthicsAndMalpracticeComponent___default.a
  },
  name: 'ethics-and-malpractice',
  data: function data() {
    return {};
  }
});

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_TitleBlockComponent__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_TitleBlockComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_TitleBlockComponent__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'history',
  components: {
    TitleBlock: __WEBPACK_IMPORTED_MODULE_0__components_shared_TitleBlockComponent___default.a
  },
  data: function data() {
    return {
      siteName: 'Oncoscience'
    };
  }
});

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_TitleBlockComponent__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_TitleBlockComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_shared_TitleBlockComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_mixins_FormatersMixin__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_mixins_FormatersMixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_shared_mixins_FormatersMixin__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sponsorship-reqeuest',
  components: {
    TitleBlock: __WEBPACK_IMPORTED_MODULE_2__components_shared_TitleBlockComponent___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__components_shared_mixins_FormatersMixin___default.a],
  methods: {
    request: function request() {
      console.log(this.isValid);
      if (this.isValid) {
        console.log(JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.requestData)), this.isValid);
        this.attemptSubmit = false;
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.requestData).every(function (key) {
          this.requestData[key] = '';
          return true;
        }, this);
      } else {}
    }
  },
  computed: {
    validation: function validation() {
      var emailRE = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return {
        firstname: !!this.requestData.firstname.trim(),
        lastname: !!this.requestData.lastname.trim(),
        title: !!this.requestData.title.trim(),
        organization: !!this.requestData.organization.trim(),
        email: emailRE.test(this.requestData.email),
        phone: /^\(\d\d\d\)\s\d\d\d-\d\d\d\d$/.test(this.requestData.phone),
        topic: !!this.requestData.topic.trim(),
        date: /^\d\d\/[01]\d\/[0123]\d\/\d\d\d\d$/.test(this.requestData.date),
        description: !!this.requestData.description.trim()
      };
    },
    isValid: function isValid() {
      var validation = this.validation;
      this.attemptSubmit = true;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(validation).every(function (key) {
        return validation[key];
      });
    }
  },
  data: function data() {
    return {
      siteName: 'Oncoscience',
      attemptSubmit: false,
      requestData: {
        firstname: '',
        lastname: '',
        title: '',
        organization: '',
        email: '',
        phone: '',
        topic: '',
        date: '',
        description: ''
      }
    };
  }
});

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_AuthorComponent__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_AuthorComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_AuthorComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_mixins_UtilityMixin__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_mixins_UtilityMixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_mixins_UtilityMixin__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Author: __WEBPACK_IMPORTED_MODULE_0__components_shared_AuthorComponent___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__components_shared_mixins_UtilityMixin___default.a],
  name: 'editorial-board-members',
  data: function data() {
    return {
      editorsInChief: [],
      editorialBoardMembers: []
    };
  },
  created: function created() {
    this.$http.get(this.$store.state.dataUrlMockFile).then(function (response) {
      this.editorsInChief = response.body.editorsInChief;
      this.editorialBoardMembers = response.body.editorialBoardMembers;
    }, function () {});
  }
});

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_CondensedIssueComponent__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_CondensedIssueComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_CondensedIssueComponent__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hundered-plus-papers',
  components: {
    CondensedIssue: __WEBPACK_IMPORTED_MODULE_0__components_shared_CondensedIssueComponent___default.a
  },
  data: function data() {
    return {
      papersList: []
    };
  },

  props: {
    collectionId: {
      default: function _default() {
        return this.$route.params ? this.$route.params.id : undefined;
      }
    }
  },
  created: function created() {
    this.$http.get(this.$store.state.dataUrlArticleList).then(function (response) {
      this.papersList = response.body.articles;
    }, function () {});
  }
});

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_for_authors_for_authors_policies_ForAuthorsPoliciesPage__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_for_authors_for_authors_policies_ForAuthorsPoliciesPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_for_authors_for_authors_policies_ForAuthorsPoliciesPage__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'for-authors',
  components: {
    ForAuthorsPolicies: __WEBPACK_IMPORTED_MODULE_0__components_for_authors_for_authors_policies_ForAuthorsPoliciesPage___default.a
  },
  data: function data() {
    return {
      currentPage: 'Submission Guidelines'
    };
  }
});

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'for-authors-mobile-menu',
  props: ['anchorsList']
});

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'for-authors-page-side-menu',
  props: ['anchorsList'],
  methods: {
    handleScroll: function handleScroll() {
      if (!this.$store.state.isEnhanced) {
        var articleAnchors = document.getElementById('sidebar');
        var articleAnchorsParent = articleAnchors.parentElement;
        var scrollPosition = articleAnchors ? parseInt(articleAnchorsParent.offsetTop) : 0;

        this.scrolled = window.scrollY > scrollPosition + 135;

        articleAnchors.style.width = articleAnchorsParent.offsetWidth - 30 + 'px';
        if (this.scrolled && window.scrollY + articleAnchors.offsetHeight + 10 + 420 > (document.documentElement.scrollHeight || document.body.scrollHeight)) {
          articleAnchors.style.top = 'auto';
          articleAnchors.style.bottom = 20 + 'px';
          articleAnchors.style.position = 'absolute';
        } else if (this.scrolled) {
          articleAnchors.style.bottom = 'auto';
          articleAnchors.style.top = 60 + 'px';
          articleAnchors.style.position = 'fixed';
        } else {
          articleAnchors.style.position = 'static';
        }
      }
    }
  },
  mounted: function mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  }
});

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageMobileMenu__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageMobileMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageMobileMenu__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'for-authors-archiving-content',
  components: { ForAuthorsMobileMenu: __WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageMobileMenu___default.a },
  props: ['anchorsList'],
  data: function data() {
    return {
      siteName: 'Oncoscience'
    };
  }
});

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageMobileMenu__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageMobileMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageMobileMenu__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'for-authors-copyright-licensing-content',
  components: { ForAuthorsMobileMenu: __WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageMobileMenu___default.a },
  props: ['anchorsList'],
  data: function data() {
    return {
      siteName: 'Oncoscience'
    };
  }
});

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageMobileMenu__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageMobileMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageMobileMenu__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'for-authors-ethics-malpractice-content',
  components: { ForAuthorsMobileMenu: __WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageMobileMenu___default.a },
  props: ['anchorsList'],
  data: function data() {
    return {
      siteName: 'Oncoscience'
    };
  }
});

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageSideMenu__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageSideMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageSideMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_for_authors_for_authors_policies_ProcessingFeeContent__ = __webpack_require__(1317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_for_authors_for_authors_policies_ProcessingFeeContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_for_authors_for_authors_policies_ProcessingFeeContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_for_authors_for_authors_policies_PlagerismContent__ = __webpack_require__(1316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_for_authors_for_authors_policies_PlagerismContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_for_authors_for_authors_policies_PlagerismContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_for_authors_for_authors_policies_PeerReviewContent__ = __webpack_require__(1315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_for_authors_for_authors_policies_PeerReviewContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_for_authors_for_authors_policies_PeerReviewContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_for_authors_for_authors_policies_EthicsMalpracticeContent__ = __webpack_require__(1314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_for_authors_for_authors_policies_EthicsMalpracticeContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_for_authors_for_authors_policies_EthicsMalpracticeContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_for_authors_for_authors_policies_CopyrightLicensingContent__ = __webpack_require__(1313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_for_authors_for_authors_policies_CopyrightLicensingContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_for_authors_for_authors_policies_CopyrightLicensingContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_for_authors_for_authors_policies_ArchivingContent__ = __webpack_require__(1312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_for_authors_for_authors_policies_ArchivingContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_for_authors_for_authors_policies_ArchivingContent__);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ForAuthorsPageSideMenu: __WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageSideMenu___default.a,
    ForAuthorsProcessingFeeContent: __WEBPACK_IMPORTED_MODULE_1__components_for_authors_for_authors_policies_ProcessingFeeContent___default.a,
    ForAuthorsPlagerismContent: __WEBPACK_IMPORTED_MODULE_2__components_for_authors_for_authors_policies_PlagerismContent___default.a,
    ForAuthorsPeerReviewContent: __WEBPACK_IMPORTED_MODULE_3__components_for_authors_for_authors_policies_PeerReviewContent___default.a,
    ForAuthorsEthicsMalpracticeContent: __WEBPACK_IMPORTED_MODULE_4__components_for_authors_for_authors_policies_EthicsMalpracticeContent___default.a,
    ForAuthorsCopyrightLicensingContent: __WEBPACK_IMPORTED_MODULE_5__components_for_authors_for_authors_policies_CopyrightLicensingContent___default.a,
    ForAuthorsArchivingContent: __WEBPACK_IMPORTED_MODULE_6__components_for_authors_for_authors_policies_ArchivingContent___default.a
  },
  name: 'for-authors-policies',
  data: function data() {
    return {
      menuAnchorsList: [{ anchor: 'ethic', name: 'Ethics & Malpractice' }, { anchor: 'copyright', name: 'Copyright & Licensing' }, { anchor: 'peer-review', name: 'Peer Review' }, { anchor: 'plagerism', name: 'Plagerism' }, { anchor: 'processing-fee', name: 'Processing Fee' }, { anchor: 'archiving', name: 'Archiving' }]
    };
  }
});

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageMobileMenu__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageMobileMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageMobileMenu__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'for-authors-peer-review-content',
  components: { ForAuthorsMobileMenu: __WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageMobileMenu___default.a },
  props: ['anchorsList'],
  data: function data() {
    return {
      siteName: 'Oncoscience'
    };
  }
});

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageMobileMenu__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageMobileMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageMobileMenu__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'for-authors-plagerism-content',
  components: { ForAuthorsMobileMenu: __WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageMobileMenu___default.a },
  props: ['anchorsList'],
  data: function data() {
    return {
      siteName: 'Oncoscience'
    };
  }
});

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageMobileMenu__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageMobileMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageMobileMenu__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'for-authors-processing-fee-content',
  components: { ForAuthorsMobileMenu: __WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageMobileMenu___default.a },
  props: ['anchorsList'],
  data: function data() {
    return {
      siteName: 'Oncoscience'
    };
  }
});

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageMobileMenu__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageMobileMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageMobileMenu__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'for-authors-style-guide-content',
  components: { ForAuthorsMobileMenu: __WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageMobileMenu___default.a },
  props: {
    anchorsList: {
      default: []
    }
  }
});

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageSideMenu__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageSideMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageSideMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_for_authors_for_authors_style_guide_ForAutorsStyleGuideContent__ = __webpack_require__(1318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_for_authors_for_authors_style_guide_ForAutorsStyleGuideContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_for_authors_for_authors_style_guide_ForAutorsStyleGuideContent__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ForAuthorsPageSideMenu: __WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageSideMenu___default.a,
    ForAuthorsStyleGuideContent: __WEBPACK_IMPORTED_MODULE_1__components_for_authors_for_authors_style_guide_ForAutorsStyleGuideContent___default.a
  },
  name: 'for-authors-style-guide',
  data: function data() {
    return {
      anchorsList: [{ anchor: 'research', name: 'Research' }, { anchor: 'editorial', name: 'Editorial' }, { anchor: 'review', name: 'Review' }, { anchor: 'book-reader', name: 'Book Reader' }]
    };
  }
});

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageMobileMenu__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageMobileMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageMobileMenu__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'for-authors-file-submission-content',
  components: { ForAuthorsMobileMenu: __WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageMobileMenu___default.a },
  props: ['anchorsList'],
  data: function data() {
    return {
      siteName: 'Oncoscience'
    };
  }
});

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageMobileMenu__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageMobileMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageMobileMenu__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'for-authors-revisions-submission-content',
  components: { ForAuthorsMobileMenu: __WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageMobileMenu___default.a },
  props: ['anchorsList'],
  data: function data() {
    return {
      siteName: 'Oncoscience'
    };
  }
});

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageMobileMenu__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageMobileMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageMobileMenu__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'for-authors-special-submission-content',
  components: { ForAuthorsMobileMenu: __WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageMobileMenu___default.a },
  props: ['anchorsList'],
  data: function data() {
    return {
      siteName: 'Oncoscience'
    };
  }
});

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageMobileMenu__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageMobileMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageMobileMenu__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'for-authors-submission-content',
  components: { ForAuthorsMobileMenu: __WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageMobileMenu___default.a },
  props: ['anchorsList'],
  data: function data() {
    return {
      siteName: 'Oncoscience',
      site: "oncoscience"
    };
  }
});

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageSideMenu__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageSideMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageSideMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_for_authors_for_authors_submission_ForAuthorsSubmissionContent__ = __webpack_require__(1323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_for_authors_for_authors_submission_ForAuthorsSubmissionContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_for_authors_for_authors_submission_ForAuthorsSubmissionContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_for_authors_for_authors_submission_ForAuthorsSpecialSubmissionContent__ = __webpack_require__(1322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_for_authors_for_authors_submission_ForAuthorsSpecialSubmissionContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_for_authors_for_authors_submission_ForAuthorsSpecialSubmissionContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_for_authors_for_authors_submission_ForAuthorsRevisionsSubmissiomContent__ = __webpack_require__(1321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_for_authors_for_authors_submission_ForAuthorsRevisionsSubmissiomContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_for_authors_for_authors_submission_ForAuthorsRevisionsSubmissiomContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_for_authors_for_authors_submission_ForAuthorsFileSubmissionContent__ = __webpack_require__(1320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_for_authors_for_authors_submission_ForAuthorsFileSubmissionContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_for_authors_for_authors_submission_ForAuthorsFileSubmissionContent__);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ForAuthorsPageSideMenu: __WEBPACK_IMPORTED_MODULE_0__components_for_authors_ForAuthorsPageSideMenu___default.a,
    ForAuthorsSubmissionContent: __WEBPACK_IMPORTED_MODULE_1__components_for_authors_for_authors_submission_ForAuthorsSubmissionContent___default.a,
    ForAuthorsSpecialSubmissionContent: __WEBPACK_IMPORTED_MODULE_2__components_for_authors_for_authors_submission_ForAuthorsSpecialSubmissionContent___default.a,
    ForAuthorsRevisionsSubmissionContent: __WEBPACK_IMPORTED_MODULE_3__components_for_authors_for_authors_submission_ForAuthorsRevisionsSubmissiomContent___default.a,
    ForAuthorsFileSubmissionContent: __WEBPACK_IMPORTED_MODULE_4__components_for_authors_for_authors_submission_ForAuthorsFileSubmissionContent___default.a
  },
  name: 'for-authors-submission',
  data: function data() {
    return {
      menuAnchorsList: [{ anchor: 'submission', name: 'Submission' }, { anchor: 'files', name: 'Submission of Files' }, { anchor: 'special', name: 'Special Submissions' }, { anchor: 'revisions', name: 'Submitting Revisions' }]
    };
  }
});

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_TitleBlockComponent__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_TitleBlockComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_TitleBlockComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_FullIssueComponent__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_FullIssueComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_FullIssueComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_CondensedIssueComponent__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_CondensedIssueComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_shared_CondensedIssueComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home_SectionsBeyondOncologyComponent__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home_SectionsBeyondOncologyComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home_SectionsBeyondOncologyComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_home_SpecialCollectionArchivesComponent__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_home_SpecialCollectionArchivesComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_home_SpecialCollectionArchivesComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_mixins_UtilityMixin__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_mixins_UtilityMixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_shared_mixins_UtilityMixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_main_layout_sidebar_SidebarSignUpButtonComponent__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_main_layout_sidebar_SidebarSignUpButtonComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_main_layout_sidebar_SidebarSignUpButtonComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_main_layout_sidebar_SidebarCurrentIssueComponent__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_main_layout_sidebar_SidebarCurrentIssueComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_main_layout_sidebar_SidebarCurrentIssueComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_main_layout_sidebar_SidebarQuickLinksComponent__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_main_layout_sidebar_SidebarQuickLinksComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_main_layout_sidebar_SidebarQuickLinksComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_main_layout_sidebar_SidebarSponsorshipComponent__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_main_layout_sidebar_SidebarSponsorshipComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_main_layout_sidebar_SidebarSponsorshipComponent__);













/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    TitleBlock: __WEBPACK_IMPORTED_MODULE_0__components_shared_TitleBlockComponent___default.a,
    FullIssue: __WEBPACK_IMPORTED_MODULE_1__components_shared_FullIssueComponent___default.a,
    CondensedIssue: __WEBPACK_IMPORTED_MODULE_2__components_shared_CondensedIssueComponent___default.a,
    SectionsBeyondOncology: __WEBPACK_IMPORTED_MODULE_3__components_home_SectionsBeyondOncologyComponent___default.a,
    SpecialCollectionArchives: __WEBPACK_IMPORTED_MODULE_4__components_home_SpecialCollectionArchivesComponent___default.a,
    SidebarSignupButton: __WEBPACK_IMPORTED_MODULE_6__components_main_layout_sidebar_SidebarSignUpButtonComponent___default.a,
    SidebarCurrentIssue: __WEBPACK_IMPORTED_MODULE_7__components_main_layout_sidebar_SidebarCurrentIssueComponent___default.a,
    SidebarQuickLinks: __WEBPACK_IMPORTED_MODULE_8__components_main_layout_sidebar_SidebarQuickLinksComponent___default.a,
    SidebarSponsorship: __WEBPACK_IMPORTED_MODULE_9__components_main_layout_sidebar_SidebarSponsorshipComponent___default.a
  },
  name: 'home',
  mixins: [__WEBPACK_IMPORTED_MODULE_5__components_shared_mixins_UtilityMixin___default.a],
  data: function data() {
    return {
      siteName: 'Oncoscience',
      topArticle: {},
      issues: [],
      top100issues: []
    };
  },
  created: function created() {
    this.$store.state.isEnhanced = false;
    this.$http.get(this.$store.state.dataUrlArticle).then(function (response) {
      var topArticle = response.body;

      for (var i = 0; i < topArticle.files.figures.length; i++) {
        topArticle.files.figures[i].optimized_urls = {};
        topArticle.files.figures[i].optimized_urls['small'] = 'https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/' + topArticle.files.figures[i].optimized_file;
        topArticle.files.figures[i].optimized_urls['hero'] = 'https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/' + topArticle.files.figures[i].optimized_file;
      }
      this.topArticle = topArticle;
    }, function () {});

    this.$http.get(this.$store.state.dataUrlArticleList).then(function (response) {
      this.issues = response.body.articles;
    }, function () {});

    this.$http.get(this.$store.state.dataUrlArticleList).then(function (response) {
      this.top100issues = response.body.articles;
    }, function () {});
  }
});

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_TitleBlockComponent__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_TitleBlockComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_TitleBlockComponent__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sections-beyond-oncology',
  components: {
    TitleBlock: __WEBPACK_IMPORTED_MODULE_0__components_shared_TitleBlockComponent___default.a
  },
  data: function data() {
    return {};
  }
});

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_TitleBlockComponent__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_TitleBlockComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_TitleBlockComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_mixins_UtilityMixin__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_mixins_UtilityMixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_mixins_UtilityMixin__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'special-collection-archives',
  components: {
    TitleBlock: __WEBPACK_IMPORTED_MODULE_0__components_shared_TitleBlockComponent___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__components_shared_mixins_UtilityMixin___default.a],
  data: function data() {
    return {
      items: []
    };
  },
  created: function created() {
    this.$http.get(this.$store.state.dataUrlMockFile).then(function (response) {
      this.items = response.body.specialCollectionArchives;
    }, function () {});
  }
});

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_main_layout_footer_area_copyright_FooterCopyrightComponent__ = __webpack_require__(1327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_main_layout_footer_area_copyright_FooterCopyrightComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_main_layout_footer_area_copyright_FooterCopyrightComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_main_layout_shared_SocialMediaButtonsComponent__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_main_layout_shared_SocialMediaButtonsComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_main_layout_shared_SocialMediaButtonsComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_main_layout_footer_area_navigation_FooterNavigationComponent__ = __webpack_require__(1329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_main_layout_footer_area_navigation_FooterNavigationComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_main_layout_footer_area_navigation_FooterNavigationComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_main_layout_footer_area_journals_family_FooterJournalsFamilyComponent__ = __webpack_require__(1328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_main_layout_footer_area_journals_family_FooterJournalsFamilyComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_main_layout_footer_area_journals_family_FooterJournalsFamilyComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_mixins_UtilityMixin__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_mixins_UtilityMixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_shared_mixins_UtilityMixin__);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    FooterCopyright: __WEBPACK_IMPORTED_MODULE_0__components_main_layout_footer_area_copyright_FooterCopyrightComponent___default.a,
    SocialMediaButtons: __WEBPACK_IMPORTED_MODULE_1__components_main_layout_shared_SocialMediaButtonsComponent___default.a,
    FooterNavigation: __WEBPACK_IMPORTED_MODULE_2__components_main_layout_footer_area_navigation_FooterNavigationComponent___default.a,
    FooterJournalsFamily: __WEBPACK_IMPORTED_MODULE_3__components_main_layout_footer_area_journals_family_FooterJournalsFamilyComponent___default.a
  },
  name: 'footer-area',
  mixins: [__WEBPACK_IMPORTED_MODULE_4__components_shared_mixins_UtilityMixin___default.a],
  data: function data() {
    return {
      footerLogo: 'img/' + "oncoscience" + '/footer-logo.png',
      mediaLinks: {
        facebookUrl: 'https://www.facebook.com/Oncoscience-1665197337075767/',
        twitterUrl: 'https://twitter.com/OncoscienceJrnl',
        youTubeUrl: '',
        googlePlusUrl: 'https://plus.google.com/b/103027542121087451258/103027542121087451258',
        linkedInUrl: ''
      }
    };
  },

  methods: {
    scrollTop: function scrollTop() {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    }
  }
});

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'footer-copyright',
  data: function data() {
    return {};
  }
});

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_mixins_UtilityMixin__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_mixins_UtilityMixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_mixins_UtilityMixin__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'footer-journals-family',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_shared_mixins_UtilityMixin___default.a],
  data: function data() {
    return {
      rapamycinLogo: 'img/rapamycin-logo.png',
      siteName: 'Oncoscience',
      sitesList: [{ name: 'Oncotarget' }, { name: 'Oncoscience' }, { name: 'Aging' }, { name: 'Genes & Cancer' }]
    };
  },

  computed: {
    sortedList: function sortedList() {
      var _this = this;

      var indexOfFirestItem = 0;
      var result = this.sitesList.slice();
      var firstItem = this.sitesList.find(function (item, index) {
        if (item.name === _this.siteName) {
          indexOfFirestItem = index;
          return true;
        } else {
          return false;
        }
      });
      result.splice(indexOfFirestItem, 1);
      result.unshift(firstItem);
      return result;
    }
  }
});

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'footer-navigation',
  data: function data() {
    return {};
  }
});

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_main_layout_header_nav_HeaderNavComponent__ = __webpack_require__(1333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_main_layout_header_nav_HeaderNavComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_main_layout_header_nav_HeaderNavComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_main_layout_shared_SocialMediaButtonsComponent__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_main_layout_shared_SocialMediaButtonsComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_main_layout_shared_SocialMediaButtonsComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_mixins_UtilityMixin__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_mixins_UtilityMixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_shared_mixins_UtilityMixin__);






var navWrapper = document.getElementById('navWrapper');
var scrollPosition = navWrapper ? navWrapper.offsetTop : 0;

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SocialMediaButtons: __WEBPACK_IMPORTED_MODULE_1__components_main_layout_shared_SocialMediaButtonsComponent___default.a,
    HeaderNav: __WEBPACK_IMPORTED_MODULE_0__components_main_layout_header_nav_HeaderNavComponent___default.a
  },
  name: 'header-area',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__components_shared_mixins_UtilityMixin___default.a],
  data: function data() {
    var images = __webpack_require__(1485);
    return {
      headerText: '',
      logoPath: 'img/' + "oncoscience" + '/header-logo.png',
      backgroundPath: 'url(' + images('./header-img.png') + ')',
      issn: '2331-4737',
      mediaLinks: {
        facebookUrl: 'https://www.facebook.com/Oncoscience-1665197337075767/',
        twitterUrl: 'https://twitter.com/OncoscienceJrnl',
        youTubeUrl: '',
        googlePlusUrl: 'https://plus.google.com/b/103027542121087451258/103027542121087451258',
        linkedInUrl: ''
      },
      scrolled: false
    };
  },

  methods: {
    handleScroll: function handleScroll() {
      this.scrolled = window.scrollY > scrollPosition;
    }
  },
  created: function created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  }
});

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'header-breadcrumbs',
  data: function data() {
    return {
      breadcrumbs: []
    };
  },
  created: function created() {
    var self = this;
    this.$root.$on('changeBreadCrumbs', function (breabcrumbs) {
      self.breadcrumbs = breabcrumbs;
    });
  },

  watch: {
    '$route': function $route(to, from) {
      if (from.matched[0].name !== 'article-page') {
        this.breadcrumbs = [];
      }
    }
  },
  destroyed: function destroyed() {
    this.$root.$off('changeBreadCrumbs');
  },

  computed: {
    isArticlePage: function isArticlePage() {
      return this.$route.matched.filter(function (item) {
        return item.name === 'article-page';
      }).length;
    },
    isEditoralBoardPage: function isEditoralBoardPage() {
      return this.$route.name === 'editorialBoardMembers' || this.$route.name === 'editorialBoardMemberDetail';
    },
    isHundredPlusPage: function isHundredPlusPage() {
      return this.$route.name === 'hundredPlus';
    },
    isHomePage: function isHomePage() {
      return this.$route.name === 'Home';
    },
    linkText: function linkText() {
      if (this.isArticlePage) {
        return 'View Current Issue >';
      } else if (this.isEditoralBoardPage) {
        return 'View 100+ Papers from the Editorial Board >';
      } else if (this.isHundredPlusPage) {
        return 'View the Editorial Board >';
      } else {
        return 'View Archives >';
      }
    },
    routeName: function routeName() {
      if (this.isArticlePage) {
        return 'currentIssue';
      } else if (this.isEditoralBoardPage) {
        return 'hundredPlus';
      } else if (this.isHundredPlusPage) {
        return 'editorialBoardMembers';
      } else {
        return 'archivedIssues';
      }
    }
  }
});

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'header-events-block'
});

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_main_layout_header_nav_dropdowns_EditorialBoardDropdownComponent__ = __webpack_require__(1336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_main_layout_header_nav_dropdowns_EditorialBoardDropdownComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_main_layout_header_nav_dropdowns_EditorialBoardDropdownComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_main_layout_header_nav_dropdowns_PublicationsDropdownComponent__ = __webpack_require__(1338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_main_layout_header_nav_dropdowns_PublicationsDropdownComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_main_layout_header_nav_dropdowns_PublicationsDropdownComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_main_layout_header_nav_dropdowns_AboutDropdownComponent__ = __webpack_require__(1335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_main_layout_header_nav_dropdowns_AboutDropdownComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_main_layout_header_nav_dropdowns_AboutDropdownComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_main_layout_header_nav_dropdowns_ForAuthorsDropdownComponent__ = __webpack_require__(1337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_main_layout_header_nav_dropdowns_ForAuthorsDropdownComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_main_layout_header_nav_dropdowns_ForAuthorsDropdownComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_main_layout_header_nav_SearchFieldComponent__ = __webpack_require__(1334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_main_layout_header_nav_SearchFieldComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_main_layout_header_nav_SearchFieldComponent__);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    EditorialBoardDropdown: __WEBPACK_IMPORTED_MODULE_0__components_main_layout_header_nav_dropdowns_EditorialBoardDropdownComponent___default.a,
    PublicationsDropdown: __WEBPACK_IMPORTED_MODULE_1__components_main_layout_header_nav_dropdowns_PublicationsDropdownComponent___default.a,
    AboutDropdown: __WEBPACK_IMPORTED_MODULE_2__components_main_layout_header_nav_dropdowns_AboutDropdownComponent___default.a,
    ForAuthorsDropdown: __WEBPACK_IMPORTED_MODULE_3__components_main_layout_header_nav_dropdowns_ForAuthorsDropdownComponent___default.a,
    SearchField: __WEBPACK_IMPORTED_MODULE_4__components_main_layout_header_nav_SearchFieldComponent___default.a
  },
  name: 'header-nav'
});

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'search-field',
  data: function data() {
    return {
      searchRequest: ''
    };
  }
});

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'about-dropdown',
  methods: {
    goTo: function goTo(rO) {
      this.$router.push(rO);
    }
  }
});

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'editorial-board-dropdown',
  methods: {
    goTo: function goTo(rO) {
      this.$router.push(rO);
    }
  }
});

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'for-authors-dropdown',
  methods: {
    goTo: function goTo(rO) {
      this.$router.push(rO);
    }
  }
});

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'publications-dropdown',
  methods: {
    goTo: function goTo(rO) {
      this.$router.push(rO);
    }
  }
});

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'social-media-buttons',
  props: {
    mediaLinks: {
      type: Object,
      default: function _default() {
        return {
          facebookUrl: '',
          twitterUrl: '',
          linkedInUrl: '',
          googlePlusUrl: '',
          youTubeUrl: ''
        };
      }
    }
  },
  data: function data() {
    return {};
  }
});

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sort-bar',
  props: ['sortBar'],
  data: function data() {
    return {
      sortBy: ['Most Recently Added', 'Citations', 'Most Viewed', 'Altmetric'],
      queryParams: {
        sortBy: 'Most Recently Added'
      },
      defaultQueryParams: {
        sortBy: 'Most Recently Added'
      }
    };
  },

  methods: {
    onChangeQueryParams: function onChangeQueryParams(queryParam) {
      this.queryParams = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.queryParams, queryParam);
    }
  }
});

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'altmetric-stats-bar'
});

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_main_layout_sidebar_SidebarSignUpButtonComponent__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_main_layout_sidebar_SidebarSignUpButtonComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_main_layout_sidebar_SidebarSignUpButtonComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_main_layout_sidebar_AltmetricStatsBarComponent__ = __webpack_require__(1340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_main_layout_sidebar_AltmetricStatsBarComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_main_layout_sidebar_AltmetricStatsBarComponent__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sidebar-article-section',
  components: {
    SidebarSignupButton: __WEBPACK_IMPORTED_MODULE_0__components_main_layout_sidebar_SidebarSignUpButtonComponent___default.a,
    AltmetricStatsBar: __WEBPACK_IMPORTED_MODULE_1__components_main_layout_sidebar_AltmetricStatsBarComponent___default.a
  },
  data: function data() {
    return {
      keywords: [],
      pdf: false
    };
  },

  props: ['article'],
  computed: {
    keywordsFormatted: function keywordsFormatted() {
      return this.keywords.join(', ');
    }
  },
  methods: {
    getPdf: function getPdf() {
      if (this.pdf) {
        location.href = this.pdf;
      }
    }
  },
  mounted: function mounted() {
    this.keywords = this.article.keywords;
    if (this.article && this.article.files.pdf && this.article.files.pdf.display) {
      this.pdf = this.article.files.pdf.url;
    }
  }
});

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_TitleBlockComponent__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_TitleBlockComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_TitleBlockComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_about_EthicsAndMalpracticeComponent__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_about_EthicsAndMalpracticeComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_about_EthicsAndMalpracticeComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_main_layout_sidebar_SidebarSignUpButtonComponent__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_main_layout_sidebar_SidebarSignUpButtonComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_main_layout_sidebar_SidebarSignUpButtonComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_main_layout_sidebar_SidebarCurrentIssueComponent__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_main_layout_sidebar_SidebarCurrentIssueComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_main_layout_sidebar_SidebarCurrentIssueComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_main_layout_sidebar_SidebarQuickLinksComponent__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_main_layout_sidebar_SidebarQuickLinksComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_main_layout_sidebar_SidebarQuickLinksComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_main_layout_sidebar_SidebarSponsorshipComponent__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_main_layout_sidebar_SidebarSponsorshipComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_main_layout_sidebar_SidebarSponsorshipComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_mixins_UtilityMixin__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_mixins_UtilityMixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_shared_mixins_UtilityMixin__);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    EthicsAndMalpracticeContent: __WEBPACK_IMPORTED_MODULE_1__components_about_EthicsAndMalpracticeComponent___default.a,
    TitleBlock: __WEBPACK_IMPORTED_MODULE_0__components_shared_TitleBlockComponent___default.a,
    SidebarSignupButton: __WEBPACK_IMPORTED_MODULE_2__components_main_layout_sidebar_SidebarSignUpButtonComponent___default.a,
    SidebarCurrentIssue: __WEBPACK_IMPORTED_MODULE_3__components_main_layout_sidebar_SidebarCurrentIssueComponent___default.a,
    SidebarQuickLinks: __WEBPACK_IMPORTED_MODULE_4__components_main_layout_sidebar_SidebarQuickLinksComponent___default.a,
    SidebarSponsorship: __WEBPACK_IMPORTED_MODULE_5__components_main_layout_sidebar_SidebarSponsorshipComponent___default.a
  },
  name: 'sidebar',
  mixins: [__WEBPACK_IMPORTED_MODULE_6__components_shared_mixins_UtilityMixin___default.a],
  data: function data() {
    return {
      site: {
        name: 'Oncoscience',
        mobileSiteCoverUrl: 'MobileSiteCover.png'
      }
    };
  }
});

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_mixins_UtilityMixin__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_mixins_UtilityMixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_mixins_UtilityMixin__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sidebar-current-issue',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_shared_mixins_UtilityMixin___default.a],
  data: function data() {
    return {
      currentIssue: false
    };
  },
  created: function created() {
    this.$http.get(this.$store.state.dataUrlIssue).then(function (response) {
      var issue = response.body;
      var unique = function unique(arr) {
        var nArray = [];
        for (var i = 0; i < arr.length; i++) {
          if (!nArray.find(function (item) {
            return item.text === arr[i].text;
          })) {
            nArray.length += 1;
            nArray[nArray.length - 1] = arr[i];
          }
        }
        return nArray;
      };

      issue.rubricLinks = unique(issue.articles.map(function (item) {
        return {
          url: '/issue/volume/' + issue.volume + '/number/' + issue.issue + '#' + item.article_type.nlm_type,
          text: item.article_type.name
        };
      }));
      this.currentIssue = issue;
    }, function () {});
  }
});

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sidebar-quick-links',
  data: function data() {
    return {};
  }
});

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sidebarSignupButton',
  data: function data() {
    return {
      site: {
        name: 'Oncoscience',
        mobileSiteCoverUrl: 'MobileSiteCover.png'
      }
    };
  }
});

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_mixins_UtilityMixin__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_mixins_UtilityMixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_mixins_UtilityMixin__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sidebar-sponsorship',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_shared_mixins_UtilityMixin___default.a],
  data: function data() {
    return {
      sponsorshipItem: {
        dates: 'April 25-28, 2016',
        siteUrl: 'http://ivaoconf.com',
        coverUrl: 'SponsorshipCover.png',
        name: 'Biomedical Innovation in Healthy Longevity',
        city: 'Saint-Petersburg',
        country: 'Russia'
      }
    };
  }
});

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_CondensedIssueComponent__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_CondensedIssueComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_CondensedIssueComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_mixins_UtilityMixin__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_mixins_UtilityMixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_mixins_UtilityMixin__);




/* harmony default export */ __webpack_exports__["default"] = ({

  components: {
    CondensedIssue: __WEBPACK_IMPORTED_MODULE_0__components_shared_CondensedIssueComponent___default.a
  },
  name: 'advance-online-publications',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__components_shared_mixins_UtilityMixin___default.a],
  data: function data() {
    return {
      articles: []
    };
  },
  created: function created() {
    this.$http.get(this.$store.state.dataUrlArticleList).then(function (response) {
      this.articles = response.body.articles;
    }, function () {});
  }
});

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_mixins_UtilityMixin__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_mixins_UtilityMixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_mixins_UtilityMixin__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  mixins: [__WEBPACK_IMPORTED_MODULE_1__components_shared_mixins_UtilityMixin___default.a],
  name: 'archived-issues',
  data: function data() {
    return {
      issues: [],
      anchorsList: [],
      selectedAnchor: ''
    };
  },
  created: function created() {
    this.$http.get(this.$store.state.dataUrlIssue).then(function (response) {
      var issue = response.body;

      this.issues = [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, issue, { issue_linkable: '1' }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, issue, { issue_linkable: '2', issue: 999 })];

      this.anchorsList = this.issues.map(function (item) {
        return { text: 'Volume ' + item.volume + ', Number ' + item.issue + ' | ' + 'Pages: ' + item.pages.start + ' - ' + item.pages.end, anchor: 'anchor' + item.issue_linkable };
      });
      this.selectedAnchor = this.anchorsList[0] ? this.anchorsList[0].text : '';
    }, function () {});
  }
});

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_FullVideoComponent__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_FullVideoComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_FullVideoComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_CondensedVideoComponent__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_CondensedVideoComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_CondensedVideoComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_mixins_UtilityMixin__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_mixins_UtilityMixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_shared_mixins_UtilityMixin__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    FullVideo: __WEBPACK_IMPORTED_MODULE_0__components_shared_FullVideoComponent___default.a,
    CondensedVideo: __WEBPACK_IMPORTED_MODULE_1__components_shared_CondensedVideoComponent___default.a
  },
  name: 'author-interviews',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__components_shared_mixins_UtilityMixin___default.a],
  data: function data() {
    return {
      issues: []
    };
  },
  created: function created() {
    this.issues = this.getStaticPath('mocks/video-list.json').videos;
  },
  mounted: function mounted() {
    this.$parent.sortBar = {
      title: 'Interviews with Outstanding Authors',
      count: this.issues.length + ' Videos'
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.$parent.sortBar = false;
  }
});

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_CondensedIssueComponent__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_CondensedIssueComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_CondensedIssueComponent__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'collection-detail',
  components: {
    CondensedIssue: __WEBPACK_IMPORTED_MODULE_0__components_shared_CondensedIssueComponent___default.a
  },
  data: function data() {
    return {
      collectionArticles: []
    };
  },

  props: {
    collectionId: {
      default: function _default() {
        return this.$route.params ? this.$route.params.id : undefined;
      }
    }
  },
  created: function created() {
    this.$http.get(this.$store.state.dataUrlArticleList).then(function (response) {
      this.collectionArticles = response.body.articles;
    }, function () {});
  }
});

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_MediaContainerComponent__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_MediaContainerComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_MediaContainerComponent__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'collections',
  components: {
    MediaContainer: __WEBPACK_IMPORTED_MODULE_0__components_shared_MediaContainerComponent___default.a
  },
  data: function data() {
    return {
      collections: []
    };
  },
  created: function created() {
    this.$http.get(this.$store.state.dataUrlIssue).then(function (response) {
      var collection = response.body;

      collection['articlesData'] = collection.articles[3];
      collection['articlesData']['caption'] = collection.caption;
      collection['description'] = 'Description of the collection goes here dolor sit amet, consectetur adipiscing elit. ' + 'Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. ' + 'Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ' + 'ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget.';
      collection['id'] = parseInt(collection.issue);
      collection['articlesTypes'] = collection.articles.map(function (item) {
        return item.article_type.name;
      }).filter(function (item, i, allItems) {
        return i === allItems.indexOf(item);
      });
      this.collections = [collection, collection];
    }, function () {});
  }
});

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_main_layout_sidebar_SidebarSponsorshipComponent__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_main_layout_sidebar_SidebarSponsorshipComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_main_layout_sidebar_SidebarSponsorshipComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_main_layout_sidebar_SidebarCurrentIssueComponent__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_main_layout_sidebar_SidebarCurrentIssueComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_main_layout_sidebar_SidebarCurrentIssueComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_main_layout_sidebar_SidebarSignUpButtonComponent__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_main_layout_sidebar_SidebarSignUpButtonComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_main_layout_sidebar_SidebarSignUpButtonComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_TitleBlockComponent__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_TitleBlockComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_shared_TitleBlockComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_FullIssueComponent__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_FullIssueComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_shared_FullIssueComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_CondensedIssueComponent__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_CondensedIssueComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_shared_CondensedIssueComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_home_SectionsBeyondOncologyComponent__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_home_SectionsBeyondOncologyComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_home_SectionsBeyondOncologyComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_home_SpecialCollectionArchivesComponent__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_home_SpecialCollectionArchivesComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_home_SpecialCollectionArchivesComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_shared_mixins_UtilityMixin__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_shared_mixins_UtilityMixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_shared_mixins_UtilityMixin__);












/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SidebarSponsorship: __WEBPACK_IMPORTED_MODULE_0__components_main_layout_sidebar_SidebarSponsorshipComponent___default.a,
    SidebarCurrentIssue: __WEBPACK_IMPORTED_MODULE_1__components_main_layout_sidebar_SidebarCurrentIssueComponent___default.a,
    SidebarSignupButton: __WEBPACK_IMPORTED_MODULE_2__components_main_layout_sidebar_SidebarSignUpButtonComponent___default.a,
    TitleBlock: __WEBPACK_IMPORTED_MODULE_3__components_shared_TitleBlockComponent___default.a,
    FullIssue: __WEBPACK_IMPORTED_MODULE_4__components_shared_FullIssueComponent___default.a,
    CondensedIssue: __WEBPACK_IMPORTED_MODULE_5__components_shared_CondensedIssueComponent___default.a,
    SectionsBeyondOncology: __WEBPACK_IMPORTED_MODULE_6__components_home_SectionsBeyondOncologyComponent___default.a,
    SpecialCollectionArchives: __WEBPACK_IMPORTED_MODULE_7__components_home_SpecialCollectionArchivesComponent___default.a
  },
  name: 'issue-detail',
  mixins: [__WEBPACK_IMPORTED_MODULE_8__components_shared_mixins_UtilityMixin___default.a],
  data: function data() {
    return {
      siteName: 'Oncoscience',
      issue: {},
      topArticle: {},
      currentSection: false
    };
  },
  created: function created() {
    this.$http.get(this.$store.state.dataUrlArticle).then(function (response) {
      var topArticle = response.body;

      for (var i = 0; i < topArticle.files.figures.length; i++) {
        topArticle.files.figures[i].optimized_urls = {};
        topArticle.files.figures[i].optimized_urls['small'] = 'https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/' + topArticle.files.figures[i].optimized_file;
        topArticle.files.figures[i].optimized_urls['hero'] = 'https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/' + topArticle.files.figures[i].optimized_file;
      }
      this.topArticle = topArticle;
    }, function () {});

    this.$http.get(this.$store.state.dataUrlIssue).then(function (response) {
      var issue = response.body;
      var unique = function unique(arr) {
        var nArray = [];
        for (var i = 0; i < arr.length; i++) {
          if (!nArray.find(function (item) {
            return item.text === arr[i].text;
          })) {
            nArray.length += 1;
            nArray[nArray.length - 1] = arr[i];
          }
        }
        return nArray;
      };

      issue.rubricLinks = unique(issue.articles.map(function (item) {
        return {
          id: item.article_type.nlm_type,
          url: '/issue/volume/' + issue.volume + '/number/' + issue.issue + '#' + item.article_type.nlm_type,
          text: item.article_type.name
        };
      }));
      this.issue = issue;
      if (!issue.current) {
        this.$root.$emit('changeBreadCrumbs', [{
          text: 'Archived Issues',
          name: 'archivedIssues'
        }]);
      }
    }, function () {});
  },
  mounted: function mounted() {
    window.addEventListener('scroll', this.handleScroll);
    if (location.hash) {
      var self = this;
      setTimeout(function () {
        var anchor = self.$el.querySelector(location.hash);
        if (anchor) {
          window.scroll(0, anchor.getBoundingClientRect().top);
        }
      }, 1000);
    }
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  methods: {
    handleScroll: function handleScroll() {
      if (!this.$store.state.isEnhanced) {
        var issueAnchors = document.getElementById('issueAnchors');
        var issueAnchorsParent = issueAnchors ? issueAnchors.parentElement : null;
        var scrollPosition = issueAnchors ? parseInt(issueAnchorsParent.offsetTop) : 0;
        if (!issueAnchors) {
          return false;
        }

        this.scrolled = window.scrollY > scrollPosition + 200;

        if (this.scrolled && window.scrollY + issueAnchors.offsetHeight + 10 + 420 > (document.documentElement.scrollHeight || document.body.scrollHeight)) {
          issueAnchors.style.top = 'auto';
          issueAnchors.style.bottom = 20 + 'px';
          issueAnchors.style.position = 'absolute';
        } else if (this.scrolled) {
          issueAnchors.style.bottom = 'auto';
          issueAnchors.style.top = 60 + 'px';
          issueAnchors.style.position = 'fixed';
        } else {
          issueAnchors.style.position = 'static';
        }
      }
      this.highlightSection();
    },
    highlightSection: function highlightSection() {
      var currentSection = null;
      this.$el.querySelectorAll('.right-column section[id]').forEach(function (el) {
        if (el.getBoundingClientRect().top <= 10) {
          currentSection = el.id;
        } else if (!currentSection && el.getBoundingClientRect().top < (document.documentElement.clientHeight || document.body.clientHeight)) {
          currentSection = el.id;
          return false;
        }
      });
      this.currentSection = currentSection;
    }
  }
});

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_FullVideoComponent__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_FullVideoComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_FullVideoComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_CondensedVideoComponent__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_CondensedVideoComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_CondensedVideoComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_mixins_UtilityMixin__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_mixins_UtilityMixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_shared_mixins_UtilityMixin__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    FullVideo: __WEBPACK_IMPORTED_MODULE_0__components_shared_FullVideoComponent___default.a,
    CondensedVideo: __WEBPACK_IMPORTED_MODULE_1__components_shared_CondensedVideoComponent___default.a
  },
  name: 'videos',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__components_shared_mixins_UtilityMixin___default.a],
  data: function data() {
    return {
      issues: []
    };
  },
  created: function created() {
    this.issues = this.getStaticPath('mocks/video-list.json').videos;
  },
  mounted: function mounted() {
    this.$parent.sortBar = {
      title: 'Videos',
      count: this.issues.length + ' Videos'
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.$parent.sortBar = false;
  }
});

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_TitleBlockComponent__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_TitleBlockComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_TitleBlockComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_IssueAuthorsComponent__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_IssueAuthorsComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_shared_IssueAuthorsComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_mixins_UtilityMixin__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_mixins_UtilityMixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_shared_mixins_UtilityMixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_publications_article_detail_ArticleDetailComponent__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_publications_article_detail_ArticleDetailComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_publications_article_detail_ArticleDetailComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_article_items_ContentHeaderComponent__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_article_items_ContentHeaderComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_shared_article_items_ContentHeaderComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_article_items_ContentItemComponent__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_article_items_ContentItemComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_shared_article_items_ContentItemComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_main_layout_sidebar_SidebarArticleSectionComponent__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_main_layout_sidebar_SidebarArticleSectionComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_main_layout_sidebar_SidebarArticleSectionComponent__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'article-data',
  data: function data() {
    return {
      article: false,
      anchors: {}
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3__components_shared_mixins_UtilityMixin___default.a],
  components: {
    TitleBlock: __WEBPACK_IMPORTED_MODULE_1__components_shared_TitleBlockComponent___default.a,
    IssueAuthors: __WEBPACK_IMPORTED_MODULE_2__components_shared_IssueAuthorsComponent___default.a,
    ArticleDetailComponent: __WEBPACK_IMPORTED_MODULE_4__components_publications_article_detail_ArticleDetailComponent___default.a,
    ContentHeader: __WEBPACK_IMPORTED_MODULE_5__components_shared_article_items_ContentHeaderComponent___default.a,
    ContentItem: __WEBPACK_IMPORTED_MODULE_6__components_shared_article_items_ContentItemComponent___default.a,
    SidebarArticleSection: __WEBPACK_IMPORTED_MODULE_7__components_main_layout_sidebar_SidebarArticleSectionComponent___default.a
  },
  methods: {
    fillAnchors: function fillAnchors() {
      this.anchors['Tables'] = 'Tables';
      this.anchors['Figures'] = 'Figures';
      this.anchors['Videos'] = 'Videos';
    }
  },
  watch: {
    article: function article() {
      this.fillAnchors();
    }
  },
  created: function created() {
    if (this.$parent.article) {
      this.article = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$parent.article);
      this.fillAnchors();
    }
  }
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'articleDetailComponent',
  data: function data() {
    return {
      modalAnchors: {},
      options: [{ value: 'article-detail', text: 'Article' }, { value: 'article-detail-authors', text: 'Authors' }, { value: 'article-data', text: 'Data' }, { value: 'article-metrics', text: 'Metric' }, { value: 'article-detail-related', text: 'Related' }],
      selected: this.$route.name,
      scrolled: false
    };
  },
  mounted: function mounted() {
    this.$root.$once('show::modal', this.openNavModal);
    window.addEventListener('scroll', this.handleScroll);
    if (this.$route.hash && this.$el.querySelector(this.$route.hash)) {
      window.scroll(0, this.$el.querySelector(this.$route.hash).getBoundingClientRect().top);
    }
  },
  destroyed: function destroyed() {
    this.$root.$off('show::modal', this.openNavModal);
    window.removeEventListener('scroll', this.handleScroll);
  },

  methods: {
    isActive: function isActive(routeName) {
      return this.$route.name === routeName;
    },
    navigateTo: function navigateTo(name) {
      this.$parent.$parent.$el.classList.remove('transition-top', 'transition-bottom', 'transition-left');
      this.$parent.$parent.$el.classList.add('transition-right');
      this.$router.push({ name: name });
      if (this.$store.state.isEnhanced) {
        setTimeout(this.$parent.$parent.$parent.toggleHeader.bind(this.$parent.$parent.$parent), 1000);
      }
    },
    toggleToEnhanced: function toggleToEnhanced() {
      this.$store.commit('setMode', true);
      if (this.$route.name === 'article-data') {
        if (this.$route.hash === '#Videos') {
          this.$router.push({ name: 'article-interact-video', params: this.$route.params });
        } else if (this.$route.hash === '#Figures') {
          this.$router.push({ name: 'article-interact-figures', params: this.$route.params });
        } else {
          this.$router.push({ name: 'article-interact-tables', params: this.$route.params });
        }
      }
    },
    openNavModal: function openNavModal(modalName, anchors) {
      if (modalName !== 'navModal') {
        return;
      }
      this.modalAnchors = anchors;
    },
    jumpTo: function jumpTo(key) {
      this.$root.$emit('hide::modal', 'navModal');
      location.hash = key;
    },
    handleScroll: function handleScroll() {
      if (!this.$store.state.isEnhanced) {
        var articleAnchors = document.getElementById('articleAnchors');
        var articleAnchorsParent = articleAnchors.parentElement;
        var scrollPosition = articleAnchors ? parseInt(articleAnchorsParent.offsetTop) : 0;

        this.scrolled = window.scrollY > scrollPosition + 135;

        articleAnchors.style.width = articleAnchorsParent.offsetWidth - 30 + 'px';
        if (this.scrolled && window.scrollY + articleAnchors.offsetHeight + 10 + 420 > (document.documentElement.scrollHeight || document.body.scrollHeight)) {
          articleAnchors.style.top = 'auto';
          articleAnchors.style.bottom = 20 + 'px';
          articleAnchors.style.position = 'absolute';
        } else if (this.scrolled) {
          articleAnchors.style.bottom = 'auto';
          articleAnchors.style.top = 60 + 'px';
          articleAnchors.style.position = 'fixed';
        } else {
          articleAnchors.style.position = 'static';
        }
      }
      this.highlightSection();
    },
    handleResize: function handleResize() {
      this.handleScroll();
    },
    highlightSection: function highlightSection() {
      var currentSection = false;
      this.$el.querySelectorAll('section h1[id]').forEach(function (el) {
        if (el.getBoundingClientRect().top <= 0) {
          currentSection = el.id;
        } else if (!currentSection && el.getBoundingClientRect().top < (document.documentElement.clientHeight || document.body.clientHeight)) {
          currentSection = el.id;
          return false;
        }
      });
      this.$parent.currentSection = currentSection;
    }
  }
});

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_ArticleQuickLinksComponent__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_ArticleQuickLinksComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_ArticleQuickLinksComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_IssueAuthorsComponent__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_IssueAuthorsComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_shared_IssueAuthorsComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_mixins_UtilityMixin__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_mixins_UtilityMixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_shared_mixins_UtilityMixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_publications_article_detail_ArticleDetailComponent__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_publications_article_detail_ArticleDetailComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_publications_article_detail_ArticleDetailComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_article_items_ContentHeaderComponent__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_article_items_ContentHeaderComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_shared_article_items_ContentHeaderComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_article_items_ContentItemComponent__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_article_items_ContentItemComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_shared_article_items_ContentItemComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_main_layout_sidebar_SidebarArticleSectionComponent__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_main_layout_sidebar_SidebarArticleSectionComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_main_layout_sidebar_SidebarArticleSectionComponent__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'article-detail',
  data: function data() {
    return {
      currentSection: false,
      article: false,
      anchors: {}
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3__components_shared_mixins_UtilityMixin___default.a],
  components: {
    ArticleQuickLinks: __WEBPACK_IMPORTED_MODULE_1__components_shared_ArticleQuickLinksComponent___default.a,
    IssueAuthors: __WEBPACK_IMPORTED_MODULE_2__components_shared_IssueAuthorsComponent___default.a,
    ArticleDetailComponent: __WEBPACK_IMPORTED_MODULE_4__components_publications_article_detail_ArticleDetailComponent___default.a,
    ContentHeader: __WEBPACK_IMPORTED_MODULE_5__components_shared_article_items_ContentHeaderComponent___default.a,
    ContentItem: __WEBPACK_IMPORTED_MODULE_6__components_shared_article_items_ContentItemComponent___default.a,
    SidebarArticleSection: __WEBPACK_IMPORTED_MODULE_7__components_main_layout_sidebar_SidebarArticleSectionComponent___default.a
  },
  methods: {
    fillAnchors: function fillAnchors() {
      if (this.article && this.article.abstract) {
        this.anchors['Abstract'] = 'Abstract';
      }
      if (this.article && this.article.fullText && this.article.fullText.sections) {
        for (var i = 0; i < this.article.fullText.sections.length; i++) {
          if (this.article.fullText.sections[i].title) {
            this.anchors[this.article.fullText.sections[i].title.replace(/ /g, '')] = this.article.fullText.sections[i].title;
          }
        }
      }
      if (this.article && this.article.fullText && this.article.fullText.acks) {
        for (i = 0; i < this.article.fullText.acks.length; i++) {
          if (this.article.fullText.acks[i].title) {
            this.anchors[this.article.fullText.acks[i].title.replace(/ /g, '')] = this.article.fullText.acks[i].title;
          }
        }
      }
      if (this.article && this.article.fullText && this.article.fullText.footnotes) {
        for (i = 0; i < this.article.fullText.footnotes.length; i++) {
          if (this.article.fullText.footnotes[i].title) {
            this.anchors[this.article.fullText.footnotes[i].title.replace(/ /g, '')] = this.article.fullText.footnotes[i].title;
          }
        }
      }
      if (this.article && this.article.fullText && this.article.fullText.references) {
        this.anchors['References'] = 'References';
      }
    },
    openNav: function openNav() {
      this.$root.$emit('show::modal', 'navModal', this.anchors);
    }
  },
  created: function created() {
    this.$parent.$parent.prevPage = false;
    this.$parent.$parent.nextPage = { name: 'article-metrics' };
    this.$parent.$parent.prevSlide = false;
    this.$parent.$parent.nextSlide = { name: 'article-detail-authors' };
    if (this.$parent.article) {
      this.article = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$parent.article);
      this.fillAnchors();
    }
  },

  watch: {
    article: function article() {
      this.fillAnchors();
    }
  }
});

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'article-page',
  data: function data() {
    return {};
  },
  created: function created() {
    this.article = false;
    this.$http.get(this.$store.state.dataUrlArticle).then(function (response) {
      this.article = response.body;

      for (var i = 0; i < this.article.files.figures.length; i++) {
        this.article.files.figures[i].optimized_urls = {};
        this.article.files.figures[i].optimized_urls['small'] = 'https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/' + this.article.files.figures[i].optimized_file;
        this.article.files.figures[i].optimized_urls['hero'] = 'https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/' + this.article.files.figures[i].optimized_file;
      }
      this.$children[0].article = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.article);
      this.$root.$emit('changeBreadCrumbs', [{
        text: this.article.current ? 'Current Issue' : 'Archived Issues',
        name: this.article.current ? 'issueDetail' : 'archivedIssues',
        params: this.article.current ? {
          volumeId: this.article.volume,
          issueId: this.article.issue
        } : {}
      }, {
        text: 'Volume ' + this.article.volume + ', Number ' + this.article.issue,
        name: 'issueDetail',
        params: {
          volumeId: this.article.volume,
          issueId: this.article.issue
        }
      }, {
        text: this.article.article_type.name,
        name: 'issueDetail',
        hash: '#' + this.article.article_type.nlm_type,
        params: {
          volumeId: this.article.volume,
          issueId: this.article.issue
        }
      }]);
    });
  }
});

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_publications_article_detail_ArticleDetailComponent__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_publications_article_detail_ArticleDetailComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_publications_article_detail_ArticleDetailComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_AuthorComponent__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_AuthorComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_shared_AuthorComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_AuthorDetailsComponent__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_AuthorDetailsComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_shared_AuthorDetailsComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_IssueAuthorsComponent__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_IssueAuthorsComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_shared_IssueAuthorsComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_CondensedIssueComponent__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_CondensedIssueComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_shared_CondensedIssueComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_mixins_UtilityMixin__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_mixins_UtilityMixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_shared_mixins_UtilityMixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_main_layout_sidebar_SidebarArticleSectionComponent__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_main_layout_sidebar_SidebarArticleSectionComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_main_layout_sidebar_SidebarArticleSectionComponent__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'article-detail-authors',
  components: {
    ArticleDetailComponent: __WEBPACK_IMPORTED_MODULE_1__components_publications_article_detail_ArticleDetailComponent___default.a,
    Author: __WEBPACK_IMPORTED_MODULE_2__components_shared_AuthorComponent___default.a,
    AuthorDetails: __WEBPACK_IMPORTED_MODULE_3__components_shared_AuthorDetailsComponent___default.a,
    IssueAuthors: __WEBPACK_IMPORTED_MODULE_4__components_shared_IssueAuthorsComponent___default.a,
    CondensedIssue: __WEBPACK_IMPORTED_MODULE_5__components_shared_CondensedIssueComponent___default.a,
    SidebarArticleSection: __WEBPACK_IMPORTED_MODULE_7__components_main_layout_sidebar_SidebarArticleSectionComponent___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_6__components_shared_mixins_UtilityMixin___default.a],
  data: function data() {
    return {
      detailsMode: false,
      authorDetailId: undefined,
      article: false,
      currentIssueCutted: false,
      authors: [],

      correspondenceTo: [{ firstName: 'Name',
        lastName: 'LastName',
        email: 'text@test.com'
      }, { firstName: 'Name1',
        lastName: 'LastName1',
        email: 'text@test.com'
      }]
    };
  },

  methods: {
    openDetails: function openDetails(authorId) {
      this.detailsMode = true;
      this.authorDetailId = authorId;
    },
    closeDetails: function closeDetails() {
      this.detailsMode = false;
      this.authorDetailId = undefined;
    }
  },
  created: function created() {
    this.$parent.$parent.prevPage = false;
    this.$parent.$parent.nextPage = { name: 'article-metrics' };
    this.$parent.$parent.prevSlide = { name: 'article-detail' };
    this.$parent.$parent.nextSlide = { name: 'article-detail-related' };

    if (this.$parent.article) {
      this.article = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$parent.article);
    }

    this.$http.get(this.$store.state.dataUrlMockFile).then(function (response) {
      this.authors = response.body.editorsInChief;
    }, function () {});
  }
});

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'metrics',
  data: function data() {
    return {};
  },
  created: function created() {
    this.$parent.$parent.prevPage = { name: 'article-detail' };
    this.$parent.$parent.nextPage = { name: 'article-interact' };
    this.$parent.$parent.prevSlide = { name: 'article-metrics-geographics' };
    this.$parent.$parent.nextSlide = false;
  }
});

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'metrics',
  data: function data() {
    return {};
  },
  created: function created() {
    this.$parent.$parent.prevPage = { name: 'article-detail' };
    this.$parent.$parent.nextPage = { name: 'article-interact' };
    this.$parent.$parent.prevSlide = { name: 'article-metrics' };
    this.$parent.$parent.nextSlide = { name: 'article-metrics-demographics' };
  }
});

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'interact',
  data: function data() {
    return {
      article: false
    };
  },
  created: function created() {
    if (this.$parent.article) {
      this.article = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$parent.article);
    }
    this.$parent.$parent.prevPage = { name: 'article-metrics' };
    this.$parent.$parent.nextPage = { name: 'article-media' };
    this.$parent.$parent.prevSlide = { name: 'article-interact-tables' };
    this.$parent.$parent.nextSlide = { name: 'article-interact-video' };
  }
});

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_MediaContainerComponent__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_MediaContainerComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_MediaContainerComponent__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'interact',
  components: {
    MediaContainer: __WEBPACK_IMPORTED_MODULE_1__components_shared_MediaContainerComponent___default.a
  },
  data: function data() {
    return {
      article: false
    };
  },
  created: function created() {
    if (this.$parent.article) {
      this.article = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$parent.article);
    }
    this.$parent.$parent.prevPage = { name: 'article-metrics' };
    this.$parent.$parent.nextPage = { name: 'article-media' };
    this.$parent.$parent.prevSlide = false;
    this.$parent.$parent.nextSlide = { name: 'article-interact-tables' };
  }
});

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'interact',
  data: function data() {
    return {};
  },
  created: function created() {
    this.$parent.$parent.prevPage = { name: 'article-metrics' };
    this.$parent.$parent.nextPage = { name: 'article-media' };
    this.$parent.$parent.prevSlide = { name: 'article-interact' };
    this.$parent.$parent.nextSlide = { name: 'article-interact-figures' };
  }
});

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'interact',
  data: function data() {
    return {};
  },
  created: function created() {
    this.$parent.$parent.prevPage = { name: 'article-metrics' };
    this.$parent.$parent.nextPage = { name: 'article-media' };
    this.$parent.$parent.prevSlide = { name: 'article-interact-video' };
    this.$parent.$parent.nextSlide = false;
  }
});

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_InterviewVideoComponent__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_InterviewVideoComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_InterviewVideoComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_mixins_UtilityMixin__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_mixins_UtilityMixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_mixins_UtilityMixin__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'interact-video',
  components: {
    InterviewVideo: __WEBPACK_IMPORTED_MODULE_0__components_shared_InterviewVideoComponent___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__components_shared_mixins_UtilityMixin___default.a],
  data: function data() {
    return {
      issues: {}
    };
  },
  created: function created() {
    this.$parent.$parent.prevPage = { name: 'article-metrics' };
    this.$parent.$parent.nextPage = { name: 'article-media' };
    this.$parent.$parent.prevSlide = { name: 'article-interact-figures' };
    this.$parent.$parent.nextSlide = { name: 'article-interact-trivia' };

    this.issue = this.getStaticPath('mocks/video-list.json').videos[0];
  }
});

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'media',
  data: function data() {
    return {};
  },
  created: function created() {
    this.$parent.$parent.prevPage = { name: 'article-interact' };
    this.$parent.$parent.nextPage = false;
    this.$parent.$parent.prevSlide = { name: 'article-media-twitter' };
    this.$parent.$parent.nextSlide = { name: 'article-media-youtube' };
  }
});

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'media',
  data: function data() {
    return {};
  },
  created: function created() {
    this.$parent.$parent.prevPage = { name: 'article-interact' };
    this.$parent.$parent.nextPage = false;
    this.$parent.$parent.prevSlide = { name: 'article-media-linkedin' };
    this.$parent.$parent.nextSlide = false;
  }
});

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'media',
  data: function data() {
    return {};
  },
  created: function created() {
    this.$parent.$parent.prevPage = { name: 'article-interact' };
    this.$parent.$parent.nextPage = false;
    this.$parent.$parent.prevSlide = { name: 'article-media-youtube' };
    this.$parent.$parent.nextSlide = { name: 'article-media-google' };
  }
});

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'media',
  data: function data() {
    return {};
  },
  created: function created() {
    this.$parent.$parent.prevPage = { name: 'article-interact' };
    this.$parent.$parent.nextPage = false;
    this.$parent.$parent.prevSlide = { name: 'article-media' };
    this.$parent.$parent.nextSlide = { name: 'article-media-twitter' };
  }
});

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'media',
  data: function data() {
    return {};
  },
  created: function created() {
    this.$parent.$parent.prevPage = { name: 'article-interact' };
    this.$parent.$parent.nextPage = false;
    this.$parent.$parent.prevSlide = false;
    this.$parent.$parent.nextSlide = { name: 'article-media-news' };
  }
});

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'media',
  data: function data() {
    return {};
  },
  created: function created() {
    this.$parent.$parent.prevPage = { name: 'article-interact' };
    this.$parent.$parent.nextPage = false;
    this.$parent.$parent.prevSlide = { name: 'article-media-news' };
    this.$parent.$parent.nextSlide = { name: 'article-media-facebook' };
  }
});

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_InterviewVideoComponent__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_InterviewVideoComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_InterviewVideoComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_mixins_UtilityMixin__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_mixins_UtilityMixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_mixins_UtilityMixin__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'media',
  components: {
    InterviewVideo: __WEBPACK_IMPORTED_MODULE_0__components_shared_InterviewVideoComponent___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__components_shared_mixins_UtilityMixin___default.a],
  data: function data() {
    return {
      issues: {}
    };
  },
  created: function created() {
    this.$parent.$parent.prevPage = { name: 'article-interact' };
    this.$parent.$parent.nextPage = false;
    this.$parent.$parent.prevSlide = { name: 'article-media-facebook' };
    this.$parent.$parent.nextSlide = { name: 'article-media-linkedin' };

    this.issue = this.getStaticPath('mocks/video-list.json').videos[0];
  }
});

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_IssueAuthorsComponent__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_IssueAuthorsComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_IssueAuthorsComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_publications_article_detail_ArticleDetailComponent__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_publications_article_detail_ArticleDetailComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_publications_article_detail_ArticleDetailComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_main_layout_sidebar_SidebarArticleSectionComponent__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_main_layout_sidebar_SidebarArticleSectionComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_main_layout_sidebar_SidebarArticleSectionComponent__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'metrics',
  components: {
    IssueAuthors: __WEBPACK_IMPORTED_MODULE_1__components_shared_IssueAuthorsComponent___default.a,
    ArticleDetailComponent: __WEBPACK_IMPORTED_MODULE_2__components_publications_article_detail_ArticleDetailComponent___default.a,
    SidebarArticleSection: __WEBPACK_IMPORTED_MODULE_3__components_main_layout_sidebar_SidebarArticleSectionComponent___default.a
  },
  data: function data() {
    return {
      article: false
    };
  },
  created: function created() {
    this.$parent.$parent.prevPage = { name: 'article-detail' };
    this.$parent.$parent.nextPage = { name: 'article-interact' };
    this.$parent.$parent.prevSlide = false;
    this.$parent.$parent.nextSlide = { name: 'article-metrics-geographics' };
    if (this.$store.state.isEnhanced) {
      this.$parent.$parent.toggleHeader();
    }
    if (this.$parent.article) {
      this.article = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$parent.article);
    }
  }
});

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_IssueAuthorsComponent__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_IssueAuthorsComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_IssueAuthorsComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_publications_article_detail_ArticleDetailComponent__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_publications_article_detail_ArticleDetailComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_publications_article_detail_ArticleDetailComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_CondensedIssueComponent__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_CondensedIssueComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_shared_CondensedIssueComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_mixins_UtilityMixin__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_mixins_UtilityMixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_shared_mixins_UtilityMixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_main_layout_sidebar_SidebarArticleSectionComponent__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_main_layout_sidebar_SidebarArticleSectionComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_main_layout_sidebar_SidebarArticleSectionComponent__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'article-detail-related',
  components: {
    IssueAuthors: __WEBPACK_IMPORTED_MODULE_1__components_shared_IssueAuthorsComponent___default.a,
    ArticleDetailComponent: __WEBPACK_IMPORTED_MODULE_2__components_publications_article_detail_ArticleDetailComponent___default.a,
    CondensedIssue: __WEBPACK_IMPORTED_MODULE_3__components_shared_CondensedIssueComponent___default.a,
    SidebarArticleSection: __WEBPACK_IMPORTED_MODULE_5__components_main_layout_sidebar_SidebarArticleSectionComponent___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_4__components_shared_mixins_UtilityMixin___default.a],
  data: function data() {
    return {
      issues: [],
      article: false,
      currentIssueCutted: false
    };
  },
  created: function created() {
    this.$parent.$parent.prevPage = false;
    this.$parent.$parent.nextPage = { name: 'article-metrics' };
    this.$parent.$parent.prevSlide = { name: 'article-detail-authors' };
    this.$parent.$parent.nextSlide = false;

    this.$http.get(this.$store.state.dataUrlArticleList).then(function (response) {
      this.issues = response.body.articles;
    }, function () {});

    if (this.$parent.article) {
      this.article = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$parent.article);
    }
  }
});

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'filter-label',
  props: ['paramName'],
  data: function data() {
    return {
      labels: {
        paperType: 'Paper Type',
        author: 'Author',
        keyword: 'Keyword',
        vol: 'Volume',
        issue: 'Issue',
        date: 'Date'
      }
    };
  },

  methods: {
    remove: function remove() {
      this.$emit('remove', this.paramName);
    }
  }
});

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_search_results_FilterLabelComponent__ = __webpack_require__(1369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_search_results_FilterLabelComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_search_results_FilterLabelComponent__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'search-filter',
  components: { FilterLabel: __WEBPACK_IMPORTED_MODULE_2__components_search_results_FilterLabelComponent___default.a },
  data: function data() {
    return {
      totalItemsCount: 40,
      filteredItemsCount: 12,
      queryParams: {
        show: 'all',
        paperType: '',
        author: '',
        keyword: '',
        vol: '',
        issue: '',
        date: '',
        sortBy: 'Most Recently Added'
      },
      defaultQueryParams: {
        show: 'all',
        paperType: '',
        author: '',
        keyword: '',
        vol: '',
        issue: '',
        date: '',
        sortBy: 'Most Recently Added'
      },
      sortBy: ['Most Recently Added', 'Citations', 'Most Viewed', 'Altmetric'],

      paperTypes: [{ text: 'Paper Type', value: '' }, 'Test', 'Test 1', 'Test 2'],
      authors: [{ text: 'Author', value: '' }, 'Author 1', 'Author 2', 'Author 3'],
      keywords: [{ text: 'Keyword', value: '' }, 'Keyword 1', 'Keyword 2', 'Keyword 3'],
      volumes: [{ text: 'Vol', value: '' }, 1, 3, 4],
      issues: [{ text: 'Issue', value: '' }, 120, 123, 121],
      title: {
        advanceOnlinePublications: 'Advance Online Publications',
        collectionDetail: 'Cover Papers',
        searchResults: 'Search Results',
        hundredPlus: '100+ Papers from the Editorial Board'
      }
    };
  },

  methods: {
    onChangeQueryParams: function onChangeQueryParams(queryParam) {
      this.queryParams = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.queryParams, queryParam);
    },
    removeFilter: function removeFilter(paramName) {
      this.queryParams[paramName] = '';
      this.queryParams = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.queryParams);
    },
    clearFilters: function clearFilters() {
      this.queryParams = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.defaultQueryParams);
    }
  },
  watch: {
    'queryParams': function queryParams() {
      this.$router.push({ query: this.queryParams });
    },
    '$route.params.request': function $routeParamsRequest(changed) {
      this.$route.meta['breadcrumbObject'] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'Publications': '',
        'Search': { name: 'searchResults' }
      }, 'searched for: ' + changed + ' ', '');
      this.clearFilters();
    }
  }
});

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'search-results',
  data: function data() {
    return {
      currentPage: 2,
      queryParams: {}
    };
  },

  watch: {
    '$route.query': function $routeQuery(changedParams) {
      this.queryParams = changedParams;
    }
  }
});

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'article-quick-links',
  props: ['article'],
  methods: {
    setEnhancedView: function setEnhancedView(isEnhanced, routeParams) {
      this.$store.commit('setMode', isEnhanced);
      if (routeParams) {
        this.$router.push(routeParams);
      }
    },
    toggleAbstract: function toggleAbstract() {
      if (this.$parent.toggleAbstract) {
        this.$parent.toggleAbstract();
      }
    }
  }
});

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_mixins_UtilityMixin__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_mixins_UtilityMixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_mixins_UtilityMixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_main_layout_shared_SocialMediaButtonsComponent__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_main_layout_shared_SocialMediaButtonsComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_main_layout_shared_SocialMediaButtonsComponent__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'author',
  props: ['author'],
  components: { SocialMediaButtons: __WEBPACK_IMPORTED_MODULE_1__components_main_layout_shared_SocialMediaButtonsComponent___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_shared_mixins_UtilityMixin___default.a],
  data: function data() {
    return {
      msg: ''
    };
  }
});

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_TitleBlockComponent__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_TitleBlockComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_TitleBlockComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_mixins_UtilityMixin__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_mixins_UtilityMixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_mixins_UtilityMixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_CondensedIssueComponent__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_CondensedIssueComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_shared_CondensedIssueComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_main_layout_shared_SocialMediaButtonsComponent__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_main_layout_shared_SocialMediaButtonsComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_main_layout_shared_SocialMediaButtonsComponent__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'author-details',
  components: {
    SocialMediaButtons: __WEBPACK_IMPORTED_MODULE_3__components_main_layout_shared_SocialMediaButtonsComponent___default.a,
    CondensedIssue: __WEBPACK_IMPORTED_MODULE_2__components_shared_CondensedIssueComponent___default.a,
    TitleBlock: __WEBPACK_IMPORTED_MODULE_0__components_shared_TitleBlockComponent___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__components_shared_mixins_UtilityMixin___default.a],
  props: {
    authorId: {
      default: function _default() {
        return this.$route.params ? this.$route.params.id : undefined;
      }
    }
  },
  data: function data() {
    return {
      author: {
        photoUrl: ''
      },
      authorInfo: [],
      top100Papers: [],
      authorsIssues: [],
      siteName: 'Oncoscience'
    };
  },
  created: function created() {
    this.$http.get(this.$store.state.dataUrlMockFile).then(function (response) {
      this.author = response.body.editorsInChief[this.authorId];
    }, function () {});

    this.authorInfo = [this.author.location, this.author.education, this.author.affiliation, this.author.institution];

    this.$http.get(this.$store.state.dataUrlArticleList).then(function (response) {
      this.top100Papers = response.body.articles;
    }, function () {});

    this.$http.get(this.$store.state.dataUrlArticleList).then(function (response) {
      this.authorsIssues = response.body.articles;
    }, function () {});

    this.$on('view-all', function (id) {
      if (id === 'top100Papers') {} else if (id === 'authorsIssues') {}
    });
  }
});

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_ArticleQuickLinksComponent__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_ArticleQuickLinksComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_ArticleQuickLinksComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_IssueAuthorsComponent__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_IssueAuthorsComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_IssueAuthorsComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_mixins_UtilityMixin__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_mixins_UtilityMixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_shared_mixins_UtilityMixin__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ArticleQuickLinks: __WEBPACK_IMPORTED_MODULE_0__components_shared_ArticleQuickLinksComponent___default.a,
    IssueAuthors: __WEBPACK_IMPORTED_MODULE_1__components_shared_IssueAuthorsComponent___default.a
  },
  name: 'condensed-issue',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__components_shared_mixins_UtilityMixin___default.a],
  props: ['issue', 'smallMode', 'hideType'],
  computed: {
    coverUrl: function coverUrl() {
      return this.issue.issue && this.issue.issue.cover ? this.issue.issue.optimized_urls.small : false;
    }
  },
  methods: {
    toggleAbstract: function toggleAbstract() {
      this.isAbstractShow = !this.isAbstractShow;
    }
  },
  data: function data() {
    return {
      isAbstractShow: false
    };
  }
});

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_ArticleQuickLinksComponent__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_ArticleQuickLinksComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_ArticleQuickLinksComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_IssueAuthorsComponent__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_IssueAuthorsComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_IssueAuthorsComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_MediaPlayerComponent__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_MediaPlayerComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_shared_MediaPlayerComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_mixins_UtilityMixin__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_mixins_UtilityMixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_shared_mixins_UtilityMixin__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'condensed-video',
  props: ['issue', 'showKeywords'],
  mixins: [__WEBPACK_IMPORTED_MODULE_3__components_shared_mixins_UtilityMixin___default.a],
  components: {
    ArticleQuickLinks: __WEBPACK_IMPORTED_MODULE_0__components_shared_ArticleQuickLinksComponent___default.a,
    IssueAuthors: __WEBPACK_IMPORTED_MODULE_1__components_shared_IssueAuthorsComponent___default.a,
    MediaPlayer: __WEBPACK_IMPORTED_MODULE_2__components_shared_MediaPlayerComponent___default.a
  }
});

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_mixins_UtilityMixin__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_mixins_UtilityMixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_mixins_UtilityMixin__);




var swichPanel = document.getElementById('swichPanel');
var scrollPosition = swichPanel ? swichPanel.offsetTop : 0;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'enhansed-view',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_shared_mixins_UtilityMixin___default.a],
  data: function data() {
    return {
      prevPage: false,
      nextPage: false,
      prevSlide: false,
      nextSlide: false,
      scrolled: false
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.toggleHeader();
    window.addEventListener('scroll', this.toggleHeader);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.toggleHeader);
  },

  methods: {
    switchToTraditional: function switchToTraditional() {
      this.$store.commit('setMode', false);
      if (this.$route.name === 'article-interact') {
        this.$router.push({ name: 'article-data', params: this.$route.params });
      } else if (this.$route.name === 'article-interact-tables') {
        this.$router.push({ name: 'article-data', params: this.$route.params, hash: '#Tables' });
      } else if (this.$route.name === 'article-interact-figures') {
        this.$router.push({ name: 'article-data', params: this.$route.params, hash: '#Figures' });
      } else if (this.$route.name === 'article-interact-video') {
        this.$router.push({ name: 'article-data', params: this.$route.params, hash: '#Video' });
      } else if (this.$route.name === 'article-interact-trivia') {
        this.$router.push({ name: 'article-data', params: this.$route.params });
      } else if (this.$route.name === 'article-metrics-geographics' || this.$route.name === 'article-metrics-demographics') {
        this.$router.push({ name: 'article-detail', params: this.$route.params });
      } else if (this.$route.name.match(/^article-media/)) {
        this.$router.push({ name: 'article-detail', params: this.$route.params });
      }
    },
    toggleHeader: function toggleHeader() {
      this.scrolled = window.scrollY > scrollPosition;
      !this.prevPage && !this.prevSlide && !this.scrolled ? this.$parent.$el.classList.add('has-header') : this.$parent.$el.classList.remove('has-header');
    },
    swipeHandler: function swipeHandler(direction) {
      switch (direction) {
        case 'bottom':
          if (!this.scrolled) {
            this.navigateTop();
          }
          break;
        case 'top':
          if (document.documentElement.scrollHeight - window.pageYOffset <= document.documentElement.clientHeight || document.documentElement.scrollHeight < document.documentElement.clientHeight) {
            this.navigateBottom();
          }
          break;
        case 'right':
          this.navigateLeft();
          break;
        case 'left':
          this.navigateRight();
          break;
      }
    },
    navigateTop: function navigateTop() {
      this.$el.classList.remove('transition-bottom', 'transition-left', 'transition-right');
      this.$el.classList.add('transition-top');
      this.$router.push(this.prevPage);
      setTimeout(this.toggleHeader.bind(this), 500);
    },
    navigateBottom: function navigateBottom() {
      this.$el.classList.remove('transition-top', 'transition-left', 'transition-right');
      this.$el.classList.add('transition-bottom');
      this.$router.push(this.nextPage);
      setTimeout(this.toggleHeader.bind(this), 500);
    },
    navigateLeft: function navigateLeft() {
      this.$el.classList.remove('transition-top', 'transition-bottom', 'transition-right');
      this.$el.classList.add('transition-left');
      this.$router.push(this.prevSlide);
      setTimeout(this.toggleHeader.bind(this), 500);
    },
    navigateRight: function navigateRight() {
      this.$el.classList.remove('transition-top', 'transition-bottom', 'transition-left');
      this.$el.classList.add('transition-right');
      this.$router.push(this.nextSlide);
      setTimeout(this.toggleHeader.bind(this), 500);
    }
  }
});

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_ArticleQuickLinksComponent__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_ArticleQuickLinksComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_ArticleQuickLinksComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_IssueAuthorsComponent__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_IssueAuthorsComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_IssueAuthorsComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_mixins_UtilityMixin__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_mixins_UtilityMixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_shared_mixins_UtilityMixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_MediaContainerComponent__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_MediaContainerComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_shared_MediaContainerComponent__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'full-issue',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__components_shared_mixins_UtilityMixin___default.a],
  props: ['issue'],
  components: {
    ArticleQuickLinks: __WEBPACK_IMPORTED_MODULE_0__components_shared_ArticleQuickLinksComponent___default.a,
    IssueAuthors: __WEBPACK_IMPORTED_MODULE_1__components_shared_IssueAuthorsComponent___default.a,
    MediaContainer: __WEBPACK_IMPORTED_MODULE_3__components_shared_MediaContainerComponent___default.a
  },
  data: function data() {
    return {
      selectedId: 0,
      isAbstractShow: true,
      selectedUrl: this.getStaticPath('img/temp/slide-1.jpg')
    };
  },

  methods: {
    selectThis: function selectThis(slideId, $event) {
      this.selectedUrl = $event.target.target;
      this.selectedId = slideId;
    },
    toggleAbstract: function toggleAbstract() {
      this.isAbstractShow = !this.isAbstractShow;
    }
  }
});

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_ArticleQuickLinksComponent__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_ArticleQuickLinksComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_ArticleQuickLinksComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_IssueAuthorsComponent__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_IssueAuthorsComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_IssueAuthorsComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_MediaPlayerComponent__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_MediaPlayerComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_shared_MediaPlayerComponent__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'full-video',
  props: ['issue', 'showKeywords'],
  components: {
    ArticleQuickLinks: __WEBPACK_IMPORTED_MODULE_0__components_shared_ArticleQuickLinksComponent___default.a,
    IssueAuthors: __WEBPACK_IMPORTED_MODULE_1__components_shared_IssueAuthorsComponent___default.a,
    MediaPlayer: __WEBPACK_IMPORTED_MODULE_2__components_shared_MediaPlayerComponent___default.a
  }
});

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_MediaPlayerComponent__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_MediaPlayerComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_MediaPlayerComponent__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'interview-video',
  components: {
    MediaPlayer: __WEBPACK_IMPORTED_MODULE_0__components_shared_MediaPlayerComponent___default.a
  },
  props: ['issue']
});

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'issue-authors',
  props: ['authors']
});

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_MediaPlayerComponent__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_MediaPlayerComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_MediaPlayerComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_mixins_UtilityMixin__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_mixins_UtilityMixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_mixins_UtilityMixin__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'media-container',
  components: {
    MediaPlayer: __WEBPACK_IMPORTED_MODULE_0__components_shared_MediaPlayerComponent___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__components_shared_mixins_UtilityMixin___default.a],
  props: ['issue', 'figures', 'collectionsHeader'],
  data: function data() {
    return {
      selectedId: 0,
      selectedUrl: this.getStaticPath('img/temp/slide-1.jpg'),
      scrollPos: 0,
      containerHeight: 0,
      dataHeight: 0,
      hidden_top: true,
      hidden_bottom: true
    };
  },

  methods: {
    selectThis: function selectThis(slideId, $event) {
      this.selectedUrl = $event.target.target;
      this.selectedId = slideId;
    },
    loadImg: function loadImg() {
      this.containerHeight = this.$el.querySelector('.slides-container').offsetHeight;
      this.dataHeight = this.$el.querySelector('.slides-container .slides-data').offsetHeight;
      if (this.dataHeight > this.containerHeight) {
        this.hidden_bottom = false;
      }
    },
    slideUp: function slideUp() {
      this.containerHeight = this.$el.querySelector('.slides-container').offsetHeight;
      this.dataHeight = this.$el.querySelector('.slides-container .slides-data').offsetHeight;
      if (this.scrollPos < -1 * this.containerHeight) {
        this.scrollPos += this.containerHeight;
        this.hidden_bottom = false;
      } else {
        this.scrollPos = 0;
        this.hidden_top = true;
      }
    },
    slideDown: function slideDown() {
      this.containerHeight = this.$el.querySelector('.slides-container').offsetHeight;
      this.dataHeight = this.$el.querySelector('.slides-container .slides-data').offsetHeight;
      if (this.dataHeight + this.scrollPos > 2 * this.containerHeight) {
        this.scrollPos -= this.containerHeight;
        this.hidden_top = false;
      } else {
        this.scrollPos = this.containerHeight - this.dataHeight;
        this.hidden_bottom = true;
      }
    }
  }
});

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_mixins_UtilityMixin__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_mixins_UtilityMixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_mixins_UtilityMixin__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'media-player',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_shared_mixins_UtilityMixin___default.a],
  props: ['issue', 'header', 'share', 'collectionsHeader'],
  data: function data() {
    return {
      isPlayable: false,
      isFullScreen: false
    };
  },
  mounted: function mounted() {
    var self = this;
    var player = this.$el.querySelector('video');
    if (player) {
      player.onwebkitfullscreenchange = function () {
        self.isFullScreen = this.webkitDisplayingFullscreen;
      };
      player.onpause = function () {
        setTimeout(function () {
          if (this.paused) {
            self.isPlayable = false;
            this.controls = false;
          }
        }.bind(this), 250);
      };
      player.onplay = function () {
        this.controls = true;
        self.isPlayable = true;
      };
    }
  },

  methods: {
    playVideo: function playVideo($event) {
      var player = this.$el.querySelector('video');
      player.play();
    }
  },
  computed: {
    isVideo: function isVideo() {
      return this.issue.video_url;
    }
  }
});

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_TitleBlockComponent__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_TitleBlockComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_shared_TitleBlockComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_CondensedIssueComponent__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_CondensedIssueComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_shared_CondensedIssueComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_mixins_UtilityMixin__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_mixins_UtilityMixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_shared_mixins_UtilityMixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_mixins_FormatersMixin__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_mixins_FormatersMixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_shared_mixins_FormatersMixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);









/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    TitleBlock: __WEBPACK_IMPORTED_MODULE_2__components_shared_TitleBlockComponent___default.a,
    CondensedIssue: __WEBPACK_IMPORTED_MODULE_3__components_shared_CondensedIssueComponent___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_4__components_shared_mixins_UtilityMixin___default.a, __WEBPACK_IMPORTED_MODULE_5__components_shared_mixins_FormatersMixin___default.a],
  data: function data() {
    return {
      siteName: 'Oncoscience',
      reprintItem: {
        volume: '',
        issue: '',
        page_start: '',
        page_end: '',
        date: '',
        caption: '',
        title: '',
        cover_url: '',
        articles: ''
      },
      requestData: {
        specifications: '',
        includeSupplementaryMaterial: '',
        colorScheme: '',
        includeCover: '',
        name: '',
        email: '',
        phone: '',
        instruction: '',
        address: ''
      },
      attemptSubmit: false
    };
  },

  name: 'order-reprint-modal',
  created: function created() {
    this.$root.$on('show::modal', function (modalName, item) {
      if (modalName !== 'orderReprintModal') {
        return;
      }
      console.log(item);
      if (item.cover) {
        this.reprintItem = {
          'cover_url': item.optimized_urls.small,
          'volume': item.volume,
          'issue': item.issue,
          'page_end': item.pages.end,
          'page_start': item.pages.start,
          'title': item.title,
          'date': item.pub_date,
          'caption': item.caption,
          'articles': item.articles,
          'articlesTypes': item.articles.map(function (item) {
            return item.article_type.name;
          }).filter(function (item, i, allItems) {
            return i === allItems.indexOf(item);
          }).join(', ')
        };
      } else if (item.issue.issue) {
        this.reprintItem = {
          'cover_url': item.issue.optimized_urls.small,
          'volume': item.volume,
          'issue': item.issue.issue,
          'page_end': item.page_end,
          'page_start': item.page_start,
          'title': item.title,
          'date': item.dates.epub,
          'caption': item.issue.caption
        };
      } else {
        this.reprintItem = {
          'cover_url': '',
          'volume': item.volume,
          'issue': item.issue,
          'page_end': item.page_end,
          'page_start': item.page_start,
          'title': item.title,
          'date': item.dates.epub,
          'caption': ''
        };
      }
    }.bind(this));
  },

  methods: {
    request: function request() {
      if (this.isValid) {
        console.log(JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.requestData)), this.isValid, this.requestData);
        this.attemptSubmit = false;
        this.$root.$emit('hide::modal', 'orderReprintModal');
      } else {}
    }
  },
  computed: {
    validation: function validation() {
      var emailRE = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return {
        includeSupplementaryMaterial: !!this.requestData.includeSupplementaryMaterial.trim(),
        colorScheme: !!this.requestData.colorScheme.trim(),
        includeCover: !!this.requestData.includeCover.trim(),
        name: !!this.requestData.name.trim(),
        email: emailRE.test(this.requestData.email),
        phone: /^\(\d\d\d\)\s\d\d\d-\d\d\d\d$/.test(this.requestData.phone),
        instruction: !!this.requestData.instruction.trim(),
        address: !!this.requestData.address.trim()
      };
    },
    isValid: function isValid() {
      var validation = this.validation;
      this.attemptSubmit = true;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(validation).every(function (key) {
        return validation[key];
      });
    },
    timestamp: function timestamp() {
      return __WEBPACK_IMPORTED_MODULE_6_moment___default()(this.reprintItem.date).format('MMMM DD,YYYY');
    }
  }
});

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'title-block',
  props: { id: { required: false, default: '' }, title: null, linkTitle: null, linkName: null, colorTheme: null },
  data: function data() {
    return {};
  },

  methods: {
    viewAll: function viewAll(event) {
      if (this.$parent) {
        this.$parent.$emit('view-all', this.id);
      }
    }
  }
});

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'content-element',
  props: {
    tagName: {
      required: true
    }
  },
  render: function render(createElement) {
    return createElement(this.tagName, this.$slots.default);
  }
});

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'content-figure',
  props: ['figureAttr']
});

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'content-header',
  props: {
    headerLevel: {
      type: Number,
      required: true
    },
    title: null
  },
  render: function render(createElement) {
    return createElement('h' + this.headerLevel, {
      domProps: {
        id: this.title.replace(/ /g, ''),
        innerHTML: this.title }
    });
  }
});

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_article_items_ContentElementComponent__ = __webpack_require__(1374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_article_items_ContentElementComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_article_items_ContentElementComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_article_items_ContentFigureComponent__ = __webpack_require__(1375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_article_items_ContentFigureComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_article_items_ContentFigureComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_article_items_ContentTableComponent__ = __webpack_require__(1376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_article_items_ContentTableComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_shared_article_items_ContentTableComponent__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'content-item',
  components: {
    ContentElement: __WEBPACK_IMPORTED_MODULE_0__components_shared_article_items_ContentElementComponent___default.a,
    ContentFigure: __WEBPACK_IMPORTED_MODULE_1__components_shared_article_items_ContentFigureComponent___default.a,
    ContentTable: __WEBPACK_IMPORTED_MODULE_2__components_shared_article_items_ContentTableComponent___default.a
  },
  props: {
    contentItem: {
      required: true
    }
  }
});

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'content-table',
  props: ['tableContent']
});

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    phoneFormater: function phoneFormater(value) {
      var arr = value.replace(/[^\d]/g, '').split('');
      if (arr.length) arr.unshift('(');
      if (arr.length > 4) arr.splice(4, 0, ') ');
      if (arr.length > 8) arr.splice(8, 0, '-');
      return arr.join('').substring(0, 14);
    },
    dateFormater: function dateFormater(value) {
      var arr = value.replace(/[^\d]/g, '').split('');
      if (arr.length > 2) arr.splice(2, 0, '/');
      if (arr.length > 5) arr.splice(5, 0, '/');
      return arr.join('').substring(0, 10);
    }
  }
});

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    getStaticPath: function getStaticPath(fileName) {
      return fileName ? __webpack_require__(182)("./" + fileName) : '';
    },
    getFormatedDate: function getFormatedDate(date) {
      var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      var formatedDate = date;
      var now = new Date(Date.now());
      var diffYear = now.getFullYear() - date.getFullYear();
      var diffDay = Math.abs(now.getTime() - date.getTime()) / (1000 * 3600 * 24);
      if (diffYear > 1) {
        formatedDate = '' + date.getFullYear();
      } else if (diffDay > 10) {
        formatedDate = monthNames[date.getMonth()] + ' ' + date.getDate() + ', ' + date.getFullYear();
      } else if (diffDay > 2) {
        formatedDate = diffDay + ' days ago';
      } else if (diffDay > 1) {
        formatedDate = 'yesterday';
      } else {
        formatedDate = 'today';
      }
      return formatedDate;
    },
    trimTextToLength: function trimTextToLength(string, length) {
      return string.length > length ? string.substring(0, length - 3) + '...' : string;
    }
  }
});

/***/ }),
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 339 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 340 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 341 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 342 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 343 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 344 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 345 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 346 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 347 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 348 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 349 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 350 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 351 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 352 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 353 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 354 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 355 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 356 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 357 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 358 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 359 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 360 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 361 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 362 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 363 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 364 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 365 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 366 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 367 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 368 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 369 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 370 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 371 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 372 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 373 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 374 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 375 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 376 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 377 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 378 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 379 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 380 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 381 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 382 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 383 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 384 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 385 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 386 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 387 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 388 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 389 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 390 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 391 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 392 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 393 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 394 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 395 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 396 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 397 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 398 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 399 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 400 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 401 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 402 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 403 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 404 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 405 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 406 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 407 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 408 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 409 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 410 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 411 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 412 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 413 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 414 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 415 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 416 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 417 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 418 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 419 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 420 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 421 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 422 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 423 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 424 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 425 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 426 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 427 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 428 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 429 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 430 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 431 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 432 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 433 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 434 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 435 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 436 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 437 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 438 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 439 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 440 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 44,
	"./af.js": 44,
	"./ar": 51,
	"./ar-dz": 45,
	"./ar-dz.js": 45,
	"./ar-kw": 46,
	"./ar-kw.js": 46,
	"./ar-ly": 47,
	"./ar-ly.js": 47,
	"./ar-ma": 48,
	"./ar-ma.js": 48,
	"./ar-sa": 49,
	"./ar-sa.js": 49,
	"./ar-tn": 50,
	"./ar-tn.js": 50,
	"./ar.js": 51,
	"./az": 52,
	"./az.js": 52,
	"./be": 53,
	"./be.js": 53,
	"./bg": 54,
	"./bg.js": 54,
	"./bm": 55,
	"./bm.js": 55,
	"./bn": 56,
	"./bn.js": 56,
	"./bo": 57,
	"./bo.js": 57,
	"./br": 58,
	"./br.js": 58,
	"./bs": 59,
	"./bs.js": 59,
	"./ca": 60,
	"./ca.js": 60,
	"./cs": 61,
	"./cs.js": 61,
	"./cv": 62,
	"./cv.js": 62,
	"./cy": 63,
	"./cy.js": 63,
	"./da": 64,
	"./da.js": 64,
	"./de": 67,
	"./de-at": 65,
	"./de-at.js": 65,
	"./de-ch": 66,
	"./de-ch.js": 66,
	"./de.js": 67,
	"./dv": 68,
	"./dv.js": 68,
	"./el": 69,
	"./el.js": 69,
	"./en-au": 70,
	"./en-au.js": 70,
	"./en-ca": 71,
	"./en-ca.js": 71,
	"./en-gb": 72,
	"./en-gb.js": 72,
	"./en-ie": 73,
	"./en-ie.js": 73,
	"./en-il": 74,
	"./en-il.js": 74,
	"./en-nz": 75,
	"./en-nz.js": 75,
	"./eo": 76,
	"./eo.js": 76,
	"./es": 79,
	"./es-do": 77,
	"./es-do.js": 77,
	"./es-us": 78,
	"./es-us.js": 78,
	"./es.js": 79,
	"./et": 80,
	"./et.js": 80,
	"./eu": 81,
	"./eu.js": 81,
	"./fa": 82,
	"./fa.js": 82,
	"./fi": 83,
	"./fi.js": 83,
	"./fo": 84,
	"./fo.js": 84,
	"./fr": 87,
	"./fr-ca": 85,
	"./fr-ca.js": 85,
	"./fr-ch": 86,
	"./fr-ch.js": 86,
	"./fr.js": 87,
	"./fy": 88,
	"./fy.js": 88,
	"./gd": 89,
	"./gd.js": 89,
	"./gl": 90,
	"./gl.js": 90,
	"./gom-latn": 91,
	"./gom-latn.js": 91,
	"./gu": 92,
	"./gu.js": 92,
	"./he": 93,
	"./he.js": 93,
	"./hi": 94,
	"./hi.js": 94,
	"./hr": 95,
	"./hr.js": 95,
	"./hu": 96,
	"./hu.js": 96,
	"./hy-am": 97,
	"./hy-am.js": 97,
	"./id": 98,
	"./id.js": 98,
	"./is": 99,
	"./is.js": 99,
	"./it": 100,
	"./it.js": 100,
	"./ja": 101,
	"./ja.js": 101,
	"./jv": 102,
	"./jv.js": 102,
	"./ka": 103,
	"./ka.js": 103,
	"./kk": 104,
	"./kk.js": 104,
	"./km": 105,
	"./km.js": 105,
	"./kn": 106,
	"./kn.js": 106,
	"./ko": 107,
	"./ko.js": 107,
	"./ky": 108,
	"./ky.js": 108,
	"./lb": 109,
	"./lb.js": 109,
	"./lo": 110,
	"./lo.js": 110,
	"./lt": 111,
	"./lt.js": 111,
	"./lv": 112,
	"./lv.js": 112,
	"./me": 113,
	"./me.js": 113,
	"./mi": 114,
	"./mi.js": 114,
	"./mk": 115,
	"./mk.js": 115,
	"./ml": 116,
	"./ml.js": 116,
	"./mr": 117,
	"./mr.js": 117,
	"./ms": 119,
	"./ms-my": 118,
	"./ms-my.js": 118,
	"./ms.js": 119,
	"./mt": 120,
	"./mt.js": 120,
	"./my": 121,
	"./my.js": 121,
	"./nb": 122,
	"./nb.js": 122,
	"./ne": 123,
	"./ne.js": 123,
	"./nl": 125,
	"./nl-be": 124,
	"./nl-be.js": 124,
	"./nl.js": 125,
	"./nn": 126,
	"./nn.js": 126,
	"./pa-in": 127,
	"./pa-in.js": 127,
	"./pl": 128,
	"./pl.js": 128,
	"./pt": 130,
	"./pt-br": 129,
	"./pt-br.js": 129,
	"./pt.js": 130,
	"./ro": 131,
	"./ro.js": 131,
	"./ru": 132,
	"./ru.js": 132,
	"./sd": 133,
	"./sd.js": 133,
	"./se": 134,
	"./se.js": 134,
	"./si": 135,
	"./si.js": 135,
	"./sk": 136,
	"./sk.js": 136,
	"./sl": 137,
	"./sl.js": 137,
	"./sq": 138,
	"./sq.js": 138,
	"./sr": 140,
	"./sr-cyrl": 139,
	"./sr-cyrl.js": 139,
	"./sr.js": 140,
	"./ss": 141,
	"./ss.js": 141,
	"./sv": 142,
	"./sv.js": 142,
	"./sw": 143,
	"./sw.js": 143,
	"./ta": 144,
	"./ta.js": 144,
	"./te": 145,
	"./te.js": 145,
	"./tet": 146,
	"./tet.js": 146,
	"./tg": 147,
	"./tg.js": 147,
	"./th": 148,
	"./th.js": 148,
	"./tl-ph": 149,
	"./tl-ph.js": 149,
	"./tlh": 150,
	"./tlh.js": 150,
	"./tr": 151,
	"./tr.js": 151,
	"./tzl": 152,
	"./tzl.js": 152,
	"./tzm": 154,
	"./tzm-latn": 153,
	"./tzm-latn.js": 153,
	"./tzm.js": 154,
	"./ug-cn": 155,
	"./ug-cn.js": 155,
	"./uk": 156,
	"./uk.js": 156,
	"./ur": 157,
	"./ur.js": 157,
	"./uz": 159,
	"./uz-latn": 158,
	"./uz-latn.js": 158,
	"./uz.js": 159,
	"./vi": 160,
	"./vi.js": 160,
	"./x-pseudo": 161,
	"./x-pseudo.js": 161,
	"./yo": 162,
	"./yo.js": 162,
	"./zh-cn": 163,
	"./zh-cn.js": 163,
	"./zh-hk": 164,
	"./zh-hk.js": 164,
	"./zh-tw": 165,
	"./zh-tw.js": 165
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 441;

/***/ }),
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/favicon.c0fbc39.ico";

/***/ }),
/* 446 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/header-img.686fddf.png";

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/header-logo.5db473e.png";

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/favicon.1770764.ico";

/***/ }),
/* 450 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/header-img.0960e75.png";

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/header-logo.fc9f25e.png";

/***/ }),
/* 453 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAFCAYAAABmWJ3mAAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+IEmuOgAAAE1JREFUCJlNy7ENgCAABdGHsbB0BVtWcRb30DgGvQuwBy1rUFpIIlf95P4FKd9oeLBixxSkvKFg8dEQJ1Scfi7UIGX9XbqIaPOQH8P2AlHnD/+XQw6TAAAAAElFTkSuQmCC"

/***/ }),
/* 454 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAGCAYAAAAL+1RLAAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+IEmuOgAAAExJREFUCJlFyrENQEAAQNF3cokYxhg6iZiI6DCASUxCyw6qazUnfvd/fuiaacWGW6ZAwIkB1Rf3LCMOtAUePwEhokfCghkpokSN69tfRBkMNvXCqEYAAAAASUVORK5CYII="

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/arrow-right.18bfbac.png";

/***/ }),
/* 456 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 457 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 458 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAbCAYAAACTHcTmAAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+IEmuOgAAA05JREFUSInNlc9vFGUYxz/v7LzzY3e7P8qWGta4IBqqKYR4QIPEgyakMfHQ1ERiND2A8dqbJ/8A/QOMwRgTT3oyIYEbDcRIpIHShOJaQNhSKc2mdLsz3dnd2Zl5PXSL1M62QDj4XN9nPnk/z/ed9xXffn2auDItM2vZtpRSF7ENPap/IO/pvRbDUF1qhyofJoQS8ETgUKlsKuSbnlBp2fr7Y8e/KxRyGuAA0U7QCxdnPspmUq9vghqmkbeTyYSUumiFSN8PBtZcb77ZbM2pSHV6wfoyqaadtNqe4xzv60tGm6BBqCqdiLVIacJMp+T0zF8f+y0vaLuur6L4jYaRyu0pDnz13sixH9yVWi2/Kxdsgkrb1sY++eD7ZNLSAR/oA7zt9M9PTo8P7s4fAg5JQ0og0A3D6LdTSU1KXXgdJdrtYDAKvbtNr3ldqd5zzObSnmmZvuc6o+zOA2QRmgagB5F62FHa/UhpWjKbbl66XD7R9tY6LcfxUaqncmnfni/feffNnxurq47ffqEOPJq5Li2bTz8bOw3YXeUs4AJ1IJZ6fnJ6fLBYeAOYTegy8d91XdN1uqDb1aXlWwoS6+dSbDmbuf5MwzBkx3OdUShEQJ8QW/s2gnKB8pmfzv4oLTurGVJoQtvS/OqB0sSRo4fPNWqr9XarXXtcOQ4KwKmJ8beBY8BeQIvpF0Ahbnc9oVO/XhHFUnHBMA2XmA8zmXTVtIyqUj0SjINev3rj7J/lO7mENLS4//2VA3u/OHL0cGU74BboyYnxEeAt4CXi9QF2PZX+7xentGLpxUXTMhpx6Wdy6aplmctPpT97rfzbXLmyU/qL2wG3QP9X6QdBaNZX3YwAQwjRfC7pz88vfbhwf3k01KSyU8nJ55L+0Gv7zhw8+LJD98545vSDILBqK04GMKIw9IHbwCywuAl641r53M25yk76fwPcufvgxPy96piQZmTZ5hJQAS4D1WfWHx7e/8vQUMntKjvAMtCGbvqNRstues1c5VbFGCwOPjDNeP0g6HirD+uRUsgoijaU/wCWgCrrTw96Qk8sTl6Y+bzT8k62HMe/OTffY4P/lrTthGkaC8A94Aqw8vi6UEoNAyNAhvXb/klq45WYAq52R/Co/gFQ+3WU3HPD1AAAAABJRU5ErkJggg=="

/***/ }),
/* 459 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAbCAYAAAAdx42aAAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+IEmuOgAAA7xJREFUSIntl01sVUUYhp9vZs6cn3t77+X+cGvVUEJSglihTSgSTKiCcePCuDC6MW4qC1cuWLpwYULs1hgvXRgWgiYYE6MJcaUxkWCMG10YiFAx/JVSKPb+9Jx7zrjoj1iBK+rCRd/dZPK+3zPfN4sZee/tI9wuz9pxbcwLaL1HRA06UQVR0jJaX/Kt932lWjw+/swTXwELjcmpdMXnB8F2EXkJpZ9Eq62ILopIorWa9TzzQz4fnty9d/TjysbybGNyKl7xyQqAZ+2zKP2Wtv5jXpTDiyKMH6A8D6U0zmWkSUK300Znyfl6rXR47/iuT441PtzUWUwOi+ftt1F+yReEaGuXfY4s7ZIuLuKSzly5GL2z76ndR7TR1xqTU/EqgLb+fLihXIjKVWwuj/Z9lDaIVgiCw+HSbDUsbi4wPDTwxumvv3veKT0Sliv4+QLa99Geh2iNIABkWUbW7ZIlMXGrSX8p+OjxPcNvAufMauv9QEXlKlG1hjYeiPxpNIIgRqGMwVgfE4bkS4Wn+2q1YuIUUaWKCQJEFGultEZpDdZigpBCOdgFjAGzRhnPTbz+yuYPjn4q2vp3LP4XiaA9izbmARuGvktBe/aOxdf6lDF41it+c+rHV+cuXRlTXhACjHtB1MN9t8xetHcyIdrzgmKtMqCUMQCDypj7D/oX0lobG/h9/+jU/6XWAdYB1gHWAdYB/v8ARitw7r6DtVp5jvTIv30hIlmtFLpKwW+V8v5sLrTXRaQJdJvtxejGfLsyM9fceKMZFzKUAlbJinmb9FfySTHnz/Xl7DWt1AKQLMZd7+atVvn6zVZtZr5djlMxuD98qwC1avHbnSNDl4uFqAacBc4AvwI3gDgX+iYX+sWH+ksDcdx95Oz01QPi3IVCPjA7Ng+c7q9vyAOXgZ+AC8As0PGtUfVqIVevFurbnNty7peZA0Jm0m63i8OtAuzbN/I+sABkwM/ADHAL6DQmp9KDhyYU4AN91prK9qEHPwMK1cr2NhABKTANXAFuAu3G5FT34KEJATwgLyIbtgzWvwDq589MvxzmQuTokRMuV6uTxovErRa4jCxN7zn3R3cMvTg6NnwKaK9M7+i7x49lyH5lDPd6JIlSiNYY67Nl66YvxTm3E3gOKALzd3Uu6/OTp1/rdJJq3Fqg227jsgwAbX1Gx4ZPbNu26SLQBJIeUQHgxDlXAgaBUq/iyxoAhpcDfmNpZAA5llo9zdL9af2NrLas/Rn10sFDE33Aw0AF0Gu2m8BF4FpjcqpXBwD4HaAGJz+0yMlZAAAAAElFTkSuQmCC"

/***/ }),
/* 460 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAUCAYAAACeXl35AAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+IEmuOgAABLtJREFUSImllVtsVFUYhb+99zn7nJkz05npZUpboBRKubQiCILQarlKUPRBjAEJDyQaoi+YGCQmPhgfTLQvarzVJigYDdEY4wMGCASVBLDSIuWi0EqhtAhth4Fe6GVOz/GBAaq0DepKztP/Z6+z1v7Xv8XHb3/CaDC1XuIL+alpW0pKQ4zaOAzRWPiz1WtWfAR0AgP/rBujk5nZvpBf5BUV1t03e3qbEEL6vpcai6yzs2tC0x9tr5w/13Zj0uSCncAFYOheCIWP2BHOzOpe+VjFaaVkP9AE9AC0Xrw8ruF447Oz50zfl1+QcwHoBrwJE3J1MtmVd+ps60t5BTnnLUtfBxLDD5YjqjPNzYYdXFz56MLdSskUcAD4HtgH7Ptpz8H8xJVERVNT60NAO3A4Xdszq6zo5VR/v/rl6JnNQCkQHFOhYZpzMcy3Sh8o/SY3HhsCjgEN1VU1V2/1hGNRaQYCONFIIVACHE+rJDueWVc4Pvv1cxc73zlz5sKGadMKE8AZwL1LoR2wwwi5M6sg7/i8B2d2pG2sA64N71NKKWmamJZ2gCxADyvfmDOv9KtoyPru98ZL65LJ7iVAHBB3EbpDXnUgEo0uX7moFrgK/Axcqq6q8UayfhiGT7APJBaVz36NoVSi7ljjZuB+IPw3QlPrjUrba+dXzN3lBO0UUAucra6qGUy3aK31/IxopNIXslhISX9/Ktja1lF05GDd/LOnGqPcuSI3ELSbS6bkb71+vaew/tjZF9LWa5kmm44y3p9YMvlAcXFBH9AA/Ep6KgE2bXk+hVKbBj3xg6/tNToYItE9kF13smV9T5/7Yknp1GlpFbfU9s0oK96bEwtuO9/Svqqttf1JoECtXvGElsrYmxGPu6ser6iVUrQA+4GLw62sO1TPuueeOfpne3KJGYrlWZEISlvk5kT6yhdMbxBCXOFm7m7/JDBQOCn/5LmmluXtV3seKZwQP2loy1oktD1LBkLs2n98U//1JANdXW/63hDFZTNeXbaqYgfQUV1Vk3LCzrXKxfO21NY3bnc9b3xGyPLnTMvtEEJcApqB7m3vbi/3ELsMbUWkYSCkRDth7IhN8lrvarX26fVT0faGUE4c0wlh2DZWJEIglkkKVRlxrKuhULB5XvncnuqqmsHyZQs7Y+HAyc4riYfnlk28YGnjEPA1UL/9g8+F54u9gVhmXnhcPk5OLnYshpURwXQcCvOi/YZSUnpKIZTCsCwMy7rth+e65m/n2rdmZWY0m9rcCySBnszs6MGlldGNwAxuRqce6HFd70MdypjsZMcJZGahzOFpASGkM+ouBZCGwaCnoz8ePv1eT2dHY0ZOdu+X277104NmKtMwhlKu66YGXd9HmU54aTArBysjgjLMEc8ckxBAmSauH4yLUCxumUF8379d8wFp30l9UGusUBjDtkGM/LgYSqnBFP6IRQCEwNAWMpqJ74+dfyEEQimEGHFFg8CXxTOnnJBCJHzPA38UYiGQhoEy9ZifNMxRyWxTEXasbuH7vnH6RONTyV73DRV0JirDMMQodvxXWFp5RXnR9lBQ7xa+7wtuLuD5wAJgHPdwt/8SLnAZOCLSQyC5uZayAIdR3sn/AQ/oBTr/AqVqgns99ZwdAAAAAElFTkSuQmCC"

/***/ }),
/* 461 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADkAAAANCAYAAAAT88Y+AAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+IEmuOgAAA4hJREFUSInNlktv20YUhS+HpEhREh+jIijQokDQpi0S2Ok/NbzxD/DGO6+7LNpFgdYLJ4aNNo0ToKiBtBafIodDcubebkSDjWVHjr3oAS44HA3F890hj2QcHBzMLct64jjOI9M0GwAQiFgTkdRa10QkELHWWksikogI/wONDMMYM8bcvt4/Z4y5APC3UuqVZRhGbNt2PJlMgtlstu267teMMZOIQCn1fqHWWiJijYhidZSr8bV5IkIi2sR0b7Q3OF7VcH48+IyZpgmWZcGao2aMvVJK/Xx4eJgDAFhEBF3XgRAiZ4z9NBqNjmaz2TPP856ORiPXMAxAxL4YInpKKU8pNR82QGu9rilyAF8jYkNETt/1Hso0TcM0zWuGbxr3axljwBgDwzCAMSaJ6Kxt29O9vb162MErSKUUSCmhqqo6z/MjzvlxFEXf+L6/5Xmeb1kWGIYBRARENAS/rVyttauUCntwRATG2DXTveFhrcyvnTcMAwAAiKhQSp1IKX/f2dlR6x4Tqx/0sKtdhTzP1eXl5Snn/CyKose+7297nvfItu2rm20iRAQiAq31VYN6k+tMbyoi+qfrupdCiLe7u7u3vhPWukmlFJRlCXVdQ1EUtFgs3oRh+IZz/mkQBN95nvfFaDTaCLRfY5rmnSBuEiL+2bbtsRDiXZ7nsL+//8Fr1kL20lqDEAKklFAUBcRx/C4Igu8551EYhlvT6fSJ4zjmprt6D2lE/KNpmpOyLNMsyyBJEsjzfKOLb4XshYggpYSmaaAsS0iSJA2C4EfO+VEURc+m0+lT13Wdh9qtgRqt9ZmU8rQsS5Gm6RVcXdfQtu1GX7IRZC8igqZpoG1bqKoK0jQVvu//GkXRMef829lstuW67rQPqY8VEZWrMPltuVx2SZJAmqZQFAXUdQ1KKdjwpwkA7gg5MPGfkMqyrFssFidRFJ1yzh/7vv98PB5/Ytv2nWCJaNF13Yu6rt8WRYE93HK5BCklKLU2PD+oj4IcahhSeZ7jYrE4D8PwfD6ffxYEwXPP8z7vE/kmIeJfXde9EEJc5HkOcRxDlmVQliU0TQNa63t5vDdkrzUhdRGG4QXnnIdhuD2ZTL5yHIcNYBERXzdN87KqqqQPkyzLoKoqaNsWHuov5INB9loTUonv+z/M5/NfwjDcnk6nX9q2fd513UlZllWWZRDHMRRFAUIIaNv2Tu/bJvoXlp6/G00I3L4AAAAASUVORK5CYII="

/***/ }),
/* 462 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAJCAYAAAAPU20uAAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+IEmuOgAAAHRJREFUGJV9zyESwlAUQ9GUweAqugQUBsNm2AimewBVwZpQGDSsAIFAIE7VH+DT4c5EvUzyEuyxQqY0S/JMck4yJOlSg403d+ywKAlBg6tvbtiiKV1H0xyK4fQvYflxeKCvf+jxwoCunjlP0iZZJ7n8TEwyAv97xTRDw6WuAAAAAElFTkSuQmCC"

/***/ }),
/* 463 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADkAAAANCAYAAAAT88Y+AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAZdEVYdFNvZnR3YXJlAHBhaW50Lm5ldCA0LjAuMTnU1rJkAAADy0lEQVRIS8VWV2sVURj8DCoaH6LmwUgQxYAiFkQiXIVIEMEYUIKiiCU+JH6/I78mN733XkjvvVfSe+/FmSVXLusxmqj4MCxn95yZ+b49Z3YlIiLil4iMjPxtOJ1OiY+Pl8zMTCkrK5POzk6ZmJiQlZWVc5ubmw5cP2LswH1PPuc8zuc6E9/fgLEoO0wL7YiKipKEhATJzs6Wqqoq6enpkenpaVlbW7u4u7sbuL+/Hw4ogbHifjieB2LeRc7nOq4nj4n/T2Asyg7TQheio6MlKSlJ8vLypLa2VgYGBmRubk42NjZ8UUywqzATWCzmKeYHY50v15OHfOQ16R0HxqLsMC2MiYmRlJQUKSwslMbGRhkeHpaFhQUPbEm/vb2916aifgbMV6xTrH8NHj/weZCX/NQx6R8FxqLscE3muYmNjZW0tDQpKSmRlpYWGR0dlaWlpVNbW1t3YfaDqYjfBYsFj4LvA3jvgv8UdahH3eOeW2NRdrjCJCMjwwqTjo4OV5h47uzsPITBL3bDfwrwKvi/QOch9KyQov5xQspYlB0MhcrKSunu7papqSmGyQWcpycwE2Y397dxEFJh0H0C/Qv0cdSQMhZlR39/v8zOzsr6+roPRINMZv41WCz0FT6C4MfnKCFlLMod8/PzJxAK13FeQkzih4FnjOa2t7etYGGS0iivHHNL8rlp7c/gCin4ChkaGrqOkDpRUFBwaEgZCyNw+E8iBG6D9L27gLtpGl5dXdXl5WWGBdORnwOdmZlRbC/FeVIEiMKMovuK7ab4CbCuHCNJdWxsTCcnJxXfTL4lmtfFxUWLk9zUoBY1qU0PLi8HIfV+ZGTkNkLqZHFxsTGkfigO5s7CrD+EQinobnp8fFxBqIODg9rX16ddXV3a1tamzc3NWl9fr9XV1VpRUaGlpaVaVFSk+fn5mpOT8zUrK+sz/mzepqenv4SJZ7gGYPwMZ+tlbm7uO8wLhUFFuCh+DLSurk6bmpq0tbXVakpvb6+lSW02jl7oid7YWPpEo0LxrfXHmz3Lz09qaur3Yr8XB6Ne7e3tASAOowCFaLq8vNwyjYWKM0DT4TD9EUn3BoaDQfY0OTn5cWJi4gMk3y0QX8MZ8UEonEcXz7i6eRhoBPM9sN084+LivBEqV3DWbmAL3oOGA1qB0HwB7Tfw8AlewumJDa2pqdGGhgbFm7SagjrC4DsAjfPieWU4cS97g+QREALCIIwD8dABofswfROmr8L0JRjxgqHT7ub+F2gcns6gIefh8zIa7Affd9Bwf+4S4DnGr+Dd4XQ6vb8B+Hog0KKfMj0AAAAASUVORK5CYII="

/***/ }),
/* 464 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAFCAYAAABmWJ3mAAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+IEmuOgAAAElJREFUCJlNyzENgEAUBNHHzwlABzro0IIDBEBIKHEBcmjPxpUUFPypdpKd7hivHQ03ekyIghMPFh8NQ6Bi9bOhRpZ8Kimf0/YCF0gPIDzH8jkAAAAASUVORK5CYII="

/***/ }),
/* 465 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAGCAYAAAAL+1RLAAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+IEmuOgAAAExJREFUCJlFyrENQEAAQNF3cokYxhg6iZiI6DCASUxCyw6qazUnfvd/fuiaacWGW6ZAwIkB1Rf3LCMOtAUePwEhokfCghkpokSN69tfRBkMNvXCqEYAAAAASUVORK5CYII="

/***/ }),
/* 466 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAGCAYAAAAL+1RLAAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+IEmuOgAAAE1JREFUCJlFyrENQEAAQNF3cokYxhZKjYlokWhNoTQJLTuortWc+N3/+WFpthkrbpkCASd6VF/csww40BZ4/ASEiA4JE0akiBI1rm9/AXcJDJ9eWYIoAAAAAElFTkSuQmCC"

/***/ }),
/* 467 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 468 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 469 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAbCAYAAACTHcTmAAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+IEmuOgAAA0JJREFUSInNlc1rXFUYh59z7z33YzJfaaaEaTBVSQsGjVAQWxTd2FJwoUHBIJUKLlx0464r/wA3Ll0oRXAnCIJg3LmpKVhabW00TlPbTFPzMeRr7kzunbkz9xwXndTG3Ju0pQvf7Xl5eJ/3dzhHTH56jqSSrlNwMq40pRSJDSmVHSgGVtqhUuqCiunHEBrBg4GVLiglPkuF2m7GOvLGa1/kBgoG4ANqL2Zl6rd3vHzf6Dao5dj9bp9nmlKKOEbGne7+VjOsRmGrorXqpMG8XF9oe2479Bsn3FxGbYNqpeeUEk2hDeFm++T89M1320HYbTUbkVYpgypdLJb3f/Lc8WNfbq6vr2f3FbrboLbnGccmXj9ne44FREAOCHbTnzl/5XS+VBwDxiwpJdC1LFvuc7MZw5RSdDtadKPOoIrVrSgIr2l06h4z+VwgXTtq+Y3xfKkIUBCGYQBYWrOqtfm30oaRKebCm5evT7SazU6r4Uda61Tl0sHyx8+8+sLXwcaG320P1oF7O7ek6/HK+29+Dng95QLQAOpAInXm/JXT/eXSEWDalNL877llWBY90I368uosYAIi6W72FfObli07Lb8xTrmkgByIHX1bQTWAmYvf/PCVdL2CKaXAMHY0lw8NfzTy4thksLFR77Ta6/crJ0EBOH7m1EvAy8CTgJHQL4BS0nSp0OsXfhGl4QPzlmM3eoBt5eWzNenYNUhLMAE69+vv3y9WbhUNyzaSdloeGT47cvT5ud2AO6Anzrx3EjgKDJOsDzDwUPqVny4ZA8NDC9KxN5MmzeSzNek6Kw+lf/vqn1OLlepe6S/sBtwB/V+lH8exE9SbeQ22ECJ8LOmvzi+/vbGwOm4YUjvZzI+PJf0Dhw9+NzT6lE/vzXjk9ONu7G6u+3kEtopVBNwApoGFbdDq1ZnJpdnqXvp3AFaqixNrd2pvWbarpOcsAXPAz0DtkfWHRp/+tnzoiUZP2QdWgDb00m8HLS8KwuLyX1W7vzy4aKXox51usLlWV6CliuMt5T+AJaDG3a8HyzDNhcrUtQ+jMPgg9P1ocXY+ZcB/y3Yzpu3Y88Bt4BKwdv+50Fo/C5wE8tx97R+ktn6Ji8Dl3gru1T+tHGYaktKM5QAAAABJRU5ErkJggg=="

/***/ }),
/* 470 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAbCAYAAAAdx42aAAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+IEmuOgAAA7hJREFUSIntl8tvlFUYxn/vuX6X+WZqZ6alJNyKiFhBDZcEjREDmpC4MC6MLnTBwo1u+ANcuDBhZTeuNJaVGm9ho9aYaHBBjJewYaFBUYJc1LYIlJnpzHzzHRfTVlLBInHhos/u5MvzvL/zvic555OPX3mDa2Wc26OteVK03i2i1ouosijVVFqfN1YfL9Uqb9+99/4vgKuT4xO9BZ+LozFEnlZKPyxabRbRFRHVFa2mjdEnfBp/smn3PR9k9cHpyfGJzoJPFgCsd48h+mXj/TafprgkxUQR2liUUoQQ6HW7dOdaFL3uz1m1fOjOB7cfOTrx3rq83T2krd3rkhIuSXBxjHa+7wOKPCdvz5F32heTLH51y0M7XlNGT02OT3QWAYzzl9PBajmtVvFphvEebQyiFCJCCIFQFPTynLzdpt2YZdXoqhdPHjv+hGh9X1qtEWXleZ9FaY2IAFAURR+i26HTaJCU3Tsbd469BPxkFlpho0iltRpZrY42FubNi60SQZRCGYP1HpfExAPlR0pD9YqgSWs1rI8QpVgqpTVKa4xzuCgmKdudwC5g2mhrw6MvPLPh2JsfiXH+usX/JhG0dWhjRlwc+VAojHXXLb7Up4zBeFc59c13z106f2GXslEMsMcmyTLuG2UuR3t9m7Y2yurV1UoZA7BeaXMrQbcspZWxkc9uadf/KcgKwArACsAKwArA/x5AKYEQ/nWwKOFmbjdz7UJEijjzIc580ydu2kZ2RkQaQN5pdZLWbKvavNQcmmt1yyJaAYtkPrHddCDt+tRe9LGfEiVXgW7eze3cbGuweaVVb15pD4YghvCXbxEgq1a+Xrdt9EKUJXXgB+Ak8AvwB9BxsTMudpXKUGV13snvmjk7tY8Qzvg0MvV1I1+V6wMl4ALwPXAGmAbmjDWqNJilpcFsOISwcebs1D4oTC/PcwJhEWDzA9sOA1eBAjgF/A5cAeYmxyd6+w8eUIAHMuNMdXh05EOgvHHHlhaQAD3gNPArcAloTY5P5PsPHhDAAiURua22ZuhTYPi3H08/65IYOXr4SCgPDZN3OnSaDUJRUPR6hH+Y+9qtm57asH3sS6C1ML3PX3/3LZC9/SfdjWcuSqG0xvqI4dvXHpUQwr3A40AFuHxja18nPvv2+bzdrbUbDTqtJqEoADDOM7pj7P2RO9aeAxpAd5moCAgSQhgA1gMDyxWf12pg63zALP2RAaT0W32a/vlp3kRWS5b+GS2n/QcPZMAaoAroJZ8bwDlganJ8YrkOAPAn5vQkRezpjOwAAAAASUVORK5CYII="

/***/ }),
/* 471 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 472 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAFCAYAAABmWJ3mAAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+IEmuOgAAAElJREFUCJlNyzENgEAUBNHHzwnABQlWMIEBHCAAQo+Mk0N7Nq6koOBPtZPsDFNdL3RUjFgQBTce7D465kDD4edEiyz5VFK+pe0F85EO1tHxPzwAAAAASUVORK5CYII="

/***/ }),
/* 473 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAGCAYAAAAL+1RLAAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+IEmuOgAAAE5JREFUCJlFyrENQEAAQNF3cokYwBjWUGk01qHFACYxCS07qK7VnPjd//mhHtoVG26ZAgEnRlRf3LNMONAVePwEhIgeCQtmpIgSDa5vfwETLwvR2sjvIQAAAABJRU5ErkJggg=="

/***/ }),
/* 474 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAGCAYAAAAL+1RLAAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+IEmuOgAAAE5JREFUCJlFyrENQEAAQNF3comYRGUTjQ1sQosBbKEzCS07qK7VnPjd//mh3voFK26ZAgEnBlRf3LOMONAWePwEhIgOCTMmpIgSDa5vfwFTFwxVWbv+OAAAAABJRU5ErkJggg=="

/***/ }),
/* 475 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 476 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 477 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAbCAYAAACTHcTmAAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+IEmuOgAAA11JREFUSInNlc9rHGUYx7/vzPvOvLOzuzO7MaZJayqhUQihigEJVLSnErxoUDF4qWLBQz2IHjz5B/TiTQ+KCF5EEGxFC15EYltMTZX8QFM3adMm3dQ1zXZmdmd258f7esg2dpvZpC09+DC395kP83m+874vOfHRh0grrnMrk8kwRhlJbehQ3cUun3ZajKU4F4i4EEKRALkrsJDCMmXycUco45y+8vyLn+4pdCkAXABiN+h302dfLZi5oTaorukF0zRVRhmpyZg146jbqdeuBI3gohQy6gSzcrkgw41m3XGP2GZWtEEjKZYDiFpIBOHZLPt5Yfa1qBHEDacWSilTgYlM7P6He0+8cPjI5151o9osFOI2KDO48sb4xGdZblAAIYAcAH8n/ZNTk0f7it0HARykjDEAMdU0rZg1swqjjLgiIo0o7EmS5LIf+HOQnedo5/O+ofPQ99xxFLsBwFJUVQEAGkt5o0HktZAIJWNZwQ9zv06E9XoUOF6IdGMkMrEH9+7/YOzQ4a/qNx232dt0AGzNnFKD4+2J1z8BYLSULQAeAAdIx56cmjza19P3FIB5hVL1znWqUIoWaLH8z98lKaESgs3njipadl3XtMj33HHZ0ysA5BSyve9WUB6AP7889fUX1OCWyhghKc3DA4PvPDcyerpWvek0G43q7cppUADAe8eOHwLwDIBHASgp/QTAQ0TZeYe1QSfPnyP9+x5Z0TXuEYJtL9rZfIXrekWKDj9tGnR69vfvZxYXbJUxJW2/Dw8ceP/ZkdHlnYDboO8eOz4GYBRAP9L1AaDrnvR/+uWMsn9ff1nX9Xpa+nY+XzF0vn5P+hfmZ87OLF3cLf3yTsBt0P9V+nES6xuuk5eARogSPJD0S9dWXl6qrI0LSqRpmj8+kPSfOPD4t08PDrlonRn3nX6UxHzdqeYlIZpIkhDAIoB5AOU26G/zM6fnLv21m/4qACysXpkora2+JDUmDM6vA1gGMAWgct/6I4ND3zw58JjXUnYBrANoAq30vcA3/MC3S5eWtL17etc66Udx5N+obggpwYTYUv4DwHUAFWxePaBUVcunps+8FQX+m4FTC2cvlzp84H/FDK5yna8AuApgGsDG7etESjkMYAxAHpun/d3UrVviPIALrRFs1b9WuHu/3eq77wAAAABJRU5ErkJggg=="

/***/ }),
/* 478 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAbCAYAAAAdx42aAAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+IEmuOgAAA8FJREFUSIntl0toXVUUhr/9Ovuce+77kTShqekDxUgfalMbRRpJCqIOxIHoxJkOqpOCdObAgVAzMCh6EQWLUCyCxYkDUQd2UKQdCNJJabGWlqalubamyX2ec892cJtYW5vU4MBB/tlh8//r22udwdri3Y/e41ZZzxsXxrwopBxzUg47QVZJ1dBazVhtfu4vlI48s2fyGLAwVZ3uLvoCP3jISfEyUj6FlA84KXJSykhJVbNGn8oE4bfjo2NH+0qV2lR1urPoE4sA1rPPJUq8Iz1vm0mHmFSA8n2k0QglIXEkUUTcbKHj5Lf1hfLBvbuf/Prjw5/d1+y0DwqjJ0wYYsIAHfhIz+v5HCRxTLfVRrSja/3p7IdPP77nE6307FR1urMEoKw35xcL2aBcxKRDlLVIrRBSIQQ4By7pksRduu020UKdx4a2vHXsxPEXEiUf9ktFbDaDsh7SGITq+QBckvQgOhFRvcGGVO7LiR273gbO6cVWaN+XQblEqlJCGs2Se7FVAoTUSK3R1sMEAZlsbm+2r5JrCwjKRZTvI+TffQBCKZRSKM9DBz75ID8K7AJqWhrj3nz1jY3Vo4dFj/7O4ncmCqRnMMYM2CCwsesiPfOPxe/waY2xXu77X06+VpuZ2SV14AOM61Qgl3ffPXYVFqGN8QvlyqCUWgMMK61XEbR6SSW19f3Mam/934GsAawBrAGsAawB/O8BjFS9beRfSgl5T7fTt34IIZLBVNYNBJlG2Q9rWRv8LoSoA/F8u5marc+XLs1f77vaqWdjIaS7haxsw2goW4jKfngtb1OzSsoFIGpFHVNrzBcvL8xVZho3ii0SjfvLtwSwLl8+OTay7XIxzFSAs8AZ4CJwHehkbKAzNshtKvYNtqPOyKkrFydlwoVCkNa7h4ZPDBUraeAycBq4ANSAlm88uT5XCtfnSv2Jc5tPX7k4KRw6juJYgFsCeHb0iUPAApAAvwJXgRtAa6o63T2wb78ELJCxxivtHNr8DZBdt320CaSALnAeuAL8ATSnqtPxgX37BWCAtBSiMDKw4Tug/8y5s6+EQYh4/8ghl+or0+10iBvN3gLZ7cIyYx99cOtLY9sf/QloLk7vg88//SIRbkIas+xKJ4RAaIWylpGNW34UzrkdwPNADpi7e9mejhz/4fV6u1WO6o0e8M1xKs9jbMfOrx7ZdP8loA5EK0T5gBPOuTwwDORXKn5Tg8DWmwHz9EYGENJr9Xl6/0/jHrKa4vaX0Uo6sG9/BhgCSoC67bgOXAJmp6rTK3UAgD8BEEwqPPkN1/gAAAAASUVORK5CYII="

/***/ }),
/* 479 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 480 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAFCAYAAABmWJ3mAAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+IEmuOgAAAE5JREFUCJlNy7EJgDAYBeEvYmHpCn+roziLgwR3cZlASl0jpYUBverBvUsl4kDDiRkbhlQiAhWTl4Z1wI3sI+NKJUJ/1y4WtPGX70h9ewAJ3g8mD4wa1gAAAABJRU5ErkJggg=="

/***/ }),
/* 481 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAGCAYAAAAL+1RLAAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+IEmuOgAAAE1JREFUCJlFyrENQEAAQNF3cpEodZawicowWloMYBKT0LKD6lrNid/9nx+Gulmx4ZYpEHBiRPXFPcuEA12Bx09AiOiRsGBGiijR4vr2FwsbC7+XupipAAAAAElFTkSuQmCC"

/***/ }),
/* 482 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAGCAYAAAAL+1RLAAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+IEmuOgAAAExJREFUCJlFyrENQFAYAOHvf5GIMd4ANtGYiBYDmMQkT8sOKq2GuO4uFyXnBStOLwmBHQOaL26vjCjoEi4/gajQ48aMCXeFGi2Ob38ARIIMNbNlx7wAAAAASUVORK5CYII="

/***/ }),
/* 483 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 484 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 485 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAbCAYAAACTHcTmAAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+IEmuOgAAA01JREFUSInNlc9vFGUYxz/vzLyzM+12pl36I6xJqSa2pjXEmJgU9QAX5GijiciFGA5eCPHmyT+ABK8eNMbEm3owMZGLiQEKJooijURp2cbaltKusO3O7s6wszPv64EtUjvbAuHgc33efPJ+3u/zvq/47syHZJV0HF+6XdKUUmQu6FD5/j2h1ampUvWDTpM+bRgaIR4OrJWv0vSjjlDbcawXpl7/pLu/3wACQO3GnJ+++JbjeeNboFYu12d3dZumlEKliUxbyUCzXv8rDqNZtGp1gjmeF0nXbUZBcDjXk1dboDpVC2hVRyvh5vPy5szMsVYUJVG9Hmuls4kq7fWKxdPjrx3+rFGprHcXCskWqO06xkvH3v5Uuq4FxEAPEO6kXzp3/nh+cGA/sN+SUgKJZdl2we7OG6aUQrVaImk2h1Sa/hk3wt9AdzxHx/dD6ThxFART+cEBAF+YpgFgaaXvoPVNtDK6ev1o8fLlo816oxXVarHuYIxKewsjIx+MHjr4RVStBkmzWQXun7klXYeXT7zzMeC2lX2gBlSBTGzp3Pnj/lPFF4FrwrLM//Ytw7Rog0rB6toN0CZCCAHbZtPt62tYtt2KgmDKKxYV0GNkzPBmUDXgjytffvW5dB3flFJkDfzQ6Oh7Tx+YPBtubFSTu3fXH1TOggJw8NTJV4BXgRHAyFgvgH5hGDvesC3Q+YuXRGHf8JKVy9Vg+05dzytbTq6sVaehzYAuXvn127Xr13sNSxpZ+oOjz77/zIHJhZ2A26CHTp08AkwCw2TrA+x5JP3ShWmjsG94xXKcRlb6ju+XpePcfiT95aszl9ZmZ3dLf2Un4Dbo/yr9NEly0UbVQ2MLIaInkv764tKb1ZVbU4YhdC7f/f0TSX/oubFv9k5MBLTfjMdOP00SJ1xf9zTCVmkaAyXgGrCyBbp0deZseW5uN/1lgMrCwtGN5eU3pC2V7bqrwALwI1B+bP29E+NfD46N1drKAXAbaEI7/TgM3bjR6P27NG/7xeIty8ll6qetJGxUKkprLZVSm8q/A6tAmXtfD5ZhmivzF6bfjcPwRFSrx2tzNzps8N+yXceUOWcJWAR+BioP9oXW+nngCOBx77V/mNr8JX4Cfmkfwf36Bwdhdkipz3JuAAAAAElFTkSuQmCC"

/***/ }),
/* 486 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAbCAYAAAAdx42aAAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+IEmuOgAAA7VJREFUSIntlztsHFUUhr9zXzOzsw97Z9cWicCGxESAEoKUOIp4OYrTUSAKBA0lDUJISU1BgZSCdUWBwksCCYQEoqFAiQsQsiApaGgg4REcgYGYOJt4va+ZuRQbOyEkcYgoKPx3o6v//N85Z4p75dgrDa6Utm7KWPukaLVXlBoHykrrFaX1r9rZr+Mkef+eAwc+B5ZnGzPZqs+G0X0i8rQotU9ptQ2RilKqL1ovKmO/CeP407se3PtRsV5fnG3M9FZ9sgqgXfCYUvKycW5HEMe4KMKGIdoaRCl87snSPv12hzzPf4prtcMTjz7y8dzrb46l3e5hbc1+V4gJChE2CjHOIUqBhyxNSbtd0n7/XFgpv3r31NQRZczZ2cZMbw3AONeMh4fLcbVKWIwxLkAbjSiNCHgPPs/I0oy016Wz3KI+MfHi93NzTyiRB4rVKmGphAkc2liUHvgA8jwnT1PSfp9ua4VwqPLB+J49LwE/mssjDFUxSSjVErQxrLlXRyUgyqCMwQYOF0VEQ5UD5VqtAlBMqtggRNTffQBKa5TWGOdwYUg4PLwbmAQWjTbW73vh+TtPvPOuGOeuGf4PiaCtRRtzm42iwOcZxtprhl/tU8agnauc/ur4s82FhUlloxBgykaRurH7ujXXSb22zTgXFuu1TUppAzCujbmVQrcsUcrYMCzdUtf/pTYANgA2ADYANgD+/wCi9eA28i8l6uZ6M1d+iEgeVCo+KJVWXBwvmij6U0RaQNpvtwudCxeSztLSSK/VKouIAtbIbBz3C9Vq38bxOVconBWlloF+1uvZzsWL1U6zWe82m1Wf5wZ/uaM1gLhWO7F55/0LYalUB04BJ4EzwBLQs1FkbBRVSqOjm7Je796ln+envffzrlgyyfjY8eLISBFYAL4F5oFFoKOdU3GSxHGSjHrvt5yfPzONiMnTNMXj1wC2PPzQ28AykAM/AH8AF4DObGMmmz50UAEBUNLOJbWJrZ8A5bHJahsoABlwGvgNOA+0Zxsz6fShgwJYoCgiw8NjdxwFRn8/eeqZIC4gc2+85cv1GmmvR6/dxuc5eZbdcO2bd2x/amz3ri+B9ur2vnjtyHvg92tr4QaXJFGC0hobBIxMbP1MvPc7gceBCtC8fuxA3x099ly/06l1V1YuAQ9IjXOMT+76cGTbtl+AFtBfp1QIePHeDwHjwNB64Ze0Cdh+qcBFBisDiBmM+jSD/2flJmq15eqX0XqaPnSwBNwOJIC+6rgF/AKcnW3MrDcBAP4CySwmJ+jhPEEAAAAASUVORK5CYII="

/***/ }),
/* 487 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 488 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+IEmuOgAAAO5JREFUKJGV0r1KA1EQhuHZKGnttdbLSBcVFYIiKSztrGwsFbwKaxUb7exT24hXkDvQUvwPeSw8C7vL7sYMfHB+5v2YOXMCkdTDPV7wjicco1vIKSlfnOAH1xhiA6fJ6AFLTXAfn1ivSVjGGDdN8AgXTaVhE1Os1MGv2G2BF/CNvepdJyKyiOjG7MiqB52IeIyIrRaoHxGLKa8c2MGkrqzCg921jeo8GVxhUBjVs7/YboMjASN8JGCMM+yneQ+w2gQX1ansh8lwgoNZcFVr+CoYHM4DR+o7b2mKo3ng/Cu/5RVk+Mf/KEUvIi4j4vYXZm5NwUZJKxsAAAAASUVORK5CYII="

/***/ }),
/* 489 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAMCAYAAABBV8wuAAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+IEmuOgAAAHVJREFUGJWtzrEJAgEQRNF3csmlF4lYgTUIFmJFViC2ZCqYC4KBIGJiNmfgXiAa+mEZdgeWL4maVZJD3tyaJNDhjF4xqVzU8YkZmrHoKq+4QIsdplX0td+bJINv9i02mGONB7Y4jqrLJEOS06g/+fHmQ/cPxQuvSDp5Yxr8PgAAAABJRU5ErkJggg=="

/***/ }),
/* 490 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAHCAYAAAA8sqwkAAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+IEmuOgAAAKdJREFUGJVt0K9KxAEQxPGvfw7LYbQIBsN1X0MsZ7yX8AUEk2gXrJrNvoaccGATq02MBj8a/ImnODBh2Zmd3Q1hH3d4wxNOsD70fnG1mla31Vp1Ws2rzeq9H0yrWdUKFoN4rxpVW0vC52pSHVXj6rxhjYshcoaPJR7gHi94xWNY4AEbGGMXV4NhMgw6wyUKh74wxzFuhvp66dht7HwbGqL/fmn035c+Ad6y1lnqsVH0AAAAAElFTkSuQmCC"

/***/ }),
/* 491 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+IEmuOgAAAItJREFUGJWNzSGKgmEUheFHcQMmmWIUtRkmCO7CZnUJFvdksQoWmR1YbAaDwRUoyPmnfH8aPpkDh3PP5b1cSXZJ7kmmSdTcxQJfGPmgTpIJxtijqYE9rDHEpRyscMQMc1yxkeScpEmySLIt86tk60O38umGAZalf9fAHzxwKr1fA58l3+2iBv7Rv8FfBz1VQmdYYdIAAAAASUVORK5CYII="

/***/ }),
/* 492 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAALCAYAAACksgdhAAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+IEmuOgAAANRJREFUKJGFkLFqAlEQRY+yksbKIoKdf5E/ECHY2aZJkcIvSGtpkZ9IL4KN+YAEBCvTbh1IigSEiEuSY5pZeCyLDlyY996cuZfXUDlTXaAPbIE9ACrqWL2MPtWtWqhH9UN9UO/Kx0c1V68SoK3uAyhVqLNyYBKXf+pSvVFHFeCo7tRWFrm/gU+gA1yH6uoN+GnG4RDAuXpJPwJ1qh5qIqUaqDSTLe/AxQmXFfBUdSI25TUOudot51Azdajeq5saYJ4CKhnwCzwDPeAV+AKK6BfAuprzH27xJnqkh2Q3AAAAAElFTkSuQmCC"

/***/ }),
/* 493 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAJCAYAAAAGuM1UAAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+IEmuOgAAAJVJREFUGJV1kCsOwkAURQ8FgSCpRoMiYQN0h6yFNWDqSKhCDooEqiaE8EnVwVTAMBx5731f1Ept1FaN/hJ7r1Er1DoT+kddADO+uQIv8swLoEzEQwhh2XXdBjDxSnJjVYBhjHGdmqiPTMFC3WaaPQfqGZh+jL0DY2CUuaEtgGMiTv6EAQLqSt2pp/7nt2SNqF7UvVq9AeWL9PbVtLyaAAAAAElFTkSuQmCC"

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/favicon.ed390e0.ico";

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/favicon.ff15cb9.ico";

/***/ }),
/* 496 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/header-img.f7877a7.png";

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/header-logo.9874184.png";

/***/ }),
/* 499 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 500 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 501 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 502 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/CurrentIssueCover.ea56a01.png";

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/IssueCover.31cb308.png";

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/MobileSiteCover.cedbbe8.png";

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/SponsorshipCover.dd94cd6.png";

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/no-image-available.73f0bca.png";

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/slide-1.4f5be77.jpg";

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/slide-2.70b8df8.jpg";

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/slide-3.08a9939.jpg";

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/slide-4.6e551f6.jpg";

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/test_video.53027ba.png";

/***/ }),
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(369)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(201),
  /* template */
  __webpack_require__(1401),
  /* scopeId */
  "data-v-20d2dbd8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(411)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(202),
  /* template */
  __webpack_require__(1447),
  /* scopeId */
  "data-v-6e6e6ab4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(374)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(203),
  /* template */
  __webpack_require__(1408),
  /* scopeId */
  "data-v-269c2ed6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(378)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(204),
  /* template */
  __webpack_require__(1413),
  /* scopeId */
  "data-v-2bb76eef",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(436)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(205),
  /* template */
  __webpack_require__(1476),
  /* scopeId */
  "data-v-c9c570d0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(434)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(206),
  /* template */
  __webpack_require__(1474),
  /* scopeId */
  "data-v-c2022ffa",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(352)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(207),
  /* template */
  __webpack_require__(1380),
  /* scopeId */
  "data-v-071c6768",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(415)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(209),
  /* template */
  __webpack_require__(1452),
  /* scopeId */
  "data-v-72340032",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(365)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(210),
  /* template */
  __webpack_require__(1395),
  /* scopeId */
  "data-v-17c9f477",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(349)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(211),
  /* template */
  __webpack_require__(1377),
  /* scopeId */
  "data-v-01216af8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(402)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(212),
  /* template */
  __webpack_require__(1437),
  /* scopeId */
  "data-v-5fb196b0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(385)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(213),
  /* template */
  __webpack_require__(1420),
  /* scopeId */
  "data-v-3dcee436",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(418)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(214),
  /* template */
  __webpack_require__(1455),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(217),
  /* template */
  __webpack_require__(1435),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(218),
  /* template */
  __webpack_require__(1411),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(219),
  /* template */
  __webpack_require__(1397),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(221),
  /* template */
  __webpack_require__(1442),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(222),
  /* template */
  __webpack_require__(1471),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(223),
  /* template */
  __webpack_require__(1394),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(224),
  /* template */
  __webpack_require__(1449),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(225),
  /* template */
  __webpack_require__(1461),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(226),
  /* template */
  __webpack_require__(1464),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(227),
  /* template */
  __webpack_require__(1439),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(228),
  /* template */
  __webpack_require__(1441),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(229),
  /* template */
  __webpack_require__(1396),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(230),
  /* template */
  __webpack_require__(1402),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(392)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(231),
  /* template */
  __webpack_require__(1427),
  /* scopeId */
  "data-v-4cb66eb4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(381)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(234),
  /* template */
  __webpack_require__(1416),
  /* scopeId */
  "data-v-31482fea",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(362)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(235),
  /* template */
  __webpack_require__(1391),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(422)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(236),
  /* template */
  __webpack_require__(1459),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(427)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(237),
  /* template */
  __webpack_require__(1466),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(401)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(238),
  /* template */
  __webpack_require__(1436),
  /* scopeId */
  "data-v-5f9ad586",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(355)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(239),
  /* template */
  __webpack_require__(1384),
  /* scopeId */
  "data-v-0afaff32",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(409)
__webpack_require__(408)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(240),
  /* template */
  __webpack_require__(1445),
  /* scopeId */
  "data-v-6c9330c3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(440)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(241),
  /* template */
  __webpack_require__(1481),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(431)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(242),
  /* template */
  __webpack_require__(1470),
  /* scopeId */
  "data-v-b278e788",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(373)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(243),
  /* template */
  __webpack_require__(1407),
  /* scopeId */
  "data-v-2641a35d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(387)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(244),
  /* template */
  __webpack_require__(1422),
  /* scopeId */
  "data-v-3f7ff282",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(391)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(245),
  /* template */
  __webpack_require__(1426),
  /* scopeId */
  "data-v-496b0c42",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(353)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(246),
  /* template */
  __webpack_require__(1382),
  /* scopeId */
  "data-v-07cfe3d7",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(358)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(248),
  /* template */
  __webpack_require__(1387),
  /* scopeId */
  "data-v-0d98c577",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(420)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(249),
  /* template */
  __webpack_require__(1457),
  /* scopeId */
  "data-v-7f1d560e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(359)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(251),
  /* template */
  __webpack_require__(1388),
  /* scopeId */
  "data-v-0e07b582",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(417)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(256),
  /* template */
  __webpack_require__(1454),
  /* scopeId */
  "data-v-78ce083d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(416)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(257),
  /* template */
  __webpack_require__(1453),
  /* scopeId */
  "data-v-758b32ae",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(382)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(258),
  /* template */
  __webpack_require__(1417),
  /* scopeId */
  "data-v-31676c2c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(404)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(259),
  /* template */
  __webpack_require__(1440),
  /* scopeId */
  "data-v-63b9317c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(389)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(260),
  /* template */
  __webpack_require__(1424),
  /* scopeId */
  "data-v-412d6f14",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(368)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(261),
  /* template */
  __webpack_require__(1400),
  /* scopeId */
  "data-v-2083772a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(377)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(262),
  /* template */
  __webpack_require__(1412),
  /* scopeId */
  "data-v-2b2166c5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(428)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(263),
  /* template */
  __webpack_require__(1467),
  /* scopeId */
  "data-v-aa68bb34",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(397)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(265),
  /* template */
  __webpack_require__(1431),
  /* scopeId */
  "data-v-51f64acd",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(266),
  /* template */
  __webpack_require__(1403),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(438)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(267),
  /* template */
  __webpack_require__(1479),
  /* scopeId */
  "data-v-dc1fa724",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(413)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(268),
  /* template */
  __webpack_require__(1450),
  /* scopeId */
  "data-v-714bba36",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(379)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(269),
  /* template */
  __webpack_require__(1414),
  /* scopeId */
  "data-v-2c1d4cfc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(364)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(270),
  /* template */
  __webpack_require__(1393),
  /* scopeId */
  "data-v-1419971f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(370)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(271),
  /* template */
  __webpack_require__(1404),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(405)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(272),
  /* template */
  __webpack_require__(1443),
  /* scopeId */
  "data-v-686f0bc3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(429)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(273),
  /* template */
  __webpack_require__(1468),
  /* scopeId */
  "data-v-ab7a1c3e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(361)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(274),
  /* template */
  __webpack_require__(1390),
  /* scopeId */
  "data-v-1083abcb",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(388)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(275),
  /* template */
  __webpack_require__(1423),
  /* scopeId */
  "data-v-3fa17ca0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(424)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(276),
  /* template */
  __webpack_require__(1462),
  /* scopeId */
  "data-v-8fd7623a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(412)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(277),
  /* template */
  __webpack_require__(1448),
  /* scopeId */
  "data-v-6f375c08",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(403)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(278),
  /* template */
  __webpack_require__(1438),
  /* scopeId */
  "data-v-604fde3d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(430)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(279),
  /* template */
  __webpack_require__(1469),
  /* scopeId */
  "data-v-adeb886c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(367)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(280),
  /* template */
  __webpack_require__(1399),
  /* scopeId */
  "data-v-1ca30492",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(350)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(281),
  /* template */
  __webpack_require__(1378),
  /* scopeId */
  "data-v-02bc4e67",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(376)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(282),
  /* template */
  __webpack_require__(1410),
  /* scopeId */
  "data-v-29a331e9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(354)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(283),
  /* template */
  __webpack_require__(1383),
  /* scopeId */
  "data-v-0912f6a4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(410)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(284),
  /* template */
  __webpack_require__(1446),
  /* scopeId */
  "data-v-6e2080f5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(356)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(285),
  /* template */
  __webpack_require__(1385),
  /* scopeId */
  "data-v-0c309c59",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(366)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(286),
  /* template */
  __webpack_require__(1398),
  /* scopeId */
  "data-v-1c08ccce",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(351)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(292),
  /* template */
  __webpack_require__(1379),
  /* scopeId */
  "data-v-03cc34d2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(406)
__webpack_require__(407)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(299),
  /* template */
  __webpack_require__(1444),
  /* scopeId */
  "data-v-6c32d281",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(301),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(400)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(302),
  /* template */
  __webpack_require__(1434),
  /* scopeId */
  "data-v-5bf596c6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(390)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(305),
  /* template */
  __webpack_require__(1425),
  /* scopeId */
  "data-v-45c429dc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1377 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page-title"
  }, [_vm._v(_vm._s(_vm.siteName) + " Supports the Sponsor Community")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('title-block', {
    attrs: {
      "title": "Request Sponsorship",
      "color-theme": "primary-color"
    }
  }, [_c('div', {
    staticClass: "input-group half left"
  }, [_c('b-form-fieldset', {
    class: {
      error: _vm.attemptSubmit && !_vm.validation.firstname
    },
    attrs: {
      "label": "Firstname:"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Enter First Name",
      "type": "text"
    },
    model: {
      value: (_vm.requestData.firstname),
      callback: function($$v) {
        _vm.$set(_vm.requestData, "firstname", $$v)
      },
      expression: "requestData.firstname"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "input-group half"
  }, [_c('b-form-fieldset', {
    class: {
      error: _vm.attemptSubmit && !_vm.validation.lastname
    },
    attrs: {
      "label": "Lastname:"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Enter Last Name",
      "type": "text"
    },
    model: {
      value: (_vm.requestData.lastname),
      callback: function($$v) {
        _vm.$set(_vm.requestData, "lastname", $$v)
      },
      expression: "requestData.lastname"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "devider"
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('b-form-fieldset', {
    class: {
      error: _vm.attemptSubmit && !_vm.validation.title
    },
    attrs: {
      "label": "Title:"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Enter Your Title",
      "type": "text"
    },
    model: {
      value: (_vm.requestData.title),
      callback: function($$v) {
        _vm.$set(_vm.requestData, "title", $$v)
      },
      expression: "requestData.title"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "devider"
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('b-form-fieldset', {
    class: {
      error: _vm.attemptSubmit && !_vm.validation.organization
    },
    attrs: {
      "label": "Organization:"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Enter Organization",
      "type": "text"
    },
    model: {
      value: (_vm.requestData.organization),
      callback: function($$v) {
        _vm.$set(_vm.requestData, "organization", $$v)
      },
      expression: "requestData.organization"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "devider"
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group half left"
  }, [_c('b-form-fieldset', {
    class: {
      error: _vm.attemptSubmit && !_vm.validation.email
    },
    attrs: {
      "label": "Email Address:"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Enter Email Address",
      "type": "text"
    },
    model: {
      value: (_vm.requestData.email),
      callback: function($$v) {
        _vm.$set(_vm.requestData, "email", $$v)
      },
      expression: "requestData.email"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "input-group half"
  }, [_c('b-form-fieldset', {
    class: {
      error: _vm.attemptSubmit && !_vm.validation.phone
    },
    attrs: {
      "label": "Phone:"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Enter Phone Number",
      "formatter": _vm.phoneFormater
    },
    model: {
      value: (_vm.requestData.phone),
      callback: function($$v) {
        _vm.$set(_vm.requestData, "phone", $$v)
      },
      expression: "requestData.phone"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "devider"
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group half left"
  }, [_c('b-form-fieldset', {
    class: {
      error: _vm.attemptSubmit && !_vm.validation.topic
    },
    attrs: {
      "label": "Conference Topic:"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Describe your conference topic",
      "type": "text"
    },
    model: {
      value: (_vm.requestData.topic),
      callback: function($$v) {
        _vm.$set(_vm.requestData, "topic", $$v)
      },
      expression: "requestData.topic"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "input-group half"
  }, [_c('b-form-fieldset', {
    class: {
      error: _vm.attemptSubmit && !_vm.validation.date
    },
    attrs: {
      "label": "Conference Date:"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Enter the date",
      "type": "text",
      "formatter": _vm.dateFormater
    },
    model: {
      value: (_vm.requestData.date),
      callback: function($$v) {
        _vm.$set(_vm.requestData, "date", $$v)
      },
      expression: "requestData.date"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "devider"
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('b-form-fieldset', {
    class: {
      error: _vm.attemptSubmit && !_vm.validation.description
    },
    attrs: {
      "label": ("Please describe your event and how " + _vm.siteName + " could fit into it:")
    }
  }, [_c('b-form-input', {
    attrs: {
      "textarea": "",
      "rows": 3
    },
    model: {
      value: (_vm.requestData.description),
      callback: function($$v) {
        _vm.$set(_vm.requestData, "description", $$v)
      },
      expression: "requestData.description"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.request()
      }
    }
  }, [_vm._v("Submit")]), _vm._v(" "), (_vm.attemptSubmit && !_vm.isValid) ? _c('div', [_vm._v("Error")]) : _vm._e()])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisiLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisiLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisiLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi.")])])
}]}

/***/ }),
/* 1378 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-8"
  }, [_c('interview-video', {
    attrs: {
      "issue": _vm.issue
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('interview-video', {
    attrs: {
      "issue": _vm.issue
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mb-2"
  }), _vm._v(" "), _c('interview-video', {
    attrs: {
      "issue": _vm.issue
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('i', [_vm._v("Youtube")])])
}]}

/***/ }),
/* 1379 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "left-panel"
  }, [_c('a', [_c('i', [_c('icon', {
    attrs: {
      "name": "file-text-o",
      "scale": "2"
    }
  })], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Home'
      }
    }
  }, [_c('i', [_c('icon', {
    attrs: {
      "name": "home",
      "scale": "2"
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-panel"
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    staticClass: "secondary"
  }, [_c('i', [_c('icon', {
    attrs: {
      "name": "search",
      "scale": "2"
    }
  })], 1)]), _vm._v(" "), _c('a', {
    staticClass: "secondary"
  }, [_c('i', [_c('icon', {
    attrs: {
      "name": "arrow-circle-up",
      "scale": "2"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "switch-panel",
    attrs: {
      "id": "swichPanel"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.switchToTraditional()
      }
    }
  }, [_vm._v("< Switch to Traditional Reading Experience")])])]), _vm._v(" "), (_vm.prevPage) ? _c('div', {
    staticClass: "nav-btn btn-top",
    on: {
      "click": function($event) {
        _vm.navigateTop()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "caret-up",
      "scale": "2"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.nextPage) ? _c('div', {
    staticClass: "nav-btn btn-bottom",
    on: {
      "click": function($event) {
        _vm.navigateBottom()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "caret-down",
      "scale": "2"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.prevSlide) ? _c('div', {
    class: {
      'nav-btn': true, 'btn-left': true, 'has-nav-top': _vm.prevPage, 'has-nav-bottom': _vm.nextPage
    },
    on: {
      "click": function($event) {
        _vm.navigateLeft()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "caret-left",
      "scale": "2"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.nextSlide) ? _c('div', {
    class: {
      'nav-btn': true, 'btn-right': true, 'has-nav-top': _vm.prevPage, 'has-nav-bottom': _vm.nextPage
    },
    on: {
      "click": function($event) {
        _vm.navigateRight()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "caret-right",
      "scale": "2"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "touch",
      rawName: "v-touch:swipe",
      value: (_vm.swipeHandler),
      expression: "swipeHandler",
      arg: "swipe"
    }],
    class: {
      'enhanced-container': true, 'has-nav-top': _vm.prevPage, 'has-nav-bottom': _vm.nextPage
    },
    attrs: {
      "id": "enhanced-container"
    }
  }, [_c('transition', {
    attrs: {
      "name": "page",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "primary"
  }, [_c('i', [_vm._v("Submit Paper")])])
}]}

/***/ }),
/* 1380 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page-title"
  }, [_vm._v("Employees")]), _vm._v(" "), _c('div', {
    staticClass: "authors-list"
  }, _vm._l((_vm.employees), function(employee) {
    return _c('author', {
      key: employee.id,
      attrs: {
        "author": employee
      }
    }, [_c('router-link', {
      attrs: {
        "slot": "details-link",
        "to": {
          name: 'editorialBoardMemberDetail',
          params: {
            id: employee.id
          }
        }
      },
      slot: "details-link"
    }, [_vm._v("Read More")])], 1)
  }))])
},staticRenderFns: []}

/***/ }),
/* 1381 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row for-authors-policies"
  }, [_c('div', {
    staticClass: "col-md-3 hidden-sm-down"
  }, [_c('for-authors-page-side-menu', {
    attrs: {
      "anchors-list": _vm.menuAnchorsList
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md"
  }, [_c('for-authors-ethics-malpractice-content', {
    attrs: {
      "anchors-list": _vm.menuAnchorsList,
      "id": _vm.menuAnchorsList[0].anchor
    }
  }), _vm._v(" "), _c('for-authors-copyright-licensing-content', {
    attrs: {
      "anchors-list": _vm.menuAnchorsList,
      "id": _vm.menuAnchorsList[1].anchor
    }
  }), _vm._v(" "), _c('for-authors-peer-review-content', {
    attrs: {
      "anchors-list": _vm.menuAnchorsList,
      "id": _vm.menuAnchorsList[2].anchor
    }
  }), _vm._v(" "), _c('for-authors-plagerism-content', {
    attrs: {
      "anchors-list": _vm.menuAnchorsList,
      "id": _vm.menuAnchorsList[3].anchor
    }
  }), _vm._v(" "), _c('for-authors-processing-fee-content', {
    attrs: {
      "anchors-list": _vm.menuAnchorsList,
      "id": _vm.menuAnchorsList[4].anchor
    }
  }), _vm._v(" "), _c('for-authors-archiving-content', {
    attrs: {
      "anchors-list": _vm.menuAnchorsList,
      "id": _vm.menuAnchorsList[5].anchor
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1382 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-nav-item-dropdown', {
    attrs: {
      "text": "Publications"
    }
  }, [_c('b-dropdown-item', {
    on: {
      "click": function($event) {
        _vm.goTo({
          name: 'issueDetail',
          params: {
            volumeId: 1,
            issueId: 1
          }
        })
      }
    }
  }, [_vm._v("Current Issue")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        _vm.goTo({
          name: 'advanceOnlinePublications'
        })
      }
    }
  }, [_vm._v("Advance Online Publications")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        _vm.goTo({
          name: 'archivedIssues'
        })
      }
    }
  }, [_vm._v("Archived Issues")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        _vm.goTo({
          name: 'collections'
        })
      }
    }
  }, [_vm._v("Collections")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        _vm.goTo({
          name: 'videos'
        })
      }
    }
  }, [_vm._v("Videos")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        _vm.goTo({
          name: 'authorInterviews'
        })
      }
    }
  }, [_vm._v("Author Interviews")])], 1)
},staticRenderFns: []}

/***/ }),
/* 1383 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.article) ? _c('article-detail-component', [(!_vm.$store.state.isEnhanced) ? _c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.article.title))]), _vm._v(" "), _c('issue-authors', {
    attrs: {
      "authors": _vm.article.authors
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('sidebar-article-section', {
    attrs: {
      "slot": "bar",
      "article": _vm.article
    },
    slot: "bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "keywords",
    attrs: {
      "slot": "keywords"
    },
    slot: "keywords"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n      Keywords:\n    ")]), _vm._v(" "), _c('div', {}, _vm._l((_vm.article.keywords), function(keyword) {
    return _c('div', {
      staticClass: "link"
    }, [_vm._v(_vm._s(keyword))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "current-issue",
    attrs: {
      "slot": "current_article"
    },
    slot: "current_article"
  }, [_c('em', [_vm._v("Current Article:")]), _vm._v(" "), _c('condensed-issue', {
    staticClass: "mt-2",
    attrs: {
      "issue": _vm.article
    }
  })], 1), _vm._v(" "), _c('div', _vm._l((_vm.issues), function(issue, index) {
    return (index < 5) ? _c('condensed-issue', {
      key: issue.id,
      attrs: {
        "issue": issue
      }
    }) : _vm._e()
  }))], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1384 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header"
  }, [_c('div', {
    staticClass: "row justify-content-between"
  }, [_c('div', {
    staticClass: "col-auto p-0"
  }, [_c('b-nav', [_vm._l((_vm.$route.meta.breadcrumbObject), function(linkObj, linkTitle) {
    return _c('b-nav-item', {
      key: linkTitle
    }, [_c('router-link', {
      attrs: {
        "to": linkObj
      }
    }, [_vm._v("\n            " + _vm._s(linkTitle) + "\n          ")]), _vm._v(" "), _c('span', [_vm._v("/")])], 1)
  }), _vm._v(" "), _vm._l((_vm.breadcrumbs), function(linkObj) {
    return _c('b-nav-item', [_c('router-link', {
      attrs: {
        "to": linkObj
      }
    }, [_vm._v("\n            " + _vm._s(linkObj.text) + "\n          ")]), _vm._v(" "), _c('span', [_vm._v("/")])], 1)
  })], 2)], 1), _vm._v(" "), (_vm.linkText) ? _c('div', {
    staticClass: "col link"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: _vm.routeName
      }
    }
  }, [_vm._v(_vm._s(_vm.linkText))])], 1) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 1385 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-filter"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md title"
  }, [_vm._v(" " + _vm._s(_vm.title[_vm.$route.name]) + "\n      "), _c('em', [_vm._v(_vm._s(_vm.totalItemsCount) + " Results  ( Filtered to " + _vm._s(_vm.filteredItemsCount) + " results )")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md show"
  }, [_c('span', [_vm._v("Show me:")]), _vm._v(" "), _c('span', {
    class: {
      active: _vm.queryParams.show == 'all'
    },
    on: {
      "click": function($event) {
        _vm.onChangeQueryParams({
          show: 'all'
        })
      }
    }
  }, [_vm._v("All Results")]), _vm._v(" "), _c('span', {
    class: {
      active: _vm.queryParams.show == 'videos'
    },
    on: {
      "click": function($event) {
        _vm.onChangeQueryParams({
          show: 'videos'
        })
      }
    }
  }, [_vm._v("Videos")]), _vm._v(" "), _c('span', {
    class: {
      active: _vm.queryParams.show == 'figures'
    },
    on: {
      "click": function($event) {
        _vm.onChangeQueryParams({
          show: 'figures'
        })
      }
    }
  }, [_vm._v("Figures")]), _vm._v(" "), _c('span', {
    class: {
      active: _vm.queryParams.show == 'tags'
    },
    on: {
      "click": function($event) {
        _vm.onChangeQueryParams({
          show: 'tags'
        })
      }
    }
  }, [_vm._v("Tags")])])]), _vm._v(" "), _c('div', {
    staticClass: "filter-params row m-0 justify-content-between"
  }, [_c('div', {
    staticClass: "col-md-auto"
  }, [_c('span', [_vm._v("Filter By:")]), _vm._v(" "), _c('b-form-select', {
    attrs: {
      "value": _vm.queryParams.paperType,
      "options": _vm.paperTypes
    },
    on: {
      "input": function($event) {
        _vm.onChangeQueryParams({
          paperType: $event
        })
      }
    }
  }), _vm._v(" "), _c('b-form-select', {
    attrs: {
      "value": _vm.queryParams.author,
      "options": _vm.authors
    },
    on: {
      "input": function($event) {
        _vm.onChangeQueryParams({
          author: $event
        })
      }
    }
  }), _vm._v(" "), _c('b-form-select', {
    attrs: {
      "value": _vm.queryParams.keyword,
      "options": _vm.keywords
    },
    on: {
      "input": function($event) {
        _vm.onChangeQueryParams({
          keyword: $event
        })
      }
    }
  }), _vm._v(" "), _c('b-form-select', {
    attrs: {
      "value": _vm.queryParams.vol,
      "options": _vm.volumes
    },
    on: {
      "input": function($event) {
        _vm.onChangeQueryParams({
          vol: $event
        })
      }
    }
  }), _vm._v(" "), _c('b-form-select', {
    attrs: {
      "value": _vm.queryParams.issue,
      "options": _vm.issues
    },
    on: {
      "input": function($event) {
        _vm.onChangeQueryParams({
          issue: $event
        })
      }
    }
  }), _vm._v(" "), _c('b-form-input', {
    staticClass: "custom-select",
    attrs: {
      "value": _vm.queryParams.date,
      "type": "date",
      "placeholder": "Date"
    },
    on: {
      "input": function($event) {
        _vm.onChangeQueryParams({
          date: $event
        })
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-auto"
  }, [_c('span', [_vm._v("Sort By:")]), _vm._v(" "), _c('b-form-select', {
    attrs: {
      "value": _vm.queryParams.sortBy,
      "options": _vm.sortBy
    },
    on: {
      "input": function($event) {
        _vm.onChangeQueryParams({
          sortBy: $event
        })
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row m-0 justify-content-between filter-labels"
  }, [_c('div', {
    staticClass: "col-md p-0"
  }, _vm._l((_vm.queryParams), function(value, key) {
    return (value && key !== 'sortBy' && key !== 'show') ? _c('filter-label', {
      key: value,
      attrs: {
        "param-name": key
      },
      on: {
        "remove": function($event) {
          _vm.removeFilter($event)
        }
      }
    }, [_vm._v("\n        " + _vm._s(value))]) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "col-md-auto"
  }, [_c('b-button', {
    on: {
      "click": _vm.clearFilters
    }
  }, [_vm._v("\n        Clear Filters\n      ")])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1386 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    class: _vm.colorTheme,
    attrs: {
      "id": _vm.id
    }
  }, [_c('div', {
    staticClass: "d-flex header align-items-end justify-content-between"
  }, [_c('div', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.linkTitle) ? _c('div', [_c('router-link', {
    attrs: {
      "to": {
        name: _vm.linkName
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.viewAll($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.linkTitle)), _c('i', {
    staticClass: "icon icon-color-arrow-right"
  })])], 1) : _vm._e()]), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 1387 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title"
  }, [_vm._v("\n  " + _vm._s(_vm.sortBar.title) + " "), _c('span', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.sortBar.count))]), _vm._v(" "), _c('div', {
    staticClass: "sort-field"
  }, [_vm._v("\n    Sort by:\n    "), _c('b-form-select', {
    attrs: {
      "value": _vm.queryParams.sortBy,
      "options": _vm.sortBy
    },
    on: {
      "input": function($event) {
        _vm.onChangeQueryParams({
          sortBy: $event
        })
      }
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1388 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar"
  }, [(_vm.$route.name !== 'issueDetail') ? _c('sidebar-current-issue') : _vm._e(), _vm._v(" "), _c('sidebar-signup-button'), _vm._v(" "), _c('div', {
    staticClass: "pb-3"
  }), _vm._v(" "), _c('title-block', {
    attrs: {
      "title": "Aims & Scope:",
      "link-title": "learn more",
      "link-name": "forAuthorsPolicies"
    }
  }, [_c('div', {
    staticClass: "sidebar-block-content"
  }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget")])]), _vm._v(" "), _c('title-block', {
    attrs: {
      "title": "Impact Factor / Index / Archive:"
    }
  }, [_c('div', {
    staticClass: "sidebar-block-content"
  }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor.")])]), _vm._v(" "), _c('title-block', {
    attrs: {
      "title": "Ethics & Malpractice Statement:",
      "link-title": "View Full Statement",
      "link-name": "forAuthorsPolicies"
    }
  }, [_c('div', {
    staticClass: "sidebar-block-content"
  }, [_c('ethics-and-malpractice-content')], 1)]), _vm._v(" "), _c('sidebar-quick-links'), _vm._v(" "), _c('sidebar-sponsorship'), _vm._v(" "), _c('title-block', {
    attrs: {
      "title": ((_vm.site.name) + " Enhanced View:"),
      "link-title": "learn more",
      "link-name": "forAuthorsPolicies"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.getStaticPath('img/temp/' + _vm.site.mobileSiteCoverUrl)
    }
  })])], 1)
},staticRenderFns: []}

/***/ }),
/* 1389 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.currentIssue) ? _c('div', {
    staticClass: "currentIssueComponent"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n      Current Issue: "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("\n      Volume " + _vm._s(_vm.currentIssue.volume) + " , Issue " + _vm._s(_vm.currentIssue.issue) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-between"
  }, [_c('div', {
    staticClass: "col mb-2 pr-0"
  }, [_c('img', {
    attrs: {
      "width": "207",
      "src": _vm.currentIssue.optimized_urls.small
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col links"
  }, _vm._l((_vm.currentIssue.rubricLinks), function(link) {
    return _c('router-link', {
      key: link.url,
      staticClass: "link",
      attrs: {
        "to": link.url
      }
    }, [_vm._v(_vm._s(link.text)), _c('i', {
      staticClass: "icon icon-color-arrow-right"
    })])
  }))])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1390 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('section', [_c('interview-video', {
    attrs: {
      "issue": _vm.issue
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('i', [_vm._v("Videos")])])
}]}

/***/ }),
/* 1391 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-copyright"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('p', {
    staticClass: "my-4"
  }, [_vm._v("All site content, except where otherwise notes, is licensed under a Creative Commons Attribution 3.0 License.")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('p', {
    staticClass: "my-4"
  }, [_vm._v("Copyright © 2008-2016 Impact Journals, LLC. All rights reserved. Impact Journals is a trademark of Impact Journals, LLC.")])])])])])
}]}

/***/ }),
/* 1392 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('media-container', {
    attrs: {
      "issue": _vm.issue,
      "figures": _vm.issue.files.figures
    }
  }), _vm._v(" "), _c('issue-authors', {
    attrs: {
      "authors": _vm.issue.authors
    }
  }), _vm._v(" "), (_vm.issue.abstract) ? _c('div', {
    staticClass: "abstract",
    class: {
      hide: !_vm.isAbstractShow
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("ABSTRACT")]), _vm._v(" "), _c('div', {
    staticClass: "fullText",
    domProps: {
      "innerHTML": _vm._s(_vm.issue.abstract)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.issue._id) ? _c('div', {
    staticClass: "article-quick-links"
  }, [_c('article-quick-links', {
    attrs: {
      "article": _vm.issue
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1393 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.article) ? _c('div', [_c('h1', [_vm._v("Figures")]), _vm._v(" "), _vm._l((_vm.article.files.figures), function(figure) {
    return _c('section', [_c('h2', [_vm._v(_vm._s(figure.label))]), _vm._v(" "), _c('div', [_c('img', {
      attrs: {
        "src": figure.url
      }
    })]), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(figure.caption)
      }
    })])
  })], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1394 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col title"
  }, [_vm._v("Processing Fee")]), _vm._v(" "), _c('div', {
    staticClass: "col-3 pl-1 hidden-md-up"
  }, [_c('for-authors-mobile-menu', {
    attrs: {
      "anchors-list": _vm.anchorsList
    }
  })], 1)]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.siteName) + "\n    "), _c('br'), _vm._v(" "), _vm._v("\n    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapienLorem ipsum dolor sit amet, consectetur adipiscing elit.\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 1395 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page-title"
  }, [_vm._v("History")]), _vm._v(" "), _c('section', [_vm._v("\n    " + _vm._s(_vm.siteName) + " is a multidisciplinary traditional journal with free-access. " + _vm._s(_vm.siteName) + " publishes papers online in weekly issues. Each issue or paper can be printed for special demand.\n    Our mission is to make scientific results rapidly and widely available. To maximize the impact of research via insightful review. To allow exceptional discoveries to be shared quickly. To eliminate the border between specialties. To link different fields of biomedical science. To foster applications of basic and clinical science to fight disease.\n    Under the leadership of the most prominent scientists, the journal helps all researchers contribute to the progress of science. Life without disease is our ultimate goal.\n    The success of Oncotarget has prompted us to launch sections beyond oncology.\n  ")]), _vm._v(" "), _c('section', [_vm._v("\n    Open Access Statement\n    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisiLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.\n  ")]), _vm._v(" "), _c('title-block', {
    attrs: {
      "title": "Metrics",
      "color-theme": "primary-color"
    }
  }, [_c('div')])], 1)
},staticRenderFns: []}

/***/ }),
/* 1396 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col title"
  }, [_vm._v("Submission")]), _vm._v(" "), _c('div', {
    staticClass: "col-3 pl-1 hidden-md-up"
  }, [_c('for-authors-mobile-menu', {
    attrs: {
      "anchors-list": _vm.anchorsList
    }
  })], 1)]), _vm._v(" "), _c('div', [_c('p', [_vm._v("\n      All submissions must be made electronically through the online submission system ("), _c('a', {
    attrs: {
      "href": ("http://" + _vm.site + ".msubmit.net/cgi-bin/main.plex"),
      "target": "_blank"
    }
  }, [_vm._v("http://" + _vm._s(_vm.site) + ".msubmit.net/cgi-bin/main.plex")]), _vm._v(").\n      Before you submit a manuscript, be sure to read all the " + _vm._s(_vm.siteName) + " Instructions for Authors/Editorial and Publishing Policies.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      You will find complete details on how to submit a manuscript when you log on to online submission system to create an author account.\n    ")])])])
},staticRenderFns: []}

/***/ }),
/* 1397 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col title"
  }, [_vm._v("Publication Ethics and Publication Malpractice Statements")]), _vm._v(" "), _c('div', {
    staticClass: "col-3 pl-1 hidden-md-up"
  }, [_c('for-authors-mobile-menu', {
    attrs: {
      "anchors-list": _vm.anchorsList
    }
  })], 1)]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.siteName) + "\n    "), _c('br'), _vm._v(" "), _vm._v("\n    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapienLorem ipsum dolor sit amet, consectetur adipiscing elit.\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 1398 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-pagination', {
    attrs: {
      "size": "md",
      "total-rows": 100,
      "per-page": 10
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  }), _vm._v("\n  ToDO: make request with the next params:\n  " + _vm._s(_vm.queryParams) + "\n")], 1)
},staticRenderFns: []}

/***/ }),
/* 1399 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_c('i', [_vm._v("Twitter")])]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('i', [_c('b', [_vm._v("Twitter Name")]), _vm._v(" @TiwtterHandle")]), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._v("\n        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet.Lorem ipsum dolor sit amet,\n        consectetur adipiscing elit. Aenean euismod bibendum laoreet.Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n        Aenean euismod bibendum laoreet.\n        "), _c('br'), _c('br'), _vm._v(" "), _c('a', [_vm._v("http://www.grc.org/programs.aspx?id=16786")])])])]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('i', [_c('b', [_vm._v("Twitter Name")]), _vm._v(" @TiwtterHandle")]), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._v("\n        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet.Lorem ipsum dolor sit amet,\n        consectetur adipiscing elit. Aenean euismod bibendum laoreet.Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n        Aenean euismod bibendum laoreet.\n        "), _c('br'), _c('br'), _vm._v(" "), _c('a', [_vm._v("http://www.grc.org/programs.aspx?id=16786")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "img h2"
  })])])]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('i', [_c('b', [_vm._v("Twitter Name")]), _vm._v(" @TiwtterHandle")]), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._v("\n        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet.Lorem ipsum dolor sit amet,\n        consectetur adipiscing elit. Aenean euismod bibendum laoreet.Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n        Aenean euismod bibendum laoreet.\n        "), _c('br'), _c('br'), _vm._v(" "), _c('a', [_vm._v("http://www.grc.org/programs.aspx?id=16786")])])])])])
}]}

/***/ }),
/* 1400 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.issue.volume) ? _c('div', [_c('div', {
    staticClass: "hidden-md-up"
  }, [_c('sidebar-current-issue'), _vm._v(" "), _c('sidebar-signup-button')], 1), _vm._v(" "), _c('div', {
    staticClass: "row issue-number hidden-sm-down"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h2', [_vm._v("Volume " + _vm._s(_vm.issue.volume) + ", Number " + _vm._s(_vm.issue.issue))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("Pages: " + _vm._s(_vm.issue.pages.start) + " - " + _vm._s(_vm.issue.pages.end))])]), _vm._v(" "), _c('div', {
    staticClass: "left-column hidden-sm-down",
    attrs: {
      "id": "issueAnchors"
    }
  }, [_c('img', {
    staticClass: "mb-2",
    attrs: {
      "width": "170",
      "src": _vm.issue.optimized_urls.small
    }
  }), _vm._v(" "), _c('div', _vm._l((_vm.issue.rubricLinks), function(link) {
    return _c('a', {
      key: link.url,
      staticClass: "link",
      class: {
        'active': _vm.currentSection === link.id
      },
      attrs: {
        "href": link.url
      }
    }, [_vm._v("\n        " + _vm._s(link.text)), _c('i', {
      staticClass: "icon icon-color-arrow-right"
    })])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "right-column"
  }, [(_vm.topArticle.ids) ? _c('full-issue', {
    attrs: {
      "issue": _vm.topArticle
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.issue.rubricLinks), function(group) {
    return _c('title-block', {
      key: group.id,
      attrs: {
        "title": group.text,
        "id": group.id,
        "color-theme": "primary-color"
      }
    }, [_c('div', _vm._l((_vm.issue.articles), function(article, index) {
      return (article.article_type.name == group.text) ? _c('condensed-issue', {
        key: article.ids.pii,
        attrs: {
          "issue": article,
          "smallMode": index > 0 && article.article_type.name === _vm.issue.articles[index - 1].article_type.name ? true : false,
          "hideType": true
        }
      }) : _vm._e()
    }))])
  }), _vm._v(" "), _c('div', {
    staticClass: "hidden-md-up"
  }, [_c('title-block', {
    attrs: {
      "title": "Impact Factor / Index / Archive:"
    }
  }, [_c('div', {
    staticClass: "sidebar-block-content"
  }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor.")])]), _vm._v(" "), _c('sidebar-sponsorship')], 1)], 2)]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1401 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Not Found")]), _vm._v(" "), _c('p', [_vm._v("The page you requested is not found.")])])
}]}

/***/ }),
/* 1402 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row for-authors-submission"
  }, [_c('div', {
    staticClass: "col-md-3 hidden-sm-down"
  }, [_c('for-authors-page-side-menu', {
    attrs: {
      "anchors-list": _vm.menuAnchorsList
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md"
  }, [_c('for-authors-submission-content', {
    attrs: {
      "anchors-list": _vm.menuAnchorsList,
      "id": _vm.menuAnchorsList[0].anchor
    }
  }), _vm._v(" "), _c('for-authors-file-submission-content', {
    attrs: {
      "anchors-list": _vm.menuAnchorsList,
      "id": _vm.menuAnchorsList[1].anchor
    }
  }), _vm._v(" "), _c('for-authors-special-submission-content', {
    attrs: {
      "anchors-list": _vm.menuAnchorsList,
      "id": _vm.menuAnchorsList[2].anchor
    }
  }), _vm._v(" "), _c('for-authors-revisions-submission-content', {
    attrs: {
      "anchors-list": _vm.menuAnchorsList,
      "id": _vm.menuAnchorsList[3].anchor
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1403 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),
/* 1404 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "interact"
  }, [(_vm.article) ? _c('media-container', {
    attrs: {
      "issue": _vm.article,
      "figures": _vm.article.files.figures
    }
  }) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('i', [_vm._v("Interact with this Article")])])
}]}

/***/ }),
/* 1405 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "article-links"
  }, [(!_vm.$store.state.isEnhanced && _vm.article.abstract) ? _c('li', {
    staticClass: "article-link-item hidden-sm-down"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.toggleAbstract()
      }
    }
  }, [_vm._v("Abstract")])]) : _vm._e(), _vm._v(" "), (_vm.article && _vm.article.files.pdf && _vm.article.files.pdf.display) ? _c('li', {
    staticClass: "article-link-item"
  }, [_c('a', {
    attrs: {
      "href": _vm.article.files.pdf.url
    }
  }, [_vm._v("PDF")])]) : _vm._e(), _vm._v(" "), (!_vm.$store.state.isEnhanced) ? _c('li', {
    staticClass: "article-link-item"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.setEnhancedView(false, {
          name: 'article-detail',
          params: {
            pii: _vm.article.ids.pii
          }
        })
      }
    }
  }, [_vm._v("Full text")])]) : _vm._e(), _vm._v(" "), (!_vm.$store.state.isEnhanced) ? _c('li', {
    staticClass: "article-link-item"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.setEnhancedView(true, {
          name: 'article-detail',
          params: {
            pii: _vm.article.ids.pii
          }
        })
      }
    }
  }, [_vm._v("Enhanced View")])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.isEnhanced) ? _c('li', {
    staticClass: "article-link-item"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.setEnhancedView(false, {
          name: 'article-detail',
          params: {
            pii: _vm.article.ids.pii
          }
        })
      }
    }
  }, [_vm._v("Traditional View")])]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('li', {
    staticClass: "article-link-item hidden-sm-down"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.$root.$emit('show::modal', 'orderReprintModal', _vm.article)
      }
    }
  }, [_vm._v("Order a Reprint")])]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "article-link-item"
  }, [_c('a', [_vm._v("How to Cite")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "article-link-item hidden-sm-down"
  }, [_c('a', [_vm._v("Related Articles")])])
}]}

/***/ }),
/* 1406 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "list-inline"
  }, [(_vm.mediaLinks.facebookUrl) ? _c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    attrs: {
      "href": _vm.mediaLinks.facebookUrl,
      "target": "_blank"
    }
  }, [_c('icon', {
    attrs: {
      "name": "facebook-f"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.mediaLinks.twitterUrl) ? _c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    attrs: {
      "href": _vm.mediaLinks.twitterUrl,
      "target": "_blank"
    }
  }, [_c('icon', {
    attrs: {
      "name": "twitter"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.mediaLinks.linkedInUrl) ? _c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    attrs: {
      "href": _vm.mediaLinks.linkedInUrl,
      "target": "_blank"
    }
  }, [_c('icon', {
    attrs: {
      "name": "linkedin"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.mediaLinks.googlePlusUrl) ? _c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    attrs: {
      "href": _vm.mediaLinks.googlePlusUrl,
      "target": "_blank"
    }
  }, [_c('icon', {
    attrs: {
      "name": "google-plus"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.mediaLinks.youTubeUrl) ? _c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    attrs: {
      "href": _vm.mediaLinks.youTubeUrl,
      "target": "_blank"
    }
  }, [_c('icon', {
    attrs: {
      "name": "youtube"
    }
  })], 1)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1407 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-nav-item-dropdown', {
    attrs: {
      "text": "About"
    }
  }, [_c('b-dropdown-item', {
    on: {
      "click": function($event) {
        _vm.goTo({
          name: 'announcements'
        })
      }
    }
  }, [_vm._v("Announcements")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        _vm.goTo({
          name: 'history'
        })
      }
    }
  }, [_vm._v("History")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        _vm.goTo({
          name: 'aimsAndScope'
        })
      }
    }
  }, [_vm._v("Aims & Scope")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        _vm.goTo({
          name: 'employees'
        })
      }
    }
  }, [_vm._v("Employees")]), _vm._v(" "), _c('b-dropdown-item', {
    staticClass: "hidden-sm-up",
    on: {
      "click": function($event) {
        _vm.goTo({
          name: 'ethicsAndMalpractice'
        })
      }
    }
  }, [_vm._v("Ethics & Malpractice")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        _vm.goTo({
          name: 'careers'
        })
      }
    }
  }, [_vm._v("Careers")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        _vm.goTo({
          name: 'contact'
        })
      }
    }
  }, [_vm._v("Contact")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        _vm.goTo({
          name: 'sponsorshipRequest'
        })
      }
    }
  }, [_vm._v("Sponsorship Request")])], 1)
},staticRenderFns: []}

/***/ }),
/* 1408 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page-title"
  }, [_vm._v("Aims & Scope")]), _vm._v(" "), _c('section', [_vm._v("\n    " + _vm._s(_vm.siteName) + " is a multidisciplinary traditional journal with free-access. Oncotarget publishes papers online in weekly issues. Each issue or paper can be printed for special demand.\n    Our mission is to make scientific results rapidly and widely available. To maximize the impact of research via insightful review. To allow exceptional discoveries to be shared quickly. To eliminate the border between specialties. To link different fields of biomedical science. To foster applications of basic and clinical science to fight disease.\n    Under the leadership of the most prominent scientists, the journal helps all researchers contribute to the progress of science. Life without disease is our ultimate goal.\n    The success of " + _vm._s(_vm.siteName) + " has prompted us to launch sections beyond oncology.\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 1409 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n    Quick Links:\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('router-link', {
    staticClass: "link ic-style-guidelines",
    attrs: {
      "to": {
        name: 'forAuthorsStyleGuidelines'
      }
    }
  }, [_vm._v("Style Guidelines"), _c('i', {
    staticClass: "icon icon-color-arrow-right-dark"
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "link ic-submit",
    attrs: {
      "to": {
        name: 'forAuthorsStyleGuidelines'
      }
    }
  }, [_vm._v("Submit a Paper"), _c('i', {
    staticClass: "icon icon-color-arrow-right-dark"
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "link ic-peer-review",
    attrs: {
      "to": {
        name: 'forAuthorsPolicies',
        hash: '#peer-review'
      }
    }
  }, [_vm._v("Peer Review"), _c('i', {
    staticClass: "icon icon-color-arrow-right-dark"
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "link ic-plagerism",
    attrs: {
      "to": {
        name: 'forAuthorsPolicies',
        hash: '#plagerism'
      }
    }
  }, [_vm._v("Plagerism"), _c('i', {
    staticClass: "icon icon-color-arrow-right-dark"
  })])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1410 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.article) ? _c('div', [(!_vm.$store.state.isEnhanced) ? _c('article-detail-component', [_c('div', {
    staticClass: "keywords",
    attrs: {
      "slot": "keywords"
    },
    slot: "keywords"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n        Keywords:\n      ")]), _vm._v(" "), _c('div', {}, _vm._l((_vm.article.keywords), function(keyword) {
    return _c('div', {
      staticClass: "link"
    }, [_vm._v(_vm._s(keyword))])
  }))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.article.title))]), _vm._v(" "), _c('issue-authors', {
    attrs: {
      "authors": _vm.article.authors
    }
  })], 1), _vm._v(" "), _c('sidebar-article-section', {
    attrs: {
      "slot": "bar",
      "article": _vm.article
    },
    slot: "bar"
  })], 1) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-lg-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('b', [_vm._v("Alt Metric")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 text-right"
  }, [_c('b', [_vm._v("29,876")]), _vm._v(" Score")]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "img h2"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-lg-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('b', [_vm._v("Views:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 text-right"
  }, [_c('b', [_vm._v("29,876")]), _vm._v(" Total Views")]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "img h1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('div', {
    staticClass: "img h1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('div', {
    staticClass: "img h1"
  })])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('b', [_vm._v("Citations:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 text-right"
  }, [_c('b', [_vm._v("29,876")]), _vm._v(" Total Citations")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-lg-3"
  }, [_c('div', {
    staticClass: "img h1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-lg-3"
  }, [_c('div', {
    staticClass: "img h1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-lg-3"
  }, [_c('div', {
    staticClass: "img h1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-lg-3"
  }, [_c('div', {
    staticClass: "img h1"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('b', [_vm._v("Mentions")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 text-right"
  }, [_c('b', [_vm._v("29,876")]), _vm._v(" Total Mentions")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-lg-3"
  }, [_c('div', {
    staticClass: "btn active"
  }, [_vm._v("News (123)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-lg-3"
  }, [_c('div', {
    staticClass: "btn btn-default"
  }, [_vm._v("Scientific Blogs (123)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-lg-3"
  }, [_c('div', {
    staticClass: "btn btn-default"
  }, [_vm._v("Google+ (123)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-lg-3"
  }, [_c('div', {
    staticClass: "btn btn-default"
  }, [_vm._v("Citations (123)")])])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet.")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor.")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('b', [_vm._v("Social Attention:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 text-right"
  }, [_c('b', [_vm._v("29,876")]), _vm._v(" Total Shares")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-3 col-lg-3"
  }, [_c('div', {
    staticClass: "img h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "img h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "img h1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-9"
  }, [_c('div', {
    staticClass: "img h3"
  })])])])
}]}

/***/ }),
/* 1411 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col title"
  }, [_vm._v("Copyright & Licensing")]), _vm._v(" "), _c('div', {
    staticClass: "col-3 pl-1 hidden-md-up"
  }, [_c('for-authors-mobile-menu', {
    attrs: {
      "anchors-list": _vm.anchorsList
    }
  })], 1)]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.siteName) + "\n    "), _c('br'), _vm._v(" "), _vm._v("\n    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapienLorem ipsum dolor sit amet, consectetur adipiscing elit.\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 1412 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.issues.length) ? _c('full-video', {
    attrs: {
      "showKeywords": true,
      "issue": _vm.issues[0]
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "videos-list"
  }, _vm._l((_vm.issues), function(issue, index) {
    return (index > 0 && index < 7) ? _c('div', {
      key: issue.id,
      staticClass: "video-item"
    }, [_c('condensed-video', {
      attrs: {
        "issue": issue,
        "showKeywords": true
      }
    })], 1) : _vm._e()
  }))], 1)
},staticRenderFns: []}

/***/ }),
/* 1413 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page-title"
  }, [_vm._v("Announcements from " + _vm._s(_vm.siteName))]), _vm._v(" "), _c('section', _vm._l((_vm.announcements), function(item) {
    return _c('div', {
      staticClass: "announcement-item"
    }, [_c('div', {
      staticClass: "posted-date"
    }, [_vm._v("Posted " + _vm._s(_vm.getFormatedDate(item.postedDate)))]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [(item.titlePrefix) ? _c('span', [_vm._v(_vm._s(item.titlePrefix) + ": ")]) : _vm._e(), _vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "description"
    }, [_vm._v(_vm._s(item.description))]), _vm._v(" "), (item.url) ? _c('div', {}, [_c('a', {
      attrs: {
        "href": item.url
      }
    }, [_vm._v(_vm._s(item.url))])]) : _vm._e()])
  })), _vm._v(" "), _c('title-block', {
    attrs: {
      "title": "Trending Keywords",
      "link-title": "View All",
      "link-name": "",
      "color-theme": "primary-color"
    }
  }, [_c('div')]), _vm._v(" "), _c('title-block', {
    attrs: {
      "title": "Trending Popular Articles",
      "link-title": "View All",
      "link-name": "",
      "color-theme": "primary-color"
    }
  }, [_c('div', _vm._l((_vm.issues), function(issue, index) {
    return (index < 3) ? _c('condensed-issue', {
      key: issue.id,
      attrs: {
        "issue": issue
      }
    }) : _vm._e()
  }))]), _vm._v(" "), _c('title-block', {
    attrs: {
      "title": ("Top 5 " + _vm.siteName + " Papers Rated by Altmetric Attention Score"),
      "link-title": "View All",
      "link-name": "",
      "color-theme": "primary-color"
    }
  }, [_c('div', _vm._l((_vm.issues), function(issue, index) {
    return (index < 5) ? _c('condensed-issue', {
      key: issue.id,
      attrs: {
        "issue": issue
      }
    }) : _vm._e()
  }))]), _vm._v(" "), _c('title-block', {
    attrs: {
      "title": "Google Mention Alert",
      "color-theme": "primary-color"
    }
  }, [_c('div')]), _vm._v(" "), _c('title-block', {
    attrs: {
      "title": "Social Feeds",
      "color-theme": "primary-color"
    }
  }, [_c('div')])], 1)
},staticRenderFns: []}

/***/ }),
/* 1414 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b', [_vm._v("Geographics")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "img h2"
  })])])]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b', [_vm._v("Specifics:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-lg-3"
  }, [_c('div', {
    staticClass: "img h1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-lg-3"
  }, [_c('div', {
    staticClass: "img h1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-lg-3"
  }, [_c('div', {
    staticClass: "img h1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-lg-3"
  }, [_c('div', {
    staticClass: "img h1"
  })])])])])
}]}

/***/ }),
/* 1415 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n    " + _vm._s(_vm.siteName) + " follows the COPE Code of Conduct and Best Practice Guidelines for Journal Editors and the Code of Conduct for Journal Publishers.\n    "), _c('a', {
    attrs: {
      "href": "http://publicationethics.org/resources/code-conduct",
      "target": "_blank"
    }
  }, [_vm._v(" http://publicationethics.org/resources/code-conduct")]), _vm._v(" "), _c('br'), _vm._v("\n    " + _vm._s(_vm.siteName) + " follows the COPE general guidelines as well.\n    "), _c('a', {
    attrs: {
      "href": "http://publicationethics.org/resources/guidelines",
      "target": "_blank"
    }
  }, [_vm._v("http://publicationethics.org/resources/guidelines")]), _vm._v(" "), _c('br'), _vm._v("\n    Also, editors, authors, reviewers should follow the best-practice guidelines on ethical behavior ICMJE’s Recommendations for the Conduct,\n    Reporting, Editing and Publication of Scholarly Work in Medical Journals.\n    "), _c('a', {
    attrs: {
      "href": " http://www.icmje.org/recommendations/",
      "target": "_blank"
    }
  }, [_vm._v(" http://www.icmje.org/recommendations/")]), _vm._v("  In addition, " + _vm._s(_vm.siteName) + "\n    follows the relevant guidelines from Elsevier and its journals.\n    "), _c('a', {
    attrs: {
      "href": "https://www.elsevier.com/editors/publishing-ethics/perk"
    }
  }, [_vm._v("https://www.elsevier.com/editors/publishing-ethics/perk")])])
},staticRenderFns: []}

/***/ }),
/* 1416 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row mb-3"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.getStaticPath(_vm.footerLogo),
      "alt": "Footer Logo"
    }
  }), _vm._v(" "), _c('social-media-buttons', {
    attrs: {
      "media-links": _vm.mediaLinks
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "hidden-md-up col-4 text-right"
  }, [_c('button', {
    staticClass: "button-primary button-up",
    on: {
      "click": _vm.scrollTop
    }
  }, [_c('icon', {
    attrs: {
      "name": "arrow-up"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-md-8 navigation-mobile-bg"
  }, [_c('footer-navigation')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-12"
  }, [_c('footer-journals-family')], 1)])])])]), _vm._v(" "), _c('footer-copyright')], 1)
},staticRenderFns: []}

/***/ }),
/* 1417 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.issues.length) ? _c('full-video', {
    attrs: {
      "showKeywords": true,
      "issue": _vm.issues[0]
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "videos-list"
  }, _vm._l((_vm.issues), function(issue, index) {
    return (index > 0 && index < 7) ? _c('div', {
      key: issue.id,
      staticClass: "video-item"
    }, [_c('condensed-video', {
      attrs: {
        "issue": issue,
        "showKeywords": true
      }
    })], 1) : _vm._e()
  }))], 1)
},staticRenderFns: []}

/***/ }),
/* 1418 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "media"
  }, [_c('media-player', {
    attrs: {
      "issue": _vm.issue,
      "share": true,
      "header": true
    }
  })], 1), _vm._v(" "), _c('issue-authors', {
    attrs: {
      "authors": _vm.issue.authors
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.issue.description))]), _vm._v(" "), (_vm.showKeywords) ? _c('div', {
    staticClass: "keywords"
  }, [_vm._v("Keywords: "), _c('span', [_vm._v(_vm._s(_vm.issue.keywords.join(', ')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "article-quick-links"
  }, [_c('article-quick-links', {
    attrs: {
      "article": _vm.issue
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1419 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "button-signup button-primary btn-block align-items-stretch justify-content-center d-flex"
  }, [_c('div', [_vm._v(_vm._s(_vm.site.name) + " Issue Alert Sign Up")]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-wrapper align-self-center"
  }, [_c('i', {
    staticClass: "icon icon-arrow-right"
  })])
}]}

/***/ }),
/* 1420 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.papersList), function(paper) {
    return _c('condensed-issue', {
      key: paper.id,
      attrs: {
        "issue": paper
      }
    })
  }))
},staticRenderFns: []}

/***/ }),
/* 1421 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.author) ? _c('div', {
    staticClass: "author-detail"
  }, [_vm._t("header"), _vm._v(" "), _c('div', {
    staticClass: "author-item"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h1', [_vm._v(_vm._s(_vm.author.firstName) + " " + _vm._s(_vm.author.lastName))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h5', [_vm._v(_vm._s(_vm.authorInfo.filter(Boolean).join(' / ')))])]), _vm._v(" "), _c('div', {
    staticClass: "row hidden-sm-up"
  }, [_c('div', {
    staticClass: "col p-0"
  }, [_c('social-media-buttons', {
    staticClass: "social-media-buttons m-0",
    attrs: {
      "media-links": _vm.author.mediaLinks
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('a', {
    staticClass: "envelope",
    attrs: {
      "href": ("mailto:" + (_vm.author.email))
    }
  }, [_c('icon', {
    attrs: {
      "name": "envelope-o"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-12 mb-2"
  }, [_c('img', {
    attrs: {
      "src": _vm.getStaticPath(_vm.author.photoUrl ? 'img/temp/' + _vm.author.photoUrl : '')
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_vm._v("\n        " + _vm._s(_vm.author.description) + "\n        "), _vm._v(" "), _c('div', {
    staticClass: "hidden-md-down"
  }, [_c('social-media-buttons', {
    staticClass: "social-media-buttons",
    attrs: {
      "media-links": _vm.author.mediaLinks
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "button-primary",
    attrs: {
      "href": ("mailto:" + (_vm.author.email))
    }
  }, [_vm._v("Email Board author >")]), _vm._v(" "), _c('a', {
    staticClass: "button-primary"
  }, [_vm._v("Fields of Interest >")])], 1)])])]), _vm._v(" "), _c('title-block', {
    attrs: {
      "id": 'authorsIssues',
      "title": (_vm.siteName + " Papers from this Author"),
      "link-title": "View All",
      "link-name": "",
      "color-theme": "primary-color"
    }
  }, [_c('div', _vm._l((_vm.authorsIssues), function(paper) {
    return _c('condensed-issue', {
      key: paper.id,
      attrs: {
        "issue": paper
      }
    })
  }))]), _vm._v(" "), _c('title-block', {
    attrs: {
      "id": 'top100Papers',
      "title": "Top 100 Papers from the Editorial Board",
      "link-title": "View All",
      "link-name": "",
      "color-theme": "primary-color"
    }
  }, [_c('div', _vm._l((_vm.top100Papers), function(paper) {
    return _c('condensed-issue', {
      key: paper.id,
      attrs: {
        "issue": paper
      }
    })
  }))])], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1422 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-nav-item-dropdown', {
    attrs: {
      "text": "Editorial Board"
    }
  }, [_c('b-dropdown-item', {
    on: {
      "click": function($event) {
        _vm.goTo({
          name: 'editorialBoardMembers'
        })
      }
    }
  }, [_vm._v("Editorial Board Members")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        _vm.goTo({
          name: 'hundredPlus'
        })
      }
    }
  }, [_vm._v("100+ Papers from Editorial Board")])], 1)
},staticRenderFns: []}

/***/ }),
/* 1423 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_c('i', [_vm._v("Facebook")])]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-1"
  }, [_c('div', {
    staticClass: "img h1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-11"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('i', [_c('b', [_vm._v("Facebook Name")]), _c('br'), _vm._v(" Age of Post")]), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._v("\n            Lorem ipsum dolor sit amet, consectetur adipiscing elit. @ImpactJournals Aenean euismod bibendum laoreet.\n            Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor."), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-8"
  }, [_c('div', {
    staticClass: "img h2"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('h5', [_c('i', [_vm._v("Post Headline")])]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. @ImpactJournals Aenean euismod bibendum laoreet.")])])])])])])])
}]}

/***/ }),
/* 1424 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page-title"
  }, [_vm._v("Special Collection Archive")]), _vm._v(" "), _vm._l((_vm.collections), function(collection) {
    return [_c('div', {
      staticClass: "collection-container"
    }, [_c('media-container', {
      key: collection.articlesData.ids.pii,
      attrs: {
        "collections-header": true,
        "issue": collection.articlesData,
        "figures": collection.articlesData.files.figures
      }
    }), _vm._v(" "), _c('h2', [_c('router-link', {
      attrs: {
        "to": {
          name: 'collectionDetail',
          params: {
            id: collection.id
          }
        }
      }
    }, [_vm._v("Special Collection on Some Topic")])], 1), _vm._v(" "), _c('div', {
      staticClass: "types"
    }, [_vm._v(_vm._s(collection.articlesTypes.length) + " Papers inlcuding: " + _vm._s(collection.articlesTypes.join(', ')))]), _vm._v(" "), _c('div', {
      staticClass: "description"
    }, [_vm._v(_vm._s(collection.description))]), _vm._v(" "), _c('div', {
      staticClass: "text-center hidden-md-up"
    }, [_c('b-button', {
      staticClass: "button-secondary my-2 my-sm-0",
      attrs: {
        "variant": "link",
        "to": {
          name: 'collectionDetail',
          params: {
            id: collection.id
          }
        }
      }
    }, [_vm._v("\n          View Collection\n        ")])], 1)], 1)]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 1425 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": _vm.tableContent.id
    }
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.tableContent.title)
    }
  }), _vm._v(" "), _c('table', [_c('tbody', {
    domProps: {
      "innerHTML": _vm._s(_vm.tableContent.table)
    }
  }), _vm._v(" "), _c('tfoot', {
    domProps: {
      "innerHTML": _vm._s(_vm.tableContent.footer)
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 1426 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-nav-item-dropdown', {
    attrs: {
      "text": "For Authors"
    }
  }, [_c('b-dropdown-item', {
    on: {
      "click": function($event) {
        _vm.goTo({
          name: 'forAuthorsSubmissionGuidelines'
        })
      }
    }
  }, [_vm._v("Submission Guidelines")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        _vm.goTo({
          name: 'forAuthorsStyleGuidelines'
        })
      }
    }
  }, [_vm._v("Style Guidelines")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        _vm.goTo({
          name: 'forAuthorsPolicies'
        })
      }
    }
  }, [_vm._v("Policies")])], 1)
},staticRenderFns: []}

/***/ }),
/* 1427 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "hidden-md-up"
  }, [_c('sidebar-current-issue'), _vm._v(" "), _c('sidebar-signup-button')], 1), _vm._v(" "), (_vm.topArticle.ids) ? _c('full-issue', {
    attrs: {
      "issue": _vm.topArticle
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "hidden-md-up"
  }, [_c('sidebar-quick-links'), _vm._v(" "), _c('title-block', {
    attrs: {
      "title": "Impact Factor / Index / Archive:"
    }
  }, [_c('div', {
    staticClass: "sidebar-block-content"
  }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor.")])])], 1), _vm._v(" "), _c('sections-beyond-oncology'), _vm._v(" "), _c('special-collection-archives'), _vm._v(" "), _c('title-block', {
    attrs: {
      "title": ("Top 5 " + _vm.siteName + " Papers Rated by Altmetric Attention Score"),
      "link-title": "View All",
      "link-name": "",
      "color-theme": "primary-color"
    }
  }, [_c('div', _vm._l((_vm.issues), function(issue, index) {
    return (index < 5) ? _c('condensed-issue', {
      key: issue.id,
      attrs: {
        "issue": issue,
        "smallMode": index > 0 ? true : false
      }
    }) : _vm._e()
  }))]), _vm._v(" "), _c('title-block', {
    attrs: {
      "title": "Top 100 Papers from the Editorial Board",
      "link-title": "View All",
      "link-name": "",
      "color-theme": "primary-color"
    }
  }, [_c('div', _vm._l((_vm.top100issues), function(issue, index) {
    return _c('condensed-issue', {
      key: issue.id,
      attrs: {
        "issue": issue,
        "smallMode": index > 0 ? true : false
      }
    })
  }))]), _vm._v(" "), _c('div', {
    staticClass: "hidden-md-up"
  }, [_c('sidebar-sponsorship')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1428 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', [_c('altmetric-stats-bar')], 1), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n      Keywords\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "keywords"
  }, [_c('em', [_vm._v(_vm._s(_vm.keywordsFormatted))])])]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n      Article Tools\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-12 col-xl-6 mb-2"
  }, [_c('button', {
    staticClass: "button-primary btn-block",
    on: {
      "click": function($event) {
        _vm.getPdf()
      }
    }
  }, [_vm._v("Download PDF")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('sidebar-signup-button')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-6 col-md-12 col-xl-6 mb-2"
  }, [_c('button', {
    staticClass: "button-primary btn-block"
  }, [_vm._v("How to Cite")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-6 col-md-12 col-xl-6 mb-2"
  }, [_c('button', {
    staticClass: "button-primary btn-block"
  }, [_vm._v("Order a Reprint")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-6 col-md-12 col-xl-6 mb-2"
  }, [_c('button', {
    staticClass: "button-primary btn-block"
  }, [_vm._v("Supplementals")])])
}]}

/***/ }),
/* 1429 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(!_vm.$store.state.isEnhanced) ? [_c('header-area'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [(_vm.$route.name === 'Home') ? _c('header-events-block') : _c('header-breadcrumbs', {
    staticClass: "hidden-sm-down"
  }), _vm._v(" "), (_vm.sortBar) ? _c('sort-bar', {
    attrs: {
      "sortBar": _vm.sortBar
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$route.meta.filterIsAvailable) ? _c('search-filter') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12",
    class: !_vm.isArticlePage() ? 'col-md-8' : 'col-md-12'
  }, [_c('router-view')], 1), _vm._v(" "), (!_vm.isArticlePage()) ? _c('div', {
    staticClass: "col-md-4 col-12 hidden-sm-down"
  }, [_c('sidebar')], 1) : _vm._e()])], 1), _vm._v(" "), _c('footer-area'), _vm._v(" "), _c('order-reprint-modal')] : [_c('enhanced-view')]], 2)
},staticRenderFns: []}

/***/ }),
/* 1430 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('title-block', {
    attrs: {
      "title": "Sections Beyond Oncology",
      "color-theme": "primary-color"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-md-6 color0"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Gerotaget / Aging")]), _vm._v(" "), _c('div', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida\n          dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque\n          penatibus et magnis dis parturient montes, nascetur ridiculus mus. ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-6 color1"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Pathology beyond Oncology")]), _vm._v(" "), _c('div', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida\n          dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor.\n          Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-6 color2"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Immunology & Microbiology")]), _vm._v(" "), _c('div', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida\n          dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque\n          penatibus et magnis dis parturient montes, nascetur ridiculus mus. ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-6 color3"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Autophagy & Cell Death")]), _vm._v(" "), _c('div', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida\n          dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque\n          penatibus et magnis dis parturient montes, nascetur ridiculus mus. ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-6 color4"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Chromosome")]), _vm._v(" "), _c('div', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida\n          dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque\n          penatibus et magnis dis parturient montes, nascetur ridiculus mus. ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 1431 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.article) ? _c('article-detail-component', [_c('div', {
    staticClass: "anchors",
    attrs: {
      "slot": "anchors"
    },
    slot: "anchors"
  }, _vm._l((_vm.anchors), function(value, key) {
    return _c('div', [_c('a', {
      class: {
        active: key === _vm.currentSection
      },
      attrs: {
        "href": '#' + key
      }
    }, [_vm._v(_vm._s(value))])])
  })), _vm._v(" "), _c('div', {
    staticClass: "keywords",
    attrs: {
      "slot": "keywords"
    },
    slot: "keywords"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n      Keywords:\n    ")]), _vm._v(" "), _c('div', {}, _vm._l((_vm.article.keywords), function(keyword) {
    return _c('div', {
      staticClass: "link"
    }, [_vm._v(_vm._s(keyword))])
  }))]), _vm._v(" "), _c('sidebar-article-section', {
    attrs: {
      "slot": "bar",
      "article": _vm.article
    },
    slot: "bar"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('div', {
    staticClass: "type"
  }, [_vm._v(_vm._s(_vm.article.article_type.name))]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.article.title))]), _vm._v(" "), _c('div', {
    staticClass: "ids"
  }, [_vm._v("DOI: "), _c('span', [_vm._v(_vm._s(_vm.article.ids.doi))]), _vm._v("Issue: "), _c('span', [_vm._v("Volume " + _vm._s(_vm.article.volume) + ", Issue " + _vm._s(_vm.article.issue))]), _vm._v("pp " + _vm._s(_vm.article.page_start) + "-" + _vm._s(_vm.article.page_end))]), _vm._v(" "), _c('issue-authors', {
    attrs: {
      "authors": _vm.article.authors
    }
  }), _vm._v(" "), (_vm.$store.state.isEnhanced) ? _c('div', {
    staticClass: "article-quick-links"
  }, [_c('article-quick-links', {
    attrs: {
      "article": _vm.article
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "full_text"
    },
    slot: "full_text"
  }, [_c('section', [_c('a', {
    staticClass: "jumpto hidden-md-up",
    on: {
      "click": function($event) {
        _vm.openNav()
      }
    }
  }, [_vm._v("Jump To")]), _vm._v(" "), _c('p'), _c('h1', {
    attrs: {
      "id": "Abstract"
    }
  }, [_vm._v("ABSTRACT")]), _vm._v(" "), _c('div', {
    staticClass: "fullText",
    domProps: {
      "innerHTML": _vm._s(_vm.article.abstract)
    }
  }), _vm._v(" "), _c('p')]), _vm._v(" "), _vm._l((_vm.article.fullText.sections), function(sectionItem) {
    return (sectionItem.title) ? _c('div', {
      staticClass: "fullText"
    }, [_c('section', [_c('a', {
      staticClass: "jumpto hidden-md-up",
      on: {
        "click": function($event) {
          _vm.openNav()
        }
      }
    }, [_vm._v("Jump To")]), _vm._v(" "), _c('content-header', {
      attrs: {
        "header-level": sectionItem.headerLevel,
        "title": sectionItem.title
      }
    }), _vm._v(" "), _vm._l((sectionItem.content), function(contentItem) {
      return [(contentItem.contentType === 'subsection') ? [_c('content-header', {
        attrs: {
          "header-level": contentItem.headerLevel,
          "title": contentItem.title
        }
      }), _vm._v(" "), _vm._l((contentItem.content), function(subsectionItem) {
        return [_c('content-item', {
          attrs: {
            "content-item": subsectionItem
          }
        })]
      })] : _c('content-item', {
        attrs: {
          "content-item": contentItem
        }
      })]
    })], 2)]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.article.fullText.acks), function(sectionItem) {
    return (sectionItem.title) ? _c('div', {
      staticClass: "fullText"
    }, [_c('section', [_c('a', {
      staticClass: "jumpto hidden-md-up",
      on: {
        "click": function($event) {
          _vm.openNav()
        }
      }
    }, [_vm._v("Jump To")]), _vm._v(" "), _c('content-header', {
      attrs: {
        "header-level": 1,
        "title": sectionItem.title
      }
    }), _vm._v(" "), _vm._l((sectionItem.content), function(contentItem) {
      return [_c('content-item', {
        attrs: {
          "content-item": contentItem
        }
      })]
    })], 2)]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.article.fullText.footnotes), function(sectionItem) {
    return (sectionItem.title) ? _c('div', {
      staticClass: "fullText"
    }, [_c('section', [_c('a', {
      staticClass: "jumpto hidden-md-up",
      on: {
        "click": function($event) {
          _vm.openNav()
        }
      }
    }, [_vm._v("Jump To")]), _vm._v(" "), _c('content-header', {
      attrs: {
        "header-level": 1,
        "title": sectionItem.title
      }
    }), _vm._v(" "), _vm._l((sectionItem.content), function(contentItem) {
      return [_c('content-item', {
        attrs: {
          "content-item": contentItem
        }
      })]
    })], 2)]) : _vm._e()
  }), _vm._v(" "), (_vm.article.fullText.references) ? _c('div', {
    staticClass: "fullText"
  }, [_c('section', [_c('a', {
    staticClass: "jumpto hidden-md-up",
    on: {
      "click": function($event) {
        _vm.openNav()
      }
    }
  }, [_vm._v("Jump To")]), _vm._v(" "), _c('content-header', {
    attrs: {
      "header-level": 1,
      "title": 'References'
    }
  }), _vm._v(" "), _vm._l((_vm.article.fullText.references), function(reference) {
    return _c('p', {
      attrs: {
        "id": reference.id
      }
    }, [_c('span', [_vm._v(_vm._s(reference.number) + ". ")]), _vm._v(" "), _vm._l((reference.textContent), function(content) {
      return _c('span', [_vm._v(_vm._s(content.content))])
    })], 2)
  })], 2)]) : _vm._e()], 2)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1432 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media-container"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('media-player', {
    attrs: {
      "issue": _vm.issue,
      "share": false,
      "collections-header": _vm.collectionsHeader,
      "header": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "slides-container"
  }, [_c('div', {
    staticClass: "nav-top",
    class: {
      hidden: _vm.hidden_top
    },
    on: {
      "click": function($event) {
        _vm.slideUp()
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-arrow-up-large"
  })]), _vm._v(" "), _c('div', {
    staticClass: "slides-data",
    style: ('margin-top:' + _vm.scrollPos + 'px;')
  }, _vm._l((_vm.figures), function(slide, index) {
    return _c('div', [_c('img', {
      class: {
        slide: true, active: _vm.selectedId === index
      },
      attrs: {
        "src": slide.optimized_urls.small,
        "target": slide.optimized_urls.hero
      },
      on: {
        "click": function($event) {
          _vm.selectThis(index, $event)
        },
        "load": function($event) {
          _vm.loadImg()
        }
      }
    })])
  })), _vm._v(" "), _c('div', {
    staticClass: "nav-bottom",
    class: {
      hidden: _vm.hidden_bottom
    },
    on: {
      "click": function($event) {
        _vm.slideDown()
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-arrow-down-large"
  })])])])
},staticRenderFns: []}

/***/ }),
/* 1433 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.items.length) ? _c('title-block', {
    attrs: {
      "title": "Special Collection Archives",
      "color-theme": "primary-color"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      staticClass: "col-12"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.text))])])
  }))])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1434 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', {
    attrs: {
      "id": _vm.figureAttr.id
    }
  }, [_c('label', {
    domProps: {
      "innerHTML": _vm._s(_vm.figureAttr.label)
    }
  }), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": _vm.figureAttr.url,
      "alt": _vm.figureAttr.alt
    }
  })]), _vm._v(" "), _c('figcaption', {
    domProps: {
      "innerHTML": _vm._s(_vm.figureAttr.caption)
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1435 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col title"
  }, [_vm._v("Archiving")]), _vm._v(" "), _c('div', {
    staticClass: "col-3 pl-1 hidden-md-up"
  }, [_c('for-authors-mobile-menu', {
    attrs: {
      "anchors-list": _vm.anchorsList
    }
  })], 1)]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.siteName) + "\n  "), _c('br'), _vm._v(" "), _vm._v("\n   Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapienLorem ipsum dolor sit amet, consectetur adipiscing elit.\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 1436 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "header-container"
  }, [_c('div', {
    staticClass: "header-bg",
    style: ({
      'background-image': _vm.backgroundPath
    })
  }, [_c('div', {
    staticClass: "header-content"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Home'
      }
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.getStaticPath(_vm.logoPath),
      "alt": "Logo"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "header-text hidden-md-down"
  }, [_vm._v(_vm._s(_vm.headerText) + "\n        ")]), _c('div', {
    staticClass: "right-header-content ml-auto"
  }, [_c('social-media-buttons', {
    staticClass: "hidden-md-down float-right mt-0",
    attrs: {
      "media-links": _vm.mediaLinks
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "issn hidden-sm-down"
  }, [_vm._v("Online ISSN: "), _c('strong', [_vm._v(_vm._s(_vm.issn))])]), _vm._v(" "), _c('button', {
    staticClass: "button-primary"
  }, [_vm._v("Submit Paper")])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "nav-wrapper",
    class: {
      fixed: _vm.scrolled
    },
    attrs: {
      "id": "navWrapper"
    }
  }, [_c('div', {
    staticClass: "container hidden-sm-down"
  }, [_c('header-nav')], 1), _vm._v(" "), _c('div', {
    staticClass: "menu-container hidden-md-up",
    class: {
      scrolled: _vm.scrolled
    }
  }, [_c('header-nav')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1437 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', [_c('div', {
    staticClass: "page-title"
  }, [_vm._v("Editors In Chief")]), _vm._v(" "), _c('div', {
    staticClass: "authors-list"
  }, _vm._l((_vm.editorsInChief), function(member) {
    return _c('author', {
      key: member.id,
      attrs: {
        "author": member
      }
    }, [_c('router-link', {
      attrs: {
        "slot": "details-link",
        "to": {
          name: 'editorialBoardMemberDetail',
          params: {
            id: member.id
          }
        }
      },
      slot: "details-link"
    }, [_vm._v("Read More")])], 1)
  }))]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "page-title"
  }, [_vm._v("Editorial Board Members")]), _vm._v(" "), _c('div', {
    staticClass: "authors-list"
  }, _vm._l((_vm.editorialBoardMembers), function(member) {
    return _c('author', {
      key: member.id,
      attrs: {
        "author": member
      }
    }, [_c('router-link', {
      attrs: {
        "slot": "details-link",
        "to": {
          name: 'editorialBoardMemberDetail',
          params: {
            id: member.id
          }
        }
      },
      slot: "details-link"
    }, [_vm._v("Read More")])], 1)
  }))])])
},staticRenderFns: []}

/***/ }),
/* 1438 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_c('i', [_vm._v("News")])]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('i', [_vm._v("Posted 2 days ago")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('b', [_vm._v("News Story Title")]), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._v("\n        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet.Lorem ipsum dolor sit amet,\n        consectetur adipiscing elit. Aenean euismod bibendum laoreet.Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n        Aenean euismod bibendum laoreet.\n        "), _c('br'), _c('br'), _vm._v(" "), _c('a', [_vm._v("http://www.grc.org/programs.aspx?id=16786")])])])]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('i', [_vm._v("Posted September 2, 2016")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('b', [_vm._v("News Story Title")]), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-5 col-md-4 col-lg-3"
  }, [_c('div', {
    staticClass: "img h1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-7 col-md-8 col-lg-9"
  }, [_vm._v("\n        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet.Lorem ipsum dolor sit amet,\n        consectetur adipiscing elit. Aenean euismod bibendum laoreet.Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n        Aenean euismod bibendum laoreet.\n        "), _c('br'), _c('br'), _vm._v(" "), _c('a', [_vm._v("http://www.grc.org/programs.aspx?id=16786")])])])]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('i', [_vm._v("Posted 2015")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('b', [_vm._v("News Story Title")]), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._v("\n        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet.Lorem ipsum dolor sit amet,\n        consectetur adipiscing elit. Aenean euismod bibendum laoreet.Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n        Aenean euismod bibendum laoreet.\n        "), _c('br'), _c('br'), _vm._v(" "), _c('a', [_vm._v("http://www.grc.org/programs.aspx?id=16786")])])])])])
}]}

/***/ }),
/* 1439 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col title"
  }, [_vm._v("Submitting Revisions")]), _vm._v(" "), _c('div', {
    staticClass: "col-3 pl-1 hidden-md-up"
  }, [_c('for-authors-mobile-menu', {
    attrs: {
      "anchors-list": _vm.anchorsList
    }
  })], 1)]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n      If you have been asked to revise your manuscript and you are ready to resubmit it, log on to the submission system and, on your author home page,\n      click the \"Revise Manuscript\" link of the manuscript you wish to resubmit. You will be asked to review the information you originally submitted to confirm its accuracy.\n      If any of the original files have been revised, replace them. Include only the final version of each file in your revision submission.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      In your rebuttal letter, please be sure to provide a point-by-point reply to the reviewers' comments as well as a\n      listing of all the changes made, including any changes to authorship, noting the page numbers on which the individual\n      changes appear. When you have successfully resubmitted your manuscript, you will receive acknowledgment via email.\n      The revised version of your manuscript may undergo another review if the original submission required extensive changes\n      or if the authors' responses to the criticisms entail rebuttal rather than revision. A decision as to whether or not the manuscript\n      will be sent back out for review is made at the discretion of the Editors.\n    ")])])
}]}

/***/ }),
/* 1440 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.collectionArticles), function(collection) {
    return _c('condensed-issue', {
      key: collection.id,
      attrs: {
        "issue": collection
      }
    })
  }))
},staticRenderFns: []}

/***/ }),
/* 1441 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col title"
  }, [_vm._v("Special Submissions")]), _vm._v(" "), _c('div', {
    staticClass: "col-3 pl-1 hidden-md-up"
  }, [_c('for-authors-mobile-menu', {
    attrs: {
      "anchors-list": _vm.anchorsList
    }
  })], 1)]), _vm._v(" "), _c('div', [_c('p', [_vm._v("\n      1. Papers that were previously reviewed in a journal with a higher impact factor (e.g. Nature, Science, PNAS etc)\n      may be submitted with previous peer-reviews (please revise and then format accordingly to " + _vm._s(_vm.siteName) + " style).\n      Submit all files on line as separate files. Previous peer-reviews will accelerate our decision. These papers\n      will still be peer-reviewed in " + _vm._s(_vm.siteName) + ".\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      2. In exceptional cases members of the Editorial Boards may submit extraordinary papers after self-organized\n      peer-review process (PNAS-like system), albeit it may be informal in some cases. Such papers will be additionally\n      reviewed in " + _vm._s(_vm.siteName) + ", in some cases verbally (e.g. telephone) or via email, to accelerate the decision.\n      In some cases they will be additionally post-reviewed by the authors of Editorials. This system helps to accelerate\n      decision on extraordinary papers.\n    ")])])])
},staticRenderFns: []}

/***/ }),
/* 1442 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col title"
  }, [_vm._v("Peer Review")]), _vm._v(" "), _c('div', {
    staticClass: "col-3 pl-1 hidden-md-up"
  }, [_c('for-authors-mobile-menu', {
    attrs: {
      "anchors-list": _vm.anchorsList
    }
  })], 1)]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.siteName) + "\n    "), _c('br'), _vm._v(" "), _vm._v("\n    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapienLorem ipsum dolor sit amet, consectetur adipiscing elit.\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 1443 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_c('i', [_vm._v("Tables")])]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b', [_vm._v("Table 1:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._v("Oligonucleotides used for Q-PCR")]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "img h2"
  })])])]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b', [_vm._v("Table 2:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._v("Oligonucleotides used for Q-PCR")]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "img h2"
  })])])])])
}]}

/***/ }),
/* 1444 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    attrs: {
      "id": "orderReprintModal",
      "title": "Order a Reprint:",
      "size": "lg",
      "hide-footer": true
    }
  }, [_c('section', [_c('p', [_vm._v("Dear Authors and Readers,")]), _vm._v(" "), _c('p', [_vm._v("We offer on demand printing for " + _vm._s(_vm.siteName) + " Journal and Individual Articles. Our options range from a single\n      copy of a black and white article with no cover all the way up to full-color copies of complete issues.")]), _vm._v(" "), _c('p', [_vm._v("Please provide the following information and we will prepare a purchase order for your review.")])]), _vm._v(" "), _c('title-block', {
    attrs: {
      "title": "Paper / Issue Requested:"
    }
  }, [(_vm.reprintItem.cover_url) ? _c('img', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "src": _vm.reprintItem ? _vm.reprintItem.cover_url : ''
    }
  }) : _vm._e(), _vm._v(" "), _c('div', [_vm._v("Issue: Volume " + _vm._s(_vm.reprintItem.volume) + ", Number " + _vm._s(_vm.reprintItem.issue) + " - " + _vm._s(_vm.timestamp) + " Pages: " + _vm._s(_vm.reprintItem.page_start) + " - " + _vm._s(_vm.reprintItem.page_end))]), _vm._v(" "), _c('div', [_vm._v("About the Cover")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.reprintItem.title))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.reprintItem.caption)
    }
  }), _vm._v(" "), (_vm.reprintItem.articles) ? _c('div', [_vm._v(_vm._s(_vm.reprintItem.articles.length) + " Papers inlcuding: " + _vm._s(_vm.reprintItem.articlesTypes) + ".\n    ")]) : _vm._e()]), _vm._v(" "), _c('title-block', {
    attrs: {
      "title": "Request Preferences:"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Specifications for your Request:"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Tell us about any specific requests for this Reprint",
      "type": "text"
    },
    model: {
      value: (_vm.requestData.specifications),
      callback: function($$v) {
        _vm.$set(_vm.requestData, "specifications", $$v)
      },
      expression: "requestData.specifications"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "devider"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('b-form-fieldset', {
    class: {
      error: _vm.attemptSubmit && !_vm.validation.includeSupplementaryMaterial
    },
    attrs: {
      "label": "Include Supplementary material?"
    }
  }, [_c('b-form-radio', {
    attrs: {
      "type": "text",
      "options": ['Yes', 'No']
    },
    model: {
      value: (_vm.requestData.includeSupplementaryMaterial),
      callback: function($$v) {
        _vm.$set(_vm.requestData, "includeSupplementaryMaterial", $$v)
      },
      expression: "requestData.includeSupplementaryMaterial"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('b-form-fieldset', {
    class: {
      error: _vm.attemptSubmit && !_vm.validation.colorScheme
    },
    attrs: {
      "label": "Print in Color or Black & White?"
    }
  }, [_c('b-form-radio', {
    attrs: {
      "type": "text",
      "options": ['Color', 'Black & White']
    },
    model: {
      value: (_vm.requestData.colorScheme),
      callback: function($$v) {
        _vm.$set(_vm.requestData, "colorScheme", $$v)
      },
      expression: "requestData.colorScheme"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('b-form-fieldset', {
    class: {
      error: _vm.attemptSubmit && !_vm.validation.includeCover
    },
    attrs: {
      "label": "Include Cover?"
    }
  }, [_c('b-form-radio', {
    attrs: {
      "type": "text",
      "options": ['Yes', 'No']
    },
    model: {
      value: (_vm.requestData.includeCover),
      callback: function($$v) {
        _vm.$set(_vm.requestData, "includeCover", $$v)
      },
      expression: "requestData.includeCover"
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('title-block', {
    attrs: {
      "title": "Shipping Details:"
    }
  }, [_c('b-form-fieldset', {
    class: {
      error: _vm.attemptSubmit && !_vm.validation.name
    },
    attrs: {
      "label": "Name"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Enter Full  Name",
      "type": "text"
    },
    model: {
      value: (_vm.requestData.name),
      callback: function($$v) {
        _vm.$set(_vm.requestData, "name", $$v)
      },
      expression: "requestData.name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "devider"
  }), _vm._v(" "), _c('b-form-fieldset', {
    class: {
      error: _vm.attemptSubmit && !_vm.validation.email
    },
    attrs: {
      "label": "Email Address"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Enter Email Address",
      "type": "text"
    },
    model: {
      value: (_vm.requestData.email),
      callback: function($$v) {
        _vm.$set(_vm.requestData, "email", $$v)
      },
      expression: "requestData.email"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "devider"
  }), _vm._v(" "), _c('b-form-fieldset', {
    class: {
      error: _vm.attemptSubmit && !_vm.validation.phone
    },
    attrs: {
      "label": "Phone Namber"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Enter Phone Number",
      "formatter": _vm.phoneFormater
    },
    model: {
      value: (_vm.requestData.phone),
      callback: function($$v) {
        _vm.$set(_vm.requestData, "phone", $$v)
      },
      expression: "requestData.phone"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "devider"
  }), _vm._v(" "), _c('b-form-fieldset', {
    class: {
      error: _vm.attemptSubmit && !_vm.validation.instruction
    },
    attrs: {
      "label": "Institution"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Enter Your Affiliated Institution",
      "type": "text"
    },
    model: {
      value: (_vm.requestData.instruction),
      callback: function($$v) {
        _vm.$set(_vm.requestData, "instruction", $$v)
      },
      expression: "requestData.instruction"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "devider"
  }), _vm._v(" "), _c('b-form-fieldset', {
    class: {
      error: _vm.attemptSubmit && !_vm.validation.address
    },
    attrs: {
      "label": "Shipping Address, including Zip Code"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Enter Your Shipping Address",
      "type": "text"
    },
    model: {
      value: (_vm.requestData.address),
      callback: function($$v) {
        _vm.$set(_vm.requestData, "address", $$v)
      },
      expression: "requestData.address"
    }
  })], 1), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.request()
      }
    }
  }, [_vm._v("Submit")]), _vm._v(" "), (_vm.attemptSubmit && !_vm.isValid) ? _c('div', [_vm._v("Error")]) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1445 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "events-block"
  }, [_c('div', {
    staticClass: "justify-content-between"
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "divider-vertical"
  }), _vm._v(" "), _c('div', {
    staticClass: "link"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'archivedIssues'
      }
    }
  }, [_vm._v("View Archives >")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "events-list"
  }, [_c('span', {
    staticClass: "event"
  }, [_c('span', {
    staticClass: "date"
  }, [_vm._v("\n          August 7-12, 2016\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "name"
  }, [_vm._v("\n          Oncotarget journal is a Sponsor of Rare Cells in Cordon Conference, South Hadley, MA.\n        ")])]), _vm._v(" "), _c('span', {
    staticClass: "divider-vertical"
  }), _vm._v(" "), _c('span', {
    staticClass: "event"
  }, [_c('span', {
    staticClass: "date"
  }, [_vm._v("\n          September 25-28, 2016\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "name"
  }, [_vm._v("\n          Circulation Cordon Research Conference, South Hadley, MA.\n        ")])])])
}]}

/***/ }),
/* 1446 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filter-label"
  }, [_vm._v(_vm._s(_vm.labels[_vm.paramName]) + ": "), _vm._t("default"), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "link"
    },
    on: {
      "click": _vm.remove
    }
  }, [_c('icon', {
    attrs: {
      "name": "times"
    }
  })], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 1447 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Style Guide")])])
}]}

/***/ }),
/* 1448 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_c('i', [_vm._v("Linked In")])]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-1"
  }, [_c('div', {
    staticClass: "img h1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-11"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('i', [_c('b', [_vm._v("User Name")]), _c('br'), _vm._v(" Designation")]), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._v("\n            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet.Lorem ipsum dolor sit amet,\n            consectetur adipiscing elit. Aenean euismod bibendum laoreet.Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n            Aenean euismod bibendum laoreet. "), _c('a', [_vm._v("http://www.grc.org/programs.aspx?id=16786")])])])])])]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-1"
  }, [_c('div', {
    staticClass: "img h1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-11"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('i', [_c('b', [_vm._v("User Name")]), _c('br'), _vm._v(" Designation")]), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._v("\n            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet.Lorem ipsum dolor sit amet,\n            consectetur adipiscing elit. Aenean euismod bibendum laoreet.Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n            Aenean euismod bibendum laoreet."), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "img h2"
  })])])])])])])
}]}

/***/ }),
/* 1449 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    attrs: {
      "id": _vm.anchorsList[0].anchor || ''
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col title"
  }, [_vm._v("Research")]), _vm._v(" "), _c('div', {
    staticClass: "col-3 pl-1 hidden-md-up"
  }, [_c('for-authors-mobile-menu', {
    attrs: {
      "anchors-list": _vm.anchorsList
    }
  })], 1)]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('section', {
    attrs: {
      "id": _vm.anchorsList[1].anchor || ''
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col title"
  }, [_vm._v("Editorial")]), _vm._v(" "), _c('div', {
    staticClass: "col-3 pl-1 hidden-md-up"
  }, [_c('for-authors-mobile-menu', {
    attrs: {
      "anchors-list": _vm.anchorsList
    }
  })], 1)]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('section', {
    attrs: {
      "id": _vm.anchorsList[2].anchor || ''
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col title"
  }, [_vm._v("Review")]), _vm._v(" "), _c('div', {
    staticClass: "col-3 pl-1 hidden-md-up"
  }, [_c('for-authors-mobile-menu', {
    attrs: {
      "anchors-list": _vm.anchorsList
    }
  })], 1)]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('section', {
    attrs: {
      "id": _vm.anchorsList[3].anchor || ''
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col title"
  }, [_vm._v("Book Reader")]), _vm._v(" "), _c('div', {
    staticClass: "col-3 pl-1 hidden-md-up"
  }, [_c('for-authors-mobile-menu', {
    attrs: {
      "anchors-list": _vm.anchorsList
    }
  })], 1)]), _vm._v(" "), _vm._m(3)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n        News and editorials are invited. Editorials are brief discussions of recently published papers usually in other\n        leading journals by the authors of the original papers. There is the strict word limit – 800 words and no more\n        than 7 references. No more than 3 co-authors, including corresponding author, are allowed.\n      ")]), _vm._v(" "), _c('p', [_vm._v("Note: Special title and reference format:")]), _vm._v(" "), _c('p', [_vm._v("\n        Title must be short, no descriptive title, 3-7 words (for example, “RB in DNA repair”)\n        Special reference format: 1 author et al, (no titles.) year. v. p.\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n        There is no page limit, no reference limit. Any number of pages and references. Up to 14 figures.\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        Please check the submission site about the order of the sections.\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        The list of references should be numbered consecutively according to the first time mentioned within the article.\n        Cite only the number assigned to the reference: Use [ ] not ( ). References should include only the articles\n        that are published or in press.\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n        Authors may suggest a Review on a broad topic of general interest. Should be well referenced, with a minimal\n        number of references above 90. Reviews should include 1-6 figures, diagrams or cartoons.\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n        Comprehensive coverage of the topic. Any number of figures. Color figures are especially welcome. Should be well\n        referenced, with a minimal number of references above 500. There is no upper limit on the number of references.\n      ")])])
}]}

/***/ }),
/* 1450 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b', [_vm._v("Demographics")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "img h2"
  })])])]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b', [_vm._v("Specifics:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-lg-3"
  }, [_c('div', {
    staticClass: "img h1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-lg-3"
  }, [_c('div', {
    staticClass: "img h1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-lg-3"
  }, [_c('div', {
    staticClass: "img h1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-lg-3"
  }, [_c('div', {
    staticClass: "img h1"
  })])])])])
}]}

/***/ }),
/* 1451 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "media"
  }, [_c('media-player', {
    attrs: {
      "issue": _vm.issue,
      "share": false,
      "header": false
    }
  })], 1), _vm._v(" "), _c('issue-authors', {
    attrs: {
      "authors": _vm.issue.authors
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.issue.description))]), _vm._v(" "), _c('div', {
    staticClass: "doi"
  }, [_vm._v("DOI: "), _c('span', [_vm._v(_vm._s(_vm.issue.ids ? _vm.issue.ids.doi : ''))]), _c('br'), _vm._v("\n    Issue: "), _c('span', [_vm._v("Volume " + _vm._s(_vm.issue.volume) + " Number" + _vm._s(_vm.issue.issue.issue))]), _vm._v("\n    pp " + _vm._s(_vm.issue.page_start) + "-" + _vm._s(_vm.issue.page_end))]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.trimTextToLength(_vm.issue.title, 40)))]), _vm._v(" "), (_vm.showKeywords) ? _c('div', {
    staticClass: "keywords"
  }, [_vm._v("Keywords: "), _c('span', [_vm._v(_vm._s(_vm.issue.keywords.join(', ')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "article-quick-links"
  }, [_c('article-quick-links', {
    attrs: {
      "article": _vm.issue
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1452 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page-title"
  }, [_vm._v("Ethics & Malpractice Statement")]), _vm._v(" "), _c('ethics-and-malpractice-content')], 1)
},staticRenderFns: []}

/***/ }),
/* 1453 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page-title"
  }, [_vm._v("Archived Issues")]), _vm._v(" "), _c('div', {
    staticClass: "mobile-menu hidden-md-up"
  }, [_c('label', [_vm._v("Jump to Volume: ")]), _vm._v(" "), _c('b-nav', {
    attrs: {
      "is-nav-bar": ""
    }
  }, [_c('b-nav-item-dropdown', {
    staticClass: "nav mobile-menu",
    attrs: {
      "right": "",
      "is-nav": "",
      "text": _vm.selectedAnchor
    }
  }, _vm._l((_vm.anchorsList), function(item) {
    return _c('b-dropdown-item', {
      key: item.anchor,
      nativeOn: {
        "click": function($event) {
          _vm.selectedAnchor = item.text
        }
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '#' + item.anchor
        }
      }
    }, [_vm._v(_vm._s(item.text))])], 1)
  }))], 1)], 1), _vm._v(" "), _vm._l((_vm.issues), function(item, index) {
    return [_c('div', {
      staticClass: "issue",
      attrs: {
        "id": 'anchor' + item.issue_linkable || ''
      }
    }, [_c('div', {
      staticClass: "hidden-sm-down row"
    }, [_c('div', {
      staticClass: "col-md-3 col-sm-6 col-xs-12 text-center"
    }, [_c('router-link', {
      staticClass: "col",
      attrs: {
        "to": {
          name: 'issueDetail',
          params: {
            volumeId: item.volume,
            issueId: item.issue
          }
        }
      }
    }, [_c('img', {
      staticClass: "issue-cover",
      attrs: {
        "src": item.optimized_urls.small
      }
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-9 col-sm-6 col-xs-12"
    }, [_c('div', {
      staticClass: "mb-2"
    }, [_c('span', {
      staticClass: "text-accent"
    }, [_vm._v("Issue:")]), _vm._v(" Volume " + _vm._s(item.volume) + ", Number " + _vm._s(item.issue) + " | "), _c('span', {
      staticClass: "text-accent"
    }, [_vm._v("Pages:")]), _vm._v(" " + _vm._s(item.pages.start) + " - " + _vm._s(item.pages.end) + "\n            "), _c('a', {
      staticClass: "article-link-item",
      on: {
        "click": function($event) {
          _vm.$root.$emit('show::modal', 'orderReprintModal', item)
        }
      }
    }, [_vm._v("Order a Reprint >")])]), _vm._v(" "), _c('div', {
      staticClass: "text-accent"
    }, [_vm._v("About the Cover")]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_c('router-link', {
      staticClass: "col",
      attrs: {
        "to": {
          name: 'issueDetail',
          params: {
            volumeId: item.volume,
            issueId: item.issue
          }
        }
      }
    }, [_vm._v("Headline Headline Headline...")])], 1), _vm._v(" "), _c('div', {
      staticClass: "caption",
      domProps: {
        "innerHTML": _vm._s(item.caption)
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "hidden-md-up row"
    }, [_c('div', {
      staticClass: "col-md-9 col-sm-6 col-xs-12"
    }, [_c('span', {
      staticClass: "text-accent"
    }, [_vm._v("Issue:")]), _vm._v(" Volume " + _vm._s(item.volume) + ", Number " + _vm._s(item.issue) + " "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "text-accent"
    }, [_vm._v("Pages:")]), _vm._v(" " + _vm._s(item.pages.start) + " - " + _vm._s(item.pages.end) + "\n          "), _c('div', {
      staticClass: "text-accent"
    }, [_vm._v("About the Cover")]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_c('router-link', {
      staticClass: "col",
      attrs: {
        "to": {
          name: 'issueDetail',
          params: {
            volumeId: item.volume,
            issueId: item.issue
          }
        }
      }
    }, [_vm._v("Headline Headline Headline...")])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "my-4 col-sm-6 col-xs-12 text-center"
    }, [_c('router-link', {
      staticClass: "col",
      attrs: {
        "to": {
          name: 'issueDetail',
          params: {
            volumeId: item.volume,
            issueId: item.issue
          }
        }
      }
    }, [_c('img', {
      staticClass: "issue-cover",
      attrs: {
        "src": item.optimized_urls.small
      }
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-9 col-sm-6 col-xs-12"
    }, [_c('div', {
      staticClass: "caption",
      domProps: {
        "innerHTML": _vm._s(item.caption)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "text-center"
    }, [_c('b-button', {
      staticClass: "button-secondary my-2 my-sm-0",
      attrs: {
        "variant": "link",
        "to": {
          name: 'issueDetail',
          params: {
            volumeId: item.volume,
            issueId: item.issue
          }
        }
      }
    }, [_vm._v("\n              View Issue\n            ")]), _c('br'), _vm._v(" "), _c('b-button', {
      staticClass: "button-secondary my-2 my-sm-0",
      attrs: {
        "variant": "link"
      },
      on: {
        "click": function($event) {
          _vm.$root.$emit('show::modal', 'orderReprintModal', item)
        }
      }
    }, [_vm._v("\n              Order a Reprint >\n            ")])], 1)])])])]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 1454 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.articles), function(article) {
    return _c('condensed-issue', {
      key: article.id,
      attrs: {
        "issue": article
      }
    })
  }))
},staticRenderFns: []}

/***/ }),
/* 1455 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "for-authors"
  }, [_c('div', {
    staticClass: "page-title"
  }, [_vm._v("For Authors")]), _vm._v(" "), _c('b-nav-item-dropdown', {
    staticClass: "nav mobile-page-menu hidden-md-up mb-2",
    attrs: {
      "is-nav": "",
      "text": _vm.currentPage
    }
  }, [_c('b-dropdown-item', [_c('router-link', {
    attrs: {
      "to": {
        name: 'forAuthorsSubmissionGuidelines'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.currentPage = 'Submission Guidelines'
      }
    }
  }, [_vm._v("Submission Guidelines")])], 1), _vm._v(" "), _c('b-dropdown-item', [_c('router-link', {
    attrs: {
      "to": {
        name: 'forAuthorsStyleGuidelines'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.currentPage = 'Style Guidelines'
      }
    }
  }, [_vm._v("Style Guidelines")])], 1), _vm._v(" "), _c('b-dropdown-item', [_c('router-link', {
    attrs: {
      "to": {
        name: 'forAuthorsPolicies'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.currentPage = 'Policies'
      }
    }
  }, [_vm._v("Policies")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-menu hidden-sm-down"
  }, [_c('b-nav', {
    staticClass: "row tabs"
  }, [_c('b-nav-item', {
    attrs: {
      "to": {
        name: 'forAuthorsSubmissionGuidelines'
      }
    }
  }, [_vm._v("Submission Guidelines")]), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "to": {
        name: 'forAuthorsStyleGuidelines'
      }
    }
  }, [_vm._v("Style Guidelines")]), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "to": {
        name: 'forAuthorsPolicies'
      }
    }
  }, [_vm._v("Policies")])], 1)], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 1456 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media-wrapper",
    class: {
      playable: _vm.isPlayable, fullscreen: _vm.isFullScreen
    }
  }, [(_vm.isVideo) ? _c('video', {
    attrs: {
      "src": _vm.getStaticPath('img/temp/test_video.png')
    }
  }) : _c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.issue.files.figures[_vm.$parent.selectedId].optimized_urls.hero
    }
  }), _vm._v(" "), (_vm.isVideo) ? _c('div', {
    staticClass: "play-button",
    style: ({
      backgroundImage: 'url(' + _vm.getStaticPath('img/play-circle.png') + ')'
    }),
    on: {
      "click": function($event) {
        _vm.playVideo($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.share) ? _c('div', {
    staticClass: "share-button",
    style: ({
      backgroundImage: 'url(' + _vm.getStaticPath('img/share-circle.png') + ')'
    })
  }) : _vm._e(), _vm._v(" "), (_vm.header && !_vm.collectionsHeader) ? _c('div', {
    staticClass: "issue-header"
  }, [_c('div', {
    staticClass: "articleType"
  }, [_vm._v("Article Type: "), _c('span', [_vm._v(_vm._s(_vm.issue.article_type.name))])]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.trimTextToLength(_vm.issue.title, 100)))])]) : _vm._e(), _vm._v(" "), (_vm.collectionsHeader) ? _c('div', {
    staticClass: "issue-header"
  }, [_c('div', {
    staticClass: "articleType",
    domProps: {
      "innerHTML": _vm._s(_vm.issue.caption)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.trimTextToLength(_vm.issue.title, 100)))])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1457 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row bar"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-3 col-md-12 col-lg-3"
  }, [_c('div', {
    staticClass: "row shared-bar"
  }, [_c('div', {
    staticClass: "col-12 col-md-4 col-lg-12"
  }, [_vm._v("Shared")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-2 col-lg-6"
  }, [_c('i', [_c('icon', {
    attrs: {
      "name": "facebook-f"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-2 col-lg-6"
  }, [_c('i', [_c('icon', {
    attrs: {
      "name": "twitter"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-2 col-lg-6"
  }, [_c('i', [_c('icon', {
    attrs: {
      "name": "linkedin"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-2 col-lg-6"
  }, [_c('i', [_c('icon', {
    attrs: {
      "name": "google-plus"
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-9 col-md-12 col-lg-9"
  }, [_c('img')])
}]}

/***/ }),
/* 1458 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "row header justify-content-between"
  }, [_c('div', {
    staticClass: "col dates"
  }, [_vm._v(_vm._s(_vm.sponsorshipItem.dates))]), _vm._v(" "), _c('div', {
    staticClass: "col website"
  }, [_vm._v(_vm._s(_vm.sponsorshipItem.siteUrl))])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.getStaticPath('img/temp/' + _vm.sponsorshipItem.coverUrl)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.sponsorshipItem.name)), _c('br'), _c('span', {
    staticClass: "location"
  }, [_vm._v(_vm._s(_vm.sponsorshipItem.city) + ", " + _vm._s(_vm.sponsorshipItem.country))])])])])])
},staticRenderFns: []}

/***/ }),
/* 1459 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-journals-family"
  }, [_c('div', {
    staticClass: "row mb-2"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('img', {
    staticClass: "float-right",
    attrs: {
      "src": _vm.getStaticPath(_vm.rapamycinLogo),
      "alt": "Rapamycin Logo"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-nav', {
    attrs: {
      "vertical": ""
    }
  }, [_vm._l((_vm.sortedList), function(site) {
    return [_c('b-nav-item', [_vm._v(_vm._s(site.name))])]
  })], 2)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "pt-3 pr-3 d-inline-block"
  }, [_vm._v("\n        Visit the Rapamycin Family of "), _c('br'), _vm._v(" Medical Science Journals\n      ")])
}]}

/***/ }),
/* 1460 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    class: _vm.klass,
    style: (_vm.style),
    attrs: {
      "version": "1.1",
      "role": _vm.label ? 'img' : 'presentation',
      "aria-label": _vm.label,
      "x": _vm.x,
      "y": _vm.y,
      "width": _vm.width,
      "height": _vm.height,
      "viewBox": _vm.box
    }
  }, [_vm._t("default", [(_vm.icon && _vm.icon.paths) ? _vm._l((_vm.icon.paths), function(path, i) {
    return _c('path', _vm._b({
      key: ("path-" + i)
    }, 'path', path, false))
  }) : _vm._e(), _vm._v(" "), (_vm.icon && _vm.icon.polygons) ? _vm._l((_vm.icon.polygons), function(polygon, i) {
    return _c('polygon', _vm._b({
      key: ("polygon-" + i)
    }, 'polygon', polygon, false))
  }) : _vm._e(), _vm._v(" "), (_vm.icon && _vm.icon.raw) ? [_c('g', {
    domProps: {
      "innerHTML": _vm._s(_vm.raw)
    }
  })] : _vm._e()])], 2)
},staticRenderFns: []}

/***/ }),
/* 1461 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row for-authors-style-guide"
  }, [_c('div', {
    staticClass: "col-md-3 hidden-sm-down"
  }, [_c('for-authors-page-side-menu', {
    attrs: {
      "anchors-list": _vm.anchorsList
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md"
  }, [_c('for-authors-style-guide-content', {
    attrs: {
      "anchors-list": _vm.anchorsList
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1462 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_c('i', [_vm._v("Google+")])]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-1"
  }, [_c('div', {
    staticClass: "img h1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-11"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('i', [_c('b', [_vm._v("User Name")]), _c('br'), _vm._v(" Designation")]), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._v("\n            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet.Lorem ipsum dolor sit amet,\n            consectetur adipiscing elit. Aenean euismod bibendum laoreet.Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n            Aenean euismod bibendum laoreet. "), _c('a', [_vm._v("http://www.grc.org/programs.aspx?id=16786")])])])])])]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-1"
  }, [_c('div', {
    staticClass: "img h1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-11"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('i', [_c('b', [_vm._v("User Name")]), _c('br'), _vm._v(" Designation")]), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._v("\n            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet.Lorem ipsum dolor sit amet,\n            consectetur adipiscing elit. Aenean euismod bibendum laoreet.Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n            Aenean euismod bibendum laoreet."), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "img h2"
  })])])])])])])
}]}

/***/ }),
/* 1463 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-nav', {
    attrs: {
      "is-nav-bar": ""
    }
  }, [_c('b-nav-item-dropdown', {
    staticClass: "nav justify-content-end mobile-menu",
    attrs: {
      "right": "",
      "is-nav": "",
      "text": "jump to"
    }
  }, _vm._l((_vm.anchorsList), function(item) {
    return _c('b-dropdown-item', {
      key: item.anchor
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '#' + item.anchor
        }
      }
    }, [_vm._v(_vm._s(item.name))])], 1)
  }))], 1)
},staticRenderFns: []}

/***/ }),
/* 1464 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col title"
  }, [_vm._v("Submission of Files")]), _vm._v(" "), _c('div', {
    staticClass: "col-3 pl-1 hidden-md-up"
  }, [_c('for-authors-mobile-menu', {
    attrs: {
      "anchors-list": _vm.anchorsList
    }
  })], 1)]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n      Please carefully read the Instructions for Authors in the submission system.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      When submitting manuscripts, authors are strongly encouraged to upload original source files into the system.\n      Uploading original source files will greatly facilitate publication of an accepted manuscript. Submit all\n      files via submission system, no emails. The following are acceptable file formats:\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      Manuscript files: Word, WordPerfect (doc or docx). No other format.\n      Graphics files: TIFF (preferable), JPG, PPT or PPTX, EPS format.\n      Once you have successfully submitted your manuscript online, you will receive acknowledgment via email.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      In submission system, please provide names, Institutions, real emails of ALL co- authors.\n    ")])])
}]}

/***/ }),
/* 1465 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "author-item"
  }, [_c('div', {
    staticClass: "row m-0 align-items-end justify-content-between"
  }, [_c('h5', {
    staticClass: "m-0"
  }, [_vm._v(_vm._s(_vm.author.firstName) + " " + _vm._s(_vm.author.lastName) + "\n      "), _c('a', {
    staticClass: "envelope",
    attrs: {
      "href": ("mailto:" + (_vm.author.email))
    }
  }, [_c('icon', {
    attrs: {
      "name": "envelope-o"
    }
  })], 1)]), _vm._v(" "), (!_vm.$store.state.isEnhanced) ? _c('social-media-buttons', {
    staticClass: "m-0 hidden-md-down",
    attrs: {
      "media-links": _vm.author.mediaLinks
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "row m-0"
  }, [_c('div', {
    staticClass: "col-4 p-0"
  }, [_c('img', {
    attrs: {
      "src": _vm.getStaticPath('img/temp/' + _vm.author.photoUrl)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col description"
  }, [_c('div', [_vm._v(_vm._s(_vm.author.institution) + ",")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.author.location))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.author.description))]), _vm._v(" "), _c('p', [_vm._t("details-link")], 2)])])])
},staticRenderFns: []}

/***/ }),
/* 1466 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-nav', {
    staticClass: "primary-nav nav-fill"
  }, [_c('b-nav-item', [_vm._v(" About\n      "), _c('b-nav', {
    staticClass: "secondary-nav",
    attrs: {
      "vertical": ""
    }
  }, [_c('b-nav-item', {
    attrs: {
      "to": {
        name: 'history'
      }
    }
  }, [_vm._v("History")]), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "to": {
        name: 'aimsAndScope'
      }
    }
  }, [_vm._v("Aims & Scope")]), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "to": {
        name: 'announcements'
      }
    }
  }, [_vm._v("News")]), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "to": {
        name: 'sponsorshipRequest'
      }
    }
  }, [_vm._v("Conference Sponsorship")])], 1)], 1), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "to": {
        name: 'contact'
      }
    }
  }, [_vm._v("Contact "), _c('div', {
    staticClass: "icon icon-color-arrow-right-dark"
  })]), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "to": {
        name: 'careers'
      }
    }
  }, [_vm._v("Careers "), _c('div', {
    staticClass: "icon icon-color-arrow-right-dark"
  })])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1467 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.article) ? _c('article-detail-component', [_c('div', {
    staticClass: "anchors",
    attrs: {
      "slot": "anchors"
    },
    slot: "anchors"
  }, _vm._l((_vm.anchors), function(value, key) {
    return _c('div', [_c('a', {
      class: {
        active: _vm.$route.hash == ('#' + key) || (key == 'Tables' && !_vm.$route.hash)
      },
      attrs: {
        "href": '#' + key
      }
    }, [_vm._v(_vm._s(value))])])
  })), _vm._v(" "), _c('div', {
    staticClass: "keywords",
    attrs: {
      "slot": "keywords"
    },
    slot: "keywords"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n      Keywords:\n    ")]), _vm._v(" "), _c('div', {}, _vm._l((_vm.article.keywords), function(keyword) {
    return _c('div', {
      staticClass: "link"
    }, [_vm._v(_vm._s(keyword))])
  }))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.article.title))]), _vm._v(" "), _c('issue-authors', {
    attrs: {
      "authors": _vm.article.authors
    }
  })], 1), _vm._v(" "), _c('sidebar-article-section', {
    attrs: {
      "slot": "bar",
      "article": _vm.article
    },
    slot: "bar"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "full_text"
    },
    slot: "full_text"
  }, [_c('title-block', {
    attrs: {
      "title": "Tables",
      "id": "Tables",
      "color-theme": "primary-color"
    }
  }), _vm._v(" "), _c('title-block', {
    attrs: {
      "title": "Figures",
      "id": "Figures",
      "color-theme": "primary-color"
    }
  }, _vm._l((_vm.article.files.figures), function(figure) {
    return _c('div', {
      staticClass: "fullText"
    }, [_c('section', [_c('h1', [_vm._v(_vm._s(figure.label))]), _vm._v(" "), _c('img', {
      attrs: {
        "src": figure.url
      }
    }), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(figure.caption)
      }
    })])])
  })), _vm._v(" "), _c('title-block', {
    attrs: {
      "title": "Videos",
      "id": "Videos",
      "color-theme": "primary-color"
    }
  })], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1468 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_c('i', [_vm._v("Trivia")])]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b', [_vm._v("Related Trivia 1:")]), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-5 col-md-4 col-lg-3"
  }, [_c('div', {
    staticClass: "img h1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-7 col-md-8 col-lg-9"
  }, [_vm._v("\n        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet.Lorem ipsum dolor sit amet,\n        consectetur adipiscing elit. Aenean euismod bibendum laoreet.Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n        Aenean euismod bibendum laoreet.\n        "), _c('br'), _c('br'), _vm._v(" "), _c('a', [_vm._v("Take the Quiz >")])])])]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b', [_vm._v("Related Trivia 2:")]), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-5 col-md-4 col-lg-3"
  }, [_c('div', {
    staticClass: "img h1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-7 col-md-8 col-lg-9"
  }, [_vm._v("\n        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet.Lorem ipsum dolor sit amet,\n        consectetur adipiscing elit. Aenean euismod bibendum laoreet.Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n        Aenean euismod bibendum laoreet.\n        "), _c('br'), _c('br'), _vm._v(" "), _c('a', [_vm._v("Take the Quiz >")])])])])])
}]}

/***/ }),
/* 1469 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-lg-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b', [_vm._v("In The Media")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "btn active"
  }, [_vm._v("News (123)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "btn btn-default"
  }, [_vm._v("Scientific Blogs (123)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "btn btn-default"
  }, [_vm._v("Google+ (123)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet.")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor.")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget.")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-lg-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b', [_vm._v("Citations:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('div', {
    staticClass: "img h1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('div', {
    staticClass: "img h1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('div', {
    staticClass: "img h1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('div', {
    staticClass: "img h1"
  })])])])])]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('b', [_vm._v("Social Attention:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 text-right"
  }, [_c('b', [_vm._v("29,876")]), _vm._v(" Total Shares")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-3 col-lg-3"
  }, [_c('div', {
    staticClass: "img h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "img h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "img h1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-9"
  }, [_c('div', {
    staticClass: "img h3"
  })])])])])
}]}

/***/ }),
/* 1470 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "form-inline ml-auto row no-gutters search-form"
  }, [_c('div', {
    staticClass: "document col-1 pl-0"
  }, [_c('icon', {
    attrs: {
      "name": "file-text-o",
      "scale": "1.25"
    }
  })], 1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchRequest),
      expression: "searchRequest"
    }],
    staticClass: "form-control col",
    attrs: {
      "type": "text",
      "placeholder": "Search Title, Abstract, Author, Keyword"
    },
    domProps: {
      "value": (_vm.searchRequest)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchRequest = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "button-wrapper col-1 p-0"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'searchResults',
        params: {
          request: _vm.searchRequest
        }
      }
    }
  }, [_c('b-button', {
    staticClass: "button-secondary button-square my-2 my-sm-0",
    attrs: {
      "disabled": !_vm.searchRequest,
      "type": "submit"
    }
  }, [_c('div', {
    staticClass: "icon icon-search"
  })])], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1471 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col title"
  }, [_vm._v("Plagerism")]), _vm._v(" "), _c('div', {
    staticClass: "col-3 pl-1 hidden-md-up"
  }, [_c('for-authors-mobile-menu', {
    attrs: {
      "anchors-list": _vm.anchorsList
    }
  })], 1)]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.siteName) + "\n    "), _c('br'), _vm._v(" "), _vm._v("\n    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapienLorem ipsum dolor sit amet, consectetur adipiscing elit.\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 1472 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "authors"
  }, [_vm._l((_vm.authors), function(author, index) {
    return [(_vm.authors.length > 1 && index > 0) ? [((_vm.authors.length - index) === 1) ? [_vm._v(" and ")] : [_vm._v(", ")]] : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(author.name_first) + " " + _vm._s(author.name_middle ? author.name_middle + ' ' : '') + _vm._s(author.name_last))])]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 1473 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "issue"
  }, [(_vm.smallMode) ? _c('div', {
    staticClass: "row no-gutters"
  }, [_c('div', {
    staticClass: "col-auto mb-3",
    class: {
      'hidden-md-up': _vm.smallMode
    }
  }, [(_vm.coverUrl) ? _c('img', {
    staticClass: "issue-cover",
    attrs: {
      "src": _vm.coverUrl
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col",
    class: {
      'hidden-md-up': _vm.smallMode
    }
  }, [_c('div', {
    staticClass: "row"
  }, [(!_vm.hideType) ? _c('div', {
    staticClass: "articleType col-sm-12"
  }, [_vm._v(_vm._s(_vm.issue.article_type ? _vm.issue.article_type.name : ''))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "title col-sm-12",
    domProps: {
      "innerHTML": _vm._s(_vm.issue.title)
    }
  }, [_vm._v(_vm._s(_vm.issue.title))])])])]) : _vm._e(), _vm._v(" "), (!_vm.hideType) ? _c('div', {
    staticClass: "articleType",
    class: {
      'hidden-sm-down': _vm.smallMode
    }
  }, [_vm._v(_vm._s(_vm.issue.article_type ? _vm.issue.article_type.name : ''))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "title",
    class: {
      'hidden-sm-down': _vm.smallMode
    },
    domProps: {
      "innerHTML": _vm._s(_vm.issue.title)
    }
  }, [_vm._v(_vm._s(_vm.issue.title))]), _vm._v(" "), _c('div', {
    staticClass: "row mb-4 no-gutters"
  }, [_c('div', {
    staticClass: "col-md-auto",
    class: {
      'hidden-sm-down': _vm.smallMode
    }
  }, [(_vm.coverUrl) ? _c('img', {
    staticClass: "issue-cover mb-3",
    attrs: {
      "src": _vm.coverUrl
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md col-sm-12"
  }, [_c('div', {
    staticClass: "doi"
  }, [_vm._v("DOI: "), _c('span', [_vm._v(_vm._s(_vm.issue.ids ? _vm.issue.ids.doi : ''))]), _vm._v("  \n                      pp " + _vm._s(_vm.issue.page_start) + "-" + _vm._s(_vm.issue.page_end) + "\n      ")]), _vm._v(" "), _c('div', {
    class: {
      'hidden-sm-down': _vm.smallMode
    }
  }, [_c('issue-authors', {
    attrs: {
      "authors": _vm.issue.authors
    }
  })], 1), _vm._v(" "), _c('article-quick-links', {
    attrs: {
      "article": _vm.issue
    }
  }), _vm._v(" "), (_vm.issue.abstract) ? _c('div', {
    staticClass: "abstract",
    class: {
      hide: !_vm.isAbstractShow
    },
    domProps: {
      "innerHTML": _vm._s(_vm.issue.abstract)
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1474 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contacts"
  }, [_c('div', {
    staticClass: "page-title"
  }, [_vm._v("Contact Us")]), _vm._v(" "), _c('div', {
    staticClass: "headquarters"
  }, [_c('h5', [_vm._v("Headquarters")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 col-12"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "p-0"
  }, [_vm._v("email: "), _c('strong', [_vm._v("Support@" + _vm._s(_vm.siteName) + ".com")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "question-form"
  }, [_c('h5', [_vm._v("Send us Question")]), _vm._v(" "), _c('small', [_vm._v("* Indicates required field")]), _vm._v(" "), _c('p', [_vm._v("To help us respond to you with the most accurate answer or assistance, please begin by selecting a department or topic from the drop down below.")]), _vm._v(" "), (!_vm.form.topic) ? _c('b-form-select', {
    attrs: {
      "options": _vm.topicsList,
      "calss": "mb-3"
    },
    model: {
      value: (_vm.form.topic),
      callback: function($$v) {
        _vm.$set(_vm.form, "topic", $$v)
      },
      expression: "form.topic"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.form.topic) ? _c('form', [_c('b-button', {
    attrs: {
      "variant": "link"
    },
    nativeOn: {
      "click": function($event) {
        _vm.form.topic = ''
      }
    }
  }, [_vm._v("< Select a different Department or Topic")]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Department, Topic or Issue:",
      "label-size": 1
    }
  }, [_c('b-form-input', {
    staticClass: "topic",
    attrs: {
      "static": true,
      "type": "text"
    },
    model: {
      value: (_vm.form.topic),
      callback: function($$v) {
        _vm.$set(_vm.form, "topic", $$v)
      },
      expression: "form.topic"
    }
  })], 1), _vm._v(" "), _c('b-form-fieldset', {
    staticClass: "custom",
    attrs: {
      "label": "Name: *",
      "state": _vm.form.name.length ? 'success' : 'warning',
      "label-size": 1
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "Enter  Name"
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Email Address: *",
      "state": _vm.form.email.length ? 'success' : 'warning',
      "label-size": 1
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "email",
      "placeholder": "Enter Email Address"
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.$set(_vm.form, "email", $$v)
      },
      expression: "form.email"
    }
  })], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Type your Question or Inquiry: *",
      "state": _vm.form.question.length ? 'success' : 'warning',
      "label-size": 1
    }
  }, [_c('b-form-input', {
    attrs: {
      "textarea": "",
      "rows": 5
    },
    model: {
      value: (_vm.form.question),
      callback: function($$v) {
        _vm.$set(_vm.form, "question", $$v)
      },
      expression: "form.question"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "button-primary"
  }, [_vm._v("Submit")])], 1) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-5 col-12"
  }, [_c('p', {
    staticClass: "p-0"
  }, [_vm._v("666 East Quaker Str., Suite 1")]), _vm._v(" "), _c('p', {
    staticClass: "p-0"
  }, [_vm._v("Orchard Park, NY 14127")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "p-0"
  }, [_vm._v("Phone: "), _c('strong', [_vm._v("1-800-922-0957 (option 2)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "p-0"
  }, [_vm._v("Fax: "), _c('strong', [_vm._v("716-508-8254")])])
}]}

/***/ }),
/* 1475 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('media-player', {
    attrs: {
      "issue": _vm.issue,
      "share": false,
      "header": false
    }
  })], 1)]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12"
  }, [_c('p'), _c('h3', [_c('i', [_vm._v("Interview with Dr. Somebody Somename & Somebody Othername")])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("\n      Division of Molecular Carcinogenesis, The Netherlands Cancer Institute, Amsterdam, The Netherlands\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      talking about their cover paper published in "), _c('i', [_c('a', [_vm._v("Volume 7 Issue 25")])]), _vm._v(" of Oncotarget called "), _c('a', [_c('b', [_vm._v("\"Intrinsic resistance\n      to PIM kinase inhibition in AML through p38α-mediated feedback activation of mTOR signaling\"")])])])])
}]}

/***/ }),
/* 1476 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page-title"
  }, [_vm._v("Careers with " + _vm._s(_vm.siteName))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('title-block', {
    attrs: {
      "title": "Open Positions",
      "link-title": "View All",
      "link-name": "",
      "color-theme": "primary-color"
    }
  }, _vm._l((_vm.positions), function(item) {
    return _c('div', {
      staticClass: "position-item"
    }, [_c('div', {
      staticClass: "posted-date"
    }, [_vm._v("Posted " + _vm._s(_vm.getFormatedDate(item.postedDate)))]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [(item.titlePrefix) ? _c('span', [_vm._v(_vm._s(item.titlePrefix) + ": ")]) : _vm._e(), _vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "description"
    }, [_vm._v(_vm._s(item.description))]), _vm._v(" "), (item.url) ? _c('div', {}, [_c('a', {
      attrs: {
        "href": item.url
      }
    }, [_vm._v("View and Apply for this Position >")])]) : _vm._e()])
  }))], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('p', [_vm._v("Working in Scholarly Publishing is.. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisiLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisiLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisiLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi.")])])
}]}

/***/ }),
/* 1477 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.state.isEnhanced) ? _c('div', {
    staticClass: "e_view"
  }, [_c('div', {
    staticClass: "right_panel"
  }, [_c('ul', {
    staticClass: "tabs"
  }, [_c('li', {
    class: {
      active: _vm.isActive('article-detail')
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.navigateTo('article-detail')
      }
    }
  }, [_vm._v("Article")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isActive('article-detail-authors')
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.navigateTo('article-detail-authors')
      }
    }
  }, [_vm._v("Authors")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isActive('article-detail-related')
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.navigateTo('article-detail-related')
      }
    }
  }, [_vm._v("Related")])])]), _vm._v(" "), _vm._t("anchors"), _vm._v(" "), _vm._t("keywords"), _vm._v(" "), _vm._t("authors"), _vm._v(" "), _vm._t("current_article")], 2), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._t("title"), _vm._v(" "), _vm._t("full_text"), _vm._v(" "), _vm._t("default")], 2)]) : _c('div', {
    staticClass: "d_view"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_vm._t("title")], 2), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._t("bar")], 2)]), _vm._v(" "), _c('ul', {
    staticClass: "tabs hidden-sm-down"
  }, [_vm._l((_vm.options), function(option) {
    return _c('li', {
      class: {
        active: _vm.isActive(option.value)
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.navigateTo(option.value)
        }
      }
    }, [_vm._v(_vm._s(option.text))])])
  }), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": _vm.toggleToEnhanced
    }
  }, [_vm._v("Enhanced View")])])], 2), _vm._v(" "), _c('b-form-select', {
    staticClass: "hidden-md-up",
    attrs: {
      "options": _vm.options
    },
    on: {
      "input": function($event) {
        _vm.navigateTo(_vm.selected)
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-lg-3 hidden-sm-down"
  }, [_c('div', {
    staticClass: "articleAnchors",
    attrs: {
      "id": "articleAnchors"
    }
  }, [_vm._t("anchors")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-lg-9 article-content"
  }, [_c('resize-observer', {
    on: {
      "notify": _vm.handleResize
    }
  }), _vm._v(" "), _vm._t("full_text")], 2)]), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "navModal",
      "title": "Jump To",
      "hide-footer": true
    }
  }, [_c('div', {
    staticClass: "anchors"
  }, _vm._l((_vm.modalAnchors), function(value, key) {
    return _c('div', [_c('a', {
      class: {
        active: _vm.$route.hash == ('#' + key) || (key == 'Abstract' && !_vm.$route.hash)
      },
      on: {
        "click": function($event) {
          _vm.jumpTo(key)
        }
      }
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])])
  }))])], 2)
},staticRenderFns: []}

/***/ }),
/* 1478 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.contentItem.contentType === 'figure') ? [_c('content-figure', {
    attrs: {
      "figure-attr": _vm.contentItem.content
    }
  })] : (_vm.contentItem.contentType === 'table') ? [_c('content-table', {
    attrs: {
      "table-content": _vm.contentItem
    }
  })] : [_c('content-element', {
    attrs: {
      "tag-name": _vm.contentItem.contentType || 'p'
    },
    domProps: {
      "innerHTML": _vm._s(_vm.contentItem.content || _vm.contentItem.content_part)
    }
  })]], 2)
},staticRenderFns: []}

/***/ }),
/* 1479 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.article) ? _c('article-detail-component', [(!_vm.$store.state.isEnhanced) ? _c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.article.title))]), _vm._v(" "), _c('issue-authors', {
    attrs: {
      "authors": _vm.article.authors
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('sidebar-article-section', {
    attrs: {
      "slot": "bar",
      "article": _vm.article
    },
    slot: "bar"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "authors"
    },
    slot: "authors"
  }, [_c('issue-authors', {
    attrs: {
      "authors": _vm.article.authors
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "current-issue",
    attrs: {
      "slot": "current_article"
    },
    slot: "current_article"
  }, [_c('em', [_vm._v("Current Article:")]), _vm._v(" "), _c('condensed-issue', {
    staticClass: "mt-2",
    attrs: {
      "issue": _vm.article
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row correspondence-to"
  }, [_c('em', [_vm._v("Correspondence to: ")]), _vm._v(" "), _vm._l((_vm.correspondenceTo), function(contact) {
    return _c('span', {
      key: contact.email
    }, [_vm._v("\n      " + _vm._s(contact.firstName) + " " + _vm._s(contact.lastName) + ": "), _c('a', {
      attrs: {
        "href": ("mailto:" + (contact.email))
      }
    }, [_vm._v(_vm._s(contact.email))])])
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.detailsMode),
      expression: "!detailsMode"
    }],
    staticClass: "row"
  }, _vm._l((_vm.authors), function(author) {
    return _c('author', {
      key: author.id,
      staticClass: "col-xs-12",
      class: {
        'col-md-6': !_vm.$store.state.isEnhanced
      },
      attrs: {
        "author": author
      }
    }, [_c('span', {
      staticClass: "link",
      attrs: {
        "slot": "details-link"
      },
      on: {
        "click": function($event) {
          _vm.openDetails(author.id)
        }
      },
      slot: "details-link"
    }, [_vm._v("Read More >")])])
  })), _vm._v(" "), (_vm.detailsMode) ? _c('author-details', {
    attrs: {
      "author-id": _vm.authorDetailId
    }
  }, [_c('div', {
    staticClass: "row no-gutters justify-content-between",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "link",
    on: {
      "click": _vm.closeDetails
    }
  }, [_vm._v("< Back to all authors")]), _vm._v(" "), _c('b-button', {
    staticClass: "link",
    attrs: {
      "variant": "link"
    },
    on: {
      "click": _vm.closeDetails
    }
  }, [_c('icon', {
    attrs: {
      "name": "times"
    }
  })], 1)], 1)]) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1480 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "sidebar"
    }
  }, [_c('b-nav', {
    staticClass: "for-authors-sidebar",
    attrs: {
      "vertical": ""
    }
  }, _vm._l((_vm.anchorsList), function(item) {
    return _c('b-nav-item', {
      key: item.anchor,
      attrs: {
        "to": {
          path: '#' + item.anchor
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }))], 1)
},staticRenderFns: []}

/***/ }),
/* 1481 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', [_c('b-nav', {
    staticClass: "hidden-sm-down"
  }, [_c('b-nav-item', {
    attrs: {
      "to": "/",
      "exact": ""
    }
  }, [_c('div', {
    staticClass: "icon icon-home"
  })]), _vm._v(" "), _c('li', {
    staticClass: "divider-vertical"
  }), _vm._v(" "), _c('editorial-board-dropdown'), _vm._v(" "), _c('li', {
    staticClass: "divider-vertical"
  }), _vm._v(" "), _c('publications-dropdown'), _vm._v(" "), _c('li', {
    staticClass: "divider-vertical"
  }), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "to": "/for-authors/submission-guidelines",
      "exact": ""
    }
  }, [_vm._v("For Authors")]), _vm._v(" "), _c('li', {
    staticClass: "divider-vertical"
  }), _vm._v(" "), _c('about-dropdown'), _vm._v(" "), _c('div', {
    staticClass: "col d-flex justify-content-center ml-auto hidden-lg-down"
  }, [_c('search-field')], 1), _vm._v(" "), _c('div', {
    staticClass: "search-dropdown col"
  }, [_c('div', {
    staticClass: "button-wrapper"
  }, [_c('b-btn', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.search_collapse",
      modifiers: {
        "search_collapse": true
      }
    }],
    staticClass: "button-secondary"
  }, [_c('div', {
    staticClass: "icon icon-search"
  })])], 1)]), _vm._v(" "), _c('button', {
    staticClass: "button-primary",
    attrs: {
      "id": "submit_btn"
    }
  }, [_vm._v("Submit Paper")]), _vm._v(" "), _c('b-collapse', {
    staticClass: "nav flex-column",
    attrs: {
      "is-nav": "",
      "id": "search_collapse"
    }
  }, [_c('search-field')], 1)], 1), _vm._v(" "), _c('b-navbar', {
    staticClass: "hidden-md-up",
    attrs: {
      "toggleable": "",
      "id": "navbar"
    }
  }, [_c('b-nav', {
    staticClass: "horizontal-nav"
  }, [_c('b-nav-item', {
    staticClass: "col",
    attrs: {
      "to": {
        name: 'editorialBoardMembers'
      }
    }
  }, [_vm._v("Editorial Board")]), _vm._v(" "), _c('b-nav-item', {
    staticClass: "col",
    attrs: {
      "to": {
        name: 'issueDetail',
        params: {
          volumeId: 1,
          issueId: 1
        }
      }
    }
  }, [_vm._v("Current Issue")]), _vm._v(" "), _c('b-nav-item', {
    staticClass: "col",
    attrs: {
      "to": {
        name: 'forAuthorsSubmissionGuidelines'
      }
    }
  }, [_vm._v("For Authors")]), _vm._v(" "), _c('b-nav-item', {
    staticClass: "col",
    attrs: {
      "to": {
        name: 'contact'
      }
    }
  }, [_vm._v("Contact")]), _vm._v(" "), _c('b-nav-item', {
    staticClass: "col-auto"
  }, [_c('b-nav-toggle', {
    staticClass: "mx-0 p-0",
    attrs: {
      "position": "static",
      "target": "nav_collapse"
    }
  })], 1)], 1), _vm._v(" "), _c('b-collapse', {
    staticClass: "nav flex-column",
    attrs: {
      "is-nav": "",
      "id": "nav_collapse"
    }
  }, [_c('b-nav-item', {
    attrs: {
      "to": "#"
    }
  }, [_c('search-field')], 1), _vm._v(" "), _c('editorial-board-dropdown', {
    staticClass: "mobile"
  }), _vm._v(" "), _c('publications-dropdown', {
    staticClass: "mobile"
  }), _vm._v(" "), _c('b-nav-item', {
    staticClass: "mobile",
    attrs: {
      "to": "/for-authors/submission-guidelines",
      "exact": ""
    }
  }, [_vm._v("For Authors")]), _vm._v(" "), _c('about-dropdown', {
    staticClass: "mobile"
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1482 */,
/* 1483 */,
/* 1484 */,
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./footer-logo.png": 166,
	"./header-img.png": 167,
	"./header-logo.png": 168
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1485;

/***/ }),
/* 1486 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[198]);


// WEBPACK FOOTER //
// static/js/app.11c1333ef97dcb2bbe63.js